export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigFloat: any;
  Datetime: Date;
  Date: string;
  UUID: string;
  Cursor: string;
  BigInt: any;
  JSON: any;
  Timezone: string;
  Time: string;
  Whoami: any;
  JwtToken: string;
  Upload: any;
}

/** The root query type which gives access points into the data universe. */
export interface Query extends Node {
  __typename: 'Query';
  /** Reads a single `AccountTransaction` using its globally unique `ID`. */
  accountTransaction: Maybe<AccountTransaction>;
  accountTransactionById: Maybe<AccountTransaction>;
  /** Reads a single `ActionLog` using its globally unique `ID`. */
  actionLog: Maybe<ActionLog>;
  actionLogById: Maybe<ActionLog>;
  activeIdentityTagsByWellthId: Maybe<Array<Maybe<IdentityTag>>>;
  address: Maybe<Address>;
  /** Reads a single `Admin` using its globally unique `ID`. */
  admin: Maybe<Admin>;
  adminById: Maybe<Admin>;
  /** Reads a single `AdminRole` using its globally unique `ID`. */
  adminRole: Maybe<AdminRole>;
  adminRoleById: Maybe<AdminRole>;
  adminRoleByName: Maybe<AdminRole>;
  /** Reads a single `AdminRolePrivilegedAction` using its globally unique `ID`. */
  adminRolePrivilegedAction: Maybe<AdminRolePrivilegedAction>;
  adminRolePrivilegedActionById: Maybe<AdminRolePrivilegedAction>;
  /** Reads and enables pagination through a set of `AccountTransaction`. */
  allAccountTransactions: Maybe<AccountTransactionsConnection>;
  /** Reads and enables pagination through a set of `ActionLog`. */
  allActionLogs: Maybe<ActionLogsConnection>;
  /** Reads and enables pagination through a set of `AdminRolePrivilegedAction`. */
  allAdminRolePrivilegedActions: Maybe<AdminRolePrivilegedActionsConnection>;
  /** Reads and enables pagination through a set of `AdminRole`. */
  allAdminRoles: Maybe<AdminRolesConnection>;
  /** Reads and enables pagination through a set of `Admin`. */
  allAdmins: Maybe<AdminsConnection>;
  allAdminTagConfigs: Maybe<Array<Maybe<TagConfigPayload>>>;
  allBonusBehaviorConfigs: Maybe<Array<Maybe<BonusBehaviorConfig>>>;
  allBonusBehaviors: Maybe<Array<Maybe<BonusBehavior>>>;
  allBonusBehaviorSubmissionPayloads: Maybe<BonusBehaviorSubmissionPayload>;
  /** Reads and enables pagination through a set of `BonusBehaviorSubmissionStatus`. */
  allBonusBehaviorSubmissionStatuses: Maybe<BonusBehaviorSubmissionStatusesConnection>;
  allChallengeRewards: Maybe<Array<ChallengeRewardDetail>>;
  /** Reads and enables pagination through a set of `CheckIn`. */
  allCheckIns: Maybe<CheckInsConnection>;
  /** Reads and enables pagination through a set of `CueCheckIn`. */
  allCueCheckIns: Maybe<CueCheckInsConnection>;
  /** Reads and enables pagination through a set of `Customer`. */
  allCustomers: Maybe<CustomersConnection>;
  /** Reads and enables pagination through a set of `DebitCardBalance`. */
  allDebitCardBalances: Maybe<DebitCardBalancesConnection>;
  /** Reads and enables pagination through a set of `DebitCard`. */
  allDebitCards: Maybe<DebitCardsConnection>;
  /** Reads and enables pagination through a set of `Device`. */
  allDevices: Maybe<DevicesConnection>;
  /** Reads and enables pagination through a set of `Group`. */
  allGroups: Maybe<GroupsConnection>;
  /** Reads and enables pagination through a set of `Heartbeat`. */
  allHeartbeats: Maybe<HeartbeatsConnection>;
  /** Reads and enables pagination through a set of `HydrationCheckIn`. */
  allHydrationCheckIns: Maybe<HydrationCheckInsConnection>;
  /** Reads and enables pagination through a set of `MarvMigration`. */
  allMarvMigrations: Maybe<MarvMigrationsConnection>;
  /** Reads and enables pagination through a set of `MarvMigrationsLock`. */
  allMarvMigrationsLocks: Maybe<MarvMigrationsLocksConnection>;
  /** Reads and enables pagination through a set of `MealCheckIn`. */
  allMealCheckIns: Maybe<MealCheckInsConnection>;
  /** Reads and enables pagination through a set of `MeasurementCheckIn`. */
  allMeasurementCheckIns: Maybe<MeasurementCheckInsConnection>;
  /** Reads and enables pagination through a set of `MedicationCheckIn`. */
  allMedicationCheckIns: Maybe<MedicationCheckInsConnection>;
  allMembers: Maybe<MemberConnection>;
  /** Reads and enables pagination through a set of `Message`. */
  allMessages: Maybe<MessagesConnection>;
  /** Reads and enables pagination through a set of `ObjectDetection`. */
  allObjectDetections: Maybe<ObjectDetectionsConnection>;
  /** Reads and enables pagination through a set of `PatientMembershipConfig`. */
  allPatientMembershipConfigs: Maybe<PatientMembershipConfigsConnection>;
  /** Reads and enables pagination through a set of `Patient`. */
  allPatients: Maybe<PatientsConnection>;
  /** Reads and enables pagination through a set of `PatientStatus`. */
  allPatientStatuses: Maybe<PatientStatusesConnection>;
  /** Reads and enables pagination through a set of `PatientStatusValue`. */
  allPatientStatusValues: Maybe<PatientStatusValuesConnection>;
  /** Reads and enables pagination through a set of `PauseReason`. */
  allPauseReasons: Maybe<PauseReasonsConnection>;
  /** Reads and enables pagination through a set of `Pause`. */
  allPauses: Maybe<PausesConnection>;
  /** Reads and enables pagination through a set of `PaymentSetup`. */
  allPaymentSetups: Maybe<PaymentSetupsConnection>;
  /** Reads and enables pagination through a set of `PrivilegedAction`. */
  allPrivilegedActions: Maybe<PrivilegedActionsConnection>;
  /** Reads and enables pagination through a set of `ProgramMfaConfig`. */
  allProgramMfaConfigs: Maybe<ProgramMfaConfigsConnection>;
  /** Reads and enables pagination through a set of `ProgramOutreachSubmission`. */
  allProgramOutreachSubmissions: Maybe<ProgramOutreachSubmissionsConnection>;
  /** Reads and enables pagination through a set of `ProgramRewardConfig`. */
  allProgramRewardConfigs: Maybe<ProgramRewardConfigsConnection>;
  /** Reads and enables pagination through a set of `ProgramReward`. */
  allProgramRewards: Maybe<ProgramRewardsConnection>;
  /** Reads and enables pagination through a set of `Program`. */
  allPrograms: Maybe<ProgramsConnection>;
  /** Reads and enables pagination through a set of `ProgramTemplate`. */
  allProgramTemplates: Maybe<ProgramTemplatesConnection>;
  /** Reads and enables pagination through a set of `ProspectStatus`. */
  allProspectStatuses: Maybe<ProspectStatusesConnection>;
  /** Reads and enables pagination through a set of `ProspectStatusValue`. */
  allProspectStatusValues: Maybe<ProspectStatusValuesConnection>;
  /** Reads and enables pagination through a set of `PushNotification`. */
  allPushNotifications: Maybe<PushNotificationsConnection>;
  /** Reads and enables pagination through a set of `PushToken`. */
  allPushTokens: Maybe<PushTokensConnection>;
  /** Reads and enables pagination through a set of `RawIncomingDatum`. */
  allRawIncomingData: Maybe<RawIncomingDataConnection>;
  /** Reads and enables pagination through a set of `ReminderConfig`. */
  allReminderConfigs: Maybe<ReminderConfigsConnection>;
  /** Reads and enables pagination through a set of `ReminderMessage`. */
  allReminderMessages: Maybe<ReminderMessagesConnection>;
  /** Reads and enables pagination through a set of `Reminder`. */
  allReminders: Maybe<RemindersConnection>;
  /** Reads and enables pagination through a set of `RewardPeriodConfig`. */
  allRewardPeriodConfigs: Maybe<RewardPeriodConfigsConnection>;
  /** Reads and enables pagination through a set of `RewardPeriod`. */
  allRewardPeriods: Maybe<RewardPeriodsConnection>;
  allRewardPeriodTransactions: Maybe<RewardPeriodTransactionConnection>;
  /** Reads and enables pagination through a set of `SmsAutoResponder`. */
  allSmsAutoResponders: Maybe<SmsAutoRespondersConnection>;
  /** Reads and enables pagination through a set of `SmsOutreachMessage`. */
  allSmsOutreachMessages: Maybe<SmsOutreachMessagesConnection>;
  /** Reads and enables pagination through a set of `SmsOutreachMessageTemplate`. */
  allSmsOutreachMessageTemplates: Maybe<SmsOutreachMessageTemplatesConnection>;
  /** Reads and enables pagination through a set of `SmsOutreachRecipient`. */
  allSmsOutreachRecipients: Maybe<SmsOutreachRecipientsConnection>;
  /** Reads and enables pagination through a set of `TimedObject`. */
  allTimedObjects: Maybe<TimedObjectsConnection>;
  /** Reads and enables pagination through a set of `TimezoneRecord`. */
  allTimezoneRecords: Maybe<TimezoneRecordsConnection>;
  /** Reads and enables pagination through a set of `WalkthroughPage`. */
  allWalkthroughPages: Maybe<WalkthroughPagesConnection>;
  /** Reads and enables pagination through a set of `Walkthrough`. */
  allWalkthroughs: Maybe<WalkthroughsConnection>;
  /** Reads and enables pagination through a set of `WalkthroughSetupConfig`. */
  allWalkthroughSetupConfigs: Maybe<WalkthroughSetupConfigsConnection>;
  /** Reads and enables pagination through a set of `WalkthroughSetup`. */
  allWalkthroughSetups: Maybe<WalkthroughSetupsConnection>;
  /** Reads and enables pagination through a set of `WalkthroughSummary`. */
  allWalkthroughSummaries: Maybe<WalkthroughSummariesConnection>;
  /** Reads and enables pagination through a set of `WinbackRewardConfig`. */
  allWinbackRewardConfigs: Maybe<WinbackRewardConfigsConnection>;
  /** Reads and enables pagination through a set of `WinbackRewardOpportunity`. */
  allWinbackRewardOpportunities: Maybe<WinbackRewardOpportunitiesConnection>;
  availablePrograms: Maybe<Array<Maybe<Program>>>;
  bonusBehavior: Maybe<BonusBehavior>;
  /** Reads a single `BonusBehaviorSubmissionStatus` using its globally unique `ID`. */
  bonusBehaviorSubmissionStatus: Maybe<BonusBehaviorSubmissionStatus>;
  bonusBehaviorSubmissionStatusByBonusBehaviorSubmissionIdAndCreatedAtAndValue: Maybe<BonusBehaviorSubmissionStatus>;
  bonusBehaviorSubmissionStatusById: Maybe<BonusBehaviorSubmissionStatus>;
  /** Reads a single `CheckIn` using its globally unique `ID`. */
  checkIn: Maybe<CheckIn>;
  checkInById: Maybe<CheckIn>;
  /** Reads a single `CueCheckIn` using its globally unique `ID`. */
  cueCheckIn: Maybe<CueCheckIn>;
  cueCheckInById: Maybe<CueCheckIn>;
  /** Gets the admin who was identified by our JWT. */
  currentAdmin: Maybe<Admin>;
  /** Gets the current authenticated patient id, or null if nonexistent. */
  currentAdminId: Maybe<Scalars['UUID']>;
  currentMetricRange: Maybe<MetricRange>;
  /** Generates the current or future reward period balance summary for a given patient */
  currentOrNextRewardPeriodBalance: Maybe<RewardPeriodBalanceDetail>;
  /** Gets the patient who was identified by our JWT. */
  currentPatient: Maybe<Patient>;
  /** Gets the current authenticated patient id, or null if nonexistent. */
  currentPatientId: Maybe<Scalars['UUID']>;
  /** Generates the current period balance summary for a given patient. */
  currentRewardPeriodBalance: Maybe<RewardPeriodBalanceDetail>;
  /** Reads a single `Customer` using its globally unique `ID`. */
  customer: Maybe<Customer>;
  customerById: Maybe<Customer>;
  customerByName: Maybe<Customer>;
  /** Reads a single `DebitCard` using its globally unique `ID`. */
  debitCard: Maybe<DebitCard>;
  /** Reads a single `DebitCardBalance` using its globally unique `ID`. */
  debitCardBalance: Maybe<DebitCardBalance>;
  debitCardBalanceById: Maybe<DebitCardBalance>;
  debitCardById: Maybe<DebitCard>;
  /** Reads a single `Device` using its globally unique `ID`. */
  device: Maybe<Device>;
  deviceById: Maybe<Device>;
  deviceDetails: Maybe<DeviceDetails>;
  dialysisAppointmentSchedule: Maybe<DialysisAppointmentScheduleSummary>;
  dialysisAppointmentSchedules: Array<DialysisAppointmentScheduleSummary>;
  emailAddress: Maybe<EmailAddress>;
  extensionJobStatus: Maybe<ExtensionJobStatus>;
  features: Array<Feature>;
  generateSignedUrl: Maybe<GenerateSignedUrlPayload>;
  getAllProspectJobs: Maybe<Array<Maybe<ProspectJob>>>;
  getAppointmentById: Maybe<Appointment>;
  getAppointments: Maybe<AppointmentConnection>;
  getBonusBehaviorPagesByPageset: Maybe<Array<Maybe<BonusBehaviorPage>>>;
  getConfigsForProgram: Maybe<ProgramConfig>;
  getProspectById: Maybe<Prospect>;
  graduationJobStatus: Maybe<GraduationJobStatus>;
  /** Reads a single `Group` using its globally unique `ID`. */
  group: Maybe<Group>;
  groupById: Maybe<Group>;
  hasBonusBehaviors: Maybe<Scalars['Boolean']>;
  /** Determine whether the current accessor (patient or admin) has access to the given privilege on the given row in a table. */
  hasPrivilege: Maybe<Scalars['Boolean']>;
  hasRewardCardDetailsByMemberId: Scalars['Boolean'];
  /** Reads a single `Heartbeat` using its globally unique `ID`. */
  heartbeat: Maybe<Heartbeat>;
  heartbeatById: Maybe<Heartbeat>;
  /** Fetches Highlights By Member Id */
  highlightByMemberId: Maybe<Array<Maybe<Highlight>>>;
  /** Reads a single `HydrationCheckIn` using its globally unique `ID`. */
  hydrationCheckIn: Maybe<HydrationCheckIn>;
  hydrationCheckInById: Maybe<HydrationCheckIn>;
  ipAddress: Scalars['String'];
  isTimezone: Maybe<Scalars['Boolean']>;
  localReminderNotifications: Maybe<Array<Maybe<LocalReminderNotification>>>;
  /** Reads a single `MarvMigration` using its globally unique `ID`. */
  marvMigration: Maybe<MarvMigration>;
  marvMigrationByLevelAndNamespace: Maybe<MarvMigration>;
  /** Reads a single `MealCheckIn` using its globally unique `ID`. */
  mealCheckIn: Maybe<MealCheckIn>;
  mealCheckInById: Maybe<MealCheckIn>;
  /** Reads a single `MeasurementCheckIn` using its globally unique `ID`. */
  measurementCheckIn: Maybe<MeasurementCheckIn>;
  measurementCheckInById: Maybe<MeasurementCheckIn>;
  /** Reads a single `MedicationCheckIn` using its globally unique `ID`. */
  medicationCheckIn: Maybe<MedicationCheckIn>;
  medicationCheckInById: Maybe<MedicationCheckIn>;
  member: Maybe<Member>;
  memberPaymentOption: Maybe<PaymentOption>;
  memberSecurityQuestions: Maybe<Array<MemberSecurityQuestion>>;
  memberTimelineEvents: Maybe<Array<Maybe<MemberTimelineEvent>>>;
  /** Reads a single `Message` using its globally unique `ID`. */
  message: Maybe<Message>;
  messageByExternalId: Maybe<Message>;
  messageById: Maybe<Message>;
  name: Maybe<Name>;
  /** Fetches an object given its globally unique `ID`. */
  node: Maybe<Node>;
  /** The root query type must be a `Node` to work well with Relay 1 mutations. This just resolves to `query`. */
  nodeId: Scalars['ID'];
  /** Reads a single `ObjectDetection` using its globally unique `ID`. */
  objectDetection: Maybe<ObjectDetection>;
  objectDetectionById: Maybe<ObjectDetection>;
  /** Reads a single `Patient` using its globally unique `ID`. */
  patient: Maybe<Patient>;
  patientById: Maybe<Patient>;
  /** Reads a single `PatientMembershipConfig` using its globally unique `ID`. */
  patientMembershipConfig: Maybe<PatientMembershipConfig>;
  patientMembershipConfigById: Maybe<PatientMembershipConfig>;
  /** Reads a single `PatientStatus` using its globally unique `ID`. */
  patientStatus: Maybe<PatientStatus>;
  patientStatusById: Maybe<PatientStatus>;
  patientStatusByPatientIdAndCreatedAtAndValue: Maybe<PatientStatus>;
  /** Reads a single `PatientStatusValue` using its globally unique `ID`. */
  patientStatusValue: Maybe<PatientStatusValue>;
  patientStatusValueById: Maybe<PatientStatusValue>;
  patientStatusValueByName: Maybe<PatientStatusValue>;
  /** Reads a single `Pause` using its globally unique `ID`. */
  pause: Maybe<Pause>;
  pauseById: Maybe<Pause>;
  /** Reads a single `PauseReason` using its globally unique `ID`. */
  pauseReason: Maybe<PauseReason>;
  pauseReasonById: Maybe<PauseReason>;
  pauseReasonByValue: Maybe<PauseReason>;
  /** Reads a single `PaymentSetup` using its globally unique `ID`. */
  paymentSetup: Maybe<PaymentSetup>;
  paymentSetupById: Maybe<PaymentSetup>;
  phoneNumber: Maybe<PhoneNumber>;
  /** Reads a single `PrivilegedAction` using its globally unique `ID`. */
  privilegedAction: Maybe<PrivilegedAction>;
  privilegedActionById: Maybe<PrivilegedAction>;
  privilegedActionByName: Maybe<PrivilegedAction>;
  /** Reads a single `Program` using its globally unique `ID`. */
  program: Maybe<Program>;
  programById: Maybe<Program>;
  programByProgramCode: Maybe<Program>;
  /** Reads a single `ProgramMfaConfig` using its globally unique `ID`. */
  programMfaConfig: Maybe<ProgramMfaConfig>;
  programMfaConfigById: Maybe<ProgramMfaConfig>;
  programMfaConfigByProgramId: Maybe<ProgramMfaConfig>;
  /** Reads a single `ProgramOutreachSubmission` using its globally unique `ID`. */
  programOutreachSubmission: Maybe<ProgramOutreachSubmission>;
  programOutreachSubmissionById: Maybe<ProgramOutreachSubmission>;
  programPaymentOptions: Maybe<Array<Maybe<PaymentOption>>>;
  /** Reads a single `ProgramReward` using its globally unique `ID`. */
  programReward: Maybe<ProgramReward>;
  programRewardById: Maybe<ProgramReward>;
  /** Reads a single `ProgramRewardConfig` using its globally unique `ID`. */
  programRewardConfig: Maybe<ProgramRewardConfig>;
  programRewardConfigById: Maybe<ProgramRewardConfig>;
  programRewardConfigByName: Maybe<ProgramRewardConfig>;
  /** Reads a single `ProgramTemplate` using its globally unique `ID`. */
  programTemplate: Maybe<ProgramTemplate>;
  programTemplateById: Maybe<ProgramTemplate>;
  programTemplateByName: Maybe<ProgramTemplate>;
  /** Reads a single `ProspectStatus` using its globally unique `ID`. */
  prospectStatus: Maybe<ProspectStatus>;
  prospectStatusById: Maybe<ProspectStatus>;
  prospectStatusByProspectIdAndCreatedAtAndValue: Maybe<ProspectStatus>;
  /** Reads a single `ProspectStatusValue` using its globally unique `ID`. */
  prospectStatusValue: Maybe<ProspectStatusValue>;
  prospectStatusValueById: Maybe<ProspectStatusValue>;
  prospectStatusValueByName: Maybe<ProspectStatusValue>;
  /** Reads a single `PushNotification` using its globally unique `ID`. */
  pushNotification: Maybe<PushNotification>;
  pushNotificationById: Maybe<PushNotification>;
  /** Reads a single `PushToken` using its globally unique `ID`. */
  pushToken: Maybe<PushToken>;
  pushTokenById: Maybe<PushToken>;
  /**
   * Exposes the root query type nested one level down. This is helpful for Relay 1
   * which can only query top level fields if they are in a particular form.
   */
  query: Query;
  /** Reads a single `RawIncomingDatum` using its globally unique `ID`. */
  rawIncomingDatum: Maybe<RawIncomingDatum>;
  rawIncomingDatumById: Maybe<RawIncomingDatum>;
  /** Reads a single `Reminder` using its globally unique `ID`. */
  reminder: Maybe<Reminder>;
  reminderById: Maybe<Reminder>;
  /** Reads a single `ReminderConfig` using its globally unique `ID`. */
  reminderConfig: Maybe<ReminderConfig>;
  reminderConfigById: Maybe<ReminderConfig>;
  /** Reads a single `ReminderMessage` using its globally unique `ID`. */
  reminderMessage: Maybe<ReminderMessage>;
  reminderMessageById: Maybe<ReminderMessage>;
  requestMfaPinReset: Maybe<RequestMfaPinResetPayload>;
  rewardCardDetailsByMemberId: Maybe<RewardCardDetails>;
  rewardCardMessage: Maybe<Scalars['String']>;
  /** Reads a single `RewardPeriod` using its globally unique `ID`. */
  rewardPeriod: Maybe<RewardPeriod>;
  rewardPeriodAndTransactions: Maybe<RewardPeriodAndTransactions>;
  rewardPeriodBalanceByRewardPeriodId: Maybe<RewardPeriodBalanceDetail>;
  rewardPeriodBalances: Maybe<RewardPeriodBalancesConnection>;
  rewardPeriodById: Maybe<RewardPeriod>;
  /** Reads a single `RewardPeriodConfig` using its globally unique `ID`. */
  rewardPeriodConfig: Maybe<RewardPeriodConfig>;
  rewardPeriodConfigById: Maybe<RewardPeriodConfig>;
  search: Maybe<SearchResult>;
  searchByValues: Maybe<SearchResult>;
  /** Reads a single `SmsAutoResponder` using its globally unique `ID`. */
  smsAutoResponder: Maybe<SmsAutoResponder>;
  smsAutoResponderById: Maybe<SmsAutoResponder>;
  /** Reads a single `SmsOutreachMessage` using its globally unique `ID`. */
  smsOutreachMessage: Maybe<SmsOutreachMessage>;
  smsOutreachMessageById: Maybe<SmsOutreachMessage>;
  /** Reads a single `SmsOutreachMessageTemplate` using its globally unique `ID`. */
  smsOutreachMessageTemplate: Maybe<SmsOutreachMessageTemplate>;
  smsOutreachMessageTemplateById: Maybe<SmsOutreachMessageTemplate>;
  /** Reads a single `SmsOutreachRecipient` using its globally unique `ID`. */
  smsOutreachRecipient: Maybe<SmsOutreachRecipient>;
  smsOutreachRecipientById: Maybe<SmsOutreachRecipient>;
  smsOutreachRecipientByPhoneNumber: Maybe<SmsOutreachRecipient>;
  /** Calculates the number of perfect task days for a member */
  streakDayCount: Maybe<Scalars['Int']>;
  /** Get the support details for a given patient. */
  supportDetails: Maybe<SupportDetailsObject>;
  /** Reads a single `TimedObject` using its globally unique `ID`. */
  timedObject: Maybe<TimedObject>;
  timedObjectById: Maybe<TimedObject>;
  /** Reads a single `TimezoneRecord` using its globally unique `ID`. */
  timezoneRecord: Maybe<TimezoneRecord>;
  timezoneRecordById: Maybe<TimezoneRecord>;
  validateAddress: Maybe<ValidateAddressPayload>;
  /** Reads a single `Walkthrough` using its globally unique `ID`. */
  walkthrough: Maybe<Walkthrough>;
  walkthroughById: Maybe<Walkthrough>;
  /** Reads a single `WalkthroughPage` using its globally unique `ID`. */
  walkthroughPage: Maybe<WalkthroughPage>;
  walkthroughPageById: Maybe<WalkthroughPage>;
  walkthroughPages: Maybe<Array<Maybe<WalkthroughPage>>>;
  /** Reads a single `WalkthroughSetup` using its globally unique `ID`. */
  walkthroughSetup: Maybe<WalkthroughSetup>;
  walkthroughSetupById: Maybe<WalkthroughSetup>;
  /** Reads a single `WalkthroughSetupConfig` using its globally unique `ID`. */
  walkthroughSetupConfig: Maybe<WalkthroughSetupConfig>;
  walkthroughSetupConfigById: Maybe<WalkthroughSetupConfig>;
  walkthroughSummaries: Maybe<Array<Maybe<WalkthroughSummary>>>;
  /** Reads a single `WalkthroughSummary` using its globally unique `ID`. */
  walkthroughSummary: Maybe<WalkthroughSummary>;
  walkthroughSummaryById: Maybe<WalkthroughSummary>;
  /** Reads a single `WinbackRewardConfig` using its globally unique `ID`. */
  winbackRewardConfig: Maybe<WinbackRewardConfig>;
  winbackRewardConfigByChallengeTypeKey: Maybe<WinbackRewardConfig>;
  winbackRewardConfigById: Maybe<WinbackRewardConfig>;
  /** Reads a single `WinbackRewardOpportunity` using its globally unique `ID`. */
  winbackRewardOpportunity: Maybe<WinbackRewardOpportunity>;
  winbackRewardOpportunityById: Maybe<WinbackRewardOpportunity>;
  winbackRewardOpportunityByPatientIdAndChallengeId: Maybe<WinbackRewardOpportunity>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAccountTransactionArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryAccountTransactionByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryActionLogArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryActionLogByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryActiveIdentityTagsByWellthIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryAddressArgs {
  id?: InputMaybe<Scalars['UUID']>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAdminArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryAdminByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryAdminRoleArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryAdminRoleByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryAdminRoleByNameArgs {
  name: Scalars['String'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryAdminRolePrivilegedActionArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryAdminRolePrivilegedActionByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllAccountTransactionsArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AccountTransactionCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountTransactionsOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllActionLogsArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ActionLogCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ActionLogsOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllAdminRolePrivilegedActionsArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AdminRolePrivilegedActionCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AdminRolePrivilegedActionsOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllAdminRolesArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AdminRoleCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AdminRolesOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllAdminsArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AdminCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AdminsOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllBonusBehaviorsArgs {
  memberId: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllBonusBehaviorSubmissionPayloadsArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  statuses: Array<InputMaybe<BonusBehaviorSubmissionStatusValue>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllBonusBehaviorSubmissionStatusesArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BonusBehaviorSubmissionStatusCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BonusBehaviorSubmissionStatusesOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllChallengeRewardsArgs {
  memberId: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllCheckInsArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CheckInCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CheckInsOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllCueCheckInsArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CueCheckInCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CueCheckInsOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllCustomersArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CustomerCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CustomersOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllDebitCardBalancesArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DebitCardBalanceCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DebitCardBalancesOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllDebitCardsArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DebitCardCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DebitCardsOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllDevicesArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DeviceCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DevicesOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllGroupsArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GroupCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllHeartbeatsArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<HeartbeatCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<HeartbeatsOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllHydrationCheckInsArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<HydrationCheckInCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<HydrationCheckInsOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllMarvMigrationsArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MarvMigrationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MarvMigrationsOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllMarvMigrationsLocksArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MarvMigrationsLockCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MarvMigrationsLocksOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllMealCheckInsArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MealCheckInCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MealCheckInsOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllMeasurementCheckInsArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MeasurementCheckInCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MeasurementCheckInsOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllMedicationCheckInsArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MedicationCheckInCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MedicationCheckInsOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllMembersArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MemberCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MemberOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllMessagesArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MessageCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MessagesOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllObjectDetectionsArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ObjectDetectionCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ObjectDetectionsOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllPatientMembershipConfigsArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientMembershipConfigCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientMembershipConfigsOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllPatientsArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientsOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllPatientStatusesArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientStatusCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientStatusesOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllPatientStatusValuesArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientStatusValueCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientStatusValuesOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllPauseReasonsArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PauseReasonCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PauseReasonsOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllPausesArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PauseCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PausesOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllPaymentSetupsArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PaymentSetupCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentSetupsOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllPrivilegedActionsArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PrivilegedActionCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PrivilegedActionsOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllProgramMfaConfigsArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProgramMfaConfigCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProgramMfaConfigsOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllProgramOutreachSubmissionsArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProgramOutreachSubmissionCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProgramOutreachSubmissionsOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllProgramRewardConfigsArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProgramRewardConfigCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProgramRewardConfigsOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllProgramRewardsArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProgramRewardCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProgramRewardsOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllProgramsArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProgramCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProgramsOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllProgramTemplatesArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProgramTemplateCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProgramTemplatesOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllProspectStatusesArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProspectStatusCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProspectStatusesOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllProspectStatusValuesArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProspectStatusValueCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProspectStatusValuesOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllPushNotificationsArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PushNotificationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PushNotificationsOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllPushTokensArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PushTokenCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PushTokensOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllRawIncomingDataArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RawIncomingDatumCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RawIncomingDataOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllReminderConfigsArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ReminderConfigCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReminderConfigsOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllReminderMessagesArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ReminderMessageCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReminderMessagesOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllRemindersArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ReminderCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RemindersOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllRewardPeriodConfigsArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RewardPeriodConfigCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RewardPeriodConfigsOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllRewardPeriodsArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RewardPeriodCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RewardPeriodsOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllRewardPeriodTransactionsArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RewardPeriodTransactionCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RewardPeriodTransactionOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllSmsAutoRespondersArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SmsAutoResponderCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SmsAutoRespondersOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllSmsOutreachMessagesArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SmsOutreachMessageCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SmsOutreachMessagesOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllSmsOutreachMessageTemplatesArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SmsOutreachMessageTemplateCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SmsOutreachMessageTemplatesOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllSmsOutreachRecipientsArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SmsOutreachRecipientCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SmsOutreachRecipientsOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllTimedObjectsArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TimedObjectCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimedObjectsOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllTimezoneRecordsArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TimezoneRecordCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimezoneRecordsOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllWalkthroughPagesArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<WalkthroughPageCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WalkthroughPagesOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllWalkthroughsArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<WalkthroughCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WalkthroughsOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllWalkthroughSetupConfigsArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<WalkthroughSetupConfigCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WalkthroughSetupConfigsOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllWalkthroughSetupsArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<WalkthroughSetupCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WalkthroughSetupsOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllWalkthroughSummariesArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<WalkthroughSummaryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WalkthroughSummariesOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllWinbackRewardConfigsArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<WinbackRewardConfigCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WinbackRewardConfigsOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAllWinbackRewardOpportunitiesArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<WinbackRewardOpportunityCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WinbackRewardOpportunitiesOrderBy>>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryAvailableProgramsArgs {
  limit?: InputMaybe<Scalars['Int']>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryBonusBehaviorArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryBonusBehaviorSubmissionStatusArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryBonusBehaviorSubmissionStatusByBonusBehaviorSubmissionIdAndCreatedAtAndValueArgs {
  bonusBehaviorSubmissionId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  value: Scalars['String'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryBonusBehaviorSubmissionStatusByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryCheckInArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryCheckInByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryCueCheckInArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryCueCheckInByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryCurrentMetricRangeArgs {
  name: MetricName;
  wellthId: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryCurrentRewardPeriodBalanceArgs {
  patientId?: InputMaybe<Scalars['UUID']>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryCustomerArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryCustomerByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryCustomerByNameArgs {
  name: Scalars['String'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryDebitCardArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryDebitCardBalanceArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryDebitCardBalanceByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryDebitCardByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryDeviceArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryDeviceByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryDeviceDetailsArgs {
  wellthId: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryDialysisAppointmentScheduleArgs {
  scheduleJob: Scalars['String'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryDialysisAppointmentSchedulesArgs {
  memberId: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryEmailAddressArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryExtensionJobStatusArgs {
  input: ExtensionJobStatusInput;
}


/** The root query type which gives access points into the data universe. */
export interface QueryFeaturesArgs {
  wellthId: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryGenerateSignedUrlArgs {
  input: GenerateSignedUrlInput;
}


/** The root query type which gives access points into the data universe. */
export interface QueryGetAllProspectJobsArgs {
  limit?: InputMaybe<Scalars['Int']>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryGetAppointmentByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryGetAppointmentsArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition: AppointmentsCondition;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryGetBonusBehaviorPagesByPagesetArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryGetConfigsForProgramArgs {
  programCode?: InputMaybe<Scalars['String']>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryGetProspectByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryGraduationJobStatusArgs {
  input: GraduationJobStatusInput;
}


/** The root query type which gives access points into the data universe. */
export interface QueryGroupArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryGroupByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryHasBonusBehaviorsArgs {
  memberId: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryHasPrivilegeArgs {
  adminOwnerId?: InputMaybe<Scalars['UUID']>;
  caller?: InputMaybe<Scalars['Whoami']>;
  patientOwnerId?: InputMaybe<Scalars['UUID']>;
  privilege?: InputMaybe<PrivilegeType>;
  targetTableName?: InputMaybe<Scalars['String']>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryHasRewardCardDetailsByMemberIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryHeartbeatArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryHeartbeatByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryHighlightByMemberIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryHydrationCheckInArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryHydrationCheckInByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryIsTimezoneArgs {
  tz?: InputMaybe<Scalars['String']>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryLocalReminderNotificationsArgs {
  limit?: InputMaybe<Scalars['Int']>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryMarvMigrationArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryMarvMigrationByLevelAndNamespaceArgs {
  level: Scalars['Int'];
  namespace: Scalars['String'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryMealCheckInArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryMealCheckInByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryMeasurementCheckInArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryMeasurementCheckInByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryMedicationCheckInArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryMedicationCheckInByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryMemberArgs {
  id?: InputMaybe<Scalars['UUID']>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryMemberPaymentOptionArgs {
  condition: PaymentOptionCondition;
}


/** The root query type which gives access points into the data universe. */
export interface QueryMemberSecurityQuestionsArgs {
  memberId: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryMemberTimelineEventsArgs {
  excludeEventCriteria?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  startTimestamp?: InputMaybe<Scalars['String']>;
  wellthId?: InputMaybe<Scalars['UUID']>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryMessageArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryMessageByExternalIdArgs {
  externalId: Scalars['String'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryMessageByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryNameArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryNodeArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryObjectDetectionArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryObjectDetectionByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryPatientArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryPatientByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryPatientMembershipConfigArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryPatientMembershipConfigByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryPatientStatusArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryPatientStatusByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryPatientStatusByPatientIdAndCreatedAtAndValueArgs {
  createdAt: Scalars['Datetime'];
  patientId: Scalars['UUID'];
  value: Scalars['String'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryPatientStatusValueArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryPatientStatusValueByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryPatientStatusValueByNameArgs {
  name: Scalars['String'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryPauseArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryPauseByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryPauseReasonArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryPauseReasonByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryPauseReasonByValueArgs {
  value: Scalars['String'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryPaymentSetupArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryPaymentSetupByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryPhoneNumberArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryPrivilegedActionArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryPrivilegedActionByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryPrivilegedActionByNameArgs {
  name: Scalars['String'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryProgramArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryProgramByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryProgramByProgramCodeArgs {
  programCode: Scalars['String'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryProgramMfaConfigArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryProgramMfaConfigByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryProgramMfaConfigByProgramIdArgs {
  programId: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryProgramOutreachSubmissionArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryProgramOutreachSubmissionByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryProgramPaymentOptionsArgs {
  condition: ProgramPaymentOptionsCondition;
}


/** The root query type which gives access points into the data universe. */
export interface QueryProgramRewardArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryProgramRewardByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryProgramRewardConfigArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryProgramRewardConfigByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryProgramRewardConfigByNameArgs {
  name: Scalars['String'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryProgramTemplateArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryProgramTemplateByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryProgramTemplateByNameArgs {
  name: Scalars['String'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryProspectStatusArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryProspectStatusByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryProspectStatusByProspectIdAndCreatedAtAndValueArgs {
  createdAt: Scalars['Datetime'];
  prospectId: Scalars['UUID'];
  value: Scalars['String'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryProspectStatusValueArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryProspectStatusValueByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryProspectStatusValueByNameArgs {
  name: Scalars['String'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryPushNotificationArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryPushNotificationByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryPushTokenArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryPushTokenByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryRawIncomingDatumArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryRawIncomingDatumByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryReminderArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryReminderByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryReminderConfigArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryReminderConfigByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryReminderMessageArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryReminderMessageByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryRequestMfaPinResetArgs {
  memberId: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryRewardCardDetailsByMemberIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryRewardCardMessageArgs {
  id?: InputMaybe<Scalars['UUID']>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryRewardPeriodArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryRewardPeriodAndTransactionsArgs {
  fromDate?: InputMaybe<Scalars['Date']>;
  memberId?: InputMaybe<Scalars['UUID']>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryRewardPeriodBalanceByRewardPeriodIdArgs {
  rewardPeriodId: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryRewardPeriodBalancesArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RewardPeriodBalancesCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  patientId?: InputMaybe<Scalars['UUID']>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryRewardPeriodByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryRewardPeriodConfigArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryRewardPeriodConfigByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QuerySearchArgs {
  searchTerm: Scalars['String'];
}


/** The root query type which gives access points into the data universe. */
export interface QuerySearchByValuesArgs {
  input: SearchByValueInput;
}


/** The root query type which gives access points into the data universe. */
export interface QuerySmsAutoResponderArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QuerySmsAutoResponderByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QuerySmsOutreachMessageArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QuerySmsOutreachMessageByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QuerySmsOutreachMessageTemplateArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QuerySmsOutreachMessageTemplateByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QuerySmsOutreachRecipientArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QuerySmsOutreachRecipientByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QuerySmsOutreachRecipientByPhoneNumberArgs {
  phoneNumber: Scalars['String'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryStreakDayCountArgs {
  patientId?: InputMaybe<Scalars['UUID']>;
}


/** The root query type which gives access points into the data universe. */
export interface QuerySupportDetailsArgs {
  patientId?: InputMaybe<Scalars['UUID']>;
}


/** The root query type which gives access points into the data universe. */
export interface QueryTimedObjectArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryTimedObjectByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryTimezoneRecordArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryTimezoneRecordByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryValidateAddressArgs {
  input: ValidateAddressInput;
}


/** The root query type which gives access points into the data universe. */
export interface QueryWalkthroughArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryWalkthroughByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryWalkthroughPageArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryWalkthroughPageByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryWalkthroughPagesArgs {
  language: Scalars['String'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryWalkthroughSetupArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryWalkthroughSetupByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryWalkthroughSetupConfigArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryWalkthroughSetupConfigByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryWalkthroughSummariesArgs {
  language: Scalars['String'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryWalkthroughSummaryArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryWalkthroughSummaryByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryWinbackRewardConfigArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryWinbackRewardConfigByChallengeTypeKeyArgs {
  challengeTypeKey: Scalars['String'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryWinbackRewardConfigByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryWinbackRewardOpportunityArgs {
  nodeId: Scalars['ID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryWinbackRewardOpportunityByIdArgs {
  id: Scalars['UUID'];
}


/** The root query type which gives access points into the data universe. */
export interface QueryWinbackRewardOpportunityByPatientIdAndChallengeIdArgs {
  challengeId: Scalars['String'];
  patientId: Scalars['UUID'];
}

/** An object with a globally unique `ID`. */
export interface Node {
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
}

/** A account_transaction, which contains details of how a patient's reward balance should have changed during a period. */
export interface AccountTransaction extends Node {
  __typename: 'AccountTransaction';
  absoluteAmount: Maybe<Scalars['Int']>;
  /** The amount of money (positive is a credit, negative is a debit) added to the account's balance during this transaction. */
  amount: Scalars['BigFloat'];
  createdAt: Scalars['Datetime'];
  /** The currency of this transaction. */
  currency: Currency;
  /** The date at which this account_transaction occurred. */
  date: Scalars['Date'];
  detail: Maybe<TransactionDetailEnum>;
  id: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** An optional freetext note about this transaction. */
  note: Maybe<Scalars['String']>;
  /** Reads a single `Patient` that is related to this `AccountTransaction`. */
  patientByPatientId: Maybe<Patient>;
  /** The patient which owns this account_transaction. */
  patientId: Scalars['UUID'];
  /** Reads and enables pagination through a set of `ProgramReward`. */
  programRewardsByAccountTransactionId: ProgramRewardsConnection;
  /** The reason for which this transaction occurred. */
  reason: AccountTransactionReason;
  updatedAt: Scalars['Datetime'];
  warehouseRowId: Scalars['BigInt'];
  /** Reads and enables pagination through a set of `WinbackRewardOpportunity`. */
  winbackRewardOpportunitiesByAccountTransactionId: WinbackRewardOpportunitiesConnection;
}


/** A account_transaction, which contains details of how a patient's reward balance should have changed during a period. */
export interface AccountTransactionProgramRewardsByAccountTransactionIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProgramRewardCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProgramRewardsOrderBy>>;
}


/** A account_transaction, which contains details of how a patient's reward balance should have changed during a period. */
export interface AccountTransactionWinbackRewardOpportunitiesByAccountTransactionIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<WinbackRewardOpportunityCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WinbackRewardOpportunitiesOrderBy>>;
}

export enum Currency {
  Eur = 'EUR',
  Usd = 'USD'
}

export enum TransactionDetailEnum {
  BloodPressureControl = 'BLOOD_PRESSURE_CONTROL',
  BloodPressureTest = 'BLOOD_PRESSURE_TEST',
  BreastCancerScreening = 'BREAST_CANCER_SCREENING',
  CervicalCancerScreening = 'CERVICAL_CANCER_SCREENING',
  ColonCancerScreening = 'COLON_CANCER_SCREENING',
  CounselorCheckin = 'COUNSELOR_CHECKIN',
  DiabeticEyeExam = 'DIABETIC_EYE_EXAM',
  DilatedEyeExam = 'DILATED_EYE_EXAM',
  EyeExam = 'EYE_EXAM',
  FluShot = 'FLU_SHOT',
  FollowupVisit = 'FOLLOWUP_VISIT',
  HarmReductionCheckin = 'HARM_REDUCTION_CHECKIN',
  Hba1CControl = 'HBA1C_CONTROL',
  Hba1CTest = 'HBA1C_TEST',
  HolidayBonus = 'HOLIDAY_BONUS',
  KidneyHealthEval = 'KIDNEY_HEALTH_EVAL',
  OrderingOfHarmReductionSupplies = 'ORDERING_OF_HARM_REDUCTION_SUPPLIES',
  PcpVisit = 'PCP_VISIT',
  WelcomeToWellth = 'WELCOME_TO_WELLTH'
}

export interface Patient extends Node {
  __typename: 'Patient';
  /** Reads and enables pagination through a set of `AccountTransaction`. */
  accountTransactionsByPatientId: AccountTransactionsConnection;
  /** Reads and enables pagination through a set of `ActionLog`. */
  actionLogsByPatientId: ActionLogsConnection;
  /** The Wellth Date of activation in the member's timezone at the moment of activation. */
  activationDate: Maybe<Scalars['Date']>;
  /** The member's timezone at the moment of activation. */
  activationTimezone: Maybe<Scalars['Timezone']>;
  activeDays: Maybe<Scalars['Int']>;
  adherence: Maybe<AdherenceSummary>;
  /** Reads a single `Admin` that is related to this `Patient`. */
  adminByEnrolledBy: Maybe<Admin>;
  appointments: Maybe<AppointmentConnection>;
  birthDate: Maybe<Scalars['Date']>;
  build: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `CheckIn`. */
  checkInsByPatientId: CheckInsConnection;
  checkInStreak: Scalars['Int'];
  createdAt: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `CueCheckIn`. */
  cueCheckInsByPatientId: CueCheckInsConnection;
  currentMetricRange: Maybe<MetricRange>;
  customerName: Scalars['String'];
  dayStreak: Scalars['Int'];
  /** Reads and enables pagination through a set of `DebitCardBalance`. */
  debitCardBalancesByPatientId: DebitCardBalancesConnection;
  /** Reads and enables pagination through a set of `DebitCard`. */
  debitCardsByPatientId: DebitCardsConnection;
  /** A free-form editable text field for relevant details about a patient that do not fit into other fields. */
  description: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `Device`. */
  devicesByPatientId: DevicesConnection;
  eligibilityEndDate: Maybe<Scalars['Date']>;
  email: Maybe<Scalars['String']>;
  enrolledBy: Maybe<Scalars['UUID']>;
  /** The Wellth Date of enrollment in the member's timezone at the moment of enrollment. */
  enrollmentDate: Maybe<Scalars['Date']>;
  /** The member's timezone at the moment of enrollment. */
  enrollmentTimezone: Maybe<Scalars['Timezone']>;
  /** The unique identifier given to the patient by our customer. */
  externalId: Maybe<Scalars['String']>;
  externalId2: Maybe<Scalars['String']>;
  features: Array<Feature>;
  firstName: Maybe<Scalars['String']>;
  fullName: Maybe<Scalars['String']>;
  getMixpanelEvents: Maybe<MixpanelEvents>;
  hasAppointments: Scalars['Boolean'];
  hasBonusBehaviors: Scalars['Boolean'];
  hasRewardCardDetails: Scalars['Boolean'];
  hasRewards: Scalars['Boolean'];
  /** Reads and enables pagination through a set of `Heartbeat`. */
  heartbeatsByPatientId: HeartbeatsConnection;
  highlights: Maybe<Array<Maybe<Highlight>>>;
  /** Reads and enables pagination through a set of `HydrationCheckIn`. */
  hydrationCheckInsByPatientId: HydrationCheckInsConnection;
  id: Scalars['UUID'];
  /** The Wellth Date of inactivation in the member's timezone at the moment of inactivation. */
  inactivationDate: Maybe<Scalars['Date']>;
  /** The member's timezone at the moment of inactivation. */
  inactivationTimezone: Maybe<Scalars['Timezone']>;
  introductionToWellth: Maybe<Scalars['String']>;
  ipAddress: Scalars['String'];
  isAutoPauseEnabled: Scalars['Boolean'];
  /** Whether the patient is receiving local notifications. */
  isLocalNotificationEnabled: Scalars['Boolean'];
  /** Whether the patient has completed the in-app product tour. */
  isProductTourCompleted: Scalars['Boolean'];
  /** Whether the product tour should always show for the patient when they open the app. */
  isProductTourRecurring: Scalars['Boolean'];
  /** Whether the patient has the ability to add/edit/delete all fields on all reminders in place ("open" mode). */
  isReminderEditingOpen: Scalars['Boolean'];
  /** Whether the patient is receiving sms notifications. */
  isReminderMessagingEnabled: Scalars['Boolean'];
  isRestfulPatient: Scalars['Boolean'];
  /** Whether the patient consents to the use of a wingperson(s). */
  isSidekickEnabled: Scalars['Boolean'];
  /** Whether the patient is a test patient; test patients should not receive payments, text messages, etc */
  isTestPatient: Scalars['Boolean'];
  language: LanguageCode;
  lastName: Maybe<Scalars['String']>;
  liveProgramDays: Maybe<Scalars['Int']>;
  maxStreak: Scalars['Int'];
  /** Reads and enables pagination through a set of `MealCheckIn`. */
  mealCheckInsByPatientId: MealCheckInsConnection;
  /** Reads and enables pagination through a set of `MeasurementCheckIn`. */
  measurementCheckInsByPatientId: MeasurementCheckInsConnection;
  /** The medicaid id of the person */
  medicaidId: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `MedicationCheckIn`. */
  medicationCheckInsByPatientId: MedicationCheckInsConnection;
  /** Reads and enables pagination through a set of `Message`. */
  messagesByPatientId: MessagesConnection;
  middleName: Maybe<Scalars['String']>;
  missedCheckinStreak: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `ObjectDetection`. */
  objectDetectionsByPatientId: ObjectDetectionsConnection;
  /** The Wellth Date of onboarding in the member's timezone at the moment of onboarding. */
  onboardingDate: Maybe<Scalars['Date']>;
  onboardingInformation: OnboardingInformation;
  /** The member's timezone at the moment of onboarding. */
  onboardingTimezone: Maybe<Scalars['Timezone']>;
  partialDayStreak: Scalars['Int'];
  /** Reads and enables pagination through a set of `PatientStatus`. */
  patientStatusesByPatientId: PatientStatusesConnection;
  /** Reads and enables pagination through a set of `Pause`. */
  pausesByPatientId: PausesConnection;
  /** The pause status of the patient at the current time. */
  pauseStatus: PauseStatus;
  paymentOptionsId: Maybe<Scalars['UUID']>;
  /** Reads and enables pagination through a set of `PaymentSetup`. */
  paymentSetupsByPatientId: PaymentSetupsConnection;
  personId: Maybe<Scalars['UUID']>;
  phoneNumber: Maybe<Scalars['String']>;
  platform: Maybe<Scalars['String']>;
  primaryAddress: Maybe<Address>;
  privacyPolicyURL: Scalars['String'];
  programCode: Scalars['String'];
  programNoteDetails: ProgramNoteDetails;
  /** Reads and enables pagination through a set of `ProgramReward`. */
  programRewardsByPatientId: ProgramRewardsConnection;
  prospectId: Scalars['UUID'];
  /** Reads and enables pagination through a set of `PushNotification`. */
  pushNotificationsByPatientId: PushNotificationsConnection;
  /** Reads and enables pagination through a set of `PushToken`. */
  pushTokensByPatientId: PushTokensConnection;
  /** Reads and enables pagination through a set of `ReminderMessage`. */
  reminderMessagesByPatientId: ReminderMessagesConnection;
  /** Reads and enables pagination through a set of `Reminder`. */
  remindersByPatientId: RemindersConnection;
  rewardCardDetails: Maybe<RewardCardDetails>;
  rewardCardMessage: Maybe<Scalars['String']>;
  rewardPeriodAndTransactions: Maybe<RewardPeriodAndTransactions>;
  rewardPeriodBalances: Maybe<RewardPeriodBalancesConnection>;
  /** Reads and enables pagination through a set of `RewardPeriod`. */
  rewardPeriodsByPatientId: RewardPeriodsConnection;
  rewardsCurrency: Currency;
  rewardsEarned: Scalars['Int'];
  rewardsEarnedPrecise: Scalars['String'];
  rewardsPotential: Scalars['Int'];
  secondaryPhoneNumber: Maybe<Scalars['String']>;
  selfServeEligible: Maybe<Scalars['Boolean']>;
  shortId: Scalars['String'];
  showRewardsMenu: Scalars['Boolean'];
  /** The name of the site where the patient was enrolled. */
  siteName: Maybe<Scalars['String']>;
  statusValue: Scalars['String'];
  termsConditionsURL: Scalars['String'];
  timezoneName: Scalars['String'];
  /** Reads and enables pagination through a set of `TimezoneRecord`. */
  timezoneRecordsByPatientId: TimezoneRecordsConnection;
  typeOfEnrollment: Maybe<Scalars['String']>;
  updatedAt: Scalars['Datetime'];
  version: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `WalkthroughSetup`. */
  walkthroughSetupsByPatientId: WalkthroughSetupsConnection;
  warehouseRowId: Scalars['BigInt'];
  wellthId: Scalars['String'];
  /** Reads and enables pagination through a set of `WinbackRewardOpportunity`. */
  winbackRewardOpportunitiesByPatientId: WinbackRewardOpportunitiesConnection;
}


export interface PatientAccountTransactionsByPatientIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AccountTransactionCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountTransactionsOrderBy>>;
}


export interface PatientActionLogsByPatientIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ActionLogCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ActionLogsOrderBy>>;
}


export interface PatientAdherenceArgs {
  endDate: Scalars['Date'];
  startDate: Scalars['Date'];
}


export interface PatientAppointmentsArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientAppointmentsCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}


export interface PatientCheckInsByPatientIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CheckInCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CheckInsOrderBy>>;
}


export interface PatientCueCheckInsByPatientIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CueCheckInCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CueCheckInsOrderBy>>;
}


export interface PatientCurrentMetricRangeArgs {
  name: MetricName;
}


export interface PatientDebitCardBalancesByPatientIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DebitCardBalanceCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DebitCardBalancesOrderBy>>;
}


export interface PatientDebitCardsByPatientIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DebitCardCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DebitCardsOrderBy>>;
}


export interface PatientDevicesByPatientIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DeviceCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DevicesOrderBy>>;
}


export interface PatientGetMixpanelEventsArgs {
  fromDate: Scalars['Date'];
  limit: Scalars['Int'];
  toDate: Scalars['Date'];
}


export interface PatientHeartbeatsByPatientIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<HeartbeatCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<HeartbeatsOrderBy>>;
}


export interface PatientHydrationCheckInsByPatientIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<HydrationCheckInCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<HydrationCheckInsOrderBy>>;
}


export interface PatientMealCheckInsByPatientIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MealCheckInCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MealCheckInsOrderBy>>;
}


export interface PatientMeasurementCheckInsByPatientIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MeasurementCheckInCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MeasurementCheckInsOrderBy>>;
}


export interface PatientMedicationCheckInsByPatientIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MedicationCheckInCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MedicationCheckInsOrderBy>>;
}


export interface PatientMessagesByPatientIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MessageCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MessagesOrderBy>>;
}


export interface PatientObjectDetectionsByPatientIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ObjectDetectionCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ObjectDetectionsOrderBy>>;
}


export interface PatientPatientStatusesByPatientIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientStatusCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientStatusesOrderBy>>;
}


export interface PatientPausesByPatientIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PauseCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PausesOrderBy>>;
}


export interface PatientPaymentSetupsByPatientIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PaymentSetupCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentSetupsOrderBy>>;
}


export interface PatientProgramRewardsByPatientIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProgramRewardCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProgramRewardsOrderBy>>;
}


export interface PatientPushNotificationsByPatientIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PushNotificationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PushNotificationsOrderBy>>;
}


export interface PatientPushTokensByPatientIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PushTokenCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PushTokensOrderBy>>;
}


export interface PatientReminderMessagesByPatientIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ReminderMessageCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReminderMessagesOrderBy>>;
}


export interface PatientRemindersByPatientIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ReminderCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RemindersOrderBy>>;
}


export interface PatientRewardPeriodAndTransactionsArgs {
  fromDate?: InputMaybe<Scalars['Date']>;
}


export interface PatientRewardPeriodBalancesArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientRewardPeriodBalancesCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}


export interface PatientRewardPeriodsByPatientIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RewardPeriodCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RewardPeriodsOrderBy>>;
}


export interface PatientTimezoneRecordsByPatientIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TimezoneRecordCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimezoneRecordsOrderBy>>;
}


export interface PatientWalkthroughSetupsByPatientIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<WalkthroughSetupCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WalkthroughSetupsOrderBy>>;
}


export interface PatientWinbackRewardOpportunitiesByPatientIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<WinbackRewardOpportunityCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WinbackRewardOpportunitiesOrderBy>>;
}

/**
 * A condition to be used against `AccountTransaction` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface AccountTransactionCondition {
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `currency` field. */
  currency?: InputMaybe<Currency>;
  /** Checks for equality with the object’s `date` field. */
  date?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `note` field. */
  note?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `patientId` field. */
  patientId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `reason` field. */
  reason?: InputMaybe<AccountTransactionReason>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `warehouseRowId` field. */
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

export enum AccountTransactionReason {
  AutoAdjustment = 'AUTO_ADJUSTMENT',
  BonusBehaviorCredit = 'BONUS_BEHAVIOR_CREDIT',
  ChallengeRewardCredit = 'CHALLENGE_REWARD_CREDIT',
  IncentiveCredit = 'INCENTIVE_CREDIT',
  LotteryTransfer = 'LOTTERY_TRANSFER',
  ManualAdjustment = 'MANUAL_ADJUSTMENT',
  OutgoingPayment = 'OUTGOING_PAYMENT',
  ProgramRewardCredit = 'PROGRAM_REWARD_CREDIT',
  RewardTransfer = 'REWARD_TRANSFER',
  Winback = 'WINBACK'
}

/** Methods to use when ordering `AccountTransaction`. */
export enum AccountTransactionsOrderBy {
  AmountAsc = 'AMOUNT_ASC',
  AmountDesc = 'AMOUNT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CurrencyAsc = 'CURRENCY_ASC',
  CurrencyDesc = 'CURRENCY_DESC',
  DateAsc = 'DATE_ASC',
  DateDesc = 'DATE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  NoteAsc = 'NOTE_ASC',
  NoteDesc = 'NOTE_DESC',
  PatientIdAsc = 'PATIENT_ID_ASC',
  PatientIdDesc = 'PATIENT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ReasonAsc = 'REASON_ASC',
  ReasonDesc = 'REASON_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  WarehouseRowIdAsc = 'WAREHOUSE_ROW_ID_ASC',
  WarehouseRowIdDesc = 'WAREHOUSE_ROW_ID_DESC'
}

/** A connection to a list of `AccountTransaction` values. */
export interface AccountTransactionsConnection {
  __typename: 'AccountTransactionsConnection';
  /** A list of edges which contains the `AccountTransaction` and cursor to aid in pagination. */
  edges: Array<AccountTransactionsEdge>;
  /** A list of `AccountTransaction` objects. */
  nodes: Array<Maybe<AccountTransaction>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AccountTransaction` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `AccountTransaction` edge in the connection. */
export interface AccountTransactionsEdge {
  __typename: 'AccountTransactionsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `AccountTransaction` at the end of the edge. */
  node: Maybe<AccountTransaction>;
}

/** Information about pagination in a connection. */
export interface PageInfo {
  __typename: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['Cursor']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['Cursor']>;
}

/**
 * A condition to be used against `ActionLog` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export interface ActionLogCondition {
  /** Checks for equality with the object’s `actionName` field. */
  actionName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `actionTime` field. */
  actionTime?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `actor` field. */
  actor?: InputMaybe<ActorCode>;
  /** Checks for equality with the object’s `adminId` field. */
  adminId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `after` field. */
  after?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `before` field. */
  before?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `diff` field. */
  diff?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `ipAddress` field. */
  ipAddress?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `objectId` field. */
  objectId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `objectType` field. */
  objectType?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `patientId` field. */
  patientId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `warehouseRowId` field. */
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

export enum ActorCode {
  Admin = 'ADMIN',
  Automated = 'AUTOMATED',
  External = 'EXTERNAL',
  Patient = 'PATIENT'
}

/** Methods to use when ordering `ActionLog`. */
export enum ActionLogsOrderBy {
  ActionNameAsc = 'ACTION_NAME_ASC',
  ActionNameDesc = 'ACTION_NAME_DESC',
  ActionTimeAsc = 'ACTION_TIME_ASC',
  ActionTimeDesc = 'ACTION_TIME_DESC',
  ActorAsc = 'ACTOR_ASC',
  ActorDesc = 'ACTOR_DESC',
  AdminIdAsc = 'ADMIN_ID_ASC',
  AdminIdDesc = 'ADMIN_ID_DESC',
  AfterAsc = 'AFTER_ASC',
  AfterDesc = 'AFTER_DESC',
  BeforeAsc = 'BEFORE_ASC',
  BeforeDesc = 'BEFORE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  DiffAsc = 'DIFF_ASC',
  DiffDesc = 'DIFF_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IpAddressAsc = 'IP_ADDRESS_ASC',
  IpAddressDesc = 'IP_ADDRESS_DESC',
  Natural = 'NATURAL',
  ObjectIdAsc = 'OBJECT_ID_ASC',
  ObjectIdDesc = 'OBJECT_ID_DESC',
  ObjectTypeAsc = 'OBJECT_TYPE_ASC',
  ObjectTypeDesc = 'OBJECT_TYPE_DESC',
  PatientIdAsc = 'PATIENT_ID_ASC',
  PatientIdDesc = 'PATIENT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  WarehouseRowIdAsc = 'WAREHOUSE_ROW_ID_ASC',
  WarehouseRowIdDesc = 'WAREHOUSE_ROW_ID_DESC'
}

/** A connection to a list of `ActionLog` values. */
export interface ActionLogsConnection {
  __typename: 'ActionLogsConnection';
  /** A list of edges which contains the `ActionLog` and cursor to aid in pagination. */
  edges: Array<ActionLogsEdge>;
  /** A list of `ActionLog` objects. */
  nodes: Array<Maybe<ActionLog>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ActionLog` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `ActionLog` edge in the connection. */
export interface ActionLogsEdge {
  __typename: 'ActionLogsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `ActionLog` at the end of the edge. */
  node: Maybe<ActionLog>;
}

/** A log of all actions taken on an object. */
export interface ActionLog extends Node {
  __typename: 'ActionLog';
  /** The type of action that was taken. */
  actionName: Scalars['String'];
  /** The timestamp when the action was taken. */
  actionTime: Scalars['Datetime'];
  /** The type of actor for which the action was created. */
  actor: ActorCode;
  /** Reads a single `Admin` that is related to this `ActionLog`. */
  adminByAdminId: Maybe<Admin>;
  /** The unique identifier for the given admin if the actor was an admin. */
  adminId: Maybe<Scalars['UUID']>;
  /** A JSON object of the changed object after the action was taken. */
  after: Maybe<Scalars['JSON']>;
  /** A JSON object of the changed object before the action was taken. */
  before: Maybe<Scalars['JSON']>;
  createdAt: Scalars['Datetime'];
  description: Maybe<Scalars['String']>;
  diff: Maybe<Scalars['JSON']>;
  id: Scalars['UUID'];
  /** The actor's ip address from where the action was taken. */
  ipAddress: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** The unique identifier for the specific object that the action was taken on. */
  objectId: Maybe<Scalars['UUID']>;
  /** The type of object that the action was taken on. */
  objectType: Maybe<Scalars['String']>;
  /** Reads a single `Patient` that is related to this `ActionLog`. */
  patientByPatientId: Maybe<Patient>;
  /** The unique identifier given to the patient that the action was taken on. */
  patientId: Maybe<Scalars['UUID']>;
  updatedAt: Scalars['Datetime'];
  warehouseRowId: Scalars['BigInt'];
}

/** An administrator of the Wellth system. */
export interface Admin extends Node {
  __typename: 'Admin';
  /** Reads and enables pagination through a set of `ActionLog`. */
  actionLogsByAdminId: ActionLogsConnection;
  /** Reads a single `AdminRole` that is related to this `Admin`. */
  adminRoleByAdminRoleId: Maybe<AdminRole>;
  adminRoleId: Scalars['UUID'];
  /** The administrator's birth date. */
  birthDate: Maybe<Scalars['Date']>;
  /** Reads and enables pagination through a set of `CheckIn`. */
  checkInsByVerifierId: CheckInsConnection;
  createdAt: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `CueCheckIn`. */
  cueCheckInsByVerifierId: CueCheckInsConnection;
  /** A string array of customers the admin is allowed to edit */
  customerAssociations: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Reads and enables pagination through a set of `Device`. */
  devicesByAdminId: DevicesConnection;
  /** The administrator's first name. */
  firstName: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `HydrationCheckIn`. */
  hydrationCheckInsByVerifierId: HydrationCheckInsConnection;
  id: Scalars['UUID'];
  /** The administrator's last name. */
  lastName: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `MealCheckIn`. */
  mealCheckInsByVerifierId: MealCheckInsConnection;
  /** Reads and enables pagination through a set of `MeasurementCheckIn`. */
  measurementCheckInsByVerifierId: MeasurementCheckInsConnection;
  /** Reads and enables pagination through a set of `MedicationCheckIn`. */
  medicationCheckInsByVerifierId: MedicationCheckInsConnection;
  /** Reads and enables pagination through a set of `Message`. */
  messagesByAdminId: MessagesConnection;
  middleName: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `PatientMembershipConfig`. */
  patientMembershipConfigsByAdminId: PatientMembershipConfigsConnection;
  /** Reads and enables pagination through a set of `Patient`. */
  patientsByEnrolledBy: PatientsConnection;
  /** Reads and enables pagination through a set of `PatientStatus`. */
  patientStatusesByAdminId: PatientStatusesConnection;
  /** The administrator's phone number. */
  phoneNumber: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `ProgramRewardConfig`. */
  programRewardConfigsByAdminId: ProgramRewardConfigsConnection;
  /** Reads and enables pagination through a set of `Program`. */
  programsByAdminId: ProgramsConnection;
  /** Reads and enables pagination through a set of `ProspectStatus`. */
  prospectStatusesByAdminId: ProspectStatusesConnection;
  /** Reads and enables pagination through a set of `ReminderConfig`. */
  reminderConfigsByAdminId: ReminderConfigsConnection;
  /** Reads and enables pagination through a set of `RewardPeriodConfig`. */
  rewardPeriodConfigsByAdminId: RewardPeriodConfigsConnection;
  /** Reads and enables pagination through a set of `SmsOutreachMessage`. */
  smsOutreachMessagesByAdminId: SmsOutreachMessagesConnection;
  /** Reads and enables pagination through a set of `SmsOutreachMessage`. */
  smsOutreachMessagesByApprovedBy: SmsOutreachMessagesConnection;
  /** Reads and enables pagination through a set of `SmsOutreachMessageTemplate`. */
  smsOutreachMessageTemplatesByAdminId: SmsOutreachMessageTemplatesConnection;
  /** Reads and enables pagination through a set of `SmsOutreachRecipient`. */
  smsOutreachRecipientsByAdminId: SmsOutreachRecipientsConnection;
  updatedAt: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `WalkthroughPage`. */
  walkthroughPagesByAdminId: WalkthroughPagesConnection;
  /** Reads and enables pagination through a set of `Walkthrough`. */
  walkthroughsByAdminId: WalkthroughsConnection;
  /** Reads and enables pagination through a set of `WalkthroughSetupConfig`. */
  walkthroughSetupConfigsByAdminId: WalkthroughSetupConfigsConnection;
  warehouseRowId: Scalars['BigInt'];
}


/** An administrator of the Wellth system. */
export interface AdminActionLogsByAdminIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ActionLogCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ActionLogsOrderBy>>;
}


/** An administrator of the Wellth system. */
export interface AdminCheckInsByVerifierIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CheckInCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CheckInsOrderBy>>;
}


/** An administrator of the Wellth system. */
export interface AdminCueCheckInsByVerifierIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CueCheckInCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CueCheckInsOrderBy>>;
}


/** An administrator of the Wellth system. */
export interface AdminDevicesByAdminIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DeviceCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DevicesOrderBy>>;
}


/** An administrator of the Wellth system. */
export interface AdminHydrationCheckInsByVerifierIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<HydrationCheckInCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<HydrationCheckInsOrderBy>>;
}


/** An administrator of the Wellth system. */
export interface AdminMealCheckInsByVerifierIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MealCheckInCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MealCheckInsOrderBy>>;
}


/** An administrator of the Wellth system. */
export interface AdminMeasurementCheckInsByVerifierIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MeasurementCheckInCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MeasurementCheckInsOrderBy>>;
}


/** An administrator of the Wellth system. */
export interface AdminMedicationCheckInsByVerifierIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MedicationCheckInCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MedicationCheckInsOrderBy>>;
}


/** An administrator of the Wellth system. */
export interface AdminMessagesByAdminIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MessageCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MessagesOrderBy>>;
}


/** An administrator of the Wellth system. */
export interface AdminPatientMembershipConfigsByAdminIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientMembershipConfigCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientMembershipConfigsOrderBy>>;
}


/** An administrator of the Wellth system. */
export interface AdminPatientsByEnrolledByArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientsOrderBy>>;
}


/** An administrator of the Wellth system. */
export interface AdminPatientStatusesByAdminIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientStatusCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientStatusesOrderBy>>;
}


/** An administrator of the Wellth system. */
export interface AdminProgramRewardConfigsByAdminIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProgramRewardConfigCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProgramRewardConfigsOrderBy>>;
}


/** An administrator of the Wellth system. */
export interface AdminProgramsByAdminIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProgramCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProgramsOrderBy>>;
}


/** An administrator of the Wellth system. */
export interface AdminProspectStatusesByAdminIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProspectStatusCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProspectStatusesOrderBy>>;
}


/** An administrator of the Wellth system. */
export interface AdminReminderConfigsByAdminIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ReminderConfigCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReminderConfigsOrderBy>>;
}


/** An administrator of the Wellth system. */
export interface AdminRewardPeriodConfigsByAdminIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RewardPeriodConfigCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RewardPeriodConfigsOrderBy>>;
}


/** An administrator of the Wellth system. */
export interface AdminSmsOutreachMessagesByAdminIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SmsOutreachMessageCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SmsOutreachMessagesOrderBy>>;
}


/** An administrator of the Wellth system. */
export interface AdminSmsOutreachMessagesByApprovedByArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SmsOutreachMessageCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SmsOutreachMessagesOrderBy>>;
}


/** An administrator of the Wellth system. */
export interface AdminSmsOutreachMessageTemplatesByAdminIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SmsOutreachMessageTemplateCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SmsOutreachMessageTemplatesOrderBy>>;
}


/** An administrator of the Wellth system. */
export interface AdminSmsOutreachRecipientsByAdminIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SmsOutreachRecipientCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SmsOutreachRecipientsOrderBy>>;
}


/** An administrator of the Wellth system. */
export interface AdminWalkthroughPagesByAdminIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<WalkthroughPageCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WalkthroughPagesOrderBy>>;
}


/** An administrator of the Wellth system. */
export interface AdminWalkthroughsByAdminIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<WalkthroughCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WalkthroughsOrderBy>>;
}


/** An administrator of the Wellth system. */
export interface AdminWalkthroughSetupConfigsByAdminIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<WalkthroughSetupConfigCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WalkthroughSetupConfigsOrderBy>>;
}

export interface AdminRole extends Node {
  __typename: 'AdminRole';
  /** Reads and enables pagination through a set of `AdminRolePrivilegedAction`. */
  adminRolePrivilegedActionsByAdminRoleId: AdminRolePrivilegedActionsConnection;
  /** Reads and enables pagination through a set of `Admin`. */
  adminsByAdminRoleId: AdminsConnection;
  createdAt: Scalars['Datetime'];
  description: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  updatedAt: Scalars['Datetime'];
  warehouseRowId: Scalars['BigInt'];
}


export interface AdminRoleAdminRolePrivilegedActionsByAdminRoleIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AdminRolePrivilegedActionCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AdminRolePrivilegedActionsOrderBy>>;
}


export interface AdminRoleAdminsByAdminRoleIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AdminCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AdminsOrderBy>>;
}

/**
 * A condition to be used against `AdminRolePrivilegedAction` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export interface AdminRolePrivilegedActionCondition {
  /** Checks for equality with the object’s `adminRoleId` field. */
  adminRoleId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `privilegedActionId` field. */
  privilegedActionId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `warehouseRowId` field. */
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** Methods to use when ordering `AdminRolePrivilegedAction`. */
export enum AdminRolePrivilegedActionsOrderBy {
  AdminRoleIdAsc = 'ADMIN_ROLE_ID_ASC',
  AdminRoleIdDesc = 'ADMIN_ROLE_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  PrivilegedActionIdAsc = 'PRIVILEGED_ACTION_ID_ASC',
  PrivilegedActionIdDesc = 'PRIVILEGED_ACTION_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  WarehouseRowIdAsc = 'WAREHOUSE_ROW_ID_ASC',
  WarehouseRowIdDesc = 'WAREHOUSE_ROW_ID_DESC'
}

/** A connection to a list of `AdminRolePrivilegedAction` values. */
export interface AdminRolePrivilegedActionsConnection {
  __typename: 'AdminRolePrivilegedActionsConnection';
  /** A list of edges which contains the `AdminRolePrivilegedAction` and cursor to aid in pagination. */
  edges: Array<AdminRolePrivilegedActionsEdge>;
  /** A list of `AdminRolePrivilegedAction` objects. */
  nodes: Array<Maybe<AdminRolePrivilegedAction>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AdminRolePrivilegedAction` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `AdminRolePrivilegedAction` edge in the connection. */
export interface AdminRolePrivilegedActionsEdge {
  __typename: 'AdminRolePrivilegedActionsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `AdminRolePrivilegedAction` at the end of the edge. */
  node: Maybe<AdminRolePrivilegedAction>;
}

export interface AdminRolePrivilegedAction extends Node {
  __typename: 'AdminRolePrivilegedAction';
  /** Reads a single `AdminRole` that is related to this `AdminRolePrivilegedAction`. */
  adminRoleByAdminRoleId: Maybe<AdminRole>;
  adminRoleId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  id: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `PrivilegedAction` that is related to this `AdminRolePrivilegedAction`. */
  privilegedActionByPrivilegedActionId: Maybe<PrivilegedAction>;
  privilegedActionId: Scalars['UUID'];
  updatedAt: Scalars['Datetime'];
  warehouseRowId: Scalars['BigInt'];
}

export interface PrivilegedAction extends Node {
  __typename: 'PrivilegedAction';
  /** Reads and enables pagination through a set of `AdminRolePrivilegedAction`. */
  adminRolePrivilegedActionsByPrivilegedActionId: AdminRolePrivilegedActionsConnection;
  createdAt: Scalars['Datetime'];
  description: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  updatedAt: Scalars['Datetime'];
  warehouseRowId: Scalars['BigInt'];
}


export interface PrivilegedActionAdminRolePrivilegedActionsByPrivilegedActionIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AdminRolePrivilegedActionCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AdminRolePrivilegedActionsOrderBy>>;
}

/** A condition to be used against `Admin` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export interface AdminCondition {
  /** Checks for equality with the object’s `adminRoleId` field. */
  adminRoleId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `birthDate` field. */
  birthDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `customerAssociations` field. */
  customerAssociations?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Checks for equality with the object’s `firstName` field. */
  firstName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `lastName` field. */
  lastName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `middleName` field. */
  middleName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `phoneNumber` field. */
  phoneNumber?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `warehouseRowId` field. */
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** Methods to use when ordering `Admin`. */
export enum AdminsOrderBy {
  AdminRoleIdAsc = 'ADMIN_ROLE_ID_ASC',
  AdminRoleIdDesc = 'ADMIN_ROLE_ID_DESC',
  BirthDateAsc = 'BIRTH_DATE_ASC',
  BirthDateDesc = 'BIRTH_DATE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CustomerAssociationsAsc = 'CUSTOMER_ASSOCIATIONS_ASC',
  CustomerAssociationsDesc = 'CUSTOMER_ASSOCIATIONS_DESC',
  FirstNameAsc = 'FIRST_NAME_ASC',
  FirstNameDesc = 'FIRST_NAME_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LastNameAsc = 'LAST_NAME_ASC',
  LastNameDesc = 'LAST_NAME_DESC',
  MiddleNameAsc = 'MIDDLE_NAME_ASC',
  MiddleNameDesc = 'MIDDLE_NAME_DESC',
  Natural = 'NATURAL',
  PhoneNumberAsc = 'PHONE_NUMBER_ASC',
  PhoneNumberDesc = 'PHONE_NUMBER_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  WarehouseRowIdAsc = 'WAREHOUSE_ROW_ID_ASC',
  WarehouseRowIdDesc = 'WAREHOUSE_ROW_ID_DESC'
}

/** A connection to a list of `Admin` values. */
export interface AdminsConnection {
  __typename: 'AdminsConnection';
  /** A list of edges which contains the `Admin` and cursor to aid in pagination. */
  edges: Array<AdminsEdge>;
  /** A list of `Admin` objects. */
  nodes: Array<Maybe<Admin>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Admin` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `Admin` edge in the connection. */
export interface AdminsEdge {
  __typename: 'AdminsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Admin` at the end of the edge. */
  node: Maybe<Admin>;
}

/** A condition to be used against `CheckIn` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export interface CheckInCondition {
  /** Checks for equality with the object’s `category` field. */
  category?: InputMaybe<CheckInCategory>;
  /** Checks for equality with the object’s `checkInTimestamp` field. */
  checkInTimestamp?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `checkInTimezone` field. */
  checkInTimezone?: InputMaybe<Scalars['Timezone']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `creditedReason` field. */
  creditedReason?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `creditedReasonDetail` field. */
  creditedReasonDetail?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `creditedReasonNote` field. */
  creditedReasonNote?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `isCredited` field. */
  isCredited?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `objectDetectionStatus` field. */
  objectDetectionStatus?: InputMaybe<ObjectDetectionStatus>;
  /** Checks for equality with the object’s `patientId` field. */
  patientId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `photoUrl` field. */
  photoUrl?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `reminderId` field. */
  reminderId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `thumbnailUrl` field. */
  thumbnailUrl?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `verificationStatus` field. */
  verificationStatus?: InputMaybe<VerificationStatus>;
  /** Checks for equality with the object’s `verifierId` field. */
  verifierId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `warehouseRowId` field. */
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

export enum CheckInCategory {
  BloodPressure = 'BLOOD_PRESSURE',
  BloodPressureConnected = 'BLOOD_PRESSURE_CONNECTED',
  Cue = 'CUE',
  Glucose = 'GLUCOSE',
  GlucoseConnected = 'GLUCOSE_CONNECTED',
  Hydration = 'HYDRATION',
  Meal = 'MEAL',
  Medication = 'MEDICATION',
  Practice = 'PRACTICE',
  PulseOx = 'PULSE_OX',
  PulseOxConnected = 'PULSE_OX_CONNECTED',
  Sleep = 'SLEEP',
  SleepConnected = 'SLEEP_CONNECTED',
  Steps = 'STEPS',
  StepsConnected = 'STEPS_CONNECTED',
  Weight = 'WEIGHT',
  WeightConnected = 'WEIGHT_CONNECTED'
}

export enum ObjectDetectionStatus {
  Empty = 'EMPTY',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  ObjectsDetected = 'OBJECTS_DETECTED',
  Unknown = 'UNKNOWN'
}

export enum VerificationStatus {
  Member = 'MEMBER',
  Rejected = 'REJECTED',
  Unknown = 'UNKNOWN',
  Verified = 'VERIFIED'
}

/** Methods to use when ordering `CheckIn`. */
export enum CheckInsOrderBy {
  CategoryAsc = 'CATEGORY_ASC',
  CategoryDesc = 'CATEGORY_DESC',
  CheckInTimestampAsc = 'CHECK_IN_TIMESTAMP_ASC',
  CheckInTimestampDesc = 'CHECK_IN_TIMESTAMP_DESC',
  CheckInTimezoneAsc = 'CHECK_IN_TIMEZONE_ASC',
  CheckInTimezoneDesc = 'CHECK_IN_TIMEZONE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreditedReasonAsc = 'CREDITED_REASON_ASC',
  CreditedReasonDesc = 'CREDITED_REASON_DESC',
  CreditedReasonDetailAsc = 'CREDITED_REASON_DETAIL_ASC',
  CreditedReasonDetailDesc = 'CREDITED_REASON_DETAIL_DESC',
  CreditedReasonNoteAsc = 'CREDITED_REASON_NOTE_ASC',
  CreditedReasonNoteDesc = 'CREDITED_REASON_NOTE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsCreditedAsc = 'IS_CREDITED_ASC',
  IsCreditedDesc = 'IS_CREDITED_DESC',
  Natural = 'NATURAL',
  ObjectDetectionStatusAsc = 'OBJECT_DETECTION_STATUS_ASC',
  ObjectDetectionStatusDesc = 'OBJECT_DETECTION_STATUS_DESC',
  PatientIdAsc = 'PATIENT_ID_ASC',
  PatientIdDesc = 'PATIENT_ID_DESC',
  PhotoUrlAsc = 'PHOTO_URL_ASC',
  PhotoUrlDesc = 'PHOTO_URL_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ReminderIdAsc = 'REMINDER_ID_ASC',
  ReminderIdDesc = 'REMINDER_ID_DESC',
  ThumbnailUrlAsc = 'THUMBNAIL_URL_ASC',
  ThumbnailUrlDesc = 'THUMBNAIL_URL_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  VerificationStatusAsc = 'VERIFICATION_STATUS_ASC',
  VerificationStatusDesc = 'VERIFICATION_STATUS_DESC',
  VerifierIdAsc = 'VERIFIER_ID_ASC',
  VerifierIdDesc = 'VERIFIER_ID_DESC',
  WarehouseRowIdAsc = 'WAREHOUSE_ROW_ID_ASC',
  WarehouseRowIdDesc = 'WAREHOUSE_ROW_ID_DESC'
}

/** A connection to a list of `CheckIn` values. */
export interface CheckInsConnection {
  __typename: 'CheckInsConnection';
  /** A list of edges which contains the `CheckIn` and cursor to aid in pagination. */
  edges: Array<CheckInsEdge>;
  /** A list of `CheckIn` objects. */
  nodes: Array<Maybe<CheckIn>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CheckIn` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `CheckIn` edge in the connection. */
export interface CheckInsEdge {
  __typename: 'CheckInsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `CheckIn` at the end of the edge. */
  node: Maybe<CheckIn>;
}

/** A check in; this is a parent type that cannot be directly instantiated. */
export interface CheckIn extends Node {
  __typename: 'CheckIn';
  /** Reads a single `Admin` that is related to this `CheckIn`. */
  adminByVerifierId: Maybe<Admin>;
  /** The category of this check-in. */
  category: CheckInCategory;
  /** The timestamp on the patient's device at the time of check-in. */
  checkInTimestamp: Scalars['Datetime'];
  /** The local timezone on the patient's device at the time of check-in. */
  checkInTimezone: Scalars['Timezone'];
  createdAt: Scalars['Datetime'];
  creditedReason: Maybe<Scalars['String']>;
  creditedReasonDetail: Maybe<Scalars['String']>;
  creditedReasonNote: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  isCredited: Scalars['Boolean'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** The object detection status of this check-in, set by the automatic object detection worker. */
  objectDetectionStatus: ObjectDetectionStatus;
  /** Reads a single `Patient` that is related to this `CheckIn`. */
  patientByPatientId: Maybe<Patient>;
  patientId: Scalars['UUID'];
  /** The URL of the large photo for this check-in; optional. */
  photoUrl: Maybe<Scalars['String']>;
  /** Reads a single `Reminder` that is related to this `CheckIn`. */
  reminderByReminderId: Maybe<Reminder>;
  /** The ID of the reminder from which this check-in originated. */
  reminderId: Scalars['UUID'];
  /** The URL of the small photo for this check-in; optional. */
  thumbnailUrl: Maybe<Scalars['String']>;
  updatedAt: Scalars['Datetime'];
  /** The verification status of this check-in, set by Wellth administrators. */
  verificationStatus: VerificationStatus;
  /** The id of the Wellth administrator who verified this check-in, if any. */
  verifierId: Maybe<Scalars['UUID']>;
  warehouseRowId: Scalars['BigInt'];
}

/** A reminder, which specifies when a certain type of check_in must be performed */
export interface Reminder extends Node {
  __typename: 'Reminder';
  /** The check_in category of the reminder, used to determine what kind of check_in to create. */
  checkInCategory: CheckInCategory;
  /** Reads and enables pagination through a set of `CheckIn`. */
  checkInsByReminderId: CheckInsConnection;
  createdAt: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `CueCheckIn`. */
  cueCheckInsByReminderId: CueCheckInsConnection;
  /** The date at which this reminder span ends (inclusive), optionally null. */
  endDate: Scalars['Date'];
  /** The time at which this reminder is due on Friday. */
  friTime: Scalars['Time'];
  /** Reads and enables pagination through a set of `HydrationCheckIn`. */
  hydrationCheckInsByReminderId: HydrationCheckInsConnection;
  id: Scalars['UUID'];
  interval: ReminderInterval;
  intervalCount: Scalars['Int'];
  /** Whether the reminder should appear as a demo flow in the application. */
  isDemo: Scalars['Boolean'];
  /** Whether completing the reminder is required in order to earn incentives for the day. */
  isRequired: Scalars['Boolean'];
  label: Maybe<Scalars['String']>;
  linkedFutureReminderId: Maybe<Scalars['UUID']>;
  /** Reads and enables pagination through a set of `MealCheckIn`. */
  mealCheckInsByReminderId: MealCheckInsConnection;
  /** Reads and enables pagination through a set of `MeasurementCheckIn`. */
  measurementCheckInsByReminderId: MeasurementCheckInsConnection;
  /** Reads and enables pagination through a set of `MedicationCheckIn`. */
  medicationCheckInsByReminderId: MedicationCheckInsConnection;
  /** The time at which this reminder is due on Monday. */
  monTime: Scalars['Time'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Patient` that is related to this `Reminder`. */
  patientByPatientId: Maybe<Patient>;
  patientId: Scalars['UUID'];
  /** Reads a single `Reminder` that is related to this `Reminder`. */
  reminderByLinkedFutureReminderId: Maybe<Reminder>;
  /** Reads a single `ReminderConfig` that is related to this `Reminder`. */
  reminderConfigByReminderConfigId: Maybe<ReminderConfig>;
  /** The reminder_config from which this reminder was created, if one existed. */
  reminderConfigId: Maybe<Scalars['UUID']>;
  /** Reads and enables pagination through a set of `ReminderMessage`. */
  reminderMessagesByReminderId: ReminderMessagesConnection;
  /** Reads and enables pagination through a set of `Reminder`. */
  remindersByLinkedFutureReminderId: RemindersConnection;
  /** The time at which this reminder is due on Saturday. */
  satTime: Scalars['Time'];
  /** The date at which this reminder span starts. */
  startDate: Scalars['Date'];
  /** The time at which this reminder is due on Sunday. */
  sunTime: Scalars['Time'];
  /** The time at which this reminder is due on Thursday. */
  thuTime: Scalars['Time'];
  /** The time at which this reminder is due on Tuesday. */
  tueTime: Scalars['Time'];
  updatedAt: Scalars['Datetime'];
  warehouseRowId: Scalars['BigInt'];
  /** The time at which this reminder is due on Wednesday. */
  wedTime: Scalars['Time'];
  /** The duration of the window after the due time. */
  windowAfterMinutes: Scalars['Int'];
  /** The duration of the window before the due time. */
  windowBeforeMinutes: Scalars['Int'];
}


/** A reminder, which specifies when a certain type of check_in must be performed */
export interface ReminderCheckInsByReminderIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CheckInCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CheckInsOrderBy>>;
}


/** A reminder, which specifies when a certain type of check_in must be performed */
export interface ReminderCueCheckInsByReminderIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CueCheckInCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CueCheckInsOrderBy>>;
}


/** A reminder, which specifies when a certain type of check_in must be performed */
export interface ReminderHydrationCheckInsByReminderIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<HydrationCheckInCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<HydrationCheckInsOrderBy>>;
}


/** A reminder, which specifies when a certain type of check_in must be performed */
export interface ReminderMealCheckInsByReminderIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MealCheckInCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MealCheckInsOrderBy>>;
}


/** A reminder, which specifies when a certain type of check_in must be performed */
export interface ReminderMeasurementCheckInsByReminderIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MeasurementCheckInCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MeasurementCheckInsOrderBy>>;
}


/** A reminder, which specifies when a certain type of check_in must be performed */
export interface ReminderMedicationCheckInsByReminderIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MedicationCheckInCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MedicationCheckInsOrderBy>>;
}


/** A reminder, which specifies when a certain type of check_in must be performed */
export interface ReminderReminderMessagesByReminderIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ReminderMessageCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReminderMessagesOrderBy>>;
}


/** A reminder, which specifies when a certain type of check_in must be performed */
export interface ReminderRemindersByLinkedFutureReminderIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ReminderCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RemindersOrderBy>>;
}

/**
 * A condition to be used against `CueCheckIn` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export interface CueCheckInCondition {
  /** Checks for equality with the object’s `category` field. */
  category?: InputMaybe<CheckInCategory>;
  /** Checks for equality with the object’s `checkInTimestamp` field. */
  checkInTimestamp?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `checkInTimezone` field. */
  checkInTimezone?: InputMaybe<Scalars['Timezone']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `creditedReason` field. */
  creditedReason?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `creditedReasonDetail` field. */
  creditedReasonDetail?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `creditedReasonNote` field. */
  creditedReasonNote?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `isCredited` field. */
  isCredited?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `objectDetectionStatus` field. */
  objectDetectionStatus?: InputMaybe<ObjectDetectionStatus>;
  /** Checks for equality with the object’s `patientId` field. */
  patientId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `photoUrl` field. */
  photoUrl?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `reminderId` field. */
  reminderId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `thumbnailUrl` field. */
  thumbnailUrl?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `verificationStatus` field. */
  verificationStatus?: InputMaybe<VerificationStatus>;
  /** Checks for equality with the object’s `verifierId` field. */
  verifierId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `warehouseRowId` field. */
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** Methods to use when ordering `CueCheckIn`. */
export enum CueCheckInsOrderBy {
  CategoryAsc = 'CATEGORY_ASC',
  CategoryDesc = 'CATEGORY_DESC',
  CheckInTimestampAsc = 'CHECK_IN_TIMESTAMP_ASC',
  CheckInTimestampDesc = 'CHECK_IN_TIMESTAMP_DESC',
  CheckInTimezoneAsc = 'CHECK_IN_TIMEZONE_ASC',
  CheckInTimezoneDesc = 'CHECK_IN_TIMEZONE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreditedReasonAsc = 'CREDITED_REASON_ASC',
  CreditedReasonDesc = 'CREDITED_REASON_DESC',
  CreditedReasonDetailAsc = 'CREDITED_REASON_DETAIL_ASC',
  CreditedReasonDetailDesc = 'CREDITED_REASON_DETAIL_DESC',
  CreditedReasonNoteAsc = 'CREDITED_REASON_NOTE_ASC',
  CreditedReasonNoteDesc = 'CREDITED_REASON_NOTE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsCreditedAsc = 'IS_CREDITED_ASC',
  IsCreditedDesc = 'IS_CREDITED_DESC',
  LabelAsc = 'LABEL_ASC',
  LabelDesc = 'LABEL_DESC',
  Natural = 'NATURAL',
  ObjectDetectionStatusAsc = 'OBJECT_DETECTION_STATUS_ASC',
  ObjectDetectionStatusDesc = 'OBJECT_DETECTION_STATUS_DESC',
  PatientIdAsc = 'PATIENT_ID_ASC',
  PatientIdDesc = 'PATIENT_ID_DESC',
  PhotoUrlAsc = 'PHOTO_URL_ASC',
  PhotoUrlDesc = 'PHOTO_URL_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ReminderIdAsc = 'REMINDER_ID_ASC',
  ReminderIdDesc = 'REMINDER_ID_DESC',
  ThumbnailUrlAsc = 'THUMBNAIL_URL_ASC',
  ThumbnailUrlDesc = 'THUMBNAIL_URL_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  VerificationStatusAsc = 'VERIFICATION_STATUS_ASC',
  VerificationStatusDesc = 'VERIFICATION_STATUS_DESC',
  VerifierIdAsc = 'VERIFIER_ID_ASC',
  VerifierIdDesc = 'VERIFIER_ID_DESC',
  WarehouseRowIdAsc = 'WAREHOUSE_ROW_ID_ASC',
  WarehouseRowIdDesc = 'WAREHOUSE_ROW_ID_DESC'
}

/** A connection to a list of `CueCheckIn` values. */
export interface CueCheckInsConnection {
  __typename: 'CueCheckInsConnection';
  /** A list of edges which contains the `CueCheckIn` and cursor to aid in pagination. */
  edges: Array<CueCheckInsEdge>;
  /** A list of `CueCheckIn` objects. */
  nodes: Array<Maybe<CueCheckIn>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CueCheckIn` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `CueCheckIn` edge in the connection. */
export interface CueCheckInsEdge {
  __typename: 'CueCheckInsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `CueCheckIn` at the end of the edge. */
  node: Maybe<CueCheckIn>;
}

/** A cue check_in. */
export interface CueCheckIn extends Node {
  __typename: 'CueCheckIn';
  /** Reads a single `Admin` that is related to this `CueCheckIn`. */
  adminByVerifierId: Maybe<Admin>;
  category: CheckInCategory;
  checkInTimestamp: Scalars['Datetime'];
  checkInTimezone: Scalars['Timezone'];
  createdAt: Scalars['Datetime'];
  creditedReason: Maybe<Scalars['String']>;
  creditedReasonDetail: Maybe<Scalars['String']>;
  creditedReasonNote: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  isCredited: Scalars['Boolean'];
  /** A label used by the cue reminder. Exists here as reference */
  label: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  objectDetectionStatus: ObjectDetectionStatus;
  /** Reads a single `Patient` that is related to this `CueCheckIn`. */
  patientByPatientId: Maybe<Patient>;
  patientId: Scalars['UUID'];
  photoUrl: Maybe<Scalars['String']>;
  /** Reads a single `Reminder` that is related to this `CueCheckIn`. */
  reminderByReminderId: Maybe<Reminder>;
  reminderId: Scalars['UUID'];
  thumbnailUrl: Maybe<Scalars['String']>;
  updatedAt: Scalars['Datetime'];
  verificationStatus: VerificationStatus;
  verifierId: Maybe<Scalars['UUID']>;
  warehouseRowId: Scalars['BigInt'];
}

/**
 * A condition to be used against `HydrationCheckIn` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface HydrationCheckInCondition {
  /** Checks for equality with the object’s `category` field. */
  category?: InputMaybe<CheckInCategory>;
  /** Checks for equality with the object’s `checkInTimestamp` field. */
  checkInTimestamp?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `checkInTimezone` field. */
  checkInTimezone?: InputMaybe<Scalars['Timezone']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `creditedReason` field. */
  creditedReason?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `creditedReasonDetail` field. */
  creditedReasonDetail?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `creditedReasonNote` field. */
  creditedReasonNote?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `isCredited` field. */
  isCredited?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `objectDetectionStatus` field. */
  objectDetectionStatus?: InputMaybe<ObjectDetectionStatus>;
  /** Checks for equality with the object’s `patientId` field. */
  patientId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `photoUrl` field. */
  photoUrl?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `reminderId` field. */
  reminderId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `thumbnailUrl` field. */
  thumbnailUrl?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `verificationStatus` field. */
  verificationStatus?: InputMaybe<VerificationStatus>;
  /** Checks for equality with the object’s `verifierId` field. */
  verifierId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `warehouseRowId` field. */
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** Methods to use when ordering `HydrationCheckIn`. */
export enum HydrationCheckInsOrderBy {
  CategoryAsc = 'CATEGORY_ASC',
  CategoryDesc = 'CATEGORY_DESC',
  CheckInTimestampAsc = 'CHECK_IN_TIMESTAMP_ASC',
  CheckInTimestampDesc = 'CHECK_IN_TIMESTAMP_DESC',
  CheckInTimezoneAsc = 'CHECK_IN_TIMEZONE_ASC',
  CheckInTimezoneDesc = 'CHECK_IN_TIMEZONE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreditedReasonAsc = 'CREDITED_REASON_ASC',
  CreditedReasonDesc = 'CREDITED_REASON_DESC',
  CreditedReasonDetailAsc = 'CREDITED_REASON_DETAIL_ASC',
  CreditedReasonDetailDesc = 'CREDITED_REASON_DETAIL_DESC',
  CreditedReasonNoteAsc = 'CREDITED_REASON_NOTE_ASC',
  CreditedReasonNoteDesc = 'CREDITED_REASON_NOTE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsCreditedAsc = 'IS_CREDITED_ASC',
  IsCreditedDesc = 'IS_CREDITED_DESC',
  Natural = 'NATURAL',
  ObjectDetectionStatusAsc = 'OBJECT_DETECTION_STATUS_ASC',
  ObjectDetectionStatusDesc = 'OBJECT_DETECTION_STATUS_DESC',
  PatientIdAsc = 'PATIENT_ID_ASC',
  PatientIdDesc = 'PATIENT_ID_DESC',
  PhotoUrlAsc = 'PHOTO_URL_ASC',
  PhotoUrlDesc = 'PHOTO_URL_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ReminderIdAsc = 'REMINDER_ID_ASC',
  ReminderIdDesc = 'REMINDER_ID_DESC',
  ThumbnailUrlAsc = 'THUMBNAIL_URL_ASC',
  ThumbnailUrlDesc = 'THUMBNAIL_URL_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  VerificationStatusAsc = 'VERIFICATION_STATUS_ASC',
  VerificationStatusDesc = 'VERIFICATION_STATUS_DESC',
  VerifierIdAsc = 'VERIFIER_ID_ASC',
  VerifierIdDesc = 'VERIFIER_ID_DESC',
  WarehouseRowIdAsc = 'WAREHOUSE_ROW_ID_ASC',
  WarehouseRowIdDesc = 'WAREHOUSE_ROW_ID_DESC'
}

/** A connection to a list of `HydrationCheckIn` values. */
export interface HydrationCheckInsConnection {
  __typename: 'HydrationCheckInsConnection';
  /** A list of edges which contains the `HydrationCheckIn` and cursor to aid in pagination. */
  edges: Array<HydrationCheckInsEdge>;
  /** A list of `HydrationCheckIn` objects. */
  nodes: Array<Maybe<HydrationCheckIn>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `HydrationCheckIn` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `HydrationCheckIn` edge in the connection. */
export interface HydrationCheckInsEdge {
  __typename: 'HydrationCheckInsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `HydrationCheckIn` at the end of the edge. */
  node: Maybe<HydrationCheckIn>;
}

/** A hydration check_in. */
export interface HydrationCheckIn extends Node {
  __typename: 'HydrationCheckIn';
  /** Reads a single `Admin` that is related to this `HydrationCheckIn`. */
  adminByVerifierId: Maybe<Admin>;
  category: CheckInCategory;
  checkInTimestamp: Scalars['Datetime'];
  checkInTimezone: Scalars['Timezone'];
  createdAt: Scalars['Datetime'];
  creditedReason: Maybe<Scalars['String']>;
  creditedReasonDetail: Maybe<Scalars['String']>;
  creditedReasonNote: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  isCredited: Scalars['Boolean'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  objectDetectionStatus: ObjectDetectionStatus;
  /** Reads a single `Patient` that is related to this `HydrationCheckIn`. */
  patientByPatientId: Maybe<Patient>;
  patientId: Scalars['UUID'];
  photoUrl: Maybe<Scalars['String']>;
  /** Reads a single `Reminder` that is related to this `HydrationCheckIn`. */
  reminderByReminderId: Maybe<Reminder>;
  reminderId: Scalars['UUID'];
  thumbnailUrl: Maybe<Scalars['String']>;
  updatedAt: Scalars['Datetime'];
  verificationStatus: VerificationStatus;
  verifierId: Maybe<Scalars['UUID']>;
  warehouseRowId: Scalars['BigInt'];
}

export enum ReminderInterval {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

/**
 * A condition to be used against `MealCheckIn` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export interface MealCheckInCondition {
  /** Checks for equality with the object’s `category` field. */
  category?: InputMaybe<CheckInCategory>;
  /** Checks for equality with the object’s `checkInTimestamp` field. */
  checkInTimestamp?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `checkInTimezone` field. */
  checkInTimezone?: InputMaybe<Scalars['Timezone']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `creditedReason` field. */
  creditedReason?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `creditedReasonDetail` field. */
  creditedReasonDetail?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `creditedReasonNote` field. */
  creditedReasonNote?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `isCredited` field. */
  isCredited?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `items` field. */
  items?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Checks for equality with the object’s `objectDetectionStatus` field. */
  objectDetectionStatus?: InputMaybe<ObjectDetectionStatus>;
  /** Checks for equality with the object’s `patientId` field. */
  patientId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `photoUrl` field. */
  photoUrl?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `reminderId` field. */
  reminderId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `thumbnailUrl` field. */
  thumbnailUrl?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `verificationStatus` field. */
  verificationStatus?: InputMaybe<VerificationStatus>;
  /** Checks for equality with the object’s `verifierId` field. */
  verifierId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `warehouseRowId` field. */
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** Methods to use when ordering `MealCheckIn`. */
export enum MealCheckInsOrderBy {
  CategoryAsc = 'CATEGORY_ASC',
  CategoryDesc = 'CATEGORY_DESC',
  CheckInTimestampAsc = 'CHECK_IN_TIMESTAMP_ASC',
  CheckInTimestampDesc = 'CHECK_IN_TIMESTAMP_DESC',
  CheckInTimezoneAsc = 'CHECK_IN_TIMEZONE_ASC',
  CheckInTimezoneDesc = 'CHECK_IN_TIMEZONE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreditedReasonAsc = 'CREDITED_REASON_ASC',
  CreditedReasonDesc = 'CREDITED_REASON_DESC',
  CreditedReasonDetailAsc = 'CREDITED_REASON_DETAIL_ASC',
  CreditedReasonDetailDesc = 'CREDITED_REASON_DETAIL_DESC',
  CreditedReasonNoteAsc = 'CREDITED_REASON_NOTE_ASC',
  CreditedReasonNoteDesc = 'CREDITED_REASON_NOTE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsCreditedAsc = 'IS_CREDITED_ASC',
  IsCreditedDesc = 'IS_CREDITED_DESC',
  ItemsAsc = 'ITEMS_ASC',
  ItemsDesc = 'ITEMS_DESC',
  Natural = 'NATURAL',
  ObjectDetectionStatusAsc = 'OBJECT_DETECTION_STATUS_ASC',
  ObjectDetectionStatusDesc = 'OBJECT_DETECTION_STATUS_DESC',
  PatientIdAsc = 'PATIENT_ID_ASC',
  PatientIdDesc = 'PATIENT_ID_DESC',
  PhotoUrlAsc = 'PHOTO_URL_ASC',
  PhotoUrlDesc = 'PHOTO_URL_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ReminderIdAsc = 'REMINDER_ID_ASC',
  ReminderIdDesc = 'REMINDER_ID_DESC',
  ThumbnailUrlAsc = 'THUMBNAIL_URL_ASC',
  ThumbnailUrlDesc = 'THUMBNAIL_URL_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  VerificationStatusAsc = 'VERIFICATION_STATUS_ASC',
  VerificationStatusDesc = 'VERIFICATION_STATUS_DESC',
  VerifierIdAsc = 'VERIFIER_ID_ASC',
  VerifierIdDesc = 'VERIFIER_ID_DESC',
  WarehouseRowIdAsc = 'WAREHOUSE_ROW_ID_ASC',
  WarehouseRowIdDesc = 'WAREHOUSE_ROW_ID_DESC'
}

/** A connection to a list of `MealCheckIn` values. */
export interface MealCheckInsConnection {
  __typename: 'MealCheckInsConnection';
  /** A list of edges which contains the `MealCheckIn` and cursor to aid in pagination. */
  edges: Array<MealCheckInsEdge>;
  /** A list of `MealCheckIn` objects. */
  nodes: Array<Maybe<MealCheckIn>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MealCheckIn` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `MealCheckIn` edge in the connection. */
export interface MealCheckInsEdge {
  __typename: 'MealCheckInsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `MealCheckIn` at the end of the edge. */
  node: Maybe<MealCheckIn>;
}

/** A meal check_in, with an array of food item names.  Schema is almost certainly subject to change. */
export interface MealCheckIn extends Node {
  __typename: 'MealCheckIn';
  /** Reads a single `Admin` that is related to this `MealCheckIn`. */
  adminByVerifierId: Maybe<Admin>;
  category: CheckInCategory;
  checkInTimestamp: Scalars['Datetime'];
  checkInTimezone: Scalars['Timezone'];
  createdAt: Scalars['Datetime'];
  creditedReason: Maybe<Scalars['String']>;
  creditedReasonDetail: Maybe<Scalars['String']>;
  creditedReasonNote: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  isCredited: Scalars['Boolean'];
  /** An array of food item names */
  items: Maybe<Array<Maybe<Scalars['String']>>>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  objectDetectionStatus: ObjectDetectionStatus;
  /** Reads a single `Patient` that is related to this `MealCheckIn`. */
  patientByPatientId: Maybe<Patient>;
  patientId: Scalars['UUID'];
  photoUrl: Maybe<Scalars['String']>;
  /** Reads a single `Reminder` that is related to this `MealCheckIn`. */
  reminderByReminderId: Maybe<Reminder>;
  reminderId: Scalars['UUID'];
  thumbnailUrl: Maybe<Scalars['String']>;
  updatedAt: Scalars['Datetime'];
  verificationStatus: VerificationStatus;
  verifierId: Maybe<Scalars['UUID']>;
  warehouseRowId: Scalars['BigInt'];
}

/**
 * A condition to be used against `MeasurementCheckIn` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface MeasurementCheckInCondition {
  /** Checks for equality with the object’s `category` field. */
  category?: InputMaybe<CheckInCategory>;
  /** Checks for equality with the object’s `checkInTimestamp` field. */
  checkInTimestamp?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `checkInTimezone` field. */
  checkInTimezone?: InputMaybe<Scalars['Timezone']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `creditedReason` field. */
  creditedReason?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `creditedReasonDetail` field. */
  creditedReasonDetail?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `creditedReasonNote` field. */
  creditedReasonNote?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `isCredited` field. */
  isCredited?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `measurements` field. */
  measurements?: InputMaybe<Array<InputMaybe<MeasurementInput>>>;
  /** Checks for equality with the object’s `objectDetectionStatus` field. */
  objectDetectionStatus?: InputMaybe<ObjectDetectionStatus>;
  /** Checks for equality with the object’s `patientId` field. */
  patientId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `photoUrl` field. */
  photoUrl?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `reminderId` field. */
  reminderId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `thumbnailUrl` field. */
  thumbnailUrl?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `verificationStatus` field. */
  verificationStatus?: InputMaybe<VerificationStatus>;
  /** Checks for equality with the object’s `verifierId` field. */
  verifierId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `warehouseRowId` field. */
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** An input for mutations affecting `Measurement` */
export interface MeasurementInput {
  autoValue?: InputMaybe<Scalars['BigFloat']>;
  manualValue?: InputMaybe<Scalars['BigFloat']>;
  name?: InputMaybe<MetricName>;
  unit?: InputMaybe<MetricUnit>;
  value?: InputMaybe<Scalars['BigFloat']>;
}

export enum MetricName {
  DiastolicBp = 'DIASTOLIC_BP',
  Glucose = 'GLUCOSE',
  Oxygenation = 'OXYGENATION',
  Pulse = 'PULSE',
  Sleep = 'SLEEP',
  Steps = 'STEPS',
  SystolicBp = 'SYSTOLIC_BP',
  Weight = 'WEIGHT'
}

export enum MetricUnit {
  Bpm = 'BPM',
  Lbs = 'LBS',
  MgPerDl = 'MG_PER_DL',
  Minutes = 'MINUTES',
  MmHg = 'MM_HG',
  MmMg = 'MM_MG',
  PctO2 = 'PCT_O2',
  Steps = 'STEPS'
}

/** Methods to use when ordering `MeasurementCheckIn`. */
export enum MeasurementCheckInsOrderBy {
  CategoryAsc = 'CATEGORY_ASC',
  CategoryDesc = 'CATEGORY_DESC',
  CheckInTimestampAsc = 'CHECK_IN_TIMESTAMP_ASC',
  CheckInTimestampDesc = 'CHECK_IN_TIMESTAMP_DESC',
  CheckInTimezoneAsc = 'CHECK_IN_TIMEZONE_ASC',
  CheckInTimezoneDesc = 'CHECK_IN_TIMEZONE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreditedReasonAsc = 'CREDITED_REASON_ASC',
  CreditedReasonDesc = 'CREDITED_REASON_DESC',
  CreditedReasonDetailAsc = 'CREDITED_REASON_DETAIL_ASC',
  CreditedReasonDetailDesc = 'CREDITED_REASON_DETAIL_DESC',
  CreditedReasonNoteAsc = 'CREDITED_REASON_NOTE_ASC',
  CreditedReasonNoteDesc = 'CREDITED_REASON_NOTE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsCreditedAsc = 'IS_CREDITED_ASC',
  IsCreditedDesc = 'IS_CREDITED_DESC',
  MeasurementsAsc = 'MEASUREMENTS_ASC',
  MeasurementsDesc = 'MEASUREMENTS_DESC',
  Natural = 'NATURAL',
  ObjectDetectionStatusAsc = 'OBJECT_DETECTION_STATUS_ASC',
  ObjectDetectionStatusDesc = 'OBJECT_DETECTION_STATUS_DESC',
  PatientIdAsc = 'PATIENT_ID_ASC',
  PatientIdDesc = 'PATIENT_ID_DESC',
  PhotoUrlAsc = 'PHOTO_URL_ASC',
  PhotoUrlDesc = 'PHOTO_URL_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ReminderIdAsc = 'REMINDER_ID_ASC',
  ReminderIdDesc = 'REMINDER_ID_DESC',
  ThumbnailUrlAsc = 'THUMBNAIL_URL_ASC',
  ThumbnailUrlDesc = 'THUMBNAIL_URL_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  VerificationStatusAsc = 'VERIFICATION_STATUS_ASC',
  VerificationStatusDesc = 'VERIFICATION_STATUS_DESC',
  VerifierIdAsc = 'VERIFIER_ID_ASC',
  VerifierIdDesc = 'VERIFIER_ID_DESC',
  WarehouseRowIdAsc = 'WAREHOUSE_ROW_ID_ASC',
  WarehouseRowIdDesc = 'WAREHOUSE_ROW_ID_DESC'
}

/** A connection to a list of `MeasurementCheckIn` values. */
export interface MeasurementCheckInsConnection {
  __typename: 'MeasurementCheckInsConnection';
  /** A list of edges which contains the `MeasurementCheckIn` and cursor to aid in pagination. */
  edges: Array<MeasurementCheckInsEdge>;
  /** A list of `MeasurementCheckIn` objects. */
  nodes: Array<Maybe<MeasurementCheckIn>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MeasurementCheckIn` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `MeasurementCheckIn` edge in the connection. */
export interface MeasurementCheckInsEdge {
  __typename: 'MeasurementCheckInsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `MeasurementCheckIn` at the end of the edge. */
  node: Maybe<MeasurementCheckIn>;
}

/** A measurement check_in, with an array of measurement entries. */
export interface MeasurementCheckIn extends Node {
  __typename: 'MeasurementCheckIn';
  /** Reads a single `Admin` that is related to this `MeasurementCheckIn`. */
  adminByVerifierId: Maybe<Admin>;
  category: CheckInCategory;
  checkInTimestamp: Scalars['Datetime'];
  checkInTimezone: Scalars['Timezone'];
  createdAt: Scalars['Datetime'];
  creditedReason: Maybe<Scalars['String']>;
  creditedReasonDetail: Maybe<Scalars['String']>;
  creditedReasonNote: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  isCredited: Scalars['Boolean'];
  /** An array of measurement entries */
  measurements: Maybe<Array<Maybe<Measurement>>>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  objectDetectionStatus: ObjectDetectionStatus;
  /** Reads a single `Patient` that is related to this `MeasurementCheckIn`. */
  patientByPatientId: Maybe<Patient>;
  patientId: Scalars['UUID'];
  photoUrl: Maybe<Scalars['String']>;
  /** Reads a single `Reminder` that is related to this `MeasurementCheckIn`. */
  reminderByReminderId: Maybe<Reminder>;
  reminderId: Scalars['UUID'];
  thumbnailUrl: Maybe<Scalars['String']>;
  updatedAt: Scalars['Datetime'];
  verificationStatus: VerificationStatus;
  verifierId: Maybe<Scalars['UUID']>;
  warehouseRowId: Scalars['BigInt'];
}

export interface Measurement {
  __typename: 'Measurement';
  autoValue: Maybe<Scalars['BigFloat']>;
  manualValue: Maybe<Scalars['BigFloat']>;
  name: Maybe<MetricName>;
  unit: Maybe<MetricUnit>;
  value: Maybe<Scalars['BigFloat']>;
}

/**
 * A condition to be used against `MedicationCheckIn` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface MedicationCheckInCondition {
  /** Checks for equality with the object’s `anomalyTypes` field. */
  anomalyTypes?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `autoHasMeds` field. */
  autoHasMeds?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `autoMedCount` field. */
  autoMedCount?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `category` field. */
  category?: InputMaybe<CheckInCategory>;
  /** Checks for equality with the object’s `checkInTimestamp` field. */
  checkInTimestamp?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `checkInTimezone` field. */
  checkInTimezone?: InputMaybe<Scalars['Timezone']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `creditedReason` field. */
  creditedReason?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `creditedReasonDetail` field. */
  creditedReasonDetail?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `creditedReasonNote` field. */
  creditedReasonNote?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `isCredited` field. */
  isCredited?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `manualHasMeds` field. */
  manualHasMeds?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `manualMedCount` field. */
  manualMedCount?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `objectDetectionStatus` field. */
  objectDetectionStatus?: InputMaybe<ObjectDetectionStatus>;
  /** Checks for equality with the object’s `patientId` field. */
  patientId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `photoUrl` field. */
  photoUrl?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `reminderId` field. */
  reminderId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `thumbnailUrl` field. */
  thumbnailUrl?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `verificationStatus` field. */
  verificationStatus?: InputMaybe<VerificationStatus>;
  /** Checks for equality with the object’s `verifierId` field. */
  verifierId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `warehouseRowId` field. */
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** Methods to use when ordering `MedicationCheckIn`. */
export enum MedicationCheckInsOrderBy {
  AnomalyTypesAsc = 'ANOMALY_TYPES_ASC',
  AnomalyTypesDesc = 'ANOMALY_TYPES_DESC',
  AutoHasMedsAsc = 'AUTO_HAS_MEDS_ASC',
  AutoHasMedsDesc = 'AUTO_HAS_MEDS_DESC',
  AutoMedCountAsc = 'AUTO_MED_COUNT_ASC',
  AutoMedCountDesc = 'AUTO_MED_COUNT_DESC',
  CategoryAsc = 'CATEGORY_ASC',
  CategoryDesc = 'CATEGORY_DESC',
  CheckInTimestampAsc = 'CHECK_IN_TIMESTAMP_ASC',
  CheckInTimestampDesc = 'CHECK_IN_TIMESTAMP_DESC',
  CheckInTimezoneAsc = 'CHECK_IN_TIMEZONE_ASC',
  CheckInTimezoneDesc = 'CHECK_IN_TIMEZONE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreditedReasonAsc = 'CREDITED_REASON_ASC',
  CreditedReasonDesc = 'CREDITED_REASON_DESC',
  CreditedReasonDetailAsc = 'CREDITED_REASON_DETAIL_ASC',
  CreditedReasonDetailDesc = 'CREDITED_REASON_DETAIL_DESC',
  CreditedReasonNoteAsc = 'CREDITED_REASON_NOTE_ASC',
  CreditedReasonNoteDesc = 'CREDITED_REASON_NOTE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsCreditedAsc = 'IS_CREDITED_ASC',
  IsCreditedDesc = 'IS_CREDITED_DESC',
  ManualHasMedsAsc = 'MANUAL_HAS_MEDS_ASC',
  ManualHasMedsDesc = 'MANUAL_HAS_MEDS_DESC',
  ManualMedCountAsc = 'MANUAL_MED_COUNT_ASC',
  ManualMedCountDesc = 'MANUAL_MED_COUNT_DESC',
  Natural = 'NATURAL',
  ObjectDetectionStatusAsc = 'OBJECT_DETECTION_STATUS_ASC',
  ObjectDetectionStatusDesc = 'OBJECT_DETECTION_STATUS_DESC',
  PatientIdAsc = 'PATIENT_ID_ASC',
  PatientIdDesc = 'PATIENT_ID_DESC',
  PhotoUrlAsc = 'PHOTO_URL_ASC',
  PhotoUrlDesc = 'PHOTO_URL_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ReminderIdAsc = 'REMINDER_ID_ASC',
  ReminderIdDesc = 'REMINDER_ID_DESC',
  ThumbnailUrlAsc = 'THUMBNAIL_URL_ASC',
  ThumbnailUrlDesc = 'THUMBNAIL_URL_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  VerificationStatusAsc = 'VERIFICATION_STATUS_ASC',
  VerificationStatusDesc = 'VERIFICATION_STATUS_DESC',
  VerifierIdAsc = 'VERIFIER_ID_ASC',
  VerifierIdDesc = 'VERIFIER_ID_DESC',
  WarehouseRowIdAsc = 'WAREHOUSE_ROW_ID_ASC',
  WarehouseRowIdDesc = 'WAREHOUSE_ROW_ID_DESC'
}

/** A connection to a list of `MedicationCheckIn` values. */
export interface MedicationCheckInsConnection {
  __typename: 'MedicationCheckInsConnection';
  /** A list of edges which contains the `MedicationCheckIn` and cursor to aid in pagination. */
  edges: Array<MedicationCheckInsEdge>;
  /** A list of `MedicationCheckIn` objects. */
  nodes: Array<Maybe<MedicationCheckIn>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MedicationCheckIn` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `MedicationCheckIn` edge in the connection. */
export interface MedicationCheckInsEdge {
  __typename: 'MedicationCheckInsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `MedicationCheckIn` at the end of the edge. */
  node: Maybe<MedicationCheckIn>;
}

/** A medication check_in, with metadata about medication presence and count. */
export interface MedicationCheckIn extends Node {
  __typename: 'MedicationCheckIn';
  /** Reads a single `Admin` that is related to this `MedicationCheckIn`. */
  adminByVerifierId: Maybe<Admin>;
  anomalyTypes: Maybe<Scalars['JSON']>;
  /** Our AI's determination of whether this photo has medications; null if it hasn't been checked yet. */
  autoHasMeds: Maybe<Scalars['Boolean']>;
  /** The number of medication objects our AI found in this photo; null if it hasn't been checked yet. */
  autoMedCount: Maybe<Scalars['Int']>;
  category: CheckInCategory;
  checkInTimestamp: Scalars['Datetime'];
  checkInTimezone: Scalars['Timezone'];
  createdAt: Scalars['Datetime'];
  creditedReason: Maybe<Scalars['String']>;
  creditedReasonDetail: Maybe<Scalars['String']>;
  creditedReasonNote: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  isCredited: Scalars['Boolean'];
  /** An administrator's determination of whether this photo has medications; null if it hasn't been checked yet. */
  manualHasMeds: Maybe<Scalars['Boolean']>;
  /** The number of medication objects an administrator found in this photo; null if it hasn't been checked yet. */
  manualMedCount: Maybe<Scalars['Int']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  objectDetectionStatus: ObjectDetectionStatus;
  /** Reads a single `Patient` that is related to this `MedicationCheckIn`. */
  patientByPatientId: Maybe<Patient>;
  patientId: Scalars['UUID'];
  photoUrl: Maybe<Scalars['String']>;
  /** Reads a single `Reminder` that is related to this `MedicationCheckIn`. */
  reminderByReminderId: Maybe<Reminder>;
  reminderId: Scalars['UUID'];
  thumbnailUrl: Maybe<Scalars['String']>;
  updatedAt: Scalars['Datetime'];
  verificationStatus: VerificationStatus;
  verifierId: Maybe<Scalars['UUID']>;
  warehouseRowId: Scalars['BigInt'];
}

/** A reminder_config, which specifies when a certain type of check_in must be performed */
export interface ReminderConfig extends Node {
  __typename: 'ReminderConfig';
  /** Reads a single `Admin` that is related to this `ReminderConfig`. */
  adminByAdminId: Maybe<Admin>;
  /** The administrator which created and owns this reminder config. */
  adminId: Scalars['UUID'];
  /** The check_in category of the reminder_config, used to determine what kind of check_in to create. */
  checkInCategory: CheckInCategory;
  createdAt: Scalars['Datetime'];
  dueTime: Scalars['Time'];
  /** The time at which this reminder is due on Friday. */
  friTime: Scalars['Time'];
  id: Scalars['UUID'];
  interval: ReminderInterval;
  intervalCount: Scalars['Int'];
  /** Whether the reminder should appear as a demo flow in the application. */
  isDemo: Scalars['Boolean'];
  /** Whether completing the reminder is required in order to earn incentives for the day. */
  isRequired: Scalars['Boolean'];
  /** The number of days for which this reminder should run. */
  lengthInDays: Scalars['Int'];
  /** The time at which this reminder is due on Monday. */
  monTime: Scalars['Time'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Program` that is related to this `ReminderConfig`. */
  programByProgramId: Maybe<Program>;
  /** A reference to the program to which this reminder_config is tied. */
  programId: Scalars['UUID'];
  /** Reads and enables pagination through a set of `Reminder`. */
  remindersByReminderConfigId: RemindersConnection;
  /** The time at which this reminder is due on Saturday. */
  satTime: Scalars['Time'];
  selfServeDefault: Maybe<Scalars['Boolean']>;
  /** The number of days after the 0th program start day at which this reminder should start. */
  startDayIndex: Scalars['Int'];
  /** The time at which this reminder is due on Sunday. */
  sunTime: Scalars['Time'];
  /** The time at which this reminder is due on Thursday. */
  thuTime: Scalars['Time'];
  /** The time at which this reminder is due on Tuesday. */
  tueTime: Scalars['Time'];
  updatedAt: Scalars['Datetime'];
  warehouseRowId: Scalars['BigInt'];
  /** The time at which this reminder is due on Wednesday. */
  wedTime: Scalars['Time'];
  /** The duration of the window after the due time. */
  windowAfterMinutes: Scalars['Int'];
  /** The duration of the window before the due time. */
  windowBeforeMinutes: Scalars['Int'];
}


/** A reminder_config, which specifies when a certain type of check_in must be performed */
export interface ReminderConfigRemindersByReminderConfigIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ReminderCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RemindersOrderBy>>;
}

/** Omit automated update and delete */
export interface Program extends Node {
  __typename: 'Program';
  /** Reads a single `Admin` that is related to this `Program`. */
  adminByAdminId: Maybe<Admin>;
  adminId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  currentActiveMembers: Maybe<Scalars['Int']>;
  /** Reads a single `Customer` that is related to this `Program`. */
  customerByCustomerId: Maybe<Customer>;
  customerId: Maybe<Scalars['UUID']>;
  customJson: Scalars['JSON'];
  eligibleForSelfServe: Scalars['Boolean'];
  /** The date of the last day at which this program can be used. */
  expiry: Scalars['Date'];
  icon: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  impactTierFloor: Maybe<Scalars['String']>;
  /** impact tiers bucket prospects in 3 or 4 bins */
  impactTiers: Scalars['String'];
  /** The amount of days a member has been paused that will automatically inactivated them. */
  inactivateAfterPausedDays: Maybe<Scalars['Int']>;
  /** Amount of days after reward period or reminder end date that will automatically inactivate member */
  inactivateDaysAfterEndDate: Maybe<Scalars['Int']>;
  isDoNotCallSuppressionEnabled: Maybe<Scalars['Boolean']>;
  /** Per-program kill switch for the automated eligibility-loss pause/notify workflow. */
  isEligibilityAutomationEnabled: Scalars['Boolean'];
  /** Flag to determine is creation is suppressed for the program */
  isProspectCreationSuppressed: Scalars['Boolean'];
  /** Flag to determine is reopening is suppressed for the program */
  isProspectReopeningSuppressed: Scalars['Boolean'];
  isProspectWorkflowsEnabled: Scalars['Boolean'];
  isTestProgram: Scalars['Boolean'];
  isUploaderDisabled: Maybe<Scalars['Boolean']>;
  /** The maximum number of times this program can be used across all patients cumulatively */
  maximumUses: Maybe<Scalars['Int']>;
  /** arbitrary reward max used in UX communications */
  maxRewards: Scalars['BigFloat'];
  /** The name of the program */
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  note: Maybe<Scalars['String']>;
  notificationPolicyId: Maybe<Scalars['UUID']>;
  /** Reads and enables pagination through a set of `PatientMembershipConfig`. */
  patientMembershipConfigsByProgramId: PatientMembershipConfigsConnection;
  pauseAfterNoActivityDays: Maybe<Scalars['Int']>;
  /** The unique textual code of the program */
  programCode: Scalars['String'];
  /** Reads a single `ProgramMfaConfig` that is related to this `Program`. */
  programMfaConfigByProgramId: Maybe<ProgramMfaConfig>;
  /**
   * Reads and enables pagination through a set of `ProgramMfaConfig`.
   * @deprecated Please use programMfaConfigByProgramId instead
   */
  programMfaConfigsByProgramId: ProgramMfaConfigsConnection;
  /** Reads and enables pagination through a set of `ProgramRewardConfig`. */
  programRewardConfigsByProgramId: ProgramRewardConfigsConnection;
  programTemplate: Maybe<Scalars['String']>;
  /** Reads a single `ProgramTemplate` that is related to this `Program`. */
  programTemplateByProgramTemplate: Maybe<ProgramTemplate>;
  /** Reads and enables pagination through a set of `ReminderConfig`. */
  reminderConfigsByProgramId: ReminderConfigsConnection;
  /** Reads and enables pagination through a set of `RewardPeriodConfig`. */
  rewardPeriodConfigsByProgramId: RewardPeriodConfigsConnection;
  /** Describes which health care sector the program is associated with */
  sector: Maybe<Scalars['String']>;
  skipBloodPressureDetection: Scalars['Boolean'];
  skipGlucoseDetection: Scalars['Boolean'];
  skipMealDetection: Scalars['Boolean'];
  skipMedicationDetection: Scalars['Boolean'];
  /** Reads and enables pagination through a set of `SmsOutreachRecipient`. */
  smsOutreachRecipientsByProgramId: SmsOutreachRecipientsConnection;
  totalActiveMembers: Maybe<Scalars['Int']>;
  updatedAt: Scalars['Datetime'];
  /** The number of times this program has been used */
  useCount: Maybe<Scalars['Int']>;
  /** Reads and enables pagination through a set of `WalkthroughSetupConfig`. */
  walkthroughSetupConfigsByProgramId: WalkthroughSetupConfigsConnection;
  warehouseRowId: Scalars['BigInt'];
}


/** Omit automated update and delete */
export interface ProgramPatientMembershipConfigsByProgramIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientMembershipConfigCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientMembershipConfigsOrderBy>>;
}


/** Omit automated update and delete */
export interface ProgramProgramMfaConfigsByProgramIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProgramMfaConfigCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProgramMfaConfigsOrderBy>>;
}


/** Omit automated update and delete */
export interface ProgramProgramRewardConfigsByProgramIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProgramRewardConfigCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProgramRewardConfigsOrderBy>>;
}


/** Omit automated update and delete */
export interface ProgramReminderConfigsByProgramIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ReminderConfigCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReminderConfigsOrderBy>>;
}


/** Omit automated update and delete */
export interface ProgramRewardPeriodConfigsByProgramIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RewardPeriodConfigCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RewardPeriodConfigsOrderBy>>;
}


/** Omit automated update and delete */
export interface ProgramSmsOutreachRecipientsByProgramIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SmsOutreachRecipientCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SmsOutreachRecipientsOrderBy>>;
}


/** Omit automated update and delete */
export interface ProgramWalkthroughSetupConfigsByProgramIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<WalkthroughSetupConfigCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WalkthroughSetupConfigsOrderBy>>;
}

export interface Customer extends Node {
  __typename: 'Customer';
  createdAt: Scalars['Datetime'];
  description: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `Program`. */
  programsByCustomerId: ProgramsConnection;
  updatedAt: Scalars['Datetime'];
  warehouseRowId: Scalars['BigInt'];
}


export interface CustomerProgramsByCustomerIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProgramCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProgramsOrderBy>>;
}

/** A condition to be used against `Program` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export interface ProgramCondition {
  /** Checks for equality with the object’s `adminId` field. */
  adminId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `customerId` field. */
  customerId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `customJson` field. */
  customJson?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `eligibleForSelfServe` field. */
  eligibleForSelfServe?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `expiry` field. */
  expiry?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `icon` field. */
  icon?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `impactTierFloor` field. */
  impactTierFloor?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `impactTiers` field. */
  impactTiers?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `inactivateAfterPausedDays` field. */
  inactivateAfterPausedDays?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `inactivateDaysAfterEndDate` field. */
  inactivateDaysAfterEndDate?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `isDoNotCallSuppressionEnabled` field. */
  isDoNotCallSuppressionEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isEligibilityAutomationEnabled` field. */
  isEligibilityAutomationEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isProspectCreationSuppressed` field. */
  isProspectCreationSuppressed?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isProspectReopeningSuppressed` field. */
  isProspectReopeningSuppressed?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isProspectWorkflowsEnabled` field. */
  isProspectWorkflowsEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isTestProgram` field. */
  isTestProgram?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isUploaderDisabled` field. */
  isUploaderDisabled?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `maximumUses` field. */
  maximumUses?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `maxRewards` field. */
  maxRewards?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `note` field. */
  note?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `notificationPolicyId` field. */
  notificationPolicyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `pauseAfterNoActivityDays` field. */
  pauseAfterNoActivityDays?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `programCode` field. */
  programCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `programTemplate` field. */
  programTemplate?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `sector` field. */
  sector?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `skipBloodPressureDetection` field. */
  skipBloodPressureDetection?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `skipGlucoseDetection` field. */
  skipGlucoseDetection?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `skipMealDetection` field. */
  skipMealDetection?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `skipMedicationDetection` field. */
  skipMedicationDetection?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `useCount` field. */
  useCount?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `warehouseRowId` field. */
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** Methods to use when ordering `Program`. */
export enum ProgramsOrderBy {
  AdminIdAsc = 'ADMIN_ID_ASC',
  AdminIdDesc = 'ADMIN_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CustomJsonAsc = 'CUSTOM_JSON_ASC',
  CustomJsonDesc = 'CUSTOM_JSON_DESC',
  CustomerIdAsc = 'CUSTOMER_ID_ASC',
  CustomerIdDesc = 'CUSTOMER_ID_DESC',
  EligibleForSelfServeAsc = 'ELIGIBLE_FOR_SELF_SERVE_ASC',
  EligibleForSelfServeDesc = 'ELIGIBLE_FOR_SELF_SERVE_DESC',
  ExpiryAsc = 'EXPIRY_ASC',
  ExpiryDesc = 'EXPIRY_DESC',
  IconAsc = 'ICON_ASC',
  IconDesc = 'ICON_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  ImpactTierFloorAsc = 'IMPACT_TIER_FLOOR_ASC',
  ImpactTierFloorDesc = 'IMPACT_TIER_FLOOR_DESC',
  ImpactTiersAsc = 'IMPACT_TIERS_ASC',
  ImpactTiersDesc = 'IMPACT_TIERS_DESC',
  InactivateAfterPausedDaysAsc = 'INACTIVATE_AFTER_PAUSED_DAYS_ASC',
  InactivateAfterPausedDaysDesc = 'INACTIVATE_AFTER_PAUSED_DAYS_DESC',
  InactivateDaysAfterEndDateAsc = 'INACTIVATE_DAYS_AFTER_END_DATE_ASC',
  InactivateDaysAfterEndDateDesc = 'INACTIVATE_DAYS_AFTER_END_DATE_DESC',
  IsDoNotCallSuppressionEnabledAsc = 'IS_DO_NOT_CALL_SUPPRESSION_ENABLED_ASC',
  IsDoNotCallSuppressionEnabledDesc = 'IS_DO_NOT_CALL_SUPPRESSION_ENABLED_DESC',
  IsEligibilityAutomationEnabledAsc = 'IS_ELIGIBILITY_AUTOMATION_ENABLED_ASC',
  IsEligibilityAutomationEnabledDesc = 'IS_ELIGIBILITY_AUTOMATION_ENABLED_DESC',
  IsProspectCreationSuppressedAsc = 'IS_PROSPECT_CREATION_SUPPRESSED_ASC',
  IsProspectCreationSuppressedDesc = 'IS_PROSPECT_CREATION_SUPPRESSED_DESC',
  IsProspectReopeningSuppressedAsc = 'IS_PROSPECT_REOPENING_SUPPRESSED_ASC',
  IsProspectReopeningSuppressedDesc = 'IS_PROSPECT_REOPENING_SUPPRESSED_DESC',
  IsProspectWorkflowsEnabledAsc = 'IS_PROSPECT_WORKFLOWS_ENABLED_ASC',
  IsProspectWorkflowsEnabledDesc = 'IS_PROSPECT_WORKFLOWS_ENABLED_DESC',
  IsTestProgramAsc = 'IS_TEST_PROGRAM_ASC',
  IsTestProgramDesc = 'IS_TEST_PROGRAM_DESC',
  IsUploaderDisabledAsc = 'IS_UPLOADER_DISABLED_ASC',
  IsUploaderDisabledDesc = 'IS_UPLOADER_DISABLED_DESC',
  MaxRewardsAsc = 'MAX_REWARDS_ASC',
  MaxRewardsDesc = 'MAX_REWARDS_DESC',
  MaximumUsesAsc = 'MAXIMUM_USES_ASC',
  MaximumUsesDesc = 'MAXIMUM_USES_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  NoteAsc = 'NOTE_ASC',
  NoteDesc = 'NOTE_DESC',
  NotificationPolicyIdAsc = 'NOTIFICATION_POLICY_ID_ASC',
  NotificationPolicyIdDesc = 'NOTIFICATION_POLICY_ID_DESC',
  PauseAfterNoActivityDaysAsc = 'PAUSE_AFTER_NO_ACTIVITY_DAYS_ASC',
  PauseAfterNoActivityDaysDesc = 'PAUSE_AFTER_NO_ACTIVITY_DAYS_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProgramCodeAsc = 'PROGRAM_CODE_ASC',
  ProgramCodeDesc = 'PROGRAM_CODE_DESC',
  ProgramTemplateAsc = 'PROGRAM_TEMPLATE_ASC',
  ProgramTemplateDesc = 'PROGRAM_TEMPLATE_DESC',
  SectorAsc = 'SECTOR_ASC',
  SectorDesc = 'SECTOR_DESC',
  SkipBloodPressureDetectionAsc = 'SKIP_BLOOD_PRESSURE_DETECTION_ASC',
  SkipBloodPressureDetectionDesc = 'SKIP_BLOOD_PRESSURE_DETECTION_DESC',
  SkipGlucoseDetectionAsc = 'SKIP_GLUCOSE_DETECTION_ASC',
  SkipGlucoseDetectionDesc = 'SKIP_GLUCOSE_DETECTION_DESC',
  SkipMealDetectionAsc = 'SKIP_MEAL_DETECTION_ASC',
  SkipMealDetectionDesc = 'SKIP_MEAL_DETECTION_DESC',
  SkipMedicationDetectionAsc = 'SKIP_MEDICATION_DETECTION_ASC',
  SkipMedicationDetectionDesc = 'SKIP_MEDICATION_DETECTION_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UseCountAsc = 'USE_COUNT_ASC',
  UseCountDesc = 'USE_COUNT_DESC',
  WarehouseRowIdAsc = 'WAREHOUSE_ROW_ID_ASC',
  WarehouseRowIdDesc = 'WAREHOUSE_ROW_ID_DESC'
}

/** A connection to a list of `Program` values. */
export interface ProgramsConnection {
  __typename: 'ProgramsConnection';
  /** A list of edges which contains the `Program` and cursor to aid in pagination. */
  edges: Array<ProgramsEdge>;
  /** A list of `Program` objects. */
  nodes: Array<Maybe<Program>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Program` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `Program` edge in the connection. */
export interface ProgramsEdge {
  __typename: 'ProgramsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Program` at the end of the edge. */
  node: Maybe<Program>;
}

/**
 * A condition to be used against `PatientMembershipConfig` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export interface PatientMembershipConfigCondition {
  /** Checks for equality with the object’s `adminId` field. */
  adminId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `groupId` field. */
  groupId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `programId` field. */
  programId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `warehouseRowId` field. */
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** Methods to use when ordering `PatientMembershipConfig`. */
export enum PatientMembershipConfigsOrderBy {
  AdminIdAsc = 'ADMIN_ID_ASC',
  AdminIdDesc = 'ADMIN_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  GroupIdAsc = 'GROUP_ID_ASC',
  GroupIdDesc = 'GROUP_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProgramIdAsc = 'PROGRAM_ID_ASC',
  ProgramIdDesc = 'PROGRAM_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  WarehouseRowIdAsc = 'WAREHOUSE_ROW_ID_ASC',
  WarehouseRowIdDesc = 'WAREHOUSE_ROW_ID_DESC'
}

/** A connection to a list of `PatientMembershipConfig` values. */
export interface PatientMembershipConfigsConnection {
  __typename: 'PatientMembershipConfigsConnection';
  /** A list of edges which contains the `PatientMembershipConfig` and cursor to aid in pagination. */
  edges: Array<PatientMembershipConfigsEdge>;
  /** A list of `PatientMembershipConfig` objects. */
  nodes: Array<Maybe<PatientMembershipConfig>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PatientMembershipConfig` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `PatientMembershipConfig` edge in the connection. */
export interface PatientMembershipConfigsEdge {
  __typename: 'PatientMembershipConfigsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `PatientMembershipConfig` at the end of the edge. */
  node: Maybe<PatientMembershipConfig>;
}

/** A mapping from a program to a group in which a patient using that program code should have membership */
export interface PatientMembershipConfig extends Node {
  __typename: 'PatientMembershipConfig';
  /** Reads a single `Admin` that is related to this `PatientMembershipConfig`. */
  adminByAdminId: Maybe<Admin>;
  /** The admin which owns this patient membership config. */
  adminId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  /** Reads a single `Group` that is related to this `PatientMembershipConfig`. */
  groupByGroupId: Maybe<Group>;
  /** The group to which patients should be given membership. */
  groupId: Scalars['UUID'];
  id: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Program` that is related to this `PatientMembershipConfig`. */
  programByProgramId: Maybe<Program>;
  /** The id of the program to which this payment setup config is related. */
  programId: Scalars['UUID'];
  updatedAt: Scalars['Datetime'];
  warehouseRowId: Scalars['BigInt'];
}

/** A group for patients and administrators in the Wellth system. */
export interface Group extends Node {
  __typename: 'Group';
  createdAt: Scalars['Datetime'];
  id: Scalars['UUID'];
  /** The group's name. */
  name: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `PatientMembershipConfig`. */
  patientMembershipConfigsByGroupId: PatientMembershipConfigsConnection;
  /** Reads and enables pagination through a set of `SmsOutreachRecipient`. */
  smsOutreachRecipientsByGroupId: SmsOutreachRecipientsConnection;
  updatedAt: Scalars['Datetime'];
  warehouseRowId: Scalars['BigInt'];
}


/** A group for patients and administrators in the Wellth system. */
export interface GroupPatientMembershipConfigsByGroupIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientMembershipConfigCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientMembershipConfigsOrderBy>>;
}


/** A group for patients and administrators in the Wellth system. */
export interface GroupSmsOutreachRecipientsByGroupIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SmsOutreachRecipientCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SmsOutreachRecipientsOrderBy>>;
}

/**
 * A condition to be used against `SmsOutreachRecipient` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export interface SmsOutreachRecipientCondition {
  /** Checks for equality with the object’s `adminId` field. */
  adminId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `birthDate` field. */
  birthDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `customerId` field. */
  customerId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `firstName` field. */
  firstName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `groupId` field. */
  groupId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `lastName` field. */
  lastName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `phoneNumber` field. */
  phoneNumber?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `programId` field. */
  programId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `subGroup` field. */
  subGroup?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `warehouseRowId` field. */
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** Methods to use when ordering `SmsOutreachRecipient`. */
export enum SmsOutreachRecipientsOrderBy {
  AdminIdAsc = 'ADMIN_ID_ASC',
  AdminIdDesc = 'ADMIN_ID_DESC',
  BirthDateAsc = 'BIRTH_DATE_ASC',
  BirthDateDesc = 'BIRTH_DATE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CustomerIdAsc = 'CUSTOMER_ID_ASC',
  CustomerIdDesc = 'CUSTOMER_ID_DESC',
  FirstNameAsc = 'FIRST_NAME_ASC',
  FirstNameDesc = 'FIRST_NAME_DESC',
  GroupIdAsc = 'GROUP_ID_ASC',
  GroupIdDesc = 'GROUP_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LastNameAsc = 'LAST_NAME_ASC',
  LastNameDesc = 'LAST_NAME_DESC',
  Natural = 'NATURAL',
  PhoneNumberAsc = 'PHONE_NUMBER_ASC',
  PhoneNumberDesc = 'PHONE_NUMBER_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProgramIdAsc = 'PROGRAM_ID_ASC',
  ProgramIdDesc = 'PROGRAM_ID_DESC',
  SubGroupAsc = 'SUB_GROUP_ASC',
  SubGroupDesc = 'SUB_GROUP_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  WarehouseRowIdAsc = 'WAREHOUSE_ROW_ID_ASC',
  WarehouseRowIdDesc = 'WAREHOUSE_ROW_ID_DESC'
}

/** A connection to a list of `SmsOutreachRecipient` values. */
export interface SmsOutreachRecipientsConnection {
  __typename: 'SmsOutreachRecipientsConnection';
  /** A list of edges which contains the `SmsOutreachRecipient` and cursor to aid in pagination. */
  edges: Array<SmsOutreachRecipientsEdge>;
  /** A list of `SmsOutreachRecipient` objects. */
  nodes: Array<Maybe<SmsOutreachRecipient>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SmsOutreachRecipient` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `SmsOutreachRecipient` edge in the connection. */
export interface SmsOutreachRecipientsEdge {
  __typename: 'SmsOutreachRecipientsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `SmsOutreachRecipient` at the end of the edge. */
  node: Maybe<SmsOutreachRecipient>;
}

/** A potential client via the Wellth platform. */
export interface SmsOutreachRecipient extends Node {
  __typename: 'SmsOutreachRecipient';
  /** Reads a single `Admin` that is related to this `SmsOutreachRecipient`. */
  adminByAdminId: Maybe<Admin>;
  adminId: Maybe<Scalars['UUID']>;
  /** The sms client's birth date. */
  birthDate: Maybe<Scalars['Date']>;
  createdAt: Scalars['Datetime'];
  /** The sms client's customer id. */
  customerId: Maybe<Scalars['String']>;
  /** The sms client's first name. */
  firstName: Maybe<Scalars['String']>;
  /** Reads a single `Group` that is related to this `SmsOutreachRecipient`. */
  groupByGroupId: Maybe<Group>;
  /** The sms client's group id. */
  groupId: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  /** The sms client's last name. */
  lastName: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** The sms client's phone number. */
  phoneNumber: Scalars['String'];
  /** Reads a single `Program` that is related to this `SmsOutreachRecipient`. */
  programByProgramId: Maybe<Program>;
  programId: Maybe<Scalars['UUID']>;
  /** Reads and enables pagination through a set of `SmsOutreachMessage`. */
  smsOutreachMessagesByRecipientId: SmsOutreachMessagesConnection;
  subGroup: Maybe<Scalars['String']>;
  updatedAt: Scalars['Datetime'];
  warehouseRowId: Scalars['BigInt'];
}


/** A potential client via the Wellth platform. */
export interface SmsOutreachRecipientSmsOutreachMessagesByRecipientIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SmsOutreachMessageCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SmsOutreachMessagesOrderBy>>;
}

/**
 * A condition to be used against `SmsOutreachMessage` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface SmsOutreachMessageCondition {
  /** Checks for equality with the object’s `adminId` field. */
  adminId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `approveAt` field. */
  approveAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `approvedAt` field. */
  approvedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `approvedBy` field. */
  approvedBy?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `batchLabel` field. */
  batchLabel?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `isAutoApprove` field. */
  isAutoApprove?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `message` field. */
  message?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `messageTemplateId` field. */
  messageTemplateId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `protocol` field. */
  protocol?: InputMaybe<SmsOutreachMessageProtocol>;
  /** Checks for equality with the object’s `readDatetime` field. */
  readDatetime?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `recipientId` field. */
  recipientId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `recipientType` field. */
  recipientType?: InputMaybe<SmsOutreachMessageRecipientType>;
  /** Checks for equality with the object’s `sendAfter` field. */
  sendAfter?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `sentDatetime` field. */
  sentDatetime?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<SmsOutreachMessageStatus>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `warehouseRowId` field. */
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

export enum SmsOutreachMessageProtocol {
  Mms = 'MMS',
  Sms = 'SMS'
}

export enum SmsOutreachMessageRecipientType {
  Admin = 'ADMIN',
  Member = 'MEMBER'
}

export enum SmsOutreachMessageStatus {
  Approved = 'APPROVED',
  Failed = 'FAILED',
  PendingApproval = 'PENDING_APPROVAL',
  Sending = 'SENDING',
  Sent = 'SENT'
}

/** Methods to use when ordering `SmsOutreachMessage`. */
export enum SmsOutreachMessagesOrderBy {
  AdminIdAsc = 'ADMIN_ID_ASC',
  AdminIdDesc = 'ADMIN_ID_DESC',
  ApproveAtAsc = 'APPROVE_AT_ASC',
  ApproveAtDesc = 'APPROVE_AT_DESC',
  ApprovedAtAsc = 'APPROVED_AT_ASC',
  ApprovedAtDesc = 'APPROVED_AT_DESC',
  ApprovedByAsc = 'APPROVED_BY_ASC',
  ApprovedByDesc = 'APPROVED_BY_DESC',
  BatchLabelAsc = 'BATCH_LABEL_ASC',
  BatchLabelDesc = 'BATCH_LABEL_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsAutoApproveAsc = 'IS_AUTO_APPROVE_ASC',
  IsAutoApproveDesc = 'IS_AUTO_APPROVE_DESC',
  MessageAsc = 'MESSAGE_ASC',
  MessageDesc = 'MESSAGE_DESC',
  MessageTemplateIdAsc = 'MESSAGE_TEMPLATE_ID_ASC',
  MessageTemplateIdDesc = 'MESSAGE_TEMPLATE_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProtocolAsc = 'PROTOCOL_ASC',
  ProtocolDesc = 'PROTOCOL_DESC',
  ReadDatetimeAsc = 'READ_DATETIME_ASC',
  ReadDatetimeDesc = 'READ_DATETIME_DESC',
  RecipientIdAsc = 'RECIPIENT_ID_ASC',
  RecipientIdDesc = 'RECIPIENT_ID_DESC',
  RecipientTypeAsc = 'RECIPIENT_TYPE_ASC',
  RecipientTypeDesc = 'RECIPIENT_TYPE_DESC',
  SendAfterAsc = 'SEND_AFTER_ASC',
  SendAfterDesc = 'SEND_AFTER_DESC',
  SentDatetimeAsc = 'SENT_DATETIME_ASC',
  SentDatetimeDesc = 'SENT_DATETIME_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  WarehouseRowIdAsc = 'WAREHOUSE_ROW_ID_ASC',
  WarehouseRowIdDesc = 'WAREHOUSE_ROW_ID_DESC'
}

/** A connection to a list of `SmsOutreachMessage` values. */
export interface SmsOutreachMessagesConnection {
  __typename: 'SmsOutreachMessagesConnection';
  /** A list of edges which contains the `SmsOutreachMessage` and cursor to aid in pagination. */
  edges: Array<SmsOutreachMessagesEdge>;
  /** A list of `SmsOutreachMessage` objects. */
  nodes: Array<Maybe<SmsOutreachMessage>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SmsOutreachMessage` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `SmsOutreachMessage` edge in the connection. */
export interface SmsOutreachMessagesEdge {
  __typename: 'SmsOutreachMessagesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `SmsOutreachMessage` at the end of the edge. */
  node: Maybe<SmsOutreachMessage>;
}

/** A message sent to a potential member via the Wellth platform. */
export interface SmsOutreachMessage extends Node {
  __typename: 'SmsOutreachMessage';
  /** Reads a single `Admin` that is related to this `SmsOutreachMessage`. */
  adminByAdminId: Maybe<Admin>;
  /** Reads a single `Admin` that is related to this `SmsOutreachMessage`. */
  adminByApprovedBy: Maybe<Admin>;
  adminId: Maybe<Scalars['UUID']>;
  /** Timestamp of when to automatically approve message */
  approveAt: Maybe<Scalars['Datetime']>;
  /** The date the message was approved. */
  approvedAt: Maybe<Scalars['Datetime']>;
  approvedBy: Maybe<Scalars['UUID']>;
  batchLabel: Maybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  id: Scalars['UUID'];
  /** Determines if a outreach message is auto approvable */
  isAutoApprove: Maybe<Scalars['Boolean']>;
  /** The content of the message. */
  message: Scalars['String'];
  messageTemplateId: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** The protocol over which the message was sent. */
  protocol: SmsOutreachMessageProtocol;
  /** The time at which this message was read by the recipient. */
  readDatetime: Maybe<Scalars['Datetime']>;
  recipientId: Maybe<Scalars['UUID']>;
  /** The party who is the recipient of this message. */
  recipientType: SmsOutreachMessageRecipientType;
  /** The date to send message after. */
  sendAfter: Maybe<Scalars['Datetime']>;
  /** The date the message was sent. */
  sentDatetime: Maybe<Scalars['Datetime']>;
  /** Reads a single `SmsOutreachMessageTemplate` that is related to this `SmsOutreachMessage`. */
  smsOutreachMessageTemplateByMessageTemplateId: Maybe<SmsOutreachMessageTemplate>;
  /** Reads a single `SmsOutreachRecipient` that is related to this `SmsOutreachMessage`. */
  smsOutreachRecipientByRecipientId: Maybe<SmsOutreachRecipient>;
  /** The status of the message. */
  status: SmsOutreachMessageStatus;
  updatedAt: Scalars['Datetime'];
  warehouseRowId: Scalars['BigInt'];
}

/** A message template sent to a potential client via the Wellth platform. */
export interface SmsOutreachMessageTemplate extends Node {
  __typename: 'SmsOutreachMessageTemplate';
  /** Reads a single `Admin` that is related to this `SmsOutreachMessageTemplate`. */
  adminByAdminId: Maybe<Admin>;
  adminId: Maybe<Scalars['UUID']>;
  /** The creation timestamp of a message template. */
  createdAt: Scalars['Datetime'];
  id: Scalars['UUID'];
  /** Determines if a outreach message template is active. */
  isActive: Maybe<Scalars['Boolean']>;
  /** The content of the message. */
  message: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `SmsOutreachMessage`. */
  smsOutreachMessagesByMessageTemplateId: SmsOutreachMessagesConnection;
  /** Title for the Sms Template. */
  title: Maybe<Scalars['String']>;
  /** The timestamp when message template was updated. */
  updatedAt: Scalars['Datetime'];
  warehouseRowId: Scalars['BigInt'];
}


/** A message template sent to a potential client via the Wellth platform. */
export interface SmsOutreachMessageTemplateSmsOutreachMessagesByMessageTemplateIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SmsOutreachMessageCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SmsOutreachMessagesOrderBy>>;
}

/** Multi Factor Authentication configuration per program */
export interface ProgramMfaConfig extends Node {
  __typename: 'ProgramMfaConfig';
  createdAt: Scalars['Datetime'];
  id: Scalars['UUID'];
  isMfaRequired: Scalars['Boolean'];
  mfaExpireMinutes: Maybe<Scalars['Int']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  numSecurityQuestions: Maybe<Scalars['Int']>;
  /** Reads a single `Program` that is related to this `ProgramMfaConfig`. */
  programByProgramId: Maybe<Program>;
  programId: Scalars['UUID'];
  updatedAt: Scalars['Datetime'];
}

/**
 * A condition to be used against `ProgramMfaConfig` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface ProgramMfaConfigCondition {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `isMfaRequired` field. */
  isMfaRequired?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `mfaExpireMinutes` field. */
  mfaExpireMinutes?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `numSecurityQuestions` field. */
  numSecurityQuestions?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `programId` field. */
  programId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
}

/** Methods to use when ordering `ProgramMfaConfig`. */
export enum ProgramMfaConfigsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsMfaRequiredAsc = 'IS_MFA_REQUIRED_ASC',
  IsMfaRequiredDesc = 'IS_MFA_REQUIRED_DESC',
  MfaExpireMinutesAsc = 'MFA_EXPIRE_MINUTES_ASC',
  MfaExpireMinutesDesc = 'MFA_EXPIRE_MINUTES_DESC',
  Natural = 'NATURAL',
  NumSecurityQuestionsAsc = 'NUM_SECURITY_QUESTIONS_ASC',
  NumSecurityQuestionsDesc = 'NUM_SECURITY_QUESTIONS_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProgramIdAsc = 'PROGRAM_ID_ASC',
  ProgramIdDesc = 'PROGRAM_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** A connection to a list of `ProgramMfaConfig` values. */
export interface ProgramMfaConfigsConnection {
  __typename: 'ProgramMfaConfigsConnection';
  /** A list of edges which contains the `ProgramMfaConfig` and cursor to aid in pagination. */
  edges: Array<ProgramMfaConfigsEdge>;
  /** A list of `ProgramMfaConfig` objects. */
  nodes: Array<Maybe<ProgramMfaConfig>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProgramMfaConfig` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `ProgramMfaConfig` edge in the connection. */
export interface ProgramMfaConfigsEdge {
  __typename: 'ProgramMfaConfigsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `ProgramMfaConfig` at the end of the edge. */
  node: Maybe<ProgramMfaConfig>;
}

/**
 * A condition to be used against `ProgramRewardConfig` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export interface ProgramRewardConfigCondition {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `adminId` field. */
  adminId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `descStringKey` field. */
  descStringKey?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `eligibleForAll` field. */
  eligibleForAll?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `endDate` field. */
  endDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `gracePeriod` field. */
  gracePeriod?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `icon` field. */
  icon?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `instantRedeem` field. */
  instantRedeem?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `programId` field. */
  programId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `rewardAmount` field. */
  rewardAmount?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `rewardCurrency` field. */
  rewardCurrency?: InputMaybe<Currency>;
  /** Checks for equality with the object’s `rewardEvent` field. */
  rewardEvent?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `startDate` field. */
  startDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `titleStringKey` field. */
  titleStringKey?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `warehouseRowId` field. */
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** Methods to use when ordering `ProgramRewardConfig`. */
export enum ProgramRewardConfigsOrderBy {
  ActiveAsc = 'ACTIVE_ASC',
  ActiveDesc = 'ACTIVE_DESC',
  AdminIdAsc = 'ADMIN_ID_ASC',
  AdminIdDesc = 'ADMIN_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DescStringKeyAsc = 'DESC_STRING_KEY_ASC',
  DescStringKeyDesc = 'DESC_STRING_KEY_DESC',
  EligibleForAllAsc = 'ELIGIBLE_FOR_ALL_ASC',
  EligibleForAllDesc = 'ELIGIBLE_FOR_ALL_DESC',
  EndDateAsc = 'END_DATE_ASC',
  EndDateDesc = 'END_DATE_DESC',
  GracePeriodAsc = 'GRACE_PERIOD_ASC',
  GracePeriodDesc = 'GRACE_PERIOD_DESC',
  IconAsc = 'ICON_ASC',
  IconDesc = 'ICON_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  InstantRedeemAsc = 'INSTANT_REDEEM_ASC',
  InstantRedeemDesc = 'INSTANT_REDEEM_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProgramIdAsc = 'PROGRAM_ID_ASC',
  ProgramIdDesc = 'PROGRAM_ID_DESC',
  RewardAmountAsc = 'REWARD_AMOUNT_ASC',
  RewardAmountDesc = 'REWARD_AMOUNT_DESC',
  RewardCurrencyAsc = 'REWARD_CURRENCY_ASC',
  RewardCurrencyDesc = 'REWARD_CURRENCY_DESC',
  RewardEventAsc = 'REWARD_EVENT_ASC',
  RewardEventDesc = 'REWARD_EVENT_DESC',
  StartDateAsc = 'START_DATE_ASC',
  StartDateDesc = 'START_DATE_DESC',
  TitleStringKeyAsc = 'TITLE_STRING_KEY_ASC',
  TitleStringKeyDesc = 'TITLE_STRING_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  WarehouseRowIdAsc = 'WAREHOUSE_ROW_ID_ASC',
  WarehouseRowIdDesc = 'WAREHOUSE_ROW_ID_DESC'
}

/** A connection to a list of `ProgramRewardConfig` values. */
export interface ProgramRewardConfigsConnection {
  __typename: 'ProgramRewardConfigsConnection';
  /** A list of edges which contains the `ProgramRewardConfig` and cursor to aid in pagination. */
  edges: Array<ProgramRewardConfigsEdge>;
  /** A list of `ProgramRewardConfig` objects. */
  nodes: Array<Maybe<ProgramRewardConfig>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProgramRewardConfig` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `ProgramRewardConfig` edge in the connection. */
export interface ProgramRewardConfigsEdge {
  __typename: 'ProgramRewardConfigsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `ProgramRewardConfig` at the end of the edge. */
  node: Maybe<ProgramRewardConfig>;
}

export interface ProgramRewardConfig extends Node {
  __typename: 'ProgramRewardConfig';
  /** toggles rewards on or off */
  active: Scalars['Boolean'];
  /** Reads a single `Admin` that is related to this `ProgramRewardConfig`. */
  adminByAdminId: Maybe<Admin>;
  adminId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  descStringKey: Maybe<Scalars['String']>;
  /** if all enrolled members should get this reward; vs segmentation or client caregap/tbd */
  eligibleForAll: Scalars['Boolean'];
  endDate: Scalars['Date'];
  /** number of days after end_date the rewards remains redeemable */
  gracePeriod: Scalars['Int'];
  icon: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** does the reward move from eligible=>rewarded or eligible=>redeemable */
  instantRedeem: Scalars['Boolean'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Program` that is related to this `ProgramRewardConfig`. */
  programByProgramId: Maybe<Program>;
  programId: Scalars['UUID'];
  /** Reads and enables pagination through a set of `ProgramReward`. */
  programRewardsByName: ProgramRewardsConnection;
  /** Reads and enables pagination through a set of `ProgramReward`. */
  programRewardsByProgramRewardConfigId: ProgramRewardsConnection;
  rewardAmount: Scalars['BigFloat'];
  rewardCurrency: Currency;
  /** enum list of reward events like ENROLLED, ADDRESS_CONFIRMED, EMAIL_CONFIRMED, BREAST_CANCER_SCREEN etc */
  rewardEvent: Scalars['String'];
  startDate: Scalars['Date'];
  titleStringKey: Maybe<Scalars['String']>;
  updatedAt: Scalars['Datetime'];
  warehouseRowId: Scalars['BigInt'];
}


export interface ProgramRewardConfigProgramRewardsByNameArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProgramRewardCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProgramRewardsOrderBy>>;
}


export interface ProgramRewardConfigProgramRewardsByProgramRewardConfigIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProgramRewardCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProgramRewardsOrderBy>>;
}

/**
 * A condition to be used against `ProgramReward` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface ProgramRewardCondition {
  /** Checks for equality with the object’s `accountTransactionId` field. */
  accountTransactionId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `closeReason` field. */
  closeReason?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `patientId` field. */
  patientId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `programRewardConfigId` field. */
  programRewardConfigId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `rewardCurrency` field. */
  rewardCurrency?: InputMaybe<Currency>;
  /** Checks for equality with the object’s `rewardedAmount` field. */
  rewardedAmount?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `warehouseRowId` field. */
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** Methods to use when ordering `ProgramReward`. */
export enum ProgramRewardsOrderBy {
  AccountTransactionIdAsc = 'ACCOUNT_TRANSACTION_ID_ASC',
  AccountTransactionIdDesc = 'ACCOUNT_TRANSACTION_ID_DESC',
  CloseReasonAsc = 'CLOSE_REASON_ASC',
  CloseReasonDesc = 'CLOSE_REASON_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PatientIdAsc = 'PATIENT_ID_ASC',
  PatientIdDesc = 'PATIENT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProgramRewardConfigIdAsc = 'PROGRAM_REWARD_CONFIG_ID_ASC',
  ProgramRewardConfigIdDesc = 'PROGRAM_REWARD_CONFIG_ID_DESC',
  RewardCurrencyAsc = 'REWARD_CURRENCY_ASC',
  RewardCurrencyDesc = 'REWARD_CURRENCY_DESC',
  RewardedAmountAsc = 'REWARDED_AMOUNT_ASC',
  RewardedAmountDesc = 'REWARDED_AMOUNT_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  WarehouseRowIdAsc = 'WAREHOUSE_ROW_ID_ASC',
  WarehouseRowIdDesc = 'WAREHOUSE_ROW_ID_DESC'
}

/** A connection to a list of `ProgramReward` values. */
export interface ProgramRewardsConnection {
  __typename: 'ProgramRewardsConnection';
  /** A list of edges which contains the `ProgramReward` and cursor to aid in pagination. */
  edges: Array<ProgramRewardsEdge>;
  /** A list of `ProgramReward` objects. */
  nodes: Array<Maybe<ProgramReward>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProgramReward` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `ProgramReward` edge in the connection. */
export interface ProgramRewardsEdge {
  __typename: 'ProgramRewardsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `ProgramReward` at the end of the edge. */
  node: Maybe<ProgramReward>;
}

export interface ProgramReward extends Node {
  __typename: 'ProgramReward';
  /** Reads a single `AccountTransaction` that is related to this `ProgramReward`. */
  accountTransactionByAccountTransactionId: Maybe<AccountTransaction>;
  accountTransactionId: Maybe<Scalars['UUID']>;
  /** expected reason is expired, but future proofing for other reasons */
  closeReason: Maybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  id: Scalars['UUID'];
  /** tracks the wellth internal reward name for convenience */
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Patient` that is related to this `ProgramReward`. */
  patientByPatientId: Maybe<Patient>;
  patientId: Scalars['UUID'];
  /** Reads a single `ProgramRewardConfig` that is related to this `ProgramReward`. */
  programRewardConfigByName: Maybe<ProgramRewardConfig>;
  /** Reads a single `ProgramRewardConfig` that is related to this `ProgramReward`. */
  programRewardConfigByProgramRewardConfigId: Maybe<ProgramRewardConfig>;
  programRewardConfigId: Scalars['UUID'];
  rewardCurrency: Currency;
  rewardedAmount: Maybe<Scalars['BigFloat']>;
  /** expiry is config end_date for eligible; config end_date+grace_period for redeemable; redeemable means ready-to-redeem */
  status: Scalars['String'];
  updatedAt: Scalars['Datetime'];
  warehouseRowId: Scalars['BigInt'];
}

export interface ProgramTemplate extends Node {
  __typename: 'ProgramTemplate';
  createdAt: Scalars['Datetime'];
  id: Scalars['UUID'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `Program`. */
  programsByProgramTemplate: ProgramsConnection;
  updatedAt: Scalars['Datetime'];
}


export interface ProgramTemplateProgramsByProgramTemplateArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProgramCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProgramsOrderBy>>;
}

/**
 * A condition to be used against `ReminderConfig` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface ReminderConfigCondition {
  /** Checks for equality with the object’s `adminId` field. */
  adminId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `checkInCategory` field. */
  checkInCategory?: InputMaybe<CheckInCategory>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `friTime` field. */
  friTime?: InputMaybe<Scalars['Time']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `interval` field. */
  interval?: InputMaybe<ReminderInterval>;
  /** Checks for equality with the object’s `intervalCount` field. */
  intervalCount?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `isDemo` field. */
  isDemo?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isRequired` field. */
  isRequired?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `lengthInDays` field. */
  lengthInDays?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `monTime` field. */
  monTime?: InputMaybe<Scalars['Time']>;
  /** Checks for equality with the object’s `programId` field. */
  programId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `satTime` field. */
  satTime?: InputMaybe<Scalars['Time']>;
  /** Checks for equality with the object’s `selfServeDefault` field. */
  selfServeDefault?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `startDayIndex` field. */
  startDayIndex?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `sunTime` field. */
  sunTime?: InputMaybe<Scalars['Time']>;
  /** Checks for equality with the object’s `thuTime` field. */
  thuTime?: InputMaybe<Scalars['Time']>;
  /** Checks for equality with the object’s `tueTime` field. */
  tueTime?: InputMaybe<Scalars['Time']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `warehouseRowId` field. */
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `wedTime` field. */
  wedTime?: InputMaybe<Scalars['Time']>;
  /** Checks for equality with the object’s `windowAfterMinutes` field. */
  windowAfterMinutes?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `windowBeforeMinutes` field. */
  windowBeforeMinutes?: InputMaybe<Scalars['Int']>;
}

/** Methods to use when ordering `ReminderConfig`. */
export enum ReminderConfigsOrderBy {
  AdminIdAsc = 'ADMIN_ID_ASC',
  AdminIdDesc = 'ADMIN_ID_DESC',
  CheckInCategoryAsc = 'CHECK_IN_CATEGORY_ASC',
  CheckInCategoryDesc = 'CHECK_IN_CATEGORY_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  FriTimeAsc = 'FRI_TIME_ASC',
  FriTimeDesc = 'FRI_TIME_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IntervalAsc = 'INTERVAL_ASC',
  IntervalCountAsc = 'INTERVAL_COUNT_ASC',
  IntervalCountDesc = 'INTERVAL_COUNT_DESC',
  IntervalDesc = 'INTERVAL_DESC',
  IsDemoAsc = 'IS_DEMO_ASC',
  IsDemoDesc = 'IS_DEMO_DESC',
  IsRequiredAsc = 'IS_REQUIRED_ASC',
  IsRequiredDesc = 'IS_REQUIRED_DESC',
  LengthInDaysAsc = 'LENGTH_IN_DAYS_ASC',
  LengthInDaysDesc = 'LENGTH_IN_DAYS_DESC',
  MonTimeAsc = 'MON_TIME_ASC',
  MonTimeDesc = 'MON_TIME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProgramIdAsc = 'PROGRAM_ID_ASC',
  ProgramIdDesc = 'PROGRAM_ID_DESC',
  SatTimeAsc = 'SAT_TIME_ASC',
  SatTimeDesc = 'SAT_TIME_DESC',
  SelfServeDefaultAsc = 'SELF_SERVE_DEFAULT_ASC',
  SelfServeDefaultDesc = 'SELF_SERVE_DEFAULT_DESC',
  StartDayIndexAsc = 'START_DAY_INDEX_ASC',
  StartDayIndexDesc = 'START_DAY_INDEX_DESC',
  SunTimeAsc = 'SUN_TIME_ASC',
  SunTimeDesc = 'SUN_TIME_DESC',
  ThuTimeAsc = 'THU_TIME_ASC',
  ThuTimeDesc = 'THU_TIME_DESC',
  TueTimeAsc = 'TUE_TIME_ASC',
  TueTimeDesc = 'TUE_TIME_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  WarehouseRowIdAsc = 'WAREHOUSE_ROW_ID_ASC',
  WarehouseRowIdDesc = 'WAREHOUSE_ROW_ID_DESC',
  WedTimeAsc = 'WED_TIME_ASC',
  WedTimeDesc = 'WED_TIME_DESC',
  WindowAfterMinutesAsc = 'WINDOW_AFTER_MINUTES_ASC',
  WindowAfterMinutesDesc = 'WINDOW_AFTER_MINUTES_DESC',
  WindowBeforeMinutesAsc = 'WINDOW_BEFORE_MINUTES_ASC',
  WindowBeforeMinutesDesc = 'WINDOW_BEFORE_MINUTES_DESC'
}

/** A connection to a list of `ReminderConfig` values. */
export interface ReminderConfigsConnection {
  __typename: 'ReminderConfigsConnection';
  /** A list of edges which contains the `ReminderConfig` and cursor to aid in pagination. */
  edges: Array<ReminderConfigsEdge>;
  /** A list of `ReminderConfig` objects. */
  nodes: Array<Maybe<ReminderConfig>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ReminderConfig` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `ReminderConfig` edge in the connection. */
export interface ReminderConfigsEdge {
  __typename: 'ReminderConfigsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `ReminderConfig` at the end of the edge. */
  node: Maybe<ReminderConfig>;
}

/**
 * A condition to be used against `RewardPeriodConfig` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface RewardPeriodConfigCondition {
  /** Checks for equality with the object’s `adminId` field. */
  adminId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `appointmentLoss` field. */
  appointmentLoss?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `lengthInDays` field. */
  lengthInDays?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `lossPerDayMax` field. */
  lossPerDayMax?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `lossType` field. */
  lossType?: InputMaybe<LossType>;
  /** Checks for equality with the object’s `programId` field. */
  programId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `rewardAmount` field. */
  rewardAmount?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `rewardCurrency` field. */
  rewardCurrency?: InputMaybe<Currency>;
  /** Checks for equality with the object’s `startDayIndex` field. */
  startDayIndex?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `warehouseRowId` field. */
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `winBackStrategy` field. */
  winBackStrategy?: InputMaybe<WinBackStrategy>;
}

export enum LossType {
  Fixed = 'FIXED',
  Random = 'RANDOM'
}

export enum WinBackStrategy {
  Appointment = 'APPOINTMENT'
}

/** Methods to use when ordering `RewardPeriodConfig`. */
export enum RewardPeriodConfigsOrderBy {
  AdminIdAsc = 'ADMIN_ID_ASC',
  AdminIdDesc = 'ADMIN_ID_DESC',
  AppointmentLossAsc = 'APPOINTMENT_LOSS_ASC',
  AppointmentLossDesc = 'APPOINTMENT_LOSS_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LengthInDaysAsc = 'LENGTH_IN_DAYS_ASC',
  LengthInDaysDesc = 'LENGTH_IN_DAYS_DESC',
  LossPerDayMaxAsc = 'LOSS_PER_DAY_MAX_ASC',
  LossPerDayMaxDesc = 'LOSS_PER_DAY_MAX_DESC',
  LossTypeAsc = 'LOSS_TYPE_ASC',
  LossTypeDesc = 'LOSS_TYPE_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProgramIdAsc = 'PROGRAM_ID_ASC',
  ProgramIdDesc = 'PROGRAM_ID_DESC',
  RewardAmountAsc = 'REWARD_AMOUNT_ASC',
  RewardAmountDesc = 'REWARD_AMOUNT_DESC',
  RewardCurrencyAsc = 'REWARD_CURRENCY_ASC',
  RewardCurrencyDesc = 'REWARD_CURRENCY_DESC',
  StartDayIndexAsc = 'START_DAY_INDEX_ASC',
  StartDayIndexDesc = 'START_DAY_INDEX_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  WarehouseRowIdAsc = 'WAREHOUSE_ROW_ID_ASC',
  WarehouseRowIdDesc = 'WAREHOUSE_ROW_ID_DESC',
  WinBackStrategyAsc = 'WIN_BACK_STRATEGY_ASC',
  WinBackStrategyDesc = 'WIN_BACK_STRATEGY_DESC'
}

/** A connection to a list of `RewardPeriodConfig` values. */
export interface RewardPeriodConfigsConnection {
  __typename: 'RewardPeriodConfigsConnection';
  /** A list of edges which contains the `RewardPeriodConfig` and cursor to aid in pagination. */
  edges: Array<RewardPeriodConfigsEdge>;
  /** A list of `RewardPeriodConfig` objects. */
  nodes: Array<Maybe<RewardPeriodConfig>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RewardPeriodConfig` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `RewardPeriodConfig` edge in the connection. */
export interface RewardPeriodConfigsEdge {
  __typename: 'RewardPeriodConfigsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `RewardPeriodConfig` at the end of the edge. */
  node: Maybe<RewardPeriodConfig>;
}

/** A reward_period_config, which specifies the details of a reward_period to be created later. */
export interface RewardPeriodConfig extends Node {
  __typename: 'RewardPeriodConfig';
  /** Reads a single `Admin` that is related to this `RewardPeriodConfig`. */
  adminByAdminId: Maybe<Admin>;
  /** The administrator which created and owns this reward_period_config. */
  adminId: Scalars['UUID'];
  appointmentLoss: Maybe<Scalars['BigFloat']>;
  createdAt: Scalars['Datetime'];
  id: Scalars['UUID'];
  /** The numeric of days for which this reward_period should run. */
  lengthInDays: Scalars['Int'];
  /** The maximum loss per day. */
  lossPerDayMax: Scalars['BigFloat'];
  /** The type of loss for this reward period; default "fixed". */
  lossType: LossType;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Program` that is related to this `RewardPeriodConfig`. */
  programByProgramId: Maybe<Program>;
  /** A reference to the program to which this reward_period_config is tied. */
  programId: Scalars['UUID'];
  /** The maximum amount of money which is possible to receive during this period. */
  rewardAmount: Scalars['BigFloat'];
  /** The currency of the reward. */
  rewardCurrency: Currency;
  /** Reads and enables pagination through a set of `RewardPeriod`. */
  rewardPeriodsByRewardPeriodConfigId: RewardPeriodsConnection;
  /** The numeric of days after the 0th program start day at which this reward_period should start. */
  startDayIndex: Scalars['Int'];
  updatedAt: Scalars['Datetime'];
  warehouseRowId: Scalars['BigInt'];
  winBackStrategy: Maybe<WinBackStrategy>;
}


/** A reward_period_config, which specifies the details of a reward_period to be created later. */
export interface RewardPeriodConfigRewardPeriodsByRewardPeriodConfigIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RewardPeriodCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RewardPeriodsOrderBy>>;
}

/**
 * A condition to be used against `RewardPeriod` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface RewardPeriodCondition {
  /** Checks for equality with the object’s `appointmentLoss` field. */
  appointmentLoss?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `endDate` field. */
  endDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `lossPerDayMax` field. */
  lossPerDayMax?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `lossType` field. */
  lossType?: InputMaybe<LossType>;
  /** Checks for equality with the object’s `patientId` field. */
  patientId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `rewardAmount` field. */
  rewardAmount?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `rewardCurrency` field. */
  rewardCurrency?: InputMaybe<Currency>;
  /** Checks for equality with the object’s `rewardPeriodConfigId` field. */
  rewardPeriodConfigId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `settledAt` field. */
  settledAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `settleDate` field. */
  settleDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `startDate` field. */
  startDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `warehouseRowId` field. */
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `winBackStrategy` field. */
  winBackStrategy?: InputMaybe<WinBackStrategy>;
}

/** Methods to use when ordering `RewardPeriod`. */
export enum RewardPeriodsOrderBy {
  AppointmentLossAsc = 'APPOINTMENT_LOSS_ASC',
  AppointmentLossDesc = 'APPOINTMENT_LOSS_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EndDateAsc = 'END_DATE_ASC',
  EndDateDesc = 'END_DATE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LossPerDayMaxAsc = 'LOSS_PER_DAY_MAX_ASC',
  LossPerDayMaxDesc = 'LOSS_PER_DAY_MAX_DESC',
  LossTypeAsc = 'LOSS_TYPE_ASC',
  LossTypeDesc = 'LOSS_TYPE_DESC',
  Natural = 'NATURAL',
  PatientIdAsc = 'PATIENT_ID_ASC',
  PatientIdDesc = 'PATIENT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RewardAmountAsc = 'REWARD_AMOUNT_ASC',
  RewardAmountDesc = 'REWARD_AMOUNT_DESC',
  RewardCurrencyAsc = 'REWARD_CURRENCY_ASC',
  RewardCurrencyDesc = 'REWARD_CURRENCY_DESC',
  RewardPeriodConfigIdAsc = 'REWARD_PERIOD_CONFIG_ID_ASC',
  RewardPeriodConfigIdDesc = 'REWARD_PERIOD_CONFIG_ID_DESC',
  SettleDateAsc = 'SETTLE_DATE_ASC',
  SettleDateDesc = 'SETTLE_DATE_DESC',
  SettledAtAsc = 'SETTLED_AT_ASC',
  SettledAtDesc = 'SETTLED_AT_DESC',
  StartDateAsc = 'START_DATE_ASC',
  StartDateDesc = 'START_DATE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  WarehouseRowIdAsc = 'WAREHOUSE_ROW_ID_ASC',
  WarehouseRowIdDesc = 'WAREHOUSE_ROW_ID_DESC',
  WinBackStrategyAsc = 'WIN_BACK_STRATEGY_ASC',
  WinBackStrategyDesc = 'WIN_BACK_STRATEGY_DESC'
}

/** A connection to a list of `RewardPeriod` values. */
export interface RewardPeriodsConnection {
  __typename: 'RewardPeriodsConnection';
  /** A list of edges which contains the `RewardPeriod` and cursor to aid in pagination. */
  edges: Array<RewardPeriodsEdge>;
  /** A list of `RewardPeriod` objects. */
  nodes: Array<Maybe<RewardPeriod>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RewardPeriod` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `RewardPeriod` edge in the connection. */
export interface RewardPeriodsEdge {
  __typename: 'RewardPeriodsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `RewardPeriod` at the end of the edge. */
  node: Maybe<RewardPeriod>;
}

/** A reward_period, which specifies how a loss-aversion reward should be calculated during a period for a patient. */
export interface RewardPeriod extends Node {
  __typename: 'RewardPeriod';
  appointmentLoss: Maybe<Scalars['BigFloat']>;
  createdAt: Scalars['Datetime'];
  /** The date at which this reward_period should end. */
  endDate: Scalars['Date'];
  id: Scalars['UUID'];
  /** The maximum loss per day. */
  lossPerDayMax: Scalars['BigFloat'];
  /** The type of loss for this reward period; default "fixed". */
  lossType: LossType;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Patient` that is related to this `RewardPeriod`. */
  patientByPatientId: Maybe<Patient>;
  /** The patient which owns this reward_period. */
  patientId: Scalars['UUID'];
  /** The maximum amount of money which is possible to receive during this period. */
  rewardAmount: Scalars['BigFloat'];
  /** The currency of the reward. */
  rewardCurrency: Currency;
  /** Reads a single `RewardPeriodConfig` that is related to this `RewardPeriod`. */
  rewardPeriodConfigByRewardPeriodConfigId: Maybe<RewardPeriodConfig>;
  /** A reference to the reward_period_config from which this reward_period was generated (if applicable). */
  rewardPeriodConfigId: Maybe<Scalars['UUID']>;
  settledAt: Maybe<Scalars['Datetime']>;
  settleDate: Scalars['Date'];
  /** The date at which this reward_period should start. */
  startDate: Scalars['Date'];
  updatedAt: Scalars['Datetime'];
  warehouseRowId: Scalars['BigInt'];
  winBackStrategy: Maybe<WinBackStrategy>;
}

/**
 * A condition to be used against `WalkthroughSetupConfig` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export interface WalkthroughSetupConfigCondition {
  /** Checks for equality with the object’s `adminId` field. */
  adminId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `note` field. */
  note?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `programId` field. */
  programId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `walkthroughId` field. */
  walkthroughId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `warehouseRowId` field. */
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** Methods to use when ordering `WalkthroughSetupConfig`. */
export enum WalkthroughSetupConfigsOrderBy {
  AdminIdAsc = 'ADMIN_ID_ASC',
  AdminIdDesc = 'ADMIN_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  NoteAsc = 'NOTE_ASC',
  NoteDesc = 'NOTE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProgramIdAsc = 'PROGRAM_ID_ASC',
  ProgramIdDesc = 'PROGRAM_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  WalkthroughIdAsc = 'WALKTHROUGH_ID_ASC',
  WalkthroughIdDesc = 'WALKTHROUGH_ID_DESC',
  WarehouseRowIdAsc = 'WAREHOUSE_ROW_ID_ASC',
  WarehouseRowIdDesc = 'WAREHOUSE_ROW_ID_DESC'
}

/** A connection to a list of `WalkthroughSetupConfig` values. */
export interface WalkthroughSetupConfigsConnection {
  __typename: 'WalkthroughSetupConfigsConnection';
  /** A list of edges which contains the `WalkthroughSetupConfig` and cursor to aid in pagination. */
  edges: Array<WalkthroughSetupConfigsEdge>;
  /** A list of `WalkthroughSetupConfig` objects. */
  nodes: Array<Maybe<WalkthroughSetupConfig>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `WalkthroughSetupConfig` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `WalkthroughSetupConfig` edge in the connection. */
export interface WalkthroughSetupConfigsEdge {
  __typename: 'WalkthroughSetupConfigsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `WalkthroughSetupConfig` at the end of the edge. */
  node: Maybe<WalkthroughSetupConfig>;
}

/** A configuration that describes the walkthrough that should be used for a new patient to be enrolled in a given program. */
export interface WalkthroughSetupConfig extends Node {
  __typename: 'WalkthroughSetupConfig';
  /** Reads a single `Admin` that is related to this `WalkthroughSetupConfig`. */
  adminByAdminId: Maybe<Admin>;
  /** The admin which owns this walkthrough setup config. */
  adminId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  id: Scalars['UUID'];
  /** The name of this walkthrough setup config. */
  name: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** An optional freetext note about this walkthrough setup config. */
  note: Maybe<Scalars['String']>;
  /** Reads a single `Program` that is related to this `WalkthroughSetupConfig`. */
  programByProgramId: Maybe<Program>;
  /** The id of the program to which this walkthrough setup config is related (optional). */
  programId: Maybe<Scalars['UUID']>;
  updatedAt: Scalars['Datetime'];
  /** Reads a single `Walkthrough` that is related to this `WalkthroughSetupConfig`. */
  walkthroughByWalkthroughId: Maybe<Walkthrough>;
  /** The walkthrough for this configuration. */
  walkthroughId: Scalars['UUID'];
  /** Reads and enables pagination through a set of `WalkthroughSetup`. */
  walkthroughSetupsByWalkthroughSetupConfigId: WalkthroughSetupsConnection;
  warehouseRowId: Scalars['BigInt'];
}


/** A configuration that describes the walkthrough that should be used for a new patient to be enrolled in a given program. */
export interface WalkthroughSetupConfigWalkthroughSetupsByWalkthroughSetupConfigIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<WalkthroughSetupCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WalkthroughSetupsOrderBy>>;
}

/** Describes how to render each walkthrough page by language and walkthrough */
export interface Walkthrough extends Node {
  __typename: 'Walkthrough';
  /** Reads a single `Admin` that is related to this `Walkthrough`. */
  adminByAdminId: Maybe<Admin>;
  adminId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  id: Scalars['UUID'];
  name: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  updatedAt: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `WalkthroughPage`. */
  walkthroughPagesByWalkthroughId: WalkthroughPagesConnection;
  /** Reads and enables pagination through a set of `WalkthroughSetupConfig`. */
  walkthroughSetupConfigsByWalkthroughId: WalkthroughSetupConfigsConnection;
  /** Reads and enables pagination through a set of `WalkthroughSetup`. */
  walkthroughSetupsByWalkthroughId: WalkthroughSetupsConnection;
  /** Reads and enables pagination through a set of `WalkthroughSummary`. */
  walkthroughSummariesByWalkthroughId: WalkthroughSummariesConnection;
  warehouseRowId: Scalars['BigInt'];
}


/** Describes how to render each walkthrough page by language and walkthrough */
export interface WalkthroughWalkthroughPagesByWalkthroughIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<WalkthroughPageCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WalkthroughPagesOrderBy>>;
}


/** Describes how to render each walkthrough page by language and walkthrough */
export interface WalkthroughWalkthroughSetupConfigsByWalkthroughIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<WalkthroughSetupConfigCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WalkthroughSetupConfigsOrderBy>>;
}


/** Describes how to render each walkthrough page by language and walkthrough */
export interface WalkthroughWalkthroughSetupsByWalkthroughIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<WalkthroughSetupCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WalkthroughSetupsOrderBy>>;
}


/** Describes how to render each walkthrough page by language and walkthrough */
export interface WalkthroughWalkthroughSummariesByWalkthroughIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<WalkthroughSummaryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WalkthroughSummariesOrderBy>>;
}

/**
 * A condition to be used against `WalkthroughPage` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface WalkthroughPageCondition {
  /** Checks for equality with the object’s `adminId` field. */
  adminId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `backgroundColor` field. */
  backgroundColor?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `detail` field. */
  detail?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `icon` field. */
  icon?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `language` field. */
  language?: InputMaybe<LanguageCode>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `pageIndex` field. */
  pageIndex?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `title` field. */
  title?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `walkthroughId` field. */
  walkthroughId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `warehouseRowId` field. */
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

export enum LanguageCode {
  En = 'EN',
  Es = 'ES',
  Ru = 'RU'
}

/** Methods to use when ordering `WalkthroughPage`. */
export enum WalkthroughPagesOrderBy {
  AdminIdAsc = 'ADMIN_ID_ASC',
  AdminIdDesc = 'ADMIN_ID_DESC',
  BackgroundColorAsc = 'BACKGROUND_COLOR_ASC',
  BackgroundColorDesc = 'BACKGROUND_COLOR_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DetailAsc = 'DETAIL_ASC',
  DetailDesc = 'DETAIL_DESC',
  IconAsc = 'ICON_ASC',
  IconDesc = 'ICON_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LanguageAsc = 'LANGUAGE_ASC',
  LanguageDesc = 'LANGUAGE_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PageIndexAsc = 'PAGE_INDEX_ASC',
  PageIndexDesc = 'PAGE_INDEX_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  WalkthroughIdAsc = 'WALKTHROUGH_ID_ASC',
  WalkthroughIdDesc = 'WALKTHROUGH_ID_DESC',
  WarehouseRowIdAsc = 'WAREHOUSE_ROW_ID_ASC',
  WarehouseRowIdDesc = 'WAREHOUSE_ROW_ID_DESC'
}

/** A connection to a list of `WalkthroughPage` values. */
export interface WalkthroughPagesConnection {
  __typename: 'WalkthroughPagesConnection';
  /** A list of edges which contains the `WalkthroughPage` and cursor to aid in pagination. */
  edges: Array<WalkthroughPagesEdge>;
  /** A list of `WalkthroughPage` objects. */
  nodes: Array<Maybe<WalkthroughPage>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `WalkthroughPage` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `WalkthroughPage` edge in the connection. */
export interface WalkthroughPagesEdge {
  __typename: 'WalkthroughPagesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `WalkthroughPage` at the end of the edge. */
  node: Maybe<WalkthroughPage>;
}

/** Describes how to render each walkthrough page by language and walkthrough */
export interface WalkthroughPage extends Node {
  __typename: 'WalkthroughPage';
  /** Reads a single `Admin` that is related to this `WalkthroughPage`. */
  adminByAdminId: Maybe<Admin>;
  adminId: Scalars['UUID'];
  /** The background color of this walkthrough page */
  backgroundColor: Maybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  /** The text to render in the body of this walkthrough page */
  detail: Scalars['String'];
  /** The icon for this walkthrough page */
  icon: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** The language of this walkthrough */
  language: LanguageCode;
  /** The name of this walkthrough (i.e. could match the program name) */
  name: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** The order in which this walkthrough page is shown in the specific walkthrough */
  pageIndex: Scalars['Int'];
  /** The text to render in the title of this walkthrough page */
  title: Scalars['String'];
  updatedAt: Scalars['Datetime'];
  /** Reads a single `Walkthrough` that is related to this `WalkthroughPage`. */
  walkthroughByWalkthroughId: Maybe<Walkthrough>;
  /** The identifier for this walkthrough (a specific series of walkthrough pages, shown in sequence) */
  walkthroughId: Maybe<Scalars['UUID']>;
  warehouseRowId: Scalars['BigInt'];
}

/**
 * A condition to be used against `WalkthroughSetup` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface WalkthroughSetupCondition {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `note` field. */
  note?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `patientId` field. */
  patientId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `walkthroughId` field. */
  walkthroughId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `walkthroughSetupConfigId` field. */
  walkthroughSetupConfigId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `warehouseRowId` field. */
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** Methods to use when ordering `WalkthroughSetup`. */
export enum WalkthroughSetupsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  NoteAsc = 'NOTE_ASC',
  NoteDesc = 'NOTE_DESC',
  PatientIdAsc = 'PATIENT_ID_ASC',
  PatientIdDesc = 'PATIENT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  WalkthroughIdAsc = 'WALKTHROUGH_ID_ASC',
  WalkthroughIdDesc = 'WALKTHROUGH_ID_DESC',
  WalkthroughSetupConfigIdAsc = 'WALKTHROUGH_SETUP_CONFIG_ID_ASC',
  WalkthroughSetupConfigIdDesc = 'WALKTHROUGH_SETUP_CONFIG_ID_DESC',
  WarehouseRowIdAsc = 'WAREHOUSE_ROW_ID_ASC',
  WarehouseRowIdDesc = 'WAREHOUSE_ROW_ID_DESC'
}

/** A connection to a list of `WalkthroughSetup` values. */
export interface WalkthroughSetupsConnection {
  __typename: 'WalkthroughSetupsConnection';
  /** A list of edges which contains the `WalkthroughSetup` and cursor to aid in pagination. */
  edges: Array<WalkthroughSetupsEdge>;
  /** A list of `WalkthroughSetup` objects. */
  nodes: Array<Maybe<WalkthroughSetup>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `WalkthroughSetup` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `WalkthroughSetup` edge in the connection. */
export interface WalkthroughSetupsEdge {
  __typename: 'WalkthroughSetupsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `WalkthroughSetup` at the end of the edge. */
  node: Maybe<WalkthroughSetup>;
}

/** A configuration that describes which walkthrough to use for a given patient. */
export interface WalkthroughSetup extends Node {
  __typename: 'WalkthroughSetup';
  createdAt: Scalars['Datetime'];
  id: Scalars['UUID'];
  name: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  note: Maybe<Scalars['String']>;
  /** Reads a single `Patient` that is related to this `WalkthroughSetup`. */
  patientByPatientId: Maybe<Patient>;
  /** The patient which owns this walkthrough setup. */
  patientId: Scalars['UUID'];
  updatedAt: Scalars['Datetime'];
  /** Reads a single `Walkthrough` that is related to this `WalkthroughSetup`. */
  walkthroughByWalkthroughId: Maybe<Walkthrough>;
  /** The id of the walkthrough configured for the given patient. */
  walkthroughId: Scalars['UUID'];
  /** Reads a single `WalkthroughSetupConfig` that is related to this `WalkthroughSetup`. */
  walkthroughSetupConfigByWalkthroughSetupConfigId: Maybe<WalkthroughSetupConfig>;
  /** The id of the walkthrough setup config from which this walkthrough setup was created. */
  walkthroughSetupConfigId: Maybe<Scalars['UUID']>;
  warehouseRowId: Scalars['BigInt'];
}

/**
 * A condition to be used against `WalkthroughSummary` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface WalkthroughSummaryCondition {
  /** Checks for equality with the object’s `adminId` field. */
  adminId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `detail` field. */
  detail?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `icon` field. */
  icon?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `index` field. */
  index?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `walkthroughId` field. */
  walkthroughId?: InputMaybe<Scalars['UUID']>;
}

/** Methods to use when ordering `WalkthroughSummary`. */
export enum WalkthroughSummariesOrderBy {
  AdminIdAsc = 'ADMIN_ID_ASC',
  AdminIdDesc = 'ADMIN_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DetailAsc = 'DETAIL_ASC',
  DetailDesc = 'DETAIL_DESC',
  IconAsc = 'ICON_ASC',
  IconDesc = 'ICON_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IndexAsc = 'INDEX_ASC',
  IndexDesc = 'INDEX_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  WalkthroughIdAsc = 'WALKTHROUGH_ID_ASC',
  WalkthroughIdDesc = 'WALKTHROUGH_ID_DESC'
}

/** A connection to a list of `WalkthroughSummary` values. */
export interface WalkthroughSummariesConnection {
  __typename: 'WalkthroughSummariesConnection';
  /** A list of edges which contains the `WalkthroughSummary` and cursor to aid in pagination. */
  edges: Array<WalkthroughSummariesEdge>;
  /** A list of `WalkthroughSummary` objects. */
  nodes: Array<Maybe<WalkthroughSummary>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `WalkthroughSummary` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `WalkthroughSummary` edge in the connection. */
export interface WalkthroughSummariesEdge {
  __typename: 'WalkthroughSummariesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `WalkthroughSummary` at the end of the edge. */
  node: Maybe<WalkthroughSummary>;
}

export interface WalkthroughSummary extends Node {
  __typename: 'WalkthroughSummary';
  adminId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  detail: Scalars['String'];
  icon: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  index: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  updatedAt: Scalars['Datetime'];
  /** Reads a single `Walkthrough` that is related to this `WalkthroughSummary`. */
  walkthroughByWalkthroughId: Maybe<Walkthrough>;
  walkthroughId: Scalars['UUID'];
}

/**
 * A condition to be used against `Reminder` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export interface ReminderCondition {
  /** Checks for equality with the object’s `checkInCategory` field. */
  checkInCategory?: InputMaybe<CheckInCategory>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `endDate` field. */
  endDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `friTime` field. */
  friTime?: InputMaybe<Scalars['Time']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `interval` field. */
  interval?: InputMaybe<ReminderInterval>;
  /** Checks for equality with the object’s `intervalCount` field. */
  intervalCount?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `isDemo` field. */
  isDemo?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isRequired` field. */
  isRequired?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `linkedFutureReminderId` field. */
  linkedFutureReminderId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `monTime` field. */
  monTime?: InputMaybe<Scalars['Time']>;
  /** Checks for equality with the object’s `patientId` field. */
  patientId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `reminderConfigId` field. */
  reminderConfigId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `satTime` field. */
  satTime?: InputMaybe<Scalars['Time']>;
  /** Checks for equality with the object’s `startDate` field. */
  startDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `sunTime` field. */
  sunTime?: InputMaybe<Scalars['Time']>;
  /** Checks for equality with the object’s `thuTime` field. */
  thuTime?: InputMaybe<Scalars['Time']>;
  /** Checks for equality with the object’s `tueTime` field. */
  tueTime?: InputMaybe<Scalars['Time']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `warehouseRowId` field. */
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `wedTime` field. */
  wedTime?: InputMaybe<Scalars['Time']>;
  /** Checks for equality with the object’s `windowAfterMinutes` field. */
  windowAfterMinutes?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `windowBeforeMinutes` field. */
  windowBeforeMinutes?: InputMaybe<Scalars['Int']>;
}

/** Methods to use when ordering `Reminder`. */
export enum RemindersOrderBy {
  CheckInCategoryAsc = 'CHECK_IN_CATEGORY_ASC',
  CheckInCategoryDesc = 'CHECK_IN_CATEGORY_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EndDateAsc = 'END_DATE_ASC',
  EndDateDesc = 'END_DATE_DESC',
  FriTimeAsc = 'FRI_TIME_ASC',
  FriTimeDesc = 'FRI_TIME_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IntervalAsc = 'INTERVAL_ASC',
  IntervalCountAsc = 'INTERVAL_COUNT_ASC',
  IntervalCountDesc = 'INTERVAL_COUNT_DESC',
  IntervalDesc = 'INTERVAL_DESC',
  IsDemoAsc = 'IS_DEMO_ASC',
  IsDemoDesc = 'IS_DEMO_DESC',
  IsRequiredAsc = 'IS_REQUIRED_ASC',
  IsRequiredDesc = 'IS_REQUIRED_DESC',
  LabelAsc = 'LABEL_ASC',
  LabelDesc = 'LABEL_DESC',
  LinkedFutureReminderIdAsc = 'LINKED_FUTURE_REMINDER_ID_ASC',
  LinkedFutureReminderIdDesc = 'LINKED_FUTURE_REMINDER_ID_DESC',
  MonTimeAsc = 'MON_TIME_ASC',
  MonTimeDesc = 'MON_TIME_DESC',
  Natural = 'NATURAL',
  PatientIdAsc = 'PATIENT_ID_ASC',
  PatientIdDesc = 'PATIENT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ReminderConfigIdAsc = 'REMINDER_CONFIG_ID_ASC',
  ReminderConfigIdDesc = 'REMINDER_CONFIG_ID_DESC',
  SatTimeAsc = 'SAT_TIME_ASC',
  SatTimeDesc = 'SAT_TIME_DESC',
  StartDateAsc = 'START_DATE_ASC',
  StartDateDesc = 'START_DATE_DESC',
  SunTimeAsc = 'SUN_TIME_ASC',
  SunTimeDesc = 'SUN_TIME_DESC',
  ThuTimeAsc = 'THU_TIME_ASC',
  ThuTimeDesc = 'THU_TIME_DESC',
  TueTimeAsc = 'TUE_TIME_ASC',
  TueTimeDesc = 'TUE_TIME_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  WarehouseRowIdAsc = 'WAREHOUSE_ROW_ID_ASC',
  WarehouseRowIdDesc = 'WAREHOUSE_ROW_ID_DESC',
  WedTimeAsc = 'WED_TIME_ASC',
  WedTimeDesc = 'WED_TIME_DESC',
  WindowAfterMinutesAsc = 'WINDOW_AFTER_MINUTES_ASC',
  WindowAfterMinutesDesc = 'WINDOW_AFTER_MINUTES_DESC',
  WindowBeforeMinutesAsc = 'WINDOW_BEFORE_MINUTES_ASC',
  WindowBeforeMinutesDesc = 'WINDOW_BEFORE_MINUTES_DESC'
}

/** A connection to a list of `Reminder` values. */
export interface RemindersConnection {
  __typename: 'RemindersConnection';
  /** A list of edges which contains the `Reminder` and cursor to aid in pagination. */
  edges: Array<RemindersEdge>;
  /** A list of `Reminder` objects. */
  nodes: Array<Maybe<Reminder>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Reminder` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `Reminder` edge in the connection. */
export interface RemindersEdge {
  __typename: 'RemindersEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Reminder` at the end of the edge. */
  node: Maybe<Reminder>;
}

/**
 * A condition to be used against `ReminderMessage` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface ReminderMessageCondition {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `messageId` field. */
  messageId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `messageTime` field. */
  messageTime?: InputMaybe<Scalars['Time']>;
  /** Checks for equality with the object’s `messageType` field. */
  messageType?: InputMaybe<ReminderMessageType>;
  /** Checks for equality with the object’s `minutesRemaining` field. */
  minutesRemaining?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `patientId` field. */
  patientId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `reminderDay` field. */
  reminderDay?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `reminderId` field. */
  reminderId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `reminderTime` field. */
  reminderTime?: InputMaybe<Scalars['Time']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<ReminderMessageStatus>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `warehouseRowId` field. */
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

export enum ReminderMessageType {
  Midwindow = 'MIDWINDOW',
  Nearend = 'NEAREND'
}

export enum ReminderMessageStatus {
  MessageCreated = 'MESSAGE_CREATED',
  Pending = 'PENDING'
}

/** Methods to use when ordering `ReminderMessage`. */
export enum ReminderMessagesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MessageIdAsc = 'MESSAGE_ID_ASC',
  MessageIdDesc = 'MESSAGE_ID_DESC',
  MessageTimeAsc = 'MESSAGE_TIME_ASC',
  MessageTimeDesc = 'MESSAGE_TIME_DESC',
  MessageTypeAsc = 'MESSAGE_TYPE_ASC',
  MessageTypeDesc = 'MESSAGE_TYPE_DESC',
  MinutesRemainingAsc = 'MINUTES_REMAINING_ASC',
  MinutesRemainingDesc = 'MINUTES_REMAINING_DESC',
  Natural = 'NATURAL',
  PatientIdAsc = 'PATIENT_ID_ASC',
  PatientIdDesc = 'PATIENT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ReminderDayAsc = 'REMINDER_DAY_ASC',
  ReminderDayDesc = 'REMINDER_DAY_DESC',
  ReminderIdAsc = 'REMINDER_ID_ASC',
  ReminderIdDesc = 'REMINDER_ID_DESC',
  ReminderTimeAsc = 'REMINDER_TIME_ASC',
  ReminderTimeDesc = 'REMINDER_TIME_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  WarehouseRowIdAsc = 'WAREHOUSE_ROW_ID_ASC',
  WarehouseRowIdDesc = 'WAREHOUSE_ROW_ID_DESC'
}

/** A connection to a list of `ReminderMessage` values. */
export interface ReminderMessagesConnection {
  __typename: 'ReminderMessagesConnection';
  /** A list of edges which contains the `ReminderMessage` and cursor to aid in pagination. */
  edges: Array<ReminderMessagesEdge>;
  /** A list of `ReminderMessage` objects. */
  nodes: Array<Maybe<ReminderMessage>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ReminderMessage` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `ReminderMessage` edge in the connection. */
export interface ReminderMessagesEdge {
  __typename: 'ReminderMessagesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `ReminderMessage` at the end of the edge. */
  node: Maybe<ReminderMessage>;
}

/** A reminder message, which indicates that a reminder SMS message has been triggered to be sent to the patient */
export interface ReminderMessage extends Node {
  __typename: 'ReminderMessage';
  createdAt: Scalars['Datetime'];
  id: Scalars['UUID'];
  /** Reads a single `Message` that is related to this `ReminderMessage`. */
  messageByMessageId: Maybe<Message>;
  /** The id of the actual SMS message that was sent to remind the patient */
  messageId: Maybe<Scalars['UUID']>;
  /** The time for which the message was sent */
  messageTime: Scalars['Time'];
  /** The type of reminder message this is; can be "midwindow" or "nearend" */
  messageType: ReminderMessageType;
  /** The number of minutes remaining in the window when the reminder message was generated */
  minutesRemaining: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Patient` that is related to this `ReminderMessage`. */
  patientByPatientId: Maybe<Patient>;
  /** The id of the patient to whom this reminder message will be sent */
  patientId: Scalars['UUID'];
  /** Reads a single `Reminder` that is related to this `ReminderMessage`. */
  reminderByReminderId: Maybe<Reminder>;
  /** The day on which the reminder was due */
  reminderDay: Scalars['Date'];
  /** The id of the reminder that this message references */
  reminderId: Scalars['UUID'];
  /** The time at which the reminder was due */
  reminderTime: Scalars['Time'];
  /** The status of the reminder message; can be "pending" or "message_created" */
  status: ReminderMessageStatus;
  updatedAt: Scalars['Datetime'];
  warehouseRowId: Scalars['BigInt'];
}

/** A message sent to or from a patient via the Wellth platform. */
export interface Message extends Node {
  __typename: 'Message';
  /** Reads a single `Admin` that is related to this `Message`. */
  adminByAdminId: Maybe<Admin>;
  /** The admin to or from whom this message is sent; optional */
  adminId: Maybe<Scalars['UUID']>;
  createdAt: Scalars['Datetime'];
  externalId: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  mediaUrls: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The content of the message. */
  message: Maybe<Scalars['String']>;
  messageType: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Patient` that is related to this `Message`. */
  patientByPatientId: Maybe<Patient>;
  /** The patient to or from whom this message is sent */
  patientId: Maybe<Scalars['UUID']>;
  /** The protocol over which the message was sent. */
  protocol: MessageProtocol;
  /** The party who is the recipient of this message */
  recipient: MessageRecipient;
  /** Reads and enables pagination through a set of `ReminderMessage`. */
  reminderMessagesByMessageId: ReminderMessagesConnection;
  /** The time at which to send the message. */
  sendAt: Maybe<Scalars['Datetime']>;
  /** The time at which this message was sent. */
  sentDatetime: Scalars['Datetime'];
  sentFrom: Maybe<Scalars['String']>;
  /** The status of the message. */
  status: Scalars['String'];
  /** The optional subject of the message (mostly applicable to emails). */
  subject: Maybe<Scalars['String']>;
  updatedAt: Scalars['Datetime'];
  warehouseRowId: Scalars['BigInt'];
}


/** A message sent to or from a patient via the Wellth platform. */
export interface MessageReminderMessagesByMessageIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ReminderMessageCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReminderMessagesOrderBy>>;
}

export enum MessageProtocol {
  Customer = 'CUSTOMER',
  Email = 'EMAIL',
  Mms = 'MMS',
  Push = 'PUSH',
  Slack = 'SLACK',
  Sms = 'SMS',
  Webhook = 'WEBHOOK'
}

export enum MessageRecipient {
  Admin = 'ADMIN',
  Patient = 'PATIENT',
  System = 'SYSTEM'
}

/** A condition to be used against `Device` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export interface DeviceCondition {
  /** Checks for equality with the object’s `adminId` field. */
  adminId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `identifier` field. */
  identifier?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `patientId` field. */
  patientId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `shortIdentifier` field. */
  shortIdentifier?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `source` field. */
  source?: InputMaybe<DeviceSource>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<DeviceType>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `warehouseRowId` field. */
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

export enum DeviceSource {
  Bodytrace = 'BODYTRACE'
}

export enum DeviceType {
  Scale = 'SCALE'
}

/** Methods to use when ordering `Device`. */
export enum DevicesOrderBy {
  AdminIdAsc = 'ADMIN_ID_ASC',
  AdminIdDesc = 'ADMIN_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IdentifierAsc = 'IDENTIFIER_ASC',
  IdentifierDesc = 'IDENTIFIER_DESC',
  Natural = 'NATURAL',
  PatientIdAsc = 'PATIENT_ID_ASC',
  PatientIdDesc = 'PATIENT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ShortIdentifierAsc = 'SHORT_IDENTIFIER_ASC',
  ShortIdentifierDesc = 'SHORT_IDENTIFIER_DESC',
  SourceAsc = 'SOURCE_ASC',
  SourceDesc = 'SOURCE_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  WarehouseRowIdAsc = 'WAREHOUSE_ROW_ID_ASC',
  WarehouseRowIdDesc = 'WAREHOUSE_ROW_ID_DESC'
}

/** A connection to a list of `Device` values. */
export interface DevicesConnection {
  __typename: 'DevicesConnection';
  /** A list of edges which contains the `Device` and cursor to aid in pagination. */
  edges: Array<DevicesEdge>;
  /** A list of `Device` objects. */
  nodes: Array<Maybe<Device>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Device` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `Device` edge in the connection. */
export interface DevicesEdge {
  __typename: 'DevicesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Device` at the end of the edge. */
  node: Maybe<Device>;
}

/** A physical device that is capable of producing measurements tied to a patient. */
export interface Device extends Node {
  __typename: 'Device';
  /** Reads a single `Admin` that is related to this `Device`. */
  adminByAdminId: Maybe<Admin>;
  /** The ID of the admin who owns this device registration */
  adminId: Maybe<Scalars['UUID']>;
  createdAt: Scalars['Datetime'];
  id: Scalars['UUID'];
  /** The identifier of the device, as created by the manufacturer. */
  identifier: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Patient` that is related to this `Device`. */
  patientByPatientId: Maybe<Patient>;
  /** The patient to whom this device is currently assigned; may be null. */
  patientId: Maybe<Scalars['UUID']>;
  /** The Wellth-assigned short identifier, e.g. ABCD, used to easily reference this specific device upon onboarding. */
  shortIdentifier: Scalars['String'];
  /** The source of the device, e.g. Bodytrace */
  source: DeviceSource;
  /** The type of the device, e.g. scale */
  type: DeviceType;
  updatedAt: Scalars['Datetime'];
  warehouseRowId: Scalars['BigInt'];
}

/** A condition to be used against `Message` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export interface MessageCondition {
  /** Checks for equality with the object’s `adminId` field. */
  adminId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `externalId` field. */
  externalId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `mediaUrls` field. */
  mediaUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Checks for equality with the object’s `message` field. */
  message?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `messageType` field. */
  messageType?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `patientId` field. */
  patientId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `protocol` field. */
  protocol?: InputMaybe<MessageProtocol>;
  /** Checks for equality with the object’s `recipient` field. */
  recipient?: InputMaybe<MessageRecipient>;
  /** Checks for equality with the object’s `sendAt` field. */
  sendAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `sentDatetime` field. */
  sentDatetime?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `sentFrom` field. */
  sentFrom?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `subject` field. */
  subject?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `warehouseRowId` field. */
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** Methods to use when ordering `Message`. */
export enum MessagesOrderBy {
  AdminIdAsc = 'ADMIN_ID_ASC',
  AdminIdDesc = 'ADMIN_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  ExternalIdAsc = 'EXTERNAL_ID_ASC',
  ExternalIdDesc = 'EXTERNAL_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MediaUrlsAsc = 'MEDIA_URLS_ASC',
  MediaUrlsDesc = 'MEDIA_URLS_DESC',
  MessageAsc = 'MESSAGE_ASC',
  MessageDesc = 'MESSAGE_DESC',
  MessageTypeAsc = 'MESSAGE_TYPE_ASC',
  MessageTypeDesc = 'MESSAGE_TYPE_DESC',
  Natural = 'NATURAL',
  PatientIdAsc = 'PATIENT_ID_ASC',
  PatientIdDesc = 'PATIENT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProtocolAsc = 'PROTOCOL_ASC',
  ProtocolDesc = 'PROTOCOL_DESC',
  RecipientAsc = 'RECIPIENT_ASC',
  RecipientDesc = 'RECIPIENT_DESC',
  SendAtAsc = 'SEND_AT_ASC',
  SendAtDesc = 'SEND_AT_DESC',
  SentDatetimeAsc = 'SENT_DATETIME_ASC',
  SentDatetimeDesc = 'SENT_DATETIME_DESC',
  SentFromAsc = 'SENT_FROM_ASC',
  SentFromDesc = 'SENT_FROM_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  SubjectAsc = 'SUBJECT_ASC',
  SubjectDesc = 'SUBJECT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  WarehouseRowIdAsc = 'WAREHOUSE_ROW_ID_ASC',
  WarehouseRowIdDesc = 'WAREHOUSE_ROW_ID_DESC'
}

/** A connection to a list of `Message` values. */
export interface MessagesConnection {
  __typename: 'MessagesConnection';
  /** A list of edges which contains the `Message` and cursor to aid in pagination. */
  edges: Array<MessagesEdge>;
  /** A list of `Message` objects. */
  nodes: Array<Maybe<Message>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Message` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `Message` edge in the connection. */
export interface MessagesEdge {
  __typename: 'MessagesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Message` at the end of the edge. */
  node: Maybe<Message>;
}

/** A condition to be used against `Patient` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export interface PatientCondition {
  /** Checks for equality with the object’s `activationDate` field. */
  activationDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `activationTimezone` field. */
  activationTimezone?: InputMaybe<Scalars['Timezone']>;
  /** Checks for equality with the object’s `activeDays` field. */
  activeDays?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `build` field. */
  build?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `eligibilityEndDate` field. */
  eligibilityEndDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `enrolledBy` field. */
  enrolledBy?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `enrollmentDate` field. */
  enrollmentDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `enrollmentTimezone` field. */
  enrollmentTimezone?: InputMaybe<Scalars['Timezone']>;
  /** Checks for equality with the object’s `externalId` field. */
  externalId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `externalId2` field. */
  externalId2?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `inactivationDate` field. */
  inactivationDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `inactivationTimezone` field. */
  inactivationTimezone?: InputMaybe<Scalars['Timezone']>;
  /** Checks for equality with the object’s `introductionToWellth` field. */
  introductionToWellth?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `isAutoPauseEnabled` field. */
  isAutoPauseEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isLocalNotificationEnabled` field. */
  isLocalNotificationEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isProductTourCompleted` field. */
  isProductTourCompleted?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isProductTourRecurring` field. */
  isProductTourRecurring?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isReminderEditingOpen` field. */
  isReminderEditingOpen?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isReminderMessagingEnabled` field. */
  isReminderMessagingEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isRestfulPatient` field. */
  isRestfulPatient?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isSidekickEnabled` field. */
  isSidekickEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isTestPatient` field. */
  isTestPatient?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `liveProgramDays` field. */
  liveProgramDays?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `medicaidId` field. */
  medicaidId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `missedCheckinStreak` field. */
  missedCheckinStreak?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `onboardingDate` field. */
  onboardingDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `onboardingTimezone` field. */
  onboardingTimezone?: InputMaybe<Scalars['Timezone']>;
  /** Checks for equality with the object’s `pauseStatus` field. */
  pauseStatus?: InputMaybe<PauseStatus>;
  /** Checks for equality with the object’s `paymentOptionsId` field. */
  paymentOptionsId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `personId` field. */
  personId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `platform` field. */
  platform?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `prospectId` field. */
  prospectId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `secondaryPhoneNumber` field. */
  secondaryPhoneNumber?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `siteName` field. */
  siteName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `typeOfEnrollment` field. */
  typeOfEnrollment?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `version` field. */
  version?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `warehouseRowId` field. */
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

export enum PauseStatus {
  Active = 'ACTIVE',
  Paused = 'PAUSED',
  Pausing = 'PAUSING',
  Unpausing = 'UNPAUSING'
}

/** Methods to use when ordering `Patient`. */
export enum PatientsOrderBy {
  ActivationDateAsc = 'ACTIVATION_DATE_ASC',
  ActivationDateDesc = 'ACTIVATION_DATE_DESC',
  ActivationTimezoneAsc = 'ACTIVATION_TIMEZONE_ASC',
  ActivationTimezoneDesc = 'ACTIVATION_TIMEZONE_DESC',
  ActiveDaysAsc = 'ACTIVE_DAYS_ASC',
  ActiveDaysDesc = 'ACTIVE_DAYS_DESC',
  BuildAsc = 'BUILD_ASC',
  BuildDesc = 'BUILD_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  EligibilityEndDateAsc = 'ELIGIBILITY_END_DATE_ASC',
  EligibilityEndDateDesc = 'ELIGIBILITY_END_DATE_DESC',
  EnrolledByAsc = 'ENROLLED_BY_ASC',
  EnrolledByDesc = 'ENROLLED_BY_DESC',
  EnrollmentDateAsc = 'ENROLLMENT_DATE_ASC',
  EnrollmentDateDesc = 'ENROLLMENT_DATE_DESC',
  EnrollmentTimezoneAsc = 'ENROLLMENT_TIMEZONE_ASC',
  EnrollmentTimezoneDesc = 'ENROLLMENT_TIMEZONE_DESC',
  ExternalIdAsc = 'EXTERNAL_ID_ASC',
  ExternalIdDesc = 'EXTERNAL_ID_DESC',
  ExternalId2Asc = 'EXTERNAL_ID2_ASC',
  ExternalId2Desc = 'EXTERNAL_ID2_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  InactivationDateAsc = 'INACTIVATION_DATE_ASC',
  InactivationDateDesc = 'INACTIVATION_DATE_DESC',
  InactivationTimezoneAsc = 'INACTIVATION_TIMEZONE_ASC',
  InactivationTimezoneDesc = 'INACTIVATION_TIMEZONE_DESC',
  IntroductionToWellthAsc = 'INTRODUCTION_TO_WELLTH_ASC',
  IntroductionToWellthDesc = 'INTRODUCTION_TO_WELLTH_DESC',
  IsAutoPauseEnabledAsc = 'IS_AUTO_PAUSE_ENABLED_ASC',
  IsAutoPauseEnabledDesc = 'IS_AUTO_PAUSE_ENABLED_DESC',
  IsLocalNotificationEnabledAsc = 'IS_LOCAL_NOTIFICATION_ENABLED_ASC',
  IsLocalNotificationEnabledDesc = 'IS_LOCAL_NOTIFICATION_ENABLED_DESC',
  IsProductTourCompletedAsc = 'IS_PRODUCT_TOUR_COMPLETED_ASC',
  IsProductTourCompletedDesc = 'IS_PRODUCT_TOUR_COMPLETED_DESC',
  IsProductTourRecurringAsc = 'IS_PRODUCT_TOUR_RECURRING_ASC',
  IsProductTourRecurringDesc = 'IS_PRODUCT_TOUR_RECURRING_DESC',
  IsReminderEditingOpenAsc = 'IS_REMINDER_EDITING_OPEN_ASC',
  IsReminderEditingOpenDesc = 'IS_REMINDER_EDITING_OPEN_DESC',
  IsReminderMessagingEnabledAsc = 'IS_REMINDER_MESSAGING_ENABLED_ASC',
  IsReminderMessagingEnabledDesc = 'IS_REMINDER_MESSAGING_ENABLED_DESC',
  IsRestfulPatientAsc = 'IS_RESTFUL_PATIENT_ASC',
  IsRestfulPatientDesc = 'IS_RESTFUL_PATIENT_DESC',
  IsSidekickEnabledAsc = 'IS_SIDEKICK_ENABLED_ASC',
  IsSidekickEnabledDesc = 'IS_SIDEKICK_ENABLED_DESC',
  IsTestPatientAsc = 'IS_TEST_PATIENT_ASC',
  IsTestPatientDesc = 'IS_TEST_PATIENT_DESC',
  LiveProgramDaysAsc = 'LIVE_PROGRAM_DAYS_ASC',
  LiveProgramDaysDesc = 'LIVE_PROGRAM_DAYS_DESC',
  MedicaidIdAsc = 'MEDICAID_ID_ASC',
  MedicaidIdDesc = 'MEDICAID_ID_DESC',
  MissedCheckinStreakAsc = 'MISSED_CHECKIN_STREAK_ASC',
  MissedCheckinStreakDesc = 'MISSED_CHECKIN_STREAK_DESC',
  Natural = 'NATURAL',
  OnboardingDateAsc = 'ONBOARDING_DATE_ASC',
  OnboardingDateDesc = 'ONBOARDING_DATE_DESC',
  OnboardingTimezoneAsc = 'ONBOARDING_TIMEZONE_ASC',
  OnboardingTimezoneDesc = 'ONBOARDING_TIMEZONE_DESC',
  PauseStatusAsc = 'PAUSE_STATUS_ASC',
  PauseStatusDesc = 'PAUSE_STATUS_DESC',
  PaymentOptionsIdAsc = 'PAYMENT_OPTIONS_ID_ASC',
  PaymentOptionsIdDesc = 'PAYMENT_OPTIONS_ID_DESC',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  PlatformAsc = 'PLATFORM_ASC',
  PlatformDesc = 'PLATFORM_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProspectIdAsc = 'PROSPECT_ID_ASC',
  ProspectIdDesc = 'PROSPECT_ID_DESC',
  SecondaryPhoneNumberAsc = 'SECONDARY_PHONE_NUMBER_ASC',
  SecondaryPhoneNumberDesc = 'SECONDARY_PHONE_NUMBER_DESC',
  SiteNameAsc = 'SITE_NAME_ASC',
  SiteNameDesc = 'SITE_NAME_DESC',
  TypeOfEnrollmentAsc = 'TYPE_OF_ENROLLMENT_ASC',
  TypeOfEnrollmentDesc = 'TYPE_OF_ENROLLMENT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  VersionAsc = 'VERSION_ASC',
  VersionDesc = 'VERSION_DESC',
  WarehouseRowIdAsc = 'WAREHOUSE_ROW_ID_ASC',
  WarehouseRowIdDesc = 'WAREHOUSE_ROW_ID_DESC'
}

/** A connection to a list of `Patient` values. */
export interface PatientsConnection {
  __typename: 'PatientsConnection';
  /** A list of edges which contains the `Patient` and cursor to aid in pagination. */
  edges: Array<PatientsEdge>;
  /** A list of `Patient` objects. */
  nodes: Array<Maybe<Patient>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Patient` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `Patient` edge in the connection. */
export interface PatientsEdge {
  __typename: 'PatientsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Patient` at the end of the edge. */
  node: Maybe<Patient>;
}

/**
 * A condition to be used against `PatientStatus` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface PatientStatusCondition {
  /** Checks for equality with the object’s `adminId` field. */
  adminId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `note` field. */
  note?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `patientId` field. */
  patientId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `reason` field. */
  reason?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `reasonDetail` field. */
  reasonDetail?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `statusTransitionDate` field. */
  statusTransitionDate?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `warehouseRowId` field. */
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** Methods to use when ordering `PatientStatus`. */
export enum PatientStatusesOrderBy {
  AdminIdAsc = 'ADMIN_ID_ASC',
  AdminIdDesc = 'ADMIN_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  NoteAsc = 'NOTE_ASC',
  NoteDesc = 'NOTE_DESC',
  PatientIdAsc = 'PATIENT_ID_ASC',
  PatientIdDesc = 'PATIENT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ReasonAsc = 'REASON_ASC',
  ReasonDesc = 'REASON_DESC',
  ReasonDetailAsc = 'REASON_DETAIL_ASC',
  ReasonDetailDesc = 'REASON_DETAIL_DESC',
  StatusTransitionDateAsc = 'STATUS_TRANSITION_DATE_ASC',
  StatusTransitionDateDesc = 'STATUS_TRANSITION_DATE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC',
  WarehouseRowIdAsc = 'WAREHOUSE_ROW_ID_ASC',
  WarehouseRowIdDesc = 'WAREHOUSE_ROW_ID_DESC'
}

/** A connection to a list of `PatientStatus` values. */
export interface PatientStatusesConnection {
  __typename: 'PatientStatusesConnection';
  /** A list of edges which contains the `PatientStatus` and cursor to aid in pagination. */
  edges: Array<PatientStatusesEdge>;
  /** A list of `PatientStatus` objects. */
  nodes: Array<Maybe<PatientStatus>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PatientStatus` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `PatientStatus` edge in the connection. */
export interface PatientStatusesEdge {
  __typename: 'PatientStatusesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `PatientStatus` at the end of the edge. */
  node: Maybe<PatientStatus>;
}

export interface PatientStatus extends Node {
  __typename: 'PatientStatus';
  /** Reads a single `Admin` that is related to this `PatientStatus`. */
  adminByAdminId: Maybe<Admin>;
  adminId: Maybe<Scalars['UUID']>;
  createdAt: Scalars['Datetime'];
  id: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  note: Maybe<Scalars['String']>;
  /** Reads a single `Patient` that is related to this `PatientStatus`. */
  patientByPatientId: Maybe<Patient>;
  patientId: Scalars['UUID'];
  /** Reads a single `PatientStatusValue` that is related to this `PatientStatus`. */
  patientStatusValueByValue: Maybe<PatientStatusValue>;
  reason: Scalars['String'];
  reasonDetail: Maybe<Scalars['String']>;
  statusTransitionDate: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  value: Scalars['String'];
  warehouseRowId: Scalars['BigInt'];
}

export interface PatientStatusValue extends Node {
  __typename: 'PatientStatusValue';
  createdAt: Scalars['Datetime'];
  id: Scalars['UUID'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `PatientStatus`. */
  patientStatusesByValue: PatientStatusesConnection;
  updatedAt: Scalars['Datetime'];
  warehouseRowId: Scalars['BigInt'];
}


export interface PatientStatusValuePatientStatusesByValueArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientStatusCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientStatusesOrderBy>>;
}

/**
 * A condition to be used against `ProspectStatus` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface ProspectStatusCondition {
  /** Checks for equality with the object’s `adminId` field. */
  adminId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `note` field. */
  note?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `prospectId` field. */
  prospectId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `reason` field. */
  reason?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `reasonDetail` field. */
  reasonDetail?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `statusTransitionDate` field. */
  statusTransitionDate?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `warehouseRowId` field. */
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** Methods to use when ordering `ProspectStatus`. */
export enum ProspectStatusesOrderBy {
  AdminIdAsc = 'ADMIN_ID_ASC',
  AdminIdDesc = 'ADMIN_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  NoteAsc = 'NOTE_ASC',
  NoteDesc = 'NOTE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProspectIdAsc = 'PROSPECT_ID_ASC',
  ProspectIdDesc = 'PROSPECT_ID_DESC',
  ReasonAsc = 'REASON_ASC',
  ReasonDesc = 'REASON_DESC',
  ReasonDetailAsc = 'REASON_DETAIL_ASC',
  ReasonDetailDesc = 'REASON_DETAIL_DESC',
  StatusTransitionDateAsc = 'STATUS_TRANSITION_DATE_ASC',
  StatusTransitionDateDesc = 'STATUS_TRANSITION_DATE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC',
  WarehouseRowIdAsc = 'WAREHOUSE_ROW_ID_ASC',
  WarehouseRowIdDesc = 'WAREHOUSE_ROW_ID_DESC'
}

/** A connection to a list of `ProspectStatus` values. */
export interface ProspectStatusesConnection {
  __typename: 'ProspectStatusesConnection';
  /** A list of edges which contains the `ProspectStatus` and cursor to aid in pagination. */
  edges: Array<ProspectStatusesEdge>;
  /** A list of `ProspectStatus` objects. */
  nodes: Array<Maybe<ProspectStatus>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProspectStatus` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `ProspectStatus` edge in the connection. */
export interface ProspectStatusesEdge {
  __typename: 'ProspectStatusesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `ProspectStatus` at the end of the edge. */
  node: Maybe<ProspectStatus>;
}

export interface ProspectStatus extends Node {
  __typename: 'ProspectStatus';
  /** Reads a single `Admin` that is related to this `ProspectStatus`. */
  adminByAdminId: Maybe<Admin>;
  adminFirstName: Maybe<Scalars['String']>;
  adminId: Maybe<Scalars['UUID']>;
  adminLastName: Maybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  id: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  note: Maybe<Scalars['String']>;
  prospectId: Maybe<Scalars['UUID']>;
  /** Reads a single `ProspectStatusValue` that is related to this `ProspectStatus`. */
  prospectStatusValueByValue: Maybe<ProspectStatusValue>;
  reason: Maybe<Scalars['String']>;
  reasonDetail: Maybe<Scalars['String']>;
  statusTransitionDate: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  value: Scalars['String'];
  warehouseRowId: Scalars['BigInt'];
}

export interface ProspectStatusValue extends Node {
  __typename: 'ProspectStatusValue';
  createdAt: Scalars['Datetime'];
  id: Scalars['UUID'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `ProspectStatus`. */
  prospectStatusesByValue: ProspectStatusesConnection;
  updatedAt: Scalars['Datetime'];
  warehouseRowId: Scalars['BigInt'];
}


export interface ProspectStatusValueProspectStatusesByValueArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProspectStatusCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProspectStatusesOrderBy>>;
}

/**
 * A condition to be used against `SmsOutreachMessageTemplate` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export interface SmsOutreachMessageTemplateCondition {
  /** Checks for equality with the object’s `adminId` field. */
  adminId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `isActive` field. */
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `message` field. */
  message?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `title` field. */
  title?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `warehouseRowId` field. */
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** Methods to use when ordering `SmsOutreachMessageTemplate`. */
export enum SmsOutreachMessageTemplatesOrderBy {
  AdminIdAsc = 'ADMIN_ID_ASC',
  AdminIdDesc = 'ADMIN_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsActiveAsc = 'IS_ACTIVE_ASC',
  IsActiveDesc = 'IS_ACTIVE_DESC',
  MessageAsc = 'MESSAGE_ASC',
  MessageDesc = 'MESSAGE_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  WarehouseRowIdAsc = 'WAREHOUSE_ROW_ID_ASC',
  WarehouseRowIdDesc = 'WAREHOUSE_ROW_ID_DESC'
}

/** A connection to a list of `SmsOutreachMessageTemplate` values. */
export interface SmsOutreachMessageTemplatesConnection {
  __typename: 'SmsOutreachMessageTemplatesConnection';
  /** A list of edges which contains the `SmsOutreachMessageTemplate` and cursor to aid in pagination. */
  edges: Array<SmsOutreachMessageTemplatesEdge>;
  /** A list of `SmsOutreachMessageTemplate` objects. */
  nodes: Array<Maybe<SmsOutreachMessageTemplate>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SmsOutreachMessageTemplate` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `SmsOutreachMessageTemplate` edge in the connection. */
export interface SmsOutreachMessageTemplatesEdge {
  __typename: 'SmsOutreachMessageTemplatesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `SmsOutreachMessageTemplate` at the end of the edge. */
  node: Maybe<SmsOutreachMessageTemplate>;
}

/**
 * A condition to be used against `Walkthrough` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export interface WalkthroughCondition {
  /** Checks for equality with the object’s `adminId` field. */
  adminId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `warehouseRowId` field. */
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** Methods to use when ordering `Walkthrough`. */
export enum WalkthroughsOrderBy {
  AdminIdAsc = 'ADMIN_ID_ASC',
  AdminIdDesc = 'ADMIN_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  WarehouseRowIdAsc = 'WAREHOUSE_ROW_ID_ASC',
  WarehouseRowIdDesc = 'WAREHOUSE_ROW_ID_DESC'
}

/** A connection to a list of `Walkthrough` values. */
export interface WalkthroughsConnection {
  __typename: 'WalkthroughsConnection';
  /** A list of edges which contains the `Walkthrough` and cursor to aid in pagination. */
  edges: Array<WalkthroughsEdge>;
  /** A list of `Walkthrough` objects. */
  nodes: Array<Maybe<Walkthrough>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Walkthrough` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `Walkthrough` edge in the connection. */
export interface WalkthroughsEdge {
  __typename: 'WalkthroughsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Walkthrough` at the end of the edge. */
  node: Maybe<Walkthrough>;
}

export interface AdherenceSummary {
  __typename: 'AdherenceSummary';
  /** The number of days that have valid checkins for all required reminders in the date window. */
  allRequiredRemindersCompletedDayCount: Maybe<Scalars['Int']>;
  creditedCheckInCount: Maybe<Scalars['Int']>;
  /** The number of adherence record days found in the date window. */
  dayCount: Maybe<Scalars['Int']>;
  /** The latest date from which this result would include an adherence record. */
  endDate: Maybe<Scalars['Date']>;
  /** The most recent (valid or invalid) checkin for the user, irrespective of date window. */
  mostRecentCheckInTimestamp: Maybe<Scalars['Datetime']>;
  /** The percent of days that have valid checkins for all required reminders in the date window. */
  percentDaysAdherent: Maybe<Scalars['BigFloat']>;
  /** The percent of required reminder-day instances that have valid checkins in the date window. */
  percentRequiredRemindersAdherent: Maybe<Scalars['BigFloat']>;
  /** The percent of reminder-day instances that have valid checkins in the date window. */
  percentTotalRemindersAdherent: Maybe<Scalars['BigFloat']>;
  percentTotalRemindersNonCreditedAdherent: Maybe<Scalars['BigFloat']>;
  /** The number of checkins (valid and invalid) for required reminders in the date window. */
  requiredCheckInCount: Maybe<Scalars['Int']>;
  /** The number of required reminder-day instances in the date window. */
  requiredReminderCount: Maybe<Scalars['Int']>;
  /** The number of valid checkins for required reminders in the date window. */
  requiredValidCheckInCount: Maybe<Scalars['Int']>;
  /** The earliest date from which this result would include an adherence record. */
  startDate: Maybe<Scalars['Date']>;
  /** The number of checkins (valid and invalid) for all (required and non-required) reminders in the date window. */
  totalCheckInCount: Maybe<Scalars['Int']>;
  /** The number of all (required and non-required) reminder-day instances in the date window. */
  totalReminderCount: Maybe<Scalars['Int']>;
  /** The number of valid checkins for all (required and non-required) reminders in the date window. */
  totalValidCheckInCount: Maybe<Scalars['Int']>;
}

export interface PatientAppointmentsCondition {
  from?: InputMaybe<Scalars['Datetime']>;
  includeRescheduledAppointments?: InputMaybe<Scalars['Boolean']>;
  to?: InputMaybe<Scalars['Datetime']>;
}

export interface AppointmentConnection {
  __typename: 'AppointmentConnection';
  edges: Array<AppointmentEdge>;
  nodes: Array<Maybe<Appointment>>;
  pageInfo: PageInfo;
  totalCount: Maybe<Scalars['Int']>;
}

export interface AppointmentEdge {
  __typename: 'AppointmentEdge';
  cursor: Maybe<Scalars['Cursor']>;
  node: Maybe<Appointment>;
}

export interface Appointment {
  __typename: 'Appointment';
  allowCredit: Maybe<Scalars['Boolean']>;
  dueTime: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  isAllDay: Maybe<Scalars['Boolean']>;
  isMissed: Maybe<Scalars['Boolean']>;
  location: Maybe<AppointmentLocation>;
  lossAmount: Maybe<Scalars['Float']>;
  lossCurrencySymbol: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  nodeId: Maybe<Scalars['ID']>;
  status: Maybe<AppointmentStatusType>;
  type: PersonVisitType;
}

export interface AppointmentLocation {
  __typename: 'AppointmentLocation';
  address: Maybe<Scalars['String']>;
  latitude: Maybe<Scalars['Float']>;
  longitude: Maybe<Scalars['Float']>;
  name: Maybe<Scalars['String']>;
  phoneNumber: Maybe<Scalars['String']>;
}

export enum AppointmentStatusType {
  Canceled = 'canceled',
  Completed = 'completed',
  Credited = 'credited',
  InProgress = 'in_progress',
  Missed = 'missed',
  Other = 'other',
  Rescheduled = 'rescheduled',
  Scheduled = 'scheduled'
}

export enum PersonVisitType {
  AnnualWellness = 'ANNUAL_WELLNESS',
  Dialysis = 'DIALYSIS',
  PrimaryCareProvider = 'PRIMARY_CARE_PROVIDER'
}

export interface MetricRange {
  __typename: 'MetricRange';
  id: Scalars['UUID'];
  lowerLimit: Scalars['Int'];
  metricName: MetricName;
  metricUnit: MetricUnit;
  upperLimit: Scalars['Int'];
  wellthId: Scalars['UUID'];
}

/**
 * A condition to be used against `DebitCardBalance` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface DebitCardBalanceCondition {
  /** Checks for equality with the object’s `balance` field. */
  balance?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `debitCardId` field. */
  debitCardId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `patientId` field. */
  patientId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<DebitCardStatus>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `warehouseRowId` field. */
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

export enum DebitCardStatus {
  Closed = 'CLOSED',
  Expired = 'EXPIRED',
  Lost = 'LOST',
  Processing = 'PROCESSING',
  Ready = 'READY',
  Received = 'RECEIVED',
  Replaced = 'REPLACED',
  Shipped = 'SHIPPED'
}

/** Methods to use when ordering `DebitCardBalance`. */
export enum DebitCardBalancesOrderBy {
  BalanceAsc = 'BALANCE_ASC',
  BalanceDesc = 'BALANCE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DebitCardIdAsc = 'DEBIT_CARD_ID_ASC',
  DebitCardIdDesc = 'DEBIT_CARD_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PatientIdAsc = 'PATIENT_ID_ASC',
  PatientIdDesc = 'PATIENT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  WarehouseRowIdAsc = 'WAREHOUSE_ROW_ID_ASC',
  WarehouseRowIdDesc = 'WAREHOUSE_ROW_ID_DESC'
}

/** A connection to a list of `DebitCardBalance` values. */
export interface DebitCardBalancesConnection {
  __typename: 'DebitCardBalancesConnection';
  /** A list of edges which contains the `DebitCardBalance` and cursor to aid in pagination. */
  edges: Array<DebitCardBalancesEdge>;
  /** A list of `DebitCardBalance` objects. */
  nodes: Array<Maybe<DebitCardBalance>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DebitCardBalance` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `DebitCardBalance` edge in the connection. */
export interface DebitCardBalancesEdge {
  __typename: 'DebitCardBalancesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `DebitCardBalance` at the end of the edge. */
  node: Maybe<DebitCardBalance>;
}

/** The balance (and status) of a debit card at a given point in time. */
export interface DebitCardBalance extends Node {
  __typename: 'DebitCardBalance';
  /** The balance available to spend on the debit card at this point in time. */
  balance: Scalars['BigFloat'];
  createdAt: Scalars['Datetime'];
  /** Reads a single `DebitCard` that is related to this `DebitCardBalance`. */
  debitCardByDebitCardId: Maybe<DebitCard>;
  /** The id of the debit card to which this balance entry pertains. */
  debitCardId: Scalars['UUID'];
  id: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Patient` that is related to this `DebitCardBalance`. */
  patientByPatientId: Maybe<Patient>;
  /** The id of the patient that owns the referenced debit card. */
  patientId: Scalars['UUID'];
  /** The status of the debit card at this point in time. */
  status: DebitCardStatus;
  updatedAt: Scalars['Datetime'];
  warehouseRowId: Scalars['BigInt'];
}

/** A debit card held by a patient */
export interface DebitCard extends Node {
  __typename: 'DebitCard';
  /** The latest retrieved balance on the card. */
  balance: Scalars['BigFloat'];
  /** Card number as reported by API */
  cardNumber: Maybe<Scalars['JSON']>;
  /** Status value of this card */
  cardStatus: Maybe<Scalars['BigFloat']>;
  createdAt: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `DebitCardBalance`. */
  debitCardBalancesByDebitCardId: DebitCardBalancesConnection;
  /** processor-specific card details. */
  details: Maybe<Scalars['JSON']>;
  /** Expiration date of this card */
  expiryDate: Maybe<Scalars['Date']>;
  /** Any extra details on the card provided by the payment processor. */
  extras: Maybe<Scalars['JSON']>;
  /** The first name on the card. */
  firstName: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** The last name on the card. */
  lastName: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Patient` that is related to this `DebitCard`. */
  patientByPatientId: Maybe<Patient>;
  /** The id of the patient who owns this debit card. */
  patientId: Scalars['UUID'];
  /** Reads and enables pagination through a set of `PaymentSetup`. */
  paymentSetupsByDebitCardId: PaymentSetupsConnection;
  /** The payment processor that created this debit card. */
  processor: PaymentProcessor;
  /** The proxy card number, used to make transactions against the card without implicating PCI compliance. */
  proxyNumber: Maybe<Scalars['String']>;
  /** The latest status of the card. */
  status: DebitCardStatus;
  /** Status description of this card */
  statusDesc: Maybe<Scalars['String']>;
  updatedAt: Scalars['Datetime'];
  warehouseRowId: Scalars['BigInt'];
}


/** A debit card held by a patient */
export interface DebitCardDebitCardBalancesByDebitCardIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DebitCardBalanceCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DebitCardBalancesOrderBy>>;
}


/** A debit card held by a patient */
export interface DebitCardPaymentSetupsByDebitCardIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PaymentSetupCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentSetupsOrderBy>>;
}

/**
 * A condition to be used against `PaymentSetup` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface PaymentSetupCondition {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `debitCardId` field. */
  debitCardId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `details` field. */
  details?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `isDefault` field. */
  isDefault?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `maxIncrement` field. */
  maxIncrement?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `note` field. */
  note?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `patientId` field. */
  patientId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `paymentOptionCode` field. */
  paymentOptionCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `processor` field. */
  processor?: InputMaybe<PaymentProcessor>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `warehouseRowId` field. */
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

export enum PaymentProcessor {
  Alder = 'ALDER',
  HawkIncentives = 'HAWK_INCENTIVES',
  Incomm = 'INCOMM',
  Pseudopay = 'PSEUDOPAY'
}

/** Methods to use when ordering `PaymentSetup`. */
export enum PaymentSetupsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DebitCardIdAsc = 'DEBIT_CARD_ID_ASC',
  DebitCardIdDesc = 'DEBIT_CARD_ID_DESC',
  DetailsAsc = 'DETAILS_ASC',
  DetailsDesc = 'DETAILS_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsDefaultAsc = 'IS_DEFAULT_ASC',
  IsDefaultDesc = 'IS_DEFAULT_DESC',
  MaxIncrementAsc = 'MAX_INCREMENT_ASC',
  MaxIncrementDesc = 'MAX_INCREMENT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  NoteAsc = 'NOTE_ASC',
  NoteDesc = 'NOTE_DESC',
  PatientIdAsc = 'PATIENT_ID_ASC',
  PatientIdDesc = 'PATIENT_ID_DESC',
  PaymentOptionCodeAsc = 'PAYMENT_OPTION_CODE_ASC',
  PaymentOptionCodeDesc = 'PAYMENT_OPTION_CODE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProcessorAsc = 'PROCESSOR_ASC',
  ProcessorDesc = 'PROCESSOR_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  WarehouseRowIdAsc = 'WAREHOUSE_ROW_ID_ASC',
  WarehouseRowIdDesc = 'WAREHOUSE_ROW_ID_DESC'
}

/** A connection to a list of `PaymentSetup` values. */
export interface PaymentSetupsConnection {
  __typename: 'PaymentSetupsConnection';
  /** A list of edges which contains the `PaymentSetup` and cursor to aid in pagination. */
  edges: Array<PaymentSetupsEdge>;
  /** A list of `PaymentSetup` objects. */
  nodes: Array<Maybe<PaymentSetup>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PaymentSetup` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `PaymentSetup` edge in the connection. */
export interface PaymentSetupsEdge {
  __typename: 'PaymentSetupsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `PaymentSetup` at the end of the edge. */
  node: Maybe<PaymentSetup>;
}

/** A configuration that describes how a particular patient's account balance should be paid out. */
export interface PaymentSetup extends Node {
  __typename: 'PaymentSetup';
  createdAt: Scalars['Datetime'];
  /** Reads a single `DebitCard` that is related to this `PaymentSetup`. */
  debitCardByDebitCardId: Maybe<DebitCard>;
  debitCardId: Maybe<Scalars['UUID']>;
  /** The typically processor-specific configuration details of this config. */
  details: Maybe<Scalars['JSON']>;
  id: Scalars['UUID'];
  /** Whether this payment setup the default setup for this patient. */
  isDefault: Scalars['Boolean'];
  maxIncrement: Maybe<Scalars['BigFloat']>;
  /** The name of this payment config. */
  name: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** An optional freetext note about this payment config. */
  note: Maybe<Scalars['String']>;
  /** Reads a single `Patient` that is related to this `PaymentSetup`. */
  patientByPatientId: Maybe<Patient>;
  /** The patient which owns this payment config. */
  patientId: Scalars['UUID'];
  paymentOptionCode: Maybe<Scalars['String']>;
  /** The payment processor to which this config pertains. */
  processor: PaymentProcessor;
  updatedAt: Scalars['Datetime'];
  warehouseRowId: Scalars['BigInt'];
}

/**
 * A condition to be used against `DebitCard` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export interface DebitCardCondition {
  /** Checks for equality with the object’s `balance` field. */
  balance?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `cardNumber` field. */
  cardNumber?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `cardStatus` field. */
  cardStatus?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `details` field. */
  details?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `expiryDate` field. */
  expiryDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `extras` field. */
  extras?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `firstName` field. */
  firstName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `lastName` field. */
  lastName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `patientId` field. */
  patientId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `processor` field. */
  processor?: InputMaybe<PaymentProcessor>;
  /** Checks for equality with the object’s `proxyNumber` field. */
  proxyNumber?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<DebitCardStatus>;
  /** Checks for equality with the object’s `statusDesc` field. */
  statusDesc?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `warehouseRowId` field. */
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** Methods to use when ordering `DebitCard`. */
export enum DebitCardsOrderBy {
  BalanceAsc = 'BALANCE_ASC',
  BalanceDesc = 'BALANCE_DESC',
  CardNumberAsc = 'CARD_NUMBER_ASC',
  CardNumberDesc = 'CARD_NUMBER_DESC',
  CardStatusAsc = 'CARD_STATUS_ASC',
  CardStatusDesc = 'CARD_STATUS_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DetailsAsc = 'DETAILS_ASC',
  DetailsDesc = 'DETAILS_DESC',
  ExpiryDateAsc = 'EXPIRY_DATE_ASC',
  ExpiryDateDesc = 'EXPIRY_DATE_DESC',
  ExtrasAsc = 'EXTRAS_ASC',
  ExtrasDesc = 'EXTRAS_DESC',
  FirstNameAsc = 'FIRST_NAME_ASC',
  FirstNameDesc = 'FIRST_NAME_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LastNameAsc = 'LAST_NAME_ASC',
  LastNameDesc = 'LAST_NAME_DESC',
  Natural = 'NATURAL',
  PatientIdAsc = 'PATIENT_ID_ASC',
  PatientIdDesc = 'PATIENT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProcessorAsc = 'PROCESSOR_ASC',
  ProcessorDesc = 'PROCESSOR_DESC',
  ProxyNumberAsc = 'PROXY_NUMBER_ASC',
  ProxyNumberDesc = 'PROXY_NUMBER_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  StatusDescAsc = 'STATUS_DESC_ASC',
  StatusDescDesc = 'STATUS_DESC_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  WarehouseRowIdAsc = 'WAREHOUSE_ROW_ID_ASC',
  WarehouseRowIdDesc = 'WAREHOUSE_ROW_ID_DESC'
}

/** A connection to a list of `DebitCard` values. */
export interface DebitCardsConnection {
  __typename: 'DebitCardsConnection';
  /** A list of edges which contains the `DebitCard` and cursor to aid in pagination. */
  edges: Array<DebitCardsEdge>;
  /** A list of `DebitCard` objects. */
  nodes: Array<Maybe<DebitCard>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DebitCard` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `DebitCard` edge in the connection. */
export interface DebitCardsEdge {
  __typename: 'DebitCardsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `DebitCard` at the end of the edge. */
  node: Maybe<DebitCard>;
}

export interface Feature {
  __typename: 'Feature';
  isEnabled: Scalars['Boolean'];
  name: Scalars['String'];
}

export interface MixpanelEvents {
  __typename: 'MixpanelEvents';
  events: Maybe<Array<Maybe<PatientEvent>>>;
}

export interface PatientEvent {
  __typename: 'PatientEvent';
  from: Maybe<Scalars['String']>;
  model: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  networkConnectionType: Maybe<NetworkConnectionType>;
  target: Maybe<Scalars['String']>;
  time: Maybe<Scalars['String']>;
  to: Maybe<Scalars['String']>;
  type: Maybe<Scalars['String']>;
}

export enum NetworkConnectionType {
  Cellular = 'cellular',
  None = 'none',
  Undefined = 'undefined',
  Unknown = 'unknown',
  Vpn = 'vpn',
  Wifi = 'wifi'
}

/**
 * A condition to be used against `Heartbeat` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export interface HeartbeatCondition {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `patientId` field. */
  patientId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `warehouseRowId` field. */
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** Methods to use when ordering `Heartbeat`. */
export enum HeartbeatsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PatientIdAsc = 'PATIENT_ID_ASC',
  PatientIdDesc = 'PATIENT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  WarehouseRowIdAsc = 'WAREHOUSE_ROW_ID_ASC',
  WarehouseRowIdDesc = 'WAREHOUSE_ROW_ID_DESC'
}

/** A connection to a list of `Heartbeat` values. */
export interface HeartbeatsConnection {
  __typename: 'HeartbeatsConnection';
  /** A list of edges which contains the `Heartbeat` and cursor to aid in pagination. */
  edges: Array<HeartbeatsEdge>;
  /** A list of `Heartbeat` objects. */
  nodes: Array<Maybe<Heartbeat>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Heartbeat` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `Heartbeat` edge in the connection. */
export interface HeartbeatsEdge {
  __typename: 'HeartbeatsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Heartbeat` at the end of the edge. */
  node: Maybe<Heartbeat>;
}

/** A record of a patient app's heartbeat ping to the API. */
export interface Heartbeat extends Node {
  __typename: 'Heartbeat';
  createdAt: Scalars['Datetime'];
  id: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Patient` that is related to this `Heartbeat`. */
  patientByPatientId: Maybe<Patient>;
  /** The ID of the patient whose app sent the heartbeat ping to the API. */
  patientId: Scalars['UUID'];
  updatedAt: Scalars['Datetime'];
  warehouseRowId: Scalars['BigInt'];
}

export interface Highlight {
  __typename: 'Highlight';
  /** The content of the highlight */
  content: HighlightContent;
  /**
   * The stable highlight id, constant across every serve of the same highlight. Lets a client
   * attribute repeated displays to one highlight (e.g. duplicate-display detection).
   */
  highlightId: Scalars['UUID'];
  /**
   * The per-serve impression id (a new impression is written on every delivery), used to record
   * the submission/display against this specific serve.
   */
  id: Scalars['UUID'];
  /**
   * True when this highlight has outgoing chain edges, i.e. submitting it may
   * return a next screen. Lets the client await the submission only for
   * chained highlights and keep standalone advances instant.
   */
  isChained: Maybe<Scalars['Boolean']>;
  /** Determines if highlight is multiselect */
  isMultiSelect: Maybe<Scalars['Boolean']>;
  /** The name of the highlight */
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Semantic recurrence class, derived server-side so clients never depend on the raw interval encoding. */
  recurrence: HighlightRecurrence;
  /** The repeat window in days; set only when recurrence is RECURRING. */
  recurrenceIntervalDays: Maybe<Scalars['Int']>;
  /** The type of highlight */
  type: Scalars['String'];
}

export interface HighlightContent {
  __typename: 'HighlightContent';
  /** The animation of the highlight content */
  animation: Maybe<Scalars['String']>;
  /** The asset url; can be png of lottie json */
  asset: Maybe<Scalars['String']>;
  /** The background color of the highlight */
  backgroundColor: Scalars['String'];
  /** A list which contains Highlight Buttons */
  buttons: Array<Maybe<HighlightButton>>;
  /** The details of the highlight content */
  detail: Maybe<Scalars['String']>;
  /** The title of the highlight content */
  title: Maybe<Scalars['String']>;
}

export interface HighlightButton {
  __typename: 'HighlightButton';
  /** The action the button performs when clicked */
  buttonAction: Maybe<Scalars['String']>;
  /** The index position of the Highlight Button */
  index: Maybe<Scalars['Int']>;
  /** The Highlight Button on press handler */
  onPress: HighlightButtonAction;
  /** The style of the Highlight Button */
  style: Maybe<HighlightButtonStyle>;
  /** The Highlight Button text */
  text: Scalars['String'];
}

export interface HighlightButtonAction {
  __typename: 'HighlightButtonAction';
  /** The Highlight Button Action */
  action: HighlightActionType;
  /** The Highlight Button redirect URL, can be null */
  url: Maybe<Scalars['String']>;
}

export enum HighlightActionType {
  Navigate = 'navigate',
  Next = 'next',
  Pick = 'pick',
  Skip = 'skip'
}

export enum HighlightButtonStyle {
  Primary = 'primary',
  Secondary = 'secondary'
}

export enum HighlightRecurrence {
  OnceOnly = 'ONCE_ONLY',
  Recurring = 'RECURRING',
  Unlimited = 'UNLIMITED'
}

/**
 * A condition to be used against `ObjectDetection` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface ObjectDetectionCondition {
  /** Checks for equality with the object’s `boundsBottom` field. */
  boundsBottom?: InputMaybe<Scalars['Float']>;
  /** Checks for equality with the object’s `boundsLeft` field. */
  boundsLeft?: InputMaybe<Scalars['Float']>;
  /** Checks for equality with the object’s `boundsRight` field. */
  boundsRight?: InputMaybe<Scalars['Float']>;
  /** Checks for equality with the object’s `boundsTop` field. */
  boundsTop?: InputMaybe<Scalars['Float']>;
  /** Checks for equality with the object’s `checkInId` field. */
  checkInId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `confidence` field. */
  confidence?: InputMaybe<Scalars['Float']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `model` field. */
  model?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `objectType` field. */
  objectType?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `patientId` field. */
  patientId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `unit` field. */
  unit?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
}

/** Methods to use when ordering `ObjectDetection`. */
export enum ObjectDetectionsOrderBy {
  BoundsBottomAsc = 'BOUNDS_BOTTOM_ASC',
  BoundsBottomDesc = 'BOUNDS_BOTTOM_DESC',
  BoundsLeftAsc = 'BOUNDS_LEFT_ASC',
  BoundsLeftDesc = 'BOUNDS_LEFT_DESC',
  BoundsRightAsc = 'BOUNDS_RIGHT_ASC',
  BoundsRightDesc = 'BOUNDS_RIGHT_DESC',
  BoundsTopAsc = 'BOUNDS_TOP_ASC',
  BoundsTopDesc = 'BOUNDS_TOP_DESC',
  CheckInIdAsc = 'CHECK_IN_ID_ASC',
  CheckInIdDesc = 'CHECK_IN_ID_DESC',
  ConfidenceAsc = 'CONFIDENCE_ASC',
  ConfidenceDesc = 'CONFIDENCE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  ModelAsc = 'MODEL_ASC',
  ModelDesc = 'MODEL_DESC',
  Natural = 'NATURAL',
  ObjectTypeAsc = 'OBJECT_TYPE_ASC',
  ObjectTypeDesc = 'OBJECT_TYPE_DESC',
  PatientIdAsc = 'PATIENT_ID_ASC',
  PatientIdDesc = 'PATIENT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UnitAsc = 'UNIT_ASC',
  UnitDesc = 'UNIT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** A connection to a list of `ObjectDetection` values. */
export interface ObjectDetectionsConnection {
  __typename: 'ObjectDetectionsConnection';
  /** A list of edges which contains the `ObjectDetection` and cursor to aid in pagination. */
  edges: Array<ObjectDetectionsEdge>;
  /** A list of `ObjectDetection` objects. */
  nodes: Array<Maybe<ObjectDetection>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ObjectDetection` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `ObjectDetection` edge in the connection. */
export interface ObjectDetectionsEdge {
  __typename: 'ObjectDetectionsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `ObjectDetection` at the end of the edge. */
  node: Maybe<ObjectDetection>;
}

/** A record of the detection of a single object in a check-in image. */
export interface ObjectDetection extends Node {
  __typename: 'ObjectDetection';
  /** The bottom boundary of the object, relative to the image height. Range: [0.0, 1/0].  Top-left of image is (0.0, 0.0) */
  boundsBottom: Maybe<Scalars['Float']>;
  /** The left boundary of the object, relative to the image height. Range: [0.0, 1/0].  Top-left of image is (0.0, 0.0) */
  boundsLeft: Maybe<Scalars['Float']>;
  /** The right boundary of the object, relative to the image height. Range: [0.0, 1/0].  Top-left of image is (0.0, 0.0) */
  boundsRight: Maybe<Scalars['Float']>;
  /** The top boundary of the object, relative to the image height. Range: [0.0, 1/0].  Top-left of image is (0.0, 0.0) */
  boundsTop: Maybe<Scalars['Float']>;
  /** The check-in from which this detection was derived. */
  checkInId: Maybe<Scalars['UUID']>;
  confidence: Maybe<Scalars['Float']>;
  createdAt: Scalars['Datetime'];
  id: Scalars['UUID'];
  model: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** The type of object detected in the check-in image. */
  objectType: Maybe<Scalars['String']>;
  /** Reads a single `Patient` that is related to this `ObjectDetection`. */
  patientByPatientId: Maybe<Patient>;
  /** The patient that made the check-in from which this detection was derived. */
  patientId: Scalars['UUID'];
  unit: Scalars['String'];
  updatedAt: Scalars['Datetime'];
}

export interface OnboardingInformation {
  __typename: 'OnboardingInformation';
  availableReminders: Maybe<Array<Maybe<AvailableReminder>>>;
  firstName: Scalars['String'];
  hasCompletedDemoCheckIn: Scalars['Boolean'];
  isPrivacyPolicyValid: Scalars['Boolean'];
  isProductTourComplete: Scalars['Boolean'];
  isTermsOfServiceValid: Scalars['Boolean'];
  lastName: Scalars['String'];
  memberStatus: MemberStatusValue;
  numberOfRequiredReminders: Scalars['Int'];
  patientId: Scalars['UUID'];
  privacyPolicyURL: Scalars['String'];
  selfServeDefaultReminders: Maybe<Array<Maybe<ReminderConfig>>>;
  supportPhoneNumber: Scalars['String'];
  termsConditionsURL: Scalars['String'];
  walkthroughPages: Maybe<Array<Maybe<WalkthroughPage>>>;
  walkthroughSummaries: Maybe<Array<Maybe<WalkthroughSummary>>>;
  wellthId: Scalars['String'];
}

export interface AvailableReminder {
  __typename: 'AvailableReminder';
  checkInCategory: CheckInCategory;
  dueTime: Scalars['Time'];
  maximum: Scalars['Int'];
  priority: Scalars['Int'];
}

export enum MemberStatusValue {
  Active = 'active',
  Enrolled = 'enrolled',
  Inactive = 'inactive',
  Onboarded = 'onboarded'
}

/** A condition to be used against `Pause` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export interface PauseCondition {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `endDate` field. */
  endDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `note` field. */
  note?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `oldReason` field. */
  oldReason?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `patientId` field. */
  patientId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `reason` field. */
  reason?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `startDate` field. */
  startDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `warehouseRowId` field. */
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** Methods to use when ordering `Pause`. */
export enum PausesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EndDateAsc = 'END_DATE_ASC',
  EndDateDesc = 'END_DATE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  NoteAsc = 'NOTE_ASC',
  NoteDesc = 'NOTE_DESC',
  OldReasonAsc = 'OLD_REASON_ASC',
  OldReasonDesc = 'OLD_REASON_DESC',
  PatientIdAsc = 'PATIENT_ID_ASC',
  PatientIdDesc = 'PATIENT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ReasonAsc = 'REASON_ASC',
  ReasonDesc = 'REASON_DESC',
  StartDateAsc = 'START_DATE_ASC',
  StartDateDesc = 'START_DATE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  WarehouseRowIdAsc = 'WAREHOUSE_ROW_ID_ASC',
  WarehouseRowIdDesc = 'WAREHOUSE_ROW_ID_DESC'
}

/** A connection to a list of `Pause` values. */
export interface PausesConnection {
  __typename: 'PausesConnection';
  /** A list of edges which contains the `Pause` and cursor to aid in pagination. */
  edges: Array<PausesEdge>;
  /** A list of `Pause` objects. */
  nodes: Array<Maybe<Pause>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Pause` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `Pause` edge in the connection. */
export interface PausesEdge {
  __typename: 'PausesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Pause` at the end of the edge. */
  node: Maybe<Pause>;
}

/** A pause, which specifies the duration during which a patient is paused */
export interface Pause extends Node {
  __typename: 'Pause';
  createdAt: Scalars['Datetime'];
  /** The date at which this pause span ends (inclusive), optionally null. */
  endDate: Maybe<Scalars['Date']>;
  id: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** The text of the note. */
  note: Maybe<Scalars['String']>;
  /** The reason for pausing a patient. */
  oldReason: Maybe<Scalars['String']>;
  /** Reads a single `Patient` that is related to this `Pause`. */
  patientByPatientId: Maybe<Patient>;
  /** The unique identifier of the patient for which the pause is created. */
  patientId: Scalars['UUID'];
  /** Reads a single `PauseReason` that is related to this `Pause`. */
  pauseReasonByReason: Maybe<PauseReason>;
  reason: Maybe<Scalars['String']>;
  /** The date at which this pause span starts. */
  startDate: Scalars['Date'];
  updatedAt: Scalars['Datetime'];
  warehouseRowId: Scalars['BigInt'];
}

export interface PauseReason extends Node {
  __typename: 'PauseReason';
  automaticInactivation: Maybe<Scalars['Boolean']>;
  automaticUnpause: Scalars['Boolean'];
  createdAt: Scalars['Datetime'];
  id: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `Pause`. */
  pausesByReason: PausesConnection;
  updatedAt: Scalars['Datetime'];
  value: Scalars['String'];
}


export interface PauseReasonPausesByReasonArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PauseCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PausesOrderBy>>;
}

export interface Address {
  __typename: 'Address';
  city: Maybe<Scalars['String']>;
  country: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['Date']>;
  customerId: Maybe<Scalars['UUID']>;
  id: Maybe<Scalars['UUID']>;
  isPrimary: Maybe<Scalars['Boolean']>;
  personId: Maybe<Scalars['UUID']>;
  state: Maybe<Scalars['String']>;
  street: Maybe<Scalars['String']>;
  street2: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['Date']>;
  zip: Maybe<Scalars['String']>;
}

export interface ProgramNoteDetails {
  __typename: 'ProgramNoteDetails';
  icon: Maybe<Scalars['String']>;
  text: Maybe<Scalars['String']>;
}

/**
 * A condition to be used against `PushNotification` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface PushNotificationCondition {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `patientId` field. */
  patientId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `payload` field. */
  payload?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `sentDatetime` field. */
  sentDatetime?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<PushNotificationStatus>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `warehouseRowId` field. */
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

export enum PushNotificationStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Sending = 'SENDING',
  Sent = 'SENT'
}

/** Methods to use when ordering `PushNotification`. */
export enum PushNotificationsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PatientIdAsc = 'PATIENT_ID_ASC',
  PatientIdDesc = 'PATIENT_ID_DESC',
  PayloadAsc = 'PAYLOAD_ASC',
  PayloadDesc = 'PAYLOAD_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SentDatetimeAsc = 'SENT_DATETIME_ASC',
  SentDatetimeDesc = 'SENT_DATETIME_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  WarehouseRowIdAsc = 'WAREHOUSE_ROW_ID_ASC',
  WarehouseRowIdDesc = 'WAREHOUSE_ROW_ID_DESC'
}

/** A connection to a list of `PushNotification` values. */
export interface PushNotificationsConnection {
  __typename: 'PushNotificationsConnection';
  /** A list of edges which contains the `PushNotification` and cursor to aid in pagination. */
  edges: Array<PushNotificationsEdge>;
  /** A list of `PushNotification` objects. */
  nodes: Array<Maybe<PushNotification>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PushNotification` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `PushNotification` edge in the connection. */
export interface PushNotificationsEdge {
  __typename: 'PushNotificationsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `PushNotification` at the end of the edge. */
  node: Maybe<PushNotification>;
}

/** A push notification sent to a patient's mobile device via the Wellth platform. */
export interface PushNotification extends Node {
  __typename: 'PushNotification';
  createdAt: Scalars['Datetime'];
  id: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Patient` that is related to this `PushNotification`. */
  patientByPatientId: Maybe<Patient>;
  /** The patient to whom this push notification is sent */
  patientId: Scalars['UUID'];
  /** The data payload that should be or was relayed to the push notification delivery service. */
  payload: Scalars['JSON'];
  /** The time at which this push notification was sent. */
  sentDatetime: Scalars['Datetime'];
  /** The status of the push notification. */
  status: PushNotificationStatus;
  updatedAt: Scalars['Datetime'];
  warehouseRowId: Scalars['BigInt'];
}

/**
 * A condition to be used against `PushToken` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export interface PushTokenCondition {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `deviceIdentifier` field. */
  deviceIdentifier?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `handler` field. */
  handler?: InputMaybe<PushTokenHandler>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `isActive` field. */
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `patientId` field. */
  patientId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `remoteIdentifier` field. */
  remoteIdentifier?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `service` field. */
  service?: InputMaybe<PushTokenService>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `warehouseRowId` field. */
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

export enum PushTokenHandler {
  Sns = 'SNS'
}

export enum PushTokenService {
  Apns = 'APNS',
  ApnsSandbox = 'APNS_SANDBOX',
  Gcm = 'GCM'
}

/** Methods to use when ordering `PushToken`. */
export enum PushTokensOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DeviceIdentifierAsc = 'DEVICE_IDENTIFIER_ASC',
  DeviceIdentifierDesc = 'DEVICE_IDENTIFIER_DESC',
  HandlerAsc = 'HANDLER_ASC',
  HandlerDesc = 'HANDLER_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsActiveAsc = 'IS_ACTIVE_ASC',
  IsActiveDesc = 'IS_ACTIVE_DESC',
  Natural = 'NATURAL',
  PatientIdAsc = 'PATIENT_ID_ASC',
  PatientIdDesc = 'PATIENT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RemoteIdentifierAsc = 'REMOTE_IDENTIFIER_ASC',
  RemoteIdentifierDesc = 'REMOTE_IDENTIFIER_DESC',
  ServiceAsc = 'SERVICE_ASC',
  ServiceDesc = 'SERVICE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  WarehouseRowIdAsc = 'WAREHOUSE_ROW_ID_ASC',
  WarehouseRowIdDesc = 'WAREHOUSE_ROW_ID_DESC'
}

/** A connection to a list of `PushToken` values. */
export interface PushTokensConnection {
  __typename: 'PushTokensConnection';
  /** A list of edges which contains the `PushToken` and cursor to aid in pagination. */
  edges: Array<PushTokensEdge>;
  /** A list of `PushToken` objects. */
  nodes: Array<Maybe<PushToken>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PushToken` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `PushToken` edge in the connection. */
export interface PushTokensEdge {
  __typename: 'PushTokensEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `PushToken` at the end of the edge. */
  node: Maybe<PushToken>;
}

/** A token created on a patient's smartphone device, used to send push notifications. */
export interface PushToken extends Node {
  __typename: 'PushToken';
  createdAt: Scalars['Datetime'];
  /** The identifier created for this token by the mobile phone device. */
  deviceIdentifier: Scalars['String'];
  /** The third-party handler of these push tokens, used to send the actual notifications. */
  handler: PushTokenHandler;
  id: Scalars['UUID'];
  isActive: Scalars['Boolean'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Patient` that is related to this `PushToken`. */
  patientByPatientId: Maybe<Patient>;
  /** The patient who created this push token. */
  patientId: Scalars['UUID'];
  /** The identifier generated by the remote service (e.g. SNS) as an endpoint identifier. */
  remoteIdentifier: Maybe<Scalars['String']>;
  /** The service for which this push token is registered. */
  service: PushTokenService;
  updatedAt: Scalars['Datetime'];
  warehouseRowId: Scalars['BigInt'];
}

export interface RewardCardDetails {
  __typename: 'RewardCardDetails';
  activationDate: Maybe<Scalars['Datetime']>;
  address: Maybe<DebitCardAddress>;
  createdAt: Maybe<Scalars['Datetime']>;
  id: Maybe<Scalars['UUID']>;
  latestBalance: Maybe<Scalars['String']>;
  orderDate: Maybe<Scalars['Datetime']>;
  packId: Maybe<Scalars['String']>;
  processor: Maybe<Scalars['String']>;
  proxyNumber: Maybe<Scalars['String']>;
  rewardCardChoice: Maybe<Scalars['String']>;
  rewardCardInfoUrl: Maybe<Scalars['String']>;
  shippedDate: Maybe<Scalars['Datetime']>;
  status: Maybe<DebitCardStatus>;
  updatedAt: Maybe<Scalars['Datetime']>;
}

export interface DebitCardAddress {
  __typename: 'DebitCardAddress';
  city: Maybe<Scalars['String']>;
  state: Maybe<Scalars['String']>;
  street: Maybe<Scalars['String']>;
  street2: Maybe<Scalars['String']>;
  zip: Maybe<Scalars['String']>;
}

export interface RewardPeriodAndTransactions {
  __typename: 'RewardPeriodAndTransactions';
  rewardPeriod: Maybe<RewardPeriod>;
  totalLosses: Maybe<Scalars['BigFloat']>;
  transactions: Maybe<Array<Maybe<SimpleTransaction>>>;
}

export interface SimpleTransaction {
  __typename: 'SimpleTransaction';
  amount: Scalars['BigFloat'];
  date: Scalars['Date'];
  reason: RewardPeriodTransactionReasonExt;
}

export enum RewardPeriodTransactionReasonExt {
  CompletedDay = 'COMPLETED_DAY',
  CreditedDay = 'CREDITED_DAY',
  DailyBonus = 'DAILY_BONUS',
  Forfeited = 'FORFEITED',
  ManualAdjustment = 'MANUAL_ADJUSTMENT',
  MissedAppointment = 'MISSED_APPOINTMENT',
  MissedDay = 'MISSED_DAY',
  PeriodStart = 'PERIOD_START',
  TransferToAccountBalance = 'TRANSFER_TO_ACCOUNT_BALANCE',
  Unknown = 'UNKNOWN'
}

export interface PatientRewardPeriodBalancesCondition {
  from?: InputMaybe<Scalars['Datetime']>;
  relativeTo?: InputMaybe<RewardBalanceRelativeTo>;
  to?: InputMaybe<Scalars['Datetime']>;
}

export enum RewardBalanceRelativeTo {
  EndDateAsc = 'END_DATE_ASC',
  EndDateDesc = 'END_DATE_DESC',
  StartDateAsc = 'START_DATE_ASC',
  StartDateDesc = 'START_DATE_DESC'
}

export interface RewardPeriodBalancesConnection {
  __typename: 'RewardPeriodBalancesConnection';
  edges: Array<RewardPeriodBalancesEdge>;
  nodes: Array<Maybe<RewardPeriodBalanceDetail>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

export interface RewardPeriodBalancesEdge {
  __typename: 'RewardPeriodBalancesEdge';
  cursor: Maybe<Scalars['Cursor']>;
  node: Maybe<RewardPeriodBalanceDetail>;
}

export interface RewardPeriodBalanceDetail {
  __typename: 'RewardPeriodBalanceDetail';
  activeIcon: Maybe<Scalars['String']>;
  inactiveIcon: Maybe<Scalars['String']>;
  nodeId: Maybe<Scalars['ID']>;
  periodCurrency: Maybe<Currency>;
  periodEnd: Maybe<Scalars['Date']>;
  periodLossPerDayMax: Maybe<Scalars['BigFloat']>;
  periodReward: Maybe<Scalars['BigFloat']>;
  periodStart: Maybe<Scalars['Date']>;
  periodSum: Maybe<Scalars['BigFloat']>;
  rewardPeriodId: Maybe<Scalars['UUID']>;
  rewardsEarned: Maybe<Scalars['BigFloat']>;
  settleDate: Maybe<Scalars['Date']>;
}

/**
 * A condition to be used against `TimezoneRecord` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface TimezoneRecordCondition {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `patientId` field. */
  patientId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `timezoneName` field. */
  timezoneName?: InputMaybe<Scalars['Timezone']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `warehouseRowId` field. */
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** Methods to use when ordering `TimezoneRecord`. */
export enum TimezoneRecordsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PatientIdAsc = 'PATIENT_ID_ASC',
  PatientIdDesc = 'PATIENT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TimezoneNameAsc = 'TIMEZONE_NAME_ASC',
  TimezoneNameDesc = 'TIMEZONE_NAME_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  WarehouseRowIdAsc = 'WAREHOUSE_ROW_ID_ASC',
  WarehouseRowIdDesc = 'WAREHOUSE_ROW_ID_DESC'
}

/** A connection to a list of `TimezoneRecord` values. */
export interface TimezoneRecordsConnection {
  __typename: 'TimezoneRecordsConnection';
  /** A list of edges which contains the `TimezoneRecord` and cursor to aid in pagination. */
  edges: Array<TimezoneRecordsEdge>;
  /** A list of `TimezoneRecord` objects. */
  nodes: Array<Maybe<TimezoneRecord>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TimezoneRecord` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `TimezoneRecord` edge in the connection. */
export interface TimezoneRecordsEdge {
  __typename: 'TimezoneRecordsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `TimezoneRecord` at the end of the edge. */
  node: Maybe<TimezoneRecord>;
}

export interface TimezoneRecord extends Node {
  __typename: 'TimezoneRecord';
  createdAt: Scalars['Datetime'];
  id: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Patient` that is related to this `TimezoneRecord`. */
  patientByPatientId: Maybe<Patient>;
  /** The ID of the patient who is moving into a new timezone. */
  patientId: Scalars['UUID'];
  /** The name of the timezone into which the patient is entering; must be one of the names returned from getTimezoneNames. */
  timezoneName: Scalars['Timezone'];
  updatedAt: Scalars['Datetime'];
  warehouseRowId: Scalars['BigInt'];
}

/**
 * A condition to be used against `WinbackRewardOpportunity` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export interface WinbackRewardOpportunityCondition {
  /** Checks for equality with the object’s `accountTransactionId` field. */
  accountTransactionId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `activatedAt` field. */
  activatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `campaignId` field. */
  campaignId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `challengeId` field. */
  challengeId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `completedAt` field. */
  completedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `expiresAt` field. */
  expiresAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `patientId` field. */
  patientId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `rewardAmount` field. */
  rewardAmount?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `rewardCurrency` field. */
  rewardCurrency?: InputMaybe<Currency>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `warehouseRowId` field. */
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `winbackRewardConfigId` field. */
  winbackRewardConfigId?: InputMaybe<Scalars['UUID']>;
}

/** Methods to use when ordering `WinbackRewardOpportunity`. */
export enum WinbackRewardOpportunitiesOrderBy {
  AccountTransactionIdAsc = 'ACCOUNT_TRANSACTION_ID_ASC',
  AccountTransactionIdDesc = 'ACCOUNT_TRANSACTION_ID_DESC',
  ActivatedAtAsc = 'ACTIVATED_AT_ASC',
  ActivatedAtDesc = 'ACTIVATED_AT_DESC',
  CampaignIdAsc = 'CAMPAIGN_ID_ASC',
  CampaignIdDesc = 'CAMPAIGN_ID_DESC',
  ChallengeIdAsc = 'CHALLENGE_ID_ASC',
  ChallengeIdDesc = 'CHALLENGE_ID_DESC',
  CompletedAtAsc = 'COMPLETED_AT_ASC',
  CompletedAtDesc = 'COMPLETED_AT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  ExpiresAtAsc = 'EXPIRES_AT_ASC',
  ExpiresAtDesc = 'EXPIRES_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PatientIdAsc = 'PATIENT_ID_ASC',
  PatientIdDesc = 'PATIENT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RewardAmountAsc = 'REWARD_AMOUNT_ASC',
  RewardAmountDesc = 'REWARD_AMOUNT_DESC',
  RewardCurrencyAsc = 'REWARD_CURRENCY_ASC',
  RewardCurrencyDesc = 'REWARD_CURRENCY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  WarehouseRowIdAsc = 'WAREHOUSE_ROW_ID_ASC',
  WarehouseRowIdDesc = 'WAREHOUSE_ROW_ID_DESC',
  WinbackRewardConfigIdAsc = 'WINBACK_REWARD_CONFIG_ID_ASC',
  WinbackRewardConfigIdDesc = 'WINBACK_REWARD_CONFIG_ID_DESC'
}

/** A connection to a list of `WinbackRewardOpportunity` values. */
export interface WinbackRewardOpportunitiesConnection {
  __typename: 'WinbackRewardOpportunitiesConnection';
  /** A list of edges which contains the `WinbackRewardOpportunity` and cursor to aid in pagination. */
  edges: Array<WinbackRewardOpportunitiesEdge>;
  /** A list of `WinbackRewardOpportunity` objects. */
  nodes: Array<Maybe<WinbackRewardOpportunity>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `WinbackRewardOpportunity` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `WinbackRewardOpportunity` edge in the connection. */
export interface WinbackRewardOpportunitiesEdge {
  __typename: 'WinbackRewardOpportunitiesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `WinbackRewardOpportunity` at the end of the edge. */
  node: Maybe<WinbackRewardOpportunity>;
}

/** Tracks patient opportunities in challenge reward campaigns from Customer.io. Each record represents a single challenge reward opportunity with an associated reward. */
export interface WinbackRewardOpportunity extends Node {
  __typename: 'WinbackRewardOpportunity';
  /** Reads a single `AccountTransaction` that is related to this `WinbackRewardOpportunity`. */
  accountTransactionByAccountTransactionId: Maybe<AccountTransaction>;
  /** Foreign key to account_transaction table once reward is paid out (nullable) */
  accountTransactionId: Maybe<Scalars['UUID']>;
  /** Timestamp when the opportunity was activated for the patient */
  activatedAt: Scalars['Datetime'];
  /** The Customer.io campaign identifier for tracking */
  campaignId: Scalars['String'];
  /** Unique identifier for this specific challenge instance (e.g., thanksgiving_2025_11_27) */
  challengeId: Scalars['String'];
  /** Timestamp when the patient completed this challenge (nullable) */
  completedAt: Maybe<Scalars['Datetime']>;
  createdAt: Scalars['Datetime'];
  /** Timestamp when this challenge offer expires */
  expiresAt: Scalars['Datetime'];
  id: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Patient` that is related to this `WinbackRewardOpportunity`. */
  patientByPatientId: Maybe<Patient>;
  /** The patient given this challenge reward opportunity */
  patientId: Scalars['UUID'];
  rewardAmount: Scalars['BigFloat'];
  rewardCurrency: Currency;
  updatedAt: Scalars['Datetime'];
  warehouseRowId: Scalars['BigInt'];
  /** Reads a single `WinbackRewardConfig` that is related to this `WinbackRewardOpportunity`. */
  winbackRewardConfigByWinbackRewardConfigId: Maybe<WinbackRewardConfig>;
  /** Foreign key to the challenge reward config blueprint */
  winbackRewardConfigId: Scalars['UUID'];
}

/** Defines the blueprints for challenge reward campaigns, including validation rules and reward details. */
export interface WinbackRewardConfig extends Node {
  __typename: 'WinbackRewardConfig';
  /** Unique string identifier for the challenge blueprint (e.g., thanksgiving_daily_v1) */
  challengeTypeKey: Scalars['String'];
  createdAt: Scalars['Datetime'];
  /** Detailed description of the challenge for internal reference */
  description: Scalars['String'];
  /** User-facing name for the challenge */
  displayName: Scalars['String'];
  /** The number of days an opportunity is active before it expires */
  durationInDays: Scalars['Int'];
  id: Scalars['UUID'];
  /** Whether this challenge blueprint is currently active and can be used to create new opportunities */
  isActive: Scalars['Boolean'];
  /** The maximum reward amount allowed for an opportunity of this type */
  maxRewardAmount: Scalars['BigFloat'];
  /** The minimum reward amount allowed for an opportunity of this type */
  minRewardAmount: Scalars['BigFloat'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** The currency of the reward (constrained to USD) */
  rewardCurrency: Currency;
  /** The system event that can trigger a completion for this challenge (e.g., user.checked_in) */
  triggerEvent: Scalars['String'];
  updatedAt: Scalars['Datetime'];
  warehouseRowId: Scalars['BigInt'];
  /** Reads and enables pagination through a set of `WinbackRewardOpportunity`. */
  winbackRewardOpportunitiesByWinbackRewardConfigId: WinbackRewardOpportunitiesConnection;
}


/** Defines the blueprints for challenge reward campaigns, including validation rules and reward details. */
export interface WinbackRewardConfigWinbackRewardOpportunitiesByWinbackRewardConfigIdArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<WinbackRewardOpportunityCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WinbackRewardOpportunitiesOrderBy>>;
}

export interface IdentityTag {
  __typename: 'IdentityTag';
  adder: Maybe<ActorCode>;
  adderId: Maybe<Scalars['UUID']>;
  backgroundColor: Maybe<Scalars['String']>;
  borderColor: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['Date']>;
  id: Maybe<Scalars['UUID']>;
  isAdminRemovable: Maybe<Scalars['Boolean']>;
  name: Maybe<Scalars['String']>;
  removedAt: Maybe<Scalars['Date']>;
  updatedAt: Maybe<Scalars['Date']>;
  wellthId: Maybe<Scalars['UUID']>;
}

/**
 * A condition to be used against `AdminRole` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export interface AdminRoleCondition {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `warehouseRowId` field. */
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** Methods to use when ordering `AdminRole`. */
export enum AdminRolesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  WarehouseRowIdAsc = 'WAREHOUSE_ROW_ID_ASC',
  WarehouseRowIdDesc = 'WAREHOUSE_ROW_ID_DESC'
}

/** A connection to a list of `AdminRole` values. */
export interface AdminRolesConnection {
  __typename: 'AdminRolesConnection';
  /** A list of edges which contains the `AdminRole` and cursor to aid in pagination. */
  edges: Array<AdminRolesEdge>;
  /** A list of `AdminRole` objects. */
  nodes: Array<Maybe<AdminRole>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AdminRole` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `AdminRole` edge in the connection. */
export interface AdminRolesEdge {
  __typename: 'AdminRolesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `AdminRole` at the end of the edge. */
  node: Maybe<AdminRole>;
}

export interface TagConfigPayload {
  __typename: 'TagConfigPayload';
  id: Maybe<Scalars['UUID']>;
  name: Maybe<Scalars['String']>;
}

export interface BonusBehaviorConfig {
  __typename: 'BonusBehaviorConfig';
  bonusBehaviorPagesetId: Maybe<Scalars['UUID']>;
  endDate: Maybe<Scalars['String']>;
  icon: Maybe<Scalars['String']>;
  id: Maybe<Scalars['UUID']>;
  name: Maybe<Scalars['String']>;
  note: Maybe<Scalars['String']>;
  programCode: Maybe<Scalars['String']>;
  rewardAmount: Maybe<Scalars['Int']>;
  rewardCurrency: Maybe<Currency>;
  startDate: Maybe<Scalars['String']>;
  verification: Maybe<Scalars['String']>;
}

export interface BonusBehavior {
  __typename: 'BonusBehavior';
  completedDate: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['Date']>;
  endDate: Maybe<Scalars['String']>;
  icon: Maybe<Scalars['String']>;
  id: Maybe<Scalars['UUID']>;
  instructionPages: Maybe<Array<Maybe<BonusBehaviorInstructionPage>>>;
  rewards: Maybe<BonusBehaviorReward>;
  startDate: Maybe<Scalars['String']>;
  status: Maybe<BonusBehaviorStatusValue>;
  submissionPage: Maybe<BonusBehaviorSubmissionPage>;
  submissionType: Maybe<BonusBehaviorSubmissionType>;
  submittedDate: Maybe<Scalars['String']>;
  successPage: Maybe<BonusBehaviorSuccessPage>;
  title: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['Date']>;
  verifyPage: Maybe<BonusBehaviorVerifyPage>;
}

export interface BonusBehaviorInstructionPage {
  __typename: 'BonusBehaviorInstructionPage';
  backgroundColor: Maybe<Scalars['String']>;
  buttonText: Maybe<Scalars['String']>;
  detail: Maybe<Scalars['String']>;
  icon: Maybe<Scalars['String']>;
  pageIndex: Maybe<Scalars['Int']>;
  title: Maybe<Scalars['String']>;
}

export interface BonusBehaviorReward {
  __typename: 'BonusBehaviorReward';
  amount: Maybe<Scalars['BigFloat']>;
  currencySymbol: Maybe<Currency>;
}

export enum BonusBehaviorStatusValue {
  ClosedExpired = 'CLOSED_EXPIRED',
  ClosedFalseCriteria = 'CLOSED_FALSE_CRITERIA',
  ClosedRewarded = 'CLOSED_REWARDED',
  Open = 'OPEN',
  UnderReview = 'UNDER_REVIEW'
}

export interface BonusBehaviorSubmissionPage {
  __typename: 'BonusBehaviorSubmissionPage';
  detail: Maybe<Scalars['String']>;
  getHelpIsEnabled: Maybe<Scalars['Boolean']>;
  getHelpText: Maybe<Scalars['String']>;
  icon: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
}

export enum BonusBehaviorSubmissionType {
  Photo = 'PHOTO'
}

export interface BonusBehaviorSuccessPage {
  __typename: 'BonusBehaviorSuccessPage';
  backgroundColor: Maybe<Scalars['String']>;
  detail: Maybe<Scalars['String']>;
  icon: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
}

export interface BonusBehaviorVerifyPage {
  __typename: 'BonusBehaviorVerifyPage';
  title: Maybe<Scalars['String']>;
}

export enum BonusBehaviorSubmissionStatusValue {
  Approved = 'APPROVED',
  Rejected = 'REJECTED',
  UnderReview = 'UNDER_REVIEW'
}

export interface BonusBehaviorSubmissionPayload {
  __typename: 'BonusBehaviorSubmissionPayload';
  edges: Array<Maybe<BonusBehaviorSubmissionEdge>>;
  nodes: Array<Maybe<BonusBehaviorSubmissionItem>>;
  pageInfo: PageInfo;
  totalCount: Maybe<Scalars['Int']>;
}

export interface BonusBehaviorSubmissionEdge {
  __typename: 'BonusBehaviorSubmissionEdge';
  cursor: Maybe<Scalars['Cursor']>;
  node: Maybe<BonusBehaviorSubmissionItem>;
}

export interface BonusBehaviorSubmissionItem {
  __typename: 'BonusBehaviorSubmissionItem';
  firstName: Maybe<Scalars['String']>;
  id: Maybe<Scalars['UUID']>;
  lastName: Maybe<Scalars['String']>;
  memberId: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  photoUrl: Maybe<Scalars['String']>;
  photoUrls: Maybe<Array<Maybe<Scalars['String']>>>;
  programCode: Maybe<Scalars['String']>;
  rewardAmount: Maybe<Scalars['Int']>;
  rewardCurrency: Maybe<Currency>;
  shortId: Maybe<Scalars['String']>;
  status: Maybe<BonusBehaviorSubmissionStatusValue>;
  timestamp: Maybe<Scalars['Date']>;
  verification: Maybe<Scalars['String']>;
}

/**
 * A condition to be used against `BonusBehaviorSubmissionStatus` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export interface BonusBehaviorSubmissionStatusCondition {
  /** Checks for equality with the object’s `actor` field. */
  actor?: InputMaybe<ActorCode>;
  /** Checks for equality with the object’s `actorId` field. */
  actorId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `bonusBehaviorSubmissionId` field. */
  bonusBehaviorSubmissionId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `note` field. */
  note?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `reason` field. */
  reason?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `statusTransitionTimestamp` field. */
  statusTransitionTimestamp?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `warehouseRowId` field. */
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** Methods to use when ordering `BonusBehaviorSubmissionStatus`. */
export enum BonusBehaviorSubmissionStatusesOrderBy {
  ActorAsc = 'ACTOR_ASC',
  ActorDesc = 'ACTOR_DESC',
  ActorIdAsc = 'ACTOR_ID_ASC',
  ActorIdDesc = 'ACTOR_ID_DESC',
  BonusBehaviorSubmissionIdAsc = 'BONUS_BEHAVIOR_SUBMISSION_ID_ASC',
  BonusBehaviorSubmissionIdDesc = 'BONUS_BEHAVIOR_SUBMISSION_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  NoteAsc = 'NOTE_ASC',
  NoteDesc = 'NOTE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ReasonAsc = 'REASON_ASC',
  ReasonDesc = 'REASON_DESC',
  StatusTransitionTimestampAsc = 'STATUS_TRANSITION_TIMESTAMP_ASC',
  StatusTransitionTimestampDesc = 'STATUS_TRANSITION_TIMESTAMP_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC',
  WarehouseRowIdAsc = 'WAREHOUSE_ROW_ID_ASC',
  WarehouseRowIdDesc = 'WAREHOUSE_ROW_ID_DESC'
}

/** A connection to a list of `BonusBehaviorSubmissionStatus` values. */
export interface BonusBehaviorSubmissionStatusesConnection {
  __typename: 'BonusBehaviorSubmissionStatusesConnection';
  /** A list of edges which contains the `BonusBehaviorSubmissionStatus` and cursor to aid in pagination. */
  edges: Array<BonusBehaviorSubmissionStatusesEdge>;
  /** A list of `BonusBehaviorSubmissionStatus` objects. */
  nodes: Array<Maybe<BonusBehaviorSubmissionStatus>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BonusBehaviorSubmissionStatus` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `BonusBehaviorSubmissionStatus` edge in the connection. */
export interface BonusBehaviorSubmissionStatusesEdge {
  __typename: 'BonusBehaviorSubmissionStatusesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `BonusBehaviorSubmissionStatus` at the end of the edge. */
  node: Maybe<BonusBehaviorSubmissionStatus>;
}

export interface BonusBehaviorSubmissionStatus extends Node {
  __typename: 'BonusBehaviorSubmissionStatus';
  actor: ActorCode;
  actorId: Maybe<Scalars['String']>;
  bonusBehaviorSubmissionId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  id: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  note: Maybe<Scalars['String']>;
  reason: Scalars['String'];
  statusTransitionTimestamp: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  value: Maybe<Scalars['String']>;
  warehouseRowId: Scalars['BigInt'];
}

export interface ChallengeRewardDetail {
  __typename: 'ChallengeRewardDetail';
  amount: Scalars['BigFloat'];
  eligibilityEndDate: Scalars['Datetime'];
  eligibilityStartDate: Scalars['Datetime'];
  id: Scalars['UUID'];
  name: Scalars['String'];
  status: Scalars['String'];
}

/**
 * A condition to be used against `Customer` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export interface CustomerCondition {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `warehouseRowId` field. */
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** Methods to use when ordering `Customer`. */
export enum CustomersOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  WarehouseRowIdAsc = 'WAREHOUSE_ROW_ID_ASC',
  WarehouseRowIdDesc = 'WAREHOUSE_ROW_ID_DESC'
}

/** A connection to a list of `Customer` values. */
export interface CustomersConnection {
  __typename: 'CustomersConnection';
  /** A list of edges which contains the `Customer` and cursor to aid in pagination. */
  edges: Array<CustomersEdge>;
  /** A list of `Customer` objects. */
  nodes: Array<Maybe<Customer>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Customer` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `Customer` edge in the connection. */
export interface CustomersEdge {
  __typename: 'CustomersEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Customer` at the end of the edge. */
  node: Maybe<Customer>;
}

/** A condition to be used against `Group` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export interface GroupCondition {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `warehouseRowId` field. */
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** Methods to use when ordering `Group`. */
export enum GroupsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  WarehouseRowIdAsc = 'WAREHOUSE_ROW_ID_ASC',
  WarehouseRowIdDesc = 'WAREHOUSE_ROW_ID_DESC'
}

/** A connection to a list of `Group` values. */
export interface GroupsConnection {
  __typename: 'GroupsConnection';
  /** A list of edges which contains the `Group` and cursor to aid in pagination. */
  edges: Array<GroupsEdge>;
  /** A list of `Group` objects. */
  nodes: Array<Maybe<Group>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Group` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `Group` edge in the connection. */
export interface GroupsEdge {
  __typename: 'GroupsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Group` at the end of the edge. */
  node: Maybe<Group>;
}

/**
 * A condition to be used against `MarvMigration` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface MarvMigrationCondition {
  /** Checks for equality with the object’s `checksum` field. */
  checksum?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `comment` field. */
  comment?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `level` field. */
  level?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `namespace` field. */
  namespace?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `timestamp` field. */
  timestamp?: InputMaybe<Scalars['Datetime']>;
}

/** Methods to use when ordering `MarvMigration`. */
export enum MarvMigrationsOrderBy {
  ChecksumAsc = 'CHECKSUM_ASC',
  ChecksumDesc = 'CHECKSUM_DESC',
  CommentAsc = 'COMMENT_ASC',
  CommentDesc = 'COMMENT_DESC',
  LevelAsc = 'LEVEL_ASC',
  LevelDesc = 'LEVEL_DESC',
  NamespaceAsc = 'NAMESPACE_ASC',
  NamespaceDesc = 'NAMESPACE_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TimestampAsc = 'TIMESTAMP_ASC',
  TimestampDesc = 'TIMESTAMP_DESC'
}

/** A connection to a list of `MarvMigration` values. */
export interface MarvMigrationsConnection {
  __typename: 'MarvMigrationsConnection';
  /** A list of edges which contains the `MarvMigration` and cursor to aid in pagination. */
  edges: Array<MarvMigrationsEdge>;
  /** A list of `MarvMigration` objects. */
  nodes: Array<Maybe<MarvMigration>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MarvMigration` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `MarvMigration` edge in the connection. */
export interface MarvMigrationsEdge {
  __typename: 'MarvMigrationsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `MarvMigration` at the end of the edge. */
  node: Maybe<MarvMigration>;
}

export interface MarvMigration extends Node {
  __typename: 'MarvMigration';
  checksum: Maybe<Scalars['String']>;
  comment: Maybe<Scalars['String']>;
  level: Scalars['Int'];
  namespace: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  timestamp: Maybe<Scalars['Datetime']>;
}

/**
 * A condition to be used against `MarvMigrationsLock` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface MarvMigrationsLockCondition {
  /** Checks for equality with the object’s `dummyColumn` field. */
  dummyColumn?: InputMaybe<Scalars['Int']>;
}

/** Methods to use when ordering `MarvMigrationsLock`. */
export enum MarvMigrationsLocksOrderBy {
  DummyColumnAsc = 'DUMMY_COLUMN_ASC',
  DummyColumnDesc = 'DUMMY_COLUMN_DESC',
  Natural = 'NATURAL'
}

/** A connection to a list of `MarvMigrationsLock` values. */
export interface MarvMigrationsLocksConnection {
  __typename: 'MarvMigrationsLocksConnection';
  /** A list of edges which contains the `MarvMigrationsLock` and cursor to aid in pagination. */
  edges: Array<MarvMigrationsLocksEdge>;
  /** A list of `MarvMigrationsLock` objects. */
  nodes: Array<Maybe<MarvMigrationsLock>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MarvMigrationsLock` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `MarvMigrationsLock` edge in the connection. */
export interface MarvMigrationsLocksEdge {
  __typename: 'MarvMigrationsLocksEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `MarvMigrationsLock` at the end of the edge. */
  node: Maybe<MarvMigrationsLock>;
}

export interface MarvMigrationsLock {
  __typename: 'MarvMigrationsLock';
  dummyColumn: Scalars['Int'];
}

export interface MemberCondition {
  externalId?: InputMaybe<Scalars['String']>;
  programCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  statuses?: InputMaybe<Array<InputMaybe<MemberStatusValue>>>;
}

export enum MemberOrderBy {
  ActivationDateAsc = 'ACTIVATION_DATE_ASC',
  ActivationDateDesc = 'ACTIVATION_DATE_DESC',
  CustomerIdAsc = 'CUSTOMER_ID_ASC',
  CustomerIdDesc = 'CUSTOMER_ID_DESC',
  EnrollmentDateAsc = 'ENROLLMENT_DATE_ASC',
  EnrollmentDateDesc = 'ENROLLMENT_DATE_DESC',
  MemberNameAsc = 'MEMBER_NAME_ASC',
  MemberNameDesc = 'MEMBER_NAME_DESC',
  ProgramCodeAsc = 'PROGRAM_CODE_ASC',
  ProgramCodeDesc = 'PROGRAM_CODE_DESC',
  ShortIdAsc = 'SHORT_ID_ASC',
  ShortIdDesc = 'SHORT_ID_DESC',
  SiteAsc = 'SITE_ASC',
  SiteDesc = 'SITE_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC'
}

export interface MemberConnection {
  __typename: 'MemberConnection';
  edges: Array<MemberEdge>;
  nodes: Array<Maybe<MemberListItem>>;
  pageInfo: PageInfo;
  totalCount: Maybe<Scalars['Int']>;
}

export interface MemberEdge {
  __typename: 'MemberEdge';
  cursor: Maybe<Scalars['Cursor']>;
  node: Maybe<MemberListItem>;
}

export interface MemberListItem {
  __typename: 'MemberListItem';
  createdAt: Maybe<Scalars['Datetime']>;
  externalId: Maybe<Scalars['String']>;
  id: Maybe<Scalars['UUID']>;
  pauseStatus: Maybe<PauseStatus>;
  person: Maybe<Person>;
  program: Maybe<Program>;
  siteName: Maybe<Scalars['String']>;
  status: Maybe<MemberStatus>;
  statuses: Maybe<Array<Maybe<PatientStatus>>>;
  updatedAt: Maybe<Scalars['Datetime']>;
}

export interface Person {
  __typename: 'Person';
  addresses: Maybe<Array<Maybe<Address>>>;
  birthDate: Maybe<Scalars['String']>;
  coverageType: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['Date']>;
  emailAddresses: Maybe<Array<Maybe<EmailAddress>>>;
  ethnicity: Maybe<Scalars['String']>;
  gender: Maybe<Gender>;
  id: Maybe<Scalars['UUID']>;
  medicareId: Maybe<Scalars['String']>;
  names: Maybe<Array<Maybe<Name>>>;
  phoneNumbers: Maybe<Array<Maybe<PhoneNumber>>>;
  planName: Maybe<Scalars['String']>;
  primaryAddress: Maybe<Address>;
  primaryEmailAddress: Maybe<Scalars['String']>;
  primaryFirstName: Maybe<Scalars['String']>;
  primaryLanguage: Maybe<ISOLanguage>;
  primaryLastName: Maybe<Scalars['String']>;
  primaryMiddleName: Maybe<Scalars['String']>;
  primaryPhoneNumber: Maybe<Scalars['String']>;
  primaryTimezone: Maybe<Scalars['String']>;
  race: Maybe<Scalars['String']>;
  shortId: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['Date']>;
}

export interface EmailAddress {
  __typename: 'EmailAddress';
  createdAt: Maybe<Scalars['Date']>;
  emailAddress: Maybe<Scalars['String']>;
  id: Maybe<Scalars['UUID']>;
  isPrimary: Maybe<Scalars['Boolean']>;
  updatedAt: Maybe<Scalars['Date']>;
}

export enum Gender {
  Female = 'female',
  Male = 'male',
  Other = 'other',
  Unknown = 'unknown'
}

export interface Name {
  __typename: 'Name';
  createdAt: Maybe<Scalars['Date']>;
  firstName: Maybe<Scalars['String']>;
  id: Maybe<Scalars['UUID']>;
  isPrimary: Maybe<Scalars['Boolean']>;
  lastName: Maybe<Scalars['String']>;
  middleName: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['Date']>;
}

export interface PhoneNumber {
  __typename: 'PhoneNumber';
  createdAt: Maybe<Scalars['Date']>;
  id: Maybe<Scalars['UUID']>;
  isPrimary: Maybe<Scalars['Boolean']>;
  phoneNumber: Maybe<Scalars['String']>;
  type: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['Date']>;
}

export enum ISOLanguage {
  En = 'EN',
  Es = 'ES',
  Ru = 'RU'
}

export interface MemberStatus {
  __typename: 'MemberStatus';
  createdAt: Maybe<Scalars['Datetime']>;
  id: Maybe<Scalars['UUID']>;
  note: Maybe<Scalars['String']>;
  reason: Maybe<Scalars['String']>;
  reasonDetail: Maybe<Scalars['String']>;
  statusTransitionDate: Maybe<Scalars['Datetime']>;
  updatedAt: Maybe<Scalars['Datetime']>;
  value: Maybe<MemberStatusValue>;
}

/**
 * A condition to be used against `PatientStatusValue` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface PatientStatusValueCondition {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `warehouseRowId` field. */
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** Methods to use when ordering `PatientStatusValue`. */
export enum PatientStatusValuesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  WarehouseRowIdAsc = 'WAREHOUSE_ROW_ID_ASC',
  WarehouseRowIdDesc = 'WAREHOUSE_ROW_ID_DESC'
}

/** A connection to a list of `PatientStatusValue` values. */
export interface PatientStatusValuesConnection {
  __typename: 'PatientStatusValuesConnection';
  /** A list of edges which contains the `PatientStatusValue` and cursor to aid in pagination. */
  edges: Array<PatientStatusValuesEdge>;
  /** A list of `PatientStatusValue` objects. */
  nodes: Array<Maybe<PatientStatusValue>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PatientStatusValue` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `PatientStatusValue` edge in the connection. */
export interface PatientStatusValuesEdge {
  __typename: 'PatientStatusValuesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `PatientStatusValue` at the end of the edge. */
  node: Maybe<PatientStatusValue>;
}

/**
 * A condition to be used against `PauseReason` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export interface PauseReasonCondition {
  /** Checks for equality with the object’s `automaticInactivation` field. */
  automaticInactivation?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `automaticUnpause` field. */
  automaticUnpause?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
}

/** Methods to use when ordering `PauseReason`. */
export enum PauseReasonsOrderBy {
  AutomaticInactivationAsc = 'AUTOMATIC_INACTIVATION_ASC',
  AutomaticInactivationDesc = 'AUTOMATIC_INACTIVATION_DESC',
  AutomaticUnpauseAsc = 'AUTOMATIC_UNPAUSE_ASC',
  AutomaticUnpauseDesc = 'AUTOMATIC_UNPAUSE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

/** A connection to a list of `PauseReason` values. */
export interface PauseReasonsConnection {
  __typename: 'PauseReasonsConnection';
  /** A list of edges which contains the `PauseReason` and cursor to aid in pagination. */
  edges: Array<PauseReasonsEdge>;
  /** A list of `PauseReason` objects. */
  nodes: Array<Maybe<PauseReason>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PauseReason` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `PauseReason` edge in the connection. */
export interface PauseReasonsEdge {
  __typename: 'PauseReasonsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `PauseReason` at the end of the edge. */
  node: Maybe<PauseReason>;
}

/**
 * A condition to be used against `PrivilegedAction` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface PrivilegedActionCondition {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `warehouseRowId` field. */
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** Methods to use when ordering `PrivilegedAction`. */
export enum PrivilegedActionsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  WarehouseRowIdAsc = 'WAREHOUSE_ROW_ID_ASC',
  WarehouseRowIdDesc = 'WAREHOUSE_ROW_ID_DESC'
}

/** A connection to a list of `PrivilegedAction` values. */
export interface PrivilegedActionsConnection {
  __typename: 'PrivilegedActionsConnection';
  /** A list of edges which contains the `PrivilegedAction` and cursor to aid in pagination. */
  edges: Array<PrivilegedActionsEdge>;
  /** A list of `PrivilegedAction` objects. */
  nodes: Array<Maybe<PrivilegedAction>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PrivilegedAction` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `PrivilegedAction` edge in the connection. */
export interface PrivilegedActionsEdge {
  __typename: 'PrivilegedActionsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `PrivilegedAction` at the end of the edge. */
  node: Maybe<PrivilegedAction>;
}

/**
 * A condition to be used against `ProgramOutreachSubmission` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export interface ProgramOutreachSubmissionCondition {
  /** Checks for equality with the object’s `birthDate` field. */
  birthDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `checksBpBg` field. */
  checksBpBg?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `emailPrimary` field. */
  emailPrimary?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `externalId` field. */
  externalId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `familyName` field. */
  familyName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `givenName` field. */
  givenName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `mailingAddressCity` field. */
  mailingAddressCity?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `mailingAddressLine1` field. */
  mailingAddressLine1?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `mailingAddressLine2` field. */
  mailingAddressLine2?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `mailingAddressState` field. */
  mailingAddressState?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `mailingAddressZipCode` field. */
  mailingAddressZipCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `phonePrimary` field. */
  phonePrimary?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `program` field. */
  program?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `rawPayload` field. */
  rawPayload?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
}

/** Methods to use when ordering `ProgramOutreachSubmission`. */
export enum ProgramOutreachSubmissionsOrderBy {
  BirthDateAsc = 'BIRTH_DATE_ASC',
  BirthDateDesc = 'BIRTH_DATE_DESC',
  ChecksBpBgAsc = 'CHECKS_BP_BG_ASC',
  ChecksBpBgDesc = 'CHECKS_BP_BG_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EmailPrimaryAsc = 'EMAIL_PRIMARY_ASC',
  EmailPrimaryDesc = 'EMAIL_PRIMARY_DESC',
  ExternalIdAsc = 'EXTERNAL_ID_ASC',
  ExternalIdDesc = 'EXTERNAL_ID_DESC',
  FamilyNameAsc = 'FAMILY_NAME_ASC',
  FamilyNameDesc = 'FAMILY_NAME_DESC',
  GivenNameAsc = 'GIVEN_NAME_ASC',
  GivenNameDesc = 'GIVEN_NAME_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MailingAddressCityAsc = 'MAILING_ADDRESS_CITY_ASC',
  MailingAddressCityDesc = 'MAILING_ADDRESS_CITY_DESC',
  MailingAddressLine_1Asc = 'MAILING_ADDRESS_LINE_1_ASC',
  MailingAddressLine_1Desc = 'MAILING_ADDRESS_LINE_1_DESC',
  MailingAddressLine_2Asc = 'MAILING_ADDRESS_LINE_2_ASC',
  MailingAddressLine_2Desc = 'MAILING_ADDRESS_LINE_2_DESC',
  MailingAddressStateAsc = 'MAILING_ADDRESS_STATE_ASC',
  MailingAddressStateDesc = 'MAILING_ADDRESS_STATE_DESC',
  MailingAddressZipCodeAsc = 'MAILING_ADDRESS_ZIP_CODE_ASC',
  MailingAddressZipCodeDesc = 'MAILING_ADDRESS_ZIP_CODE_DESC',
  Natural = 'NATURAL',
  PhonePrimaryAsc = 'PHONE_PRIMARY_ASC',
  PhonePrimaryDesc = 'PHONE_PRIMARY_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProgramAsc = 'PROGRAM_ASC',
  ProgramDesc = 'PROGRAM_DESC',
  RawPayloadAsc = 'RAW_PAYLOAD_ASC',
  RawPayloadDesc = 'RAW_PAYLOAD_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** A connection to a list of `ProgramOutreachSubmission` values. */
export interface ProgramOutreachSubmissionsConnection {
  __typename: 'ProgramOutreachSubmissionsConnection';
  /** A list of edges which contains the `ProgramOutreachSubmission` and cursor to aid in pagination. */
  edges: Array<ProgramOutreachSubmissionsEdge>;
  /** A list of `ProgramOutreachSubmission` objects. */
  nodes: Array<Maybe<ProgramOutreachSubmission>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProgramOutreachSubmission` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `ProgramOutreachSubmission` edge in the connection. */
export interface ProgramOutreachSubmissionsEdge {
  __typename: 'ProgramOutreachSubmissionsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `ProgramOutreachSubmission` at the end of the edge. */
  node: Maybe<ProgramOutreachSubmission>;
}

/** Capture inbox for program outreach campaign-form submissions (UHC, Humana, ...); matched into person/prospect downstream. */
export interface ProgramOutreachSubmission extends Node {
  __typename: 'ProgramOutreachSubmission';
  birthDate: Maybe<Scalars['Date']>;
  /** Humana only: whether the member reports taking their blood pressure or blood glucose daily ("yes"/"no"; NULL for other programs). Self-reported eligibility signal; raw_payload keeps the verbatim submitted value. */
  checksBpBg: Maybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  emailPrimary: Maybe<Scalars['String']>;
  /** Submitted Member ID; groups a member's submissions within a program (non-unique — every submission is its own row). */
  externalId: Scalars['String'];
  familyName: Maybe<Scalars['String']>;
  givenName: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  mailingAddressCity: Maybe<Scalars['String']>;
  mailingAddressLine1: Maybe<Scalars['String']>;
  mailingAddressLine2: Maybe<Scalars['String']>;
  mailingAddressState: Maybe<Scalars['String']>;
  mailingAddressZipCode: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  phonePrimary: Maybe<Scalars['String']>;
  /** Program/campaign slug (e.g. uhc); resolved to a program_id during matching. */
  program: Scalars['String'];
  /** Full submitted payload, verbatim (agreed program data-spec field names plus any extras). */
  rawPayload: Scalars['JSON'];
  updatedAt: Scalars['Datetime'];
}

/**
 * A condition to be used against `ProgramTemplate` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface ProgramTemplateCondition {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
}

/** Methods to use when ordering `ProgramTemplate`. */
export enum ProgramTemplatesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** A connection to a list of `ProgramTemplate` values. */
export interface ProgramTemplatesConnection {
  __typename: 'ProgramTemplatesConnection';
  /** A list of edges which contains the `ProgramTemplate` and cursor to aid in pagination. */
  edges: Array<ProgramTemplatesEdge>;
  /** A list of `ProgramTemplate` objects. */
  nodes: Array<Maybe<ProgramTemplate>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProgramTemplate` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `ProgramTemplate` edge in the connection. */
export interface ProgramTemplatesEdge {
  __typename: 'ProgramTemplatesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `ProgramTemplate` at the end of the edge. */
  node: Maybe<ProgramTemplate>;
}

/**
 * A condition to be used against `ProspectStatusValue` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export interface ProspectStatusValueCondition {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `warehouseRowId` field. */
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** Methods to use when ordering `ProspectStatusValue`. */
export enum ProspectStatusValuesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  WarehouseRowIdAsc = 'WAREHOUSE_ROW_ID_ASC',
  WarehouseRowIdDesc = 'WAREHOUSE_ROW_ID_DESC'
}

/** A connection to a list of `ProspectStatusValue` values. */
export interface ProspectStatusValuesConnection {
  __typename: 'ProspectStatusValuesConnection';
  /** A list of edges which contains the `ProspectStatusValue` and cursor to aid in pagination. */
  edges: Array<ProspectStatusValuesEdge>;
  /** A list of `ProspectStatusValue` objects. */
  nodes: Array<Maybe<ProspectStatusValue>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProspectStatusValue` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `ProspectStatusValue` edge in the connection. */
export interface ProspectStatusValuesEdge {
  __typename: 'ProspectStatusValuesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `ProspectStatusValue` at the end of the edge. */
  node: Maybe<ProspectStatusValue>;
}

/**
 * A condition to be used against `RawIncomingDatum` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface RawIncomingDatumCondition {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `data` field. */
  data?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `source` field. */
  source?: InputMaybe<RawIncomingDataSource>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `warehouseRowId` field. */
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

export enum RawIncomingDataSource {
  Bodytrace = 'BODYTRACE',
  Kustmr = 'KUSTMR',
  PcmiMailTracking = 'PCMI_MAIL_TRACKING',
  PcmiQrTracking = 'PCMI_QR_TRACKING',
  Twilio = 'TWILIO'
}

/** Methods to use when ordering `RawIncomingDatum`. */
export enum RawIncomingDataOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DataAsc = 'DATA_ASC',
  DataDesc = 'DATA_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SourceAsc = 'SOURCE_ASC',
  SourceDesc = 'SOURCE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  WarehouseRowIdAsc = 'WAREHOUSE_ROW_ID_ASC',
  WarehouseRowIdDesc = 'WAREHOUSE_ROW_ID_DESC'
}

/** A connection to a list of `RawIncomingDatum` values. */
export interface RawIncomingDataConnection {
  __typename: 'RawIncomingDataConnection';
  /** A list of edges which contains the `RawIncomingDatum` and cursor to aid in pagination. */
  edges: Array<RawIncomingDataEdge>;
  /** A list of `RawIncomingDatum` objects. */
  nodes: Array<Maybe<RawIncomingDatum>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RawIncomingDatum` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `RawIncomingDatum` edge in the connection. */
export interface RawIncomingDataEdge {
  __typename: 'RawIncomingDataEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `RawIncomingDatum` at the end of the edge. */
  node: Maybe<RawIncomingDatum>;
}

/** An element of data received from an external party, e.g. Twilio or Bodytrace */
export interface RawIncomingDatum extends Node {
  __typename: 'RawIncomingDatum';
  createdAt: Scalars['Datetime'];
  /** A JSON-formatted chunk of data.  No particular schema is enforced. */
  data: Scalars['JSON'];
  id: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** The source of the data, e.g. twilio or bodytrace */
  source: RawIncomingDataSource;
  updatedAt: Scalars['Datetime'];
  warehouseRowId: Scalars['BigInt'];
}

export interface RewardPeriodTransactionCondition {
  amount?: InputMaybe<Scalars['BigFloat']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  currency?: InputMaybe<Currency>;
  date?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['UUID']>;
  reason?: InputMaybe<RewardPeriodTransactionReason>;
  rewardPeriodId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

export enum RewardPeriodTransactionReason {
  DailyBonus = 'DAILY_BONUS',
  Forfeited = 'FORFEITED',
  ManualAdjustment = 'MANUAL_ADJUSTMENT',
  MissedAppointment = 'MISSED_APPOINTMENT',
  MissedDay = 'MISSED_DAY',
  PeriodStart = 'PERIOD_START',
  TransferToAccountBalance = 'TRANSFER_TO_ACCOUNT_BALANCE'
}

export enum RewardPeriodTransactionOrderBy {
  AmountAsc = 'AMOUNT_ASC',
  AmountDesc = 'AMOUNT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CurrencyAsc = 'CURRENCY_ASC',
  CurrencyDesc = 'CURRENCY_DESC',
  DateAsc = 'DATE_ASC',
  DateDesc = 'DATE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  NoteAsc = 'NOTE_ASC',
  NoteDesc = 'NOTE_DESC',
  PatientIdAsc = 'PATIENT_ID_ASC',
  PatientIdDesc = 'PATIENT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ReasonAsc = 'REASON_ASC',
  ReasonDesc = 'REASON_DESC',
  RewardPeriodIdAsc = 'REWARD_PERIOD_ID_ASC',
  RewardPeriodIdDesc = 'REWARD_PERIOD_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  WarehouseRowIdAsc = 'WAREHOUSE_ROW_ID_ASC',
  WarehouseRowIdDesc = 'WAREHOUSE_ROW_ID_DESC'
}

export interface RewardPeriodTransactionConnection {
  __typename: 'RewardPeriodTransactionConnection';
  edges: Array<RewardPeriodTransactionEdge>;
  nodes: Array<Maybe<RewardPeriodTransaction>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

export interface RewardPeriodTransactionEdge {
  __typename: 'RewardPeriodTransactionEdge';
  cursor: Maybe<Scalars['Cursor']>;
  node: Maybe<RewardPeriodTransaction>;
}

export interface RewardPeriodTransaction extends Node {
  __typename: 'RewardPeriodTransaction';
  amount: Scalars['BigFloat'];
  createdAt: Scalars['Datetime'];
  currency: Currency;
  date: Scalars['Date'];
  id: Scalars['UUID'];
  nodeId: Scalars['ID'];
  note: Maybe<Scalars['String']>;
  patientByPatientId: Maybe<Patient>;
  patientId: Scalars['UUID'];
  reason: RewardPeriodTransactionReason;
  rewardPeriodByRewardPeriodId: Maybe<RewardPeriod>;
  rewardPeriodId: Scalars['UUID'];
  updatedAt: Scalars['Datetime'];
  warehouseRowId: Scalars['BigInt'];
}

/**
 * A condition to be used against `SmsAutoResponder` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface SmsAutoResponderCondition {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `endTimestamp` field. */
  endTimestamp?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `messageKey` field. */
  messageKey?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `startTimestamp` field. */
  startTimestamp?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `warehouseRowId` field. */
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** Methods to use when ordering `SmsAutoResponder`. */
export enum SmsAutoRespondersOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EndTimestampAsc = 'END_TIMESTAMP_ASC',
  EndTimestampDesc = 'END_TIMESTAMP_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MessageKeyAsc = 'MESSAGE_KEY_ASC',
  MessageKeyDesc = 'MESSAGE_KEY_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartTimestampAsc = 'START_TIMESTAMP_ASC',
  StartTimestampDesc = 'START_TIMESTAMP_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  WarehouseRowIdAsc = 'WAREHOUSE_ROW_ID_ASC',
  WarehouseRowIdDesc = 'WAREHOUSE_ROW_ID_DESC'
}

/** A connection to a list of `SmsAutoResponder` values. */
export interface SmsAutoRespondersConnection {
  __typename: 'SmsAutoRespondersConnection';
  /** A list of edges which contains the `SmsAutoResponder` and cursor to aid in pagination. */
  edges: Array<SmsAutoRespondersEdge>;
  /** A list of `SmsAutoResponder` objects. */
  nodes: Array<Maybe<SmsAutoResponder>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SmsAutoResponder` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `SmsAutoResponder` edge in the connection. */
export interface SmsAutoRespondersEdge {
  __typename: 'SmsAutoRespondersEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `SmsAutoResponder` at the end of the edge. */
  node: Maybe<SmsAutoResponder>;
}

/** A timeframe when an automatic sms response will be sent via the Wellth platform. */
export interface SmsAutoResponder extends Node {
  __typename: 'SmsAutoResponder';
  createdAt: Scalars['Datetime'];
  /** The UTC end timestamp of the sms auto responder */
  endTimestamp: Scalars['Datetime'];
  id: Scalars['UUID'];
  /** The sms auto response message string key. */
  messageKey: Maybe<Scalars['String']>;
  /** The reference name of the timeframe which an automatic response will be sent. */
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** The UTC start timestamp of the sms auto responder */
  startTimestamp: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  warehouseRowId: Scalars['BigInt'];
}

/**
 * A condition to be used against `TimedObject` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export interface TimedObjectCondition {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
}

/** Methods to use when ordering `TimedObject`. */
export enum TimedObjectsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** A connection to a list of `TimedObject` values. */
export interface TimedObjectsConnection {
  __typename: 'TimedObjectsConnection';
  /** A list of edges which contains the `TimedObject` and cursor to aid in pagination. */
  edges: Array<TimedObjectsEdge>;
  /** A list of `TimedObject` objects. */
  nodes: Array<Maybe<TimedObject>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TimedObject` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `TimedObject` edge in the connection. */
export interface TimedObjectsEdge {
  __typename: 'TimedObjectsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `TimedObject` at the end of the edge. */
  node: Maybe<TimedObject>;
}

export interface TimedObject extends Node {
  __typename: 'TimedObject';
  /** The time this object was created. */
  createdAt: Scalars['Datetime'];
  /** The unique identifier of this object. */
  id: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** The time this object was last updated. */
  updatedAt: Scalars['Datetime'];
}

/**
 * A condition to be used against `WinbackRewardConfig` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export interface WinbackRewardConfigCondition {
  /** Checks for equality with the object’s `challengeTypeKey` field. */
  challengeTypeKey?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `displayName` field. */
  displayName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `durationInDays` field. */
  durationInDays?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `isActive` field. */
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `maxRewardAmount` field. */
  maxRewardAmount?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `minRewardAmount` field. */
  minRewardAmount?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `rewardCurrency` field. */
  rewardCurrency?: InputMaybe<Currency>;
  /** Checks for equality with the object’s `triggerEvent` field. */
  triggerEvent?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `warehouseRowId` field. */
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** Methods to use when ordering `WinbackRewardConfig`. */
export enum WinbackRewardConfigsOrderBy {
  ChallengeTypeKeyAsc = 'CHALLENGE_TYPE_KEY_ASC',
  ChallengeTypeKeyDesc = 'CHALLENGE_TYPE_KEY_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  DisplayNameAsc = 'DISPLAY_NAME_ASC',
  DisplayNameDesc = 'DISPLAY_NAME_DESC',
  DurationInDaysAsc = 'DURATION_IN_DAYS_ASC',
  DurationInDaysDesc = 'DURATION_IN_DAYS_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsActiveAsc = 'IS_ACTIVE_ASC',
  IsActiveDesc = 'IS_ACTIVE_DESC',
  MaxRewardAmountAsc = 'MAX_REWARD_AMOUNT_ASC',
  MaxRewardAmountDesc = 'MAX_REWARD_AMOUNT_DESC',
  MinRewardAmountAsc = 'MIN_REWARD_AMOUNT_ASC',
  MinRewardAmountDesc = 'MIN_REWARD_AMOUNT_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RewardCurrencyAsc = 'REWARD_CURRENCY_ASC',
  RewardCurrencyDesc = 'REWARD_CURRENCY_DESC',
  TriggerEventAsc = 'TRIGGER_EVENT_ASC',
  TriggerEventDesc = 'TRIGGER_EVENT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  WarehouseRowIdAsc = 'WAREHOUSE_ROW_ID_ASC',
  WarehouseRowIdDesc = 'WAREHOUSE_ROW_ID_DESC'
}

/** A connection to a list of `WinbackRewardConfig` values. */
export interface WinbackRewardConfigsConnection {
  __typename: 'WinbackRewardConfigsConnection';
  /** A list of edges which contains the `WinbackRewardConfig` and cursor to aid in pagination. */
  edges: Array<WinbackRewardConfigsEdge>;
  /** A list of `WinbackRewardConfig` objects. */
  nodes: Array<Maybe<WinbackRewardConfig>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `WinbackRewardConfig` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `WinbackRewardConfig` edge in the connection. */
export interface WinbackRewardConfigsEdge {
  __typename: 'WinbackRewardConfigsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `WinbackRewardConfig` at the end of the edge. */
  node: Maybe<WinbackRewardConfig>;
}

export interface DeviceDetails {
  __typename: 'DeviceDetails';
  appBuildNumber: Maybe<Scalars['String']>;
  appVersion: Maybe<Scalars['String']>;
  brand: Maybe<Scalars['String']>;
  cameraPermission: Maybe<Scalars['String']>;
  carrier: Maybe<Scalars['String']>;
  id: Maybe<Scalars['UUID']>;
  lastSeen: Maybe<Scalars['String']>;
  locationPermission: Maybe<Scalars['String']>;
  manufacturer: Maybe<Scalars['String']>;
  model: Maybe<Scalars['String']>;
  notificationsPermission: Maybe<Scalars['String']>;
  os: Maybe<Scalars['String']>;
  osVersion: Maybe<Scalars['String']>;
  wellthId: Maybe<Scalars['UUID']>;
}

export interface DialysisAppointmentScheduleSummary {
  __typename: 'DialysisAppointmentScheduleSummary';
  dayOfWeek: Scalars['String'];
  endDate: Scalars['String'];
  reminderMinutesAdvance: Maybe<Scalars['Int']>;
  scheduleJob: Scalars['String'];
  startDate: Scalars['String'];
  time: Scalars['String'];
}

export interface ExtensionJobStatusInput {
  requestId: Scalars['UUID'];
}

export interface ExtensionJobStatus {
  __typename: 'ExtensionJobStatus';
  completedChunks: Scalars['Int'];
  createdAt: Scalars['String'];
  csvDownloadUrl: Maybe<Scalars['String']>;
  errorMessage: Maybe<Scalars['String']>;
  extendedCount: Scalars['Int'];
  extensionType: Scalars['String'];
  failedCount: Scalars['Int'];
  programCode: Scalars['String'];
  requestId: Scalars['UUID'];
  skippedCount: Scalars['Int'];
  status: Scalars['String'];
  totalChunks: Scalars['Int'];
  totalMembers: Scalars['Int'];
}

export interface GenerateSignedUrlInput {
  photoUrl: Scalars['String'];
}

export interface GenerateSignedUrlPayload {
  __typename: 'GenerateSignedUrlPayload';
  signedUrl: Scalars['String'];
}

export interface ProspectJob {
  __typename: 'ProspectJob';
  createdAt: Maybe<Scalars['Datetime']>;
  id: Maybe<Scalars['UUID']>;
  inputFile: Maybe<Scalars['String']>;
  program: Maybe<Program>;
  resultFile: Maybe<Scalars['String']>;
  status: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['Datetime']>;
}

export interface AppointmentsCondition {
  from?: InputMaybe<Scalars['Datetime']>;
  includeRescheduledAppointments?: InputMaybe<Scalars['Boolean']>;
  memberId: Scalars['String'];
  to?: InputMaybe<Scalars['Datetime']>;
}

export interface BonusBehaviorPage {
  __typename: 'BonusBehaviorPage';
  bonusBehaviorPagesetId: Maybe<Scalars['String']>;
  detail: Maybe<Scalars['String']>;
  icon: Maybe<Scalars['String']>;
  id: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
  type: Maybe<BonusBehaviorPageTypeValue>;
}

export enum BonusBehaviorPageTypeValue {
  Instruction = 'instruction',
  Submission = 'submission',
  Success = 'success',
  Verify = 'verify'
}

export interface ProgramConfig {
  __typename: 'ProgramConfig';
  paymentOptions: Maybe<Array<Maybe<PaymentOption>>>;
  reminderConfigs: Maybe<Array<Maybe<ReminderConfig>>>;
  rewardPeriodConfigs: Maybe<Array<Maybe<RewardPeriodConfig>>>;
}

export interface PaymentOption {
  __typename: 'PaymentOption';
  default: Maybe<Scalars['Boolean']>;
  id: Maybe<Scalars['UUID']>;
  name: Maybe<Scalars['String']>;
  packId: Maybe<Scalars['String']>;
  processor: Maybe<PaymentProcessor>;
}

export interface Prospect {
  __typename: 'Prospect';
  activeIdentityTags: Maybe<Array<Maybe<IdentityTag>>>;
  createdAt: Maybe<Scalars['Date']>;
  customerId: Maybe<Scalars['UUID']>;
  description: Maybe<Scalars['String']>;
  eligibilityEndDate: Maybe<Scalars['String']>;
  externalId: Maybe<Scalars['String']>;
  id: Maybe<Scalars['UUID']>;
  isTestProspect: Maybe<Scalars['Boolean']>;
  medicaidId: Maybe<Scalars['String']>;
  overallScore: Maybe<Score>;
  pcpName: Maybe<Scalars['String']>;
  pcpNumber: Maybe<Scalars['String']>;
  person: Maybe<Person>;
  personId: Maybe<Scalars['UUID']>;
  program: Maybe<Program>;
  prospectNotes: Maybe<Array<Maybe<ProspectNote>>>;
  prospectStatuses: Maybe<Array<Maybe<ProspectStatus>>>;
  siteName: Maybe<Scalars['String']>;
  status: Maybe<Scalars['String']>;
}

export interface Score {
  __typename: 'Score';
  createdAt: Maybe<Scalars['Date']>;
  id: Maybe<Scalars['UUID']>;
  impactTier: Maybe<Scalars['String']>;
  scoreName: Maybe<Scalars['String']>;
  scoreValue: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['Date']>;
}

export interface ProspectNote {
  __typename: 'ProspectNote';
  admin: Maybe<Admin>;
  createdAt: Maybe<Scalars['Datetime']>;
  id: Maybe<Scalars['UUID']>;
  note: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['Datetime']>;
}

export interface GraduationJobStatusInput {
  graduationDate?: InputMaybe<Scalars['Date']>;
  requestId: Scalars['UUID'];
}

export interface GraduationJobStatus {
  __typename: 'GraduationJobStatus';
  adminId: Scalars['UUID'];
  completedChunks: Scalars['Int'];
  createdAt: Scalars['String'];
  csvDownloadUrl: Maybe<Scalars['String']>;
  errorMessage: Maybe<Scalars['String']>;
  graduationDate: Scalars['Date'];
  graduationType: Scalars['String'];
  requestId: Scalars['UUID'];
  status: Scalars['String'];
  totalChunks: Scalars['Int'];
  totalMembers: Scalars['Int'];
}

export enum PrivilegeType {
  Delete = 'DELETE',
  Insert = 'INSERT',
  Select = 'SELECT',
  Update = 'UPDATE'
}

export interface LocalReminderNotification extends Notification {
  __typename: 'LocalReminderNotification';
  body: Maybe<Scalars['String']>;
  data: Maybe<NotificationData>;
  fireAt: Maybe<Scalars['Date']>;
  id: Maybe<Scalars['UUID']>;
  taskDueDate: Maybe<Scalars['Date']>;
  title: Maybe<Scalars['String']>;
}

export interface Notification {
  body: Maybe<Scalars['String']>;
  data: Maybe<NotificationData>;
  fireAt: Maybe<Scalars['Date']>;
  id: Maybe<Scalars['UUID']>;
  taskDueDate: Maybe<Scalars['Date']>;
  title: Maybe<Scalars['String']>;
}

export interface NotificationData {
  __typename: 'NotificationData';
  checkInCategory: Maybe<Scalars['String']>;
  type: Maybe<Scalars['String']>;
}

export interface Member {
  __typename: 'Member';
  activationDate: Maybe<Scalars['String']>;
  activeIdentityTags: Maybe<Array<Maybe<IdentityTag>>>;
  /** @deprecated Use activeIdentityTags */
  activeMemberTags: Maybe<Array<Maybe<MemberTag>>>;
  adherence: Maybe<AdherenceSummary>;
  appointments: Maybe<AppointmentConnection>;
  contacts: Maybe<Array<Maybe<Contact>>>;
  createdAt: Maybe<Scalars['Datetime']>;
  /** Generates the current or future reward period balance summary for a given patient */
  currentOrNextRewardPeriodBalance: Maybe<RewardPeriodBalanceDetail>;
  currentRewardPeriodBalance: Maybe<RewardPeriodBalanceDetail>;
  customerId: Maybe<Scalars['UUID']>;
  description: Maybe<Scalars['String']>;
  eligibilityEndDate: Maybe<Scalars['String']>;
  enrolledBy: Maybe<Scalars['String']>;
  enrollmentDate: Maybe<Scalars['String']>;
  externalId: Maybe<Scalars['String']>;
  externalId2: Maybe<Scalars['String']>;
  getMixpanelEvents: Maybe<MixpanelEvents>;
  hasBonusBehaviors: Maybe<Scalars['Boolean']>;
  id: Maybe<Scalars['UUID']>;
  isAutoPauseEnabled: Maybe<Scalars['Boolean']>;
  isLocalNotificationEnabled: Maybe<Scalars['Boolean']>;
  isProductTourRecurring: Maybe<Scalars['Boolean']>;
  isReminderEditingOpen: Maybe<Scalars['Boolean']>;
  isReminderMessagingEnabled: Maybe<Scalars['Boolean']>;
  isRestfulMember: Maybe<Scalars['Boolean']>;
  isTestMember: Maybe<Scalars['Boolean']>;
  latestTimezone: Maybe<MemberTimezone>;
  medicaidId: Maybe<Scalars['String']>;
  memberMessages: Maybe<Array<Maybe<MemberMessage>>>;
  memberNotes: Maybe<Array<Maybe<MemberNote>>>;
  nodeId: Scalars['ID'];
  onboardingDate: Maybe<Scalars['String']>;
  overallScore: Maybe<Score>;
  pauseDetails: Maybe<PauseDetails>;
  pauseStatus: Maybe<PauseStatus>;
  person: Maybe<Person>;
  personId: Maybe<Scalars['UUID']>;
  privacyPolicyURL: Maybe<Scalars['String']>;
  program: Maybe<Program>;
  reminders: Maybe<Array<Maybe<Reminder>>>;
  renderCalendarView: Maybe<Array<Maybe<CalendarDay>>>;
  siteName: Maybe<Scalars['String']>;
  status: Maybe<MemberStatus>;
  statuses: Maybe<Array<Maybe<PatientStatus>>>;
  termsConditionsURL: Maybe<Scalars['String']>;
  typeOfEnrollment: Maybe<TypeOfEnrollmentOptions>;
  updatedAt: Maybe<Scalars['Datetime']>;
  wellthId: Maybe<Scalars['UUID']>;
}


export interface MemberAdherenceArgs {
  endDate: Scalars['Date'];
  startDate: Scalars['Date'];
}


export interface MemberAppointmentsArgs {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientAppointmentsCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}


export interface MemberGetMixpanelEventsArgs {
  fromDate: Scalars['Date'];
  limit: Scalars['Int'];
  toDate: Scalars['Date'];
}


export interface MemberRenderCalendarViewArgs {
  endDate: Scalars['Date'];
  startDate: Scalars['Date'];
}

export interface MemberTag {
  __typename: 'MemberTag';
  adder: Maybe<ActorCode>;
  adderId: Maybe<Scalars['UUID']>;
  backgroundColor: Maybe<Scalars['String']>;
  borderColor: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['Date']>;
  id: Maybe<Scalars['UUID']>;
  isAdminRemovable: Maybe<Scalars['Boolean']>;
  memberId: Maybe<Scalars['UUID']>;
  name: Maybe<Scalars['String']>;
  removedAt: Maybe<Scalars['Date']>;
  updatedAt: Maybe<Scalars['Date']>;
}

export interface Contact {
  __typename: 'Contact';
  createdAt: Scalars['Datetime'];
  description: Maybe<Scalars['String']>;
  emailAddress: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  id: Scalars['UUID'];
  lastName: Maybe<Scalars['String']>;
  memberId: Scalars['UUID'];
  phoneNumber: Maybe<Scalars['String']>;
  relationship: RelationshipType;
  timezone: Maybe<Scalars['String']>;
  updatedAt: Scalars['Datetime'];
}

export enum RelationshipType {
  Child = 'child',
  Friend = 'friend',
  Other = 'other',
  PaidCaregiver = 'paidCaregiver',
  Roommate = 'roommate',
  Sibling = 'sibling',
  SpousePartner = 'spousePartner',
  Unknown = 'unknown'
}

export interface MemberTimezone {
  __typename: 'MemberTimezone';
  createdAt: Maybe<Scalars['Datetime']>;
  id: Maybe<Scalars['UUID']>;
  patientId: Maybe<Scalars['UUID']>;
  timezoneName: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['Datetime']>;
}

export interface MemberMessage {
  __typename: 'MemberMessage';
  admin: Maybe<Admin>;
  createdAt: Maybe<Scalars['Datetime']>;
  id: Maybe<Scalars['UUID']>;
  message: Maybe<Scalars['String']>;
  recipient: Maybe<MessageRecipient>;
  status: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['Datetime']>;
}

export interface MemberNote {
  __typename: 'MemberNote';
  admin: Maybe<Admin>;
  createdAt: Maybe<Scalars['Datetime']>;
  id: Maybe<Scalars['UUID']>;
  note: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['Datetime']>;
}

export interface PauseDetails {
  __typename: 'PauseDetails';
  endDate: Maybe<Scalars['Date']>;
  id: Maybe<Scalars['UUID']>;
  note: Maybe<Scalars['String']>;
  previousEndDate: Maybe<Scalars['Date']>;
  previousReason: Maybe<Scalars['String']>;
  previousStartDate: Maybe<Scalars['Date']>;
  reason: Maybe<Scalars['String']>;
  startDate: Maybe<Scalars['Date']>;
  totalPausedDays: Maybe<Scalars['Int']>;
}

export interface CalendarDay {
  __typename: 'CalendarDay';
  autoMedCount: Maybe<Scalars['Int']>;
  calendarDate: Maybe<Scalars['Date']>;
  checkInCategory: Maybe<CheckInCategory>;
  checkInId: Maybe<Scalars['UUID']>;
  checkInIsValid: Maybe<Scalars['Boolean']>;
  checkInLocalTime: Maybe<Scalars['Time']>;
  checkInStatus: Maybe<Scalars['String']>;
  checkInTimezone: Maybe<Scalars['Timezone']>;
  checkInVerificationStatus: Maybe<VerificationStatus>;
  frequency: Maybe<Scalars['String']>;
  isCredited: Maybe<Scalars['Boolean']>;
  isDemo: Maybe<Scalars['Boolean']>;
  objectDetectionStatus: Maybe<Scalars['String']>;
  photoUrl: Maybe<Scalars['String']>;
  reminderDate: Maybe<Scalars['Date']>;
  reminderId: Maybe<Scalars['UUID']>;
  reminderIsRequired: Maybe<Scalars['Boolean']>;
  reminderTime: Maybe<Scalars['Time']>;
  reminderWindowHasClosed: Maybe<Scalars['Boolean']>;
  windowAfterMinutes: Maybe<Scalars['Int']>;
  windowBeforeMinutes: Maybe<Scalars['Int']>;
}

export enum TypeOfEnrollmentOptions {
  CustomerEnrollment = 'customerEnrollment',
  InboundAiTransfer = 'inboundAiTransfer',
  InboundClientWarmTransfer = 'inboundClientWarmTransfer',
  InboundGeneralCall = 'inboundGeneralCall',
  Other = 'other',
  OutboundDialer = 'outboundDialer',
  OutboundGeneralCall = 'outboundGeneralCall',
  RemoteInbound = 'remoteInbound',
  RemoteInterestForm = 'remoteInterestForm',
  RemoteOutbound = 'remoteOutbound',
  RemoteSelfServeAssistance = 'remoteSelfServeAssistance',
  SelfServe = 'selfServe',
  WebSite = 'webSite',
  WellthInPerson = 'wellthInPerson',
  WellthRemote = 'wellthRemote'
}

export interface PaymentOptionCondition {
  memberId?: InputMaybe<Scalars['UUID']>;
}

export interface MemberSecurityQuestion {
  __typename: 'MemberSecurityQuestion';
  id: Scalars['UUID'];
  question: QuestionTranslation;
}

export interface QuestionTranslation {
  __typename: 'QuestionTranslation';
  en: Scalars['String'];
  es: Scalars['String'];
}

export interface MemberTimelineEvent {
  __typename: 'MemberTimelineEvent';
  id: Maybe<Scalars['UUID']>;
  name: Maybe<Scalars['String']>;
  properties: Maybe<Scalars['JSON']>;
  timestamp: Maybe<Scalars['Date']>;
  type: Maybe<Scalars['String']>;
  wellthId: Maybe<Scalars['UUID']>;
}

export interface ProgramPaymentOptionsCondition {
  programCode?: InputMaybe<Scalars['String']>;
}

export interface RequestMfaPinResetPayload {
  __typename: 'RequestMfaPinResetPayload';
  success: Scalars['Boolean'];
}

export interface RewardPeriodBalancesCondition {
  from?: InputMaybe<Scalars['Datetime']>;
  memberId: Scalars['UUID'];
  relativeTo?: InputMaybe<RewardBalanceRelativeTo>;
  to?: InputMaybe<Scalars['Datetime']>;
}

export interface SearchResult {
  __typename: 'SearchResult';
  results: Maybe<Array<Maybe<IndividualSearchResult>>>;
}

export interface IndividualSearchResult {
  __typename: 'IndividualSearchResult';
  birthDate: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['Date']>;
  externalId: Maybe<Scalars['String']>;
  id: Maybe<Scalars['UUID']>;
  individualType: Maybe<IndividualType>;
  location: Maybe<Scalars['String']>;
  names: Maybe<Array<Maybe<Name>>>;
  personId: Maybe<Scalars['UUID']>;
  phoneNumbers: Maybe<Array<Maybe<PhoneNumber>>>;
  programCode: Maybe<Scalars['String']>;
  shortId: Maybe<Scalars['String']>;
  status: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['Date']>;
}

export enum IndividualType {
  Member = 'MEMBER',
  Prospect = 'PROSPECT'
}

export interface SearchByValueInput {
  birthDate?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  programCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  shortId?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
}

export interface SupportDetailsObject {
  __typename: 'SupportDetailsObject';
  smsPhoneNumber: Maybe<Scalars['String']>;
  voicePhoneNumber: Maybe<Scalars['String']>;
}

export interface ValidateAddressInput {
  city: Scalars['String'];
  state: Scalars['String'];
  street: Scalars['String'];
  street2?: InputMaybe<Scalars['String']>;
  zip: Scalars['String'];
}

export interface ValidateAddressPayload {
  __typename: 'ValidateAddressPayload';
  correctedAddress: Maybe<AddressLite>;
  isValid: Maybe<Scalars['Boolean']>;
  note: Maybe<Scalars['String']>;
}

export interface AddressLite {
  __typename: 'AddressLite';
  city: Maybe<Scalars['String']>;
  state: Maybe<Scalars['String']>;
  street: Maybe<Scalars['String']>;
  street2: Maybe<Scalars['String']>;
  zip: Maybe<Scalars['String']>;
}

/** The root mutation type which contains root level fields which mutate data. */
export interface Mutation {
  __typename: 'Mutation';
  addIdentityTag: Maybe<IdentityTag>;
  approveSmsOutreachMessage: Maybe<Scalars['Boolean']>;
  /** Creates a JWT token that will securely identify an admin and give them certain permissions. */
  authenticateAdmin: Maybe<AuthenticateAdminPayload>;
  cancelPauseRequest: Maybe<CancelPauseRequestPayload>;
  cancelUnpauseRequest: Maybe<CancelUnpauseRequestPayload>;
  changeBonusBehaviorSubmissionStatus: Maybe<BonusBehaviorSubmission>;
  changeMemberStatus: Maybe<Scalars['Boolean']>;
  changeProspectStatus: Maybe<Scalars['Boolean']>;
  checkInCategoryMatches: Maybe<CheckInCategoryMatchesPayload>;
  /** Creates a single `AccountTransaction`. */
  createAccountTransaction: Maybe<CreateAccountTransactionPayload>;
  createAccountTransactionCredit: Maybe<CreateAccountTransactionCreditPayload>;
  /** Creates a single `ActionLog`. */
  createActionLog: Maybe<CreateActionLogPayload>;
  createAddress: Maybe<CreateAddressPayload>;
  /** Creates a single `Admin`. */
  createAdmin: Maybe<CreateAdminPayload>;
  /** Creates a single `AdminRole`. */
  createAdminRole: Maybe<CreateAdminRolePayload>;
  /** Creates a single `AdminRolePrivilegedAction`. */
  createAdminRolePrivilegedAction: Maybe<CreateAdminRolePrivilegedActionPayload>;
  createBonusBehaviorConfig: Maybe<BonusBehaviorConfig>;
  createBonusBehaviorSubmission: Maybe<BonusBehaviorSubmission>;
  /** Creates a single `BonusBehaviorSubmissionStatus`. */
  createBonusBehaviorSubmissionStatus: Maybe<CreateBonusBehaviorSubmissionStatusPayload>;
  /** Creates a single `CheckIn`. */
  createCheckIn: Maybe<CreateCheckInPayload>;
  createCheckInData: Maybe<CheckInDataPayload>;
  createCheckInSubmission: Maybe<CheckInSubmissionPayload>;
  createContact: Maybe<Contact>;
  /** Creates a single `CueCheckIn`. */
  createCueCheckIn: Maybe<CreateCueCheckInPayload>;
  /** Creates a single `Customer`. */
  createCustomer: Maybe<CreateCustomerPayload>;
  /** Creates a single `DebitCard`. */
  createDebitCard: Maybe<CreateDebitCardPayload>;
  /** Creates a single `DebitCardBalance`. */
  createDebitCardBalance: Maybe<CreateDebitCardBalancePayload>;
  /** Creates a single `Device`. */
  createDevice: Maybe<CreateDevicePayload>;
  createDialysisAppointmentSchedule: DialysisAppointmentScheduleResponse;
  createEmailAddress: Maybe<CreateEmailAddressPayload>;
  /** Creates a single `Group`. */
  createGroup: Maybe<CreateGroupPayload>;
  /** Creates a single `Heartbeat`. */
  createHeartbeat: Maybe<CreateHeartbeatPayload>;
  /** Creates a Highlight Submission Record */
  createHighlightSubmission: Maybe<CreateHighlightSubmissionPayload>;
  /** Creates a single `HydrationCheckIn`. */
  createHydrationCheckIn: Maybe<CreateHydrationCheckInPayload>;
  /** Creates a single `MarvMigration`. */
  createMarvMigration: Maybe<CreateMarvMigrationPayload>;
  /** Creates a single `MarvMigrationsLock`. */
  createMarvMigrationsLock: Maybe<CreateMarvMigrationsLockPayload>;
  /** Creates a single `MealCheckIn`. */
  createMealCheckIn: Maybe<CreateMealCheckInPayload>;
  /** Creates a single `MeasurementCheckIn`. */
  createMeasurementCheckIn: Maybe<CreateMeasurementCheckInPayload>;
  /** Creates a single `MedicationCheckIn`. */
  createMedicationCheckIn: Maybe<CreateMedicationCheckInPayload>;
  /** Creates a single `Message`. */
  createMessage: Maybe<CreateMessagePayload>;
  createName: Maybe<CreateNamePayload>;
  /** Creates a single `ObjectDetection`. */
  createObjectDetection: Maybe<CreateObjectDetectionPayload>;
  /** Creates a single `Patient`. */
  createPatient: Maybe<CreatePatientPayload>;
  /** Creates a single `PatientMembershipConfig`. */
  createPatientMembershipConfig: Maybe<CreatePatientMembershipConfigPayload>;
  createPatientNote: Maybe<CreatePatientNotePayload>;
  /** Creates a single `PatientStatus`. */
  createPatientStatus: Maybe<CreatePatientStatusPayload>;
  /** Creates a single `PatientStatusValue`. */
  createPatientStatusValue: Maybe<CreatePatientStatusValuePayload>;
  /** Creates a single `Pause`. */
  createPause: Maybe<CreatePausePayload>;
  /** Creates a single `PauseReason`. */
  createPauseReason: Maybe<CreatePauseReasonPayload>;
  /** Creates a single `PaymentSetup`. */
  createPaymentSetup: Maybe<CreatePaymentSetupPayload>;
  createPhoneNumber: Maybe<CreatePhoneNumberPayload>;
  /** Creates a single `PrivilegedAction`. */
  createPrivilegedAction: Maybe<CreatePrivilegedActionPayload>;
  /** Creates a single `Program`. */
  createProgram: Maybe<CreateProgramPayload>;
  /** Creates a single `ProgramMfaConfig`. */
  createProgramMfaConfig: Maybe<CreateProgramMfaConfigPayload>;
  /** Creates a single `ProgramOutreachSubmission`. */
  createProgramOutreachSubmission: Maybe<CreateProgramOutreachSubmissionPayload>;
  /** Creates a single `ProgramReward`. */
  createProgramReward: Maybe<CreateProgramRewardPayload>;
  /** Creates a single `ProgramRewardConfig`. */
  createProgramRewardConfig: Maybe<CreateProgramRewardConfigPayload>;
  /** Creates a single `ProgramTemplate`. */
  createProgramTemplate: Maybe<CreateProgramTemplatePayload>;
  createProspect: Maybe<CreateProspectPayload>;
  createProspectForInactiveMember: Maybe<CreateProspectPayload>;
  createProspectNote: Maybe<CreateProspectNotePayload>;
  /** Creates a single `ProspectStatus`. */
  createProspectStatus: Maybe<CreateProspectStatusPayload>;
  /** Creates a single `ProspectStatusValue`. */
  createProspectStatusValue: Maybe<CreateProspectStatusValuePayload>;
  /** Creates a single `PushNotification`. */
  createPushNotification: Maybe<CreatePushNotificationPayload>;
  /** Creates a single `PushToken`. */
  createPushToken: Maybe<CreatePushTokenPayload>;
  /** Creates a single `RawIncomingDatum`. */
  createRawIncomingDatum: Maybe<CreateRawIncomingDatumPayload>;
  /** Creates a single `Reminder`. */
  createReminder: Maybe<CreateReminderPayload>;
  /** Creates a single `ReminderConfig`. */
  createReminderConfig: Maybe<CreateReminderConfigPayload>;
  /** Creates a single `ReminderMessage`. */
  createReminderMessage: Maybe<CreateReminderMessagePayload>;
  /** Creates a single `RewardPeriod`. */
  createRewardPeriod: Maybe<CreateRewardPeriodPayload>;
  /** Creates a single `RewardPeriodConfig`. */
  createRewardPeriodConfig: Maybe<CreateRewardPeriodConfigPayload>;
  /** Creates a single `SmsAutoResponder`. */
  createSmsAutoResponder: Maybe<CreateSmsAutoResponderPayload>;
  /** Creates a single `SmsOutreachMessage`. */
  createSmsOutreachMessage: Maybe<CreateSmsOutreachMessagePayload>;
  /** Creates a single `SmsOutreachMessageTemplate`. */
  createSmsOutreachMessageTemplate: Maybe<CreateSmsOutreachMessageTemplatePayload>;
  /** Creates a single `SmsOutreachRecipient`. */
  createSmsOutreachRecipient: Maybe<CreateSmsOutreachRecipientPayload>;
  /** Creates a single `TimedObject`. */
  createTimedObject: Maybe<CreateTimedObjectPayload>;
  /** Creates a single `TimezoneRecord`. */
  createTimezoneRecord: Maybe<CreateTimezoneRecordPayload>;
  /** Creates a single `Walkthrough`. */
  createWalkthrough: Maybe<CreateWalkthroughPayload>;
  /** Creates a single `WalkthroughPage`. */
  createWalkthroughPage: Maybe<CreateWalkthroughPagePayload>;
  /** Creates a single `WalkthroughSetup`. */
  createWalkthroughSetup: Maybe<CreateWalkthroughSetupPayload>;
  /** Creates a single `WalkthroughSetupConfig`. */
  createWalkthroughSetupConfig: Maybe<CreateWalkthroughSetupConfigPayload>;
  /** Creates a single `WalkthroughSummary`. */
  createWalkthroughSummary: Maybe<CreateWalkthroughSummaryPayload>;
  /** Creates a single `WinbackRewardConfig`. */
  createWinbackRewardConfig: Maybe<CreateWinbackRewardConfigPayload>;
  /** Creates a single `WinbackRewardOpportunity`. */
  createWinbackRewardOpportunity: Maybe<CreateWinbackRewardOpportunityPayload>;
  creditAppointment: Maybe<Appointment>;
  /** Deletes a single `AccountTransaction` using its globally unique id. */
  deleteAccountTransaction: Maybe<DeleteAccountTransactionPayload>;
  /** Deletes a single `AccountTransaction` using a unique key. */
  deleteAccountTransactionById: Maybe<DeleteAccountTransactionPayload>;
  /** Deletes a single `ActionLog` using its globally unique id. */
  deleteActionLog: Maybe<DeleteActionLogPayload>;
  /** Deletes a single `ActionLog` using a unique key. */
  deleteActionLogById: Maybe<DeleteActionLogPayload>;
  deleteAddressById: Maybe<Scalars['Boolean']>;
  /** Deletes a single `Admin` using its globally unique id. */
  deleteAdmin: Maybe<DeleteAdminPayload>;
  /** Deletes a single `Admin` using a unique key. */
  deleteAdminById: Maybe<DeleteAdminPayload>;
  /** Deletes a single `AdminRole` using its globally unique id. */
  deleteAdminRole: Maybe<DeleteAdminRolePayload>;
  /** Deletes a single `AdminRole` using a unique key. */
  deleteAdminRoleById: Maybe<DeleteAdminRolePayload>;
  /** Deletes a single `AdminRole` using a unique key. */
  deleteAdminRoleByName: Maybe<DeleteAdminRolePayload>;
  /** Deletes a single `AdminRolePrivilegedAction` using its globally unique id. */
  deleteAdminRolePrivilegedAction: Maybe<DeleteAdminRolePrivilegedActionPayload>;
  /** Deletes a single `AdminRolePrivilegedAction` using a unique key. */
  deleteAdminRolePrivilegedActionById: Maybe<DeleteAdminRolePrivilegedActionPayload>;
  /** Deletes a single `BonusBehaviorSubmissionStatus` using its globally unique id. */
  deleteBonusBehaviorSubmissionStatus: Maybe<DeleteBonusBehaviorSubmissionStatusPayload>;
  /** Deletes a single `BonusBehaviorSubmissionStatus` using a unique key. */
  deleteBonusBehaviorSubmissionStatusByBonusBehaviorSubmissionIdAndCreatedAtAndValue: Maybe<DeleteBonusBehaviorSubmissionStatusPayload>;
  /** Deletes a single `BonusBehaviorSubmissionStatus` using a unique key. */
  deleteBonusBehaviorSubmissionStatusById: Maybe<DeleteBonusBehaviorSubmissionStatusPayload>;
  /** Deletes a single `CheckIn` using its globally unique id. */
  deleteCheckIn: Maybe<DeleteCheckInPayload>;
  /** Deletes a single `CheckIn` using a unique key. */
  deleteCheckInById: Maybe<DeleteCheckInPayload>;
  deleteContactById: Maybe<Scalars['Boolean']>;
  /** Deletes a single `CueCheckIn` using its globally unique id. */
  deleteCueCheckIn: Maybe<DeleteCueCheckInPayload>;
  /** Deletes a single `CueCheckIn` using a unique key. */
  deleteCueCheckInById: Maybe<DeleteCueCheckInPayload>;
  /** Deletes a single `Customer` using its globally unique id. */
  deleteCustomer: Maybe<DeleteCustomerPayload>;
  /** Deletes a single `Customer` using a unique key. */
  deleteCustomerById: Maybe<DeleteCustomerPayload>;
  /** Deletes a single `Customer` using a unique key. */
  deleteCustomerByName: Maybe<DeleteCustomerPayload>;
  /** Deletes a single `DebitCard` using its globally unique id. */
  deleteDebitCard: Maybe<DeleteDebitCardPayload>;
  /** Deletes a single `DebitCardBalance` using its globally unique id. */
  deleteDebitCardBalance: Maybe<DeleteDebitCardBalancePayload>;
  /** Deletes a single `DebitCardBalance` using a unique key. */
  deleteDebitCardBalanceById: Maybe<DeleteDebitCardBalancePayload>;
  /** Deletes a single `DebitCard` using a unique key. */
  deleteDebitCardById: Maybe<DeleteDebitCardPayload>;
  /** Deletes a single `Device` using its globally unique id. */
  deleteDevice: Maybe<DeleteDevicePayload>;
  /** Deletes a single `Device` using a unique key. */
  deleteDeviceById: Maybe<DeleteDevicePayload>;
  deleteEmailAddressById: Maybe<Scalars['Boolean']>;
  deleteFutureDialysisAppointmentEvents: DeleteFutureDialysisAppointmentEventsPayload;
  /** Deletes a single `Group` using its globally unique id. */
  deleteGroup: Maybe<DeleteGroupPayload>;
  /** Deletes a single `Group` using a unique key. */
  deleteGroupById: Maybe<DeleteGroupPayload>;
  /** Deletes a single `Heartbeat` using its globally unique id. */
  deleteHeartbeat: Maybe<DeleteHeartbeatPayload>;
  /** Deletes a single `Heartbeat` using a unique key. */
  deleteHeartbeatById: Maybe<DeleteHeartbeatPayload>;
  /** Deletes a single `HydrationCheckIn` using its globally unique id. */
  deleteHydrationCheckIn: Maybe<DeleteHydrationCheckInPayload>;
  /** Deletes a single `HydrationCheckIn` using a unique key. */
  deleteHydrationCheckInById: Maybe<DeleteHydrationCheckInPayload>;
  /** Deletes a single `MarvMigration` using its globally unique id. */
  deleteMarvMigration: Maybe<DeleteMarvMigrationPayload>;
  /** Deletes a single `MarvMigration` using a unique key. */
  deleteMarvMigrationByLevelAndNamespace: Maybe<DeleteMarvMigrationPayload>;
  /** Deletes a single `MealCheckIn` using its globally unique id. */
  deleteMealCheckIn: Maybe<DeleteMealCheckInPayload>;
  /** Deletes a single `MealCheckIn` using a unique key. */
  deleteMealCheckInById: Maybe<DeleteMealCheckInPayload>;
  /** Deletes a single `MeasurementCheckIn` using its globally unique id. */
  deleteMeasurementCheckIn: Maybe<DeleteMeasurementCheckInPayload>;
  /** Deletes a single `MeasurementCheckIn` using a unique key. */
  deleteMeasurementCheckInById: Maybe<DeleteMeasurementCheckInPayload>;
  /** Deletes a single `MedicationCheckIn` using its globally unique id. */
  deleteMedicationCheckIn: Maybe<DeleteMedicationCheckInPayload>;
  /** Deletes a single `MedicationCheckIn` using a unique key. */
  deleteMedicationCheckInById: Maybe<DeleteMedicationCheckInPayload>;
  deleteMember: Maybe<Scalars['Boolean']>;
  /** Deletes a single `Message` using its globally unique id. */
  deleteMessage: Maybe<DeleteMessagePayload>;
  /** Deletes a single `Message` using a unique key. */
  deleteMessageByExternalId: Maybe<DeleteMessagePayload>;
  /** Deletes a single `Message` using a unique key. */
  deleteMessageById: Maybe<DeleteMessagePayload>;
  deleteNameById: Maybe<Scalars['Boolean']>;
  /** Deletes a single `ObjectDetection` using its globally unique id. */
  deleteObjectDetection: Maybe<DeleteObjectDetectionPayload>;
  /** Deletes a single `ObjectDetection` using a unique key. */
  deleteObjectDetectionById: Maybe<DeleteObjectDetectionPayload>;
  /** Deletes a single `Patient` using its globally unique id. */
  deletePatient: Maybe<DeletePatientPayload>;
  /** Deletes a single `Patient` using a unique key. */
  deletePatientById: Maybe<DeletePatientPayload>;
  /** Deletes a single `PatientMembershipConfig` using its globally unique id. */
  deletePatientMembershipConfig: Maybe<DeletePatientMembershipConfigPayload>;
  /** Deletes a single `PatientMembershipConfig` using a unique key. */
  deletePatientMembershipConfigById: Maybe<DeletePatientMembershipConfigPayload>;
  /** Deletes a single `PatientStatus` using its globally unique id. */
  deletePatientStatus: Maybe<DeletePatientStatusPayload>;
  /** Deletes a single `PatientStatus` using a unique key. */
  deletePatientStatusById: Maybe<DeletePatientStatusPayload>;
  /** Deletes a single `PatientStatus` using a unique key. */
  deletePatientStatusByPatientIdAndCreatedAtAndValue: Maybe<DeletePatientStatusPayload>;
  /** Deletes a single `PatientStatusValue` using its globally unique id. */
  deletePatientStatusValue: Maybe<DeletePatientStatusValuePayload>;
  /** Deletes a single `PatientStatusValue` using a unique key. */
  deletePatientStatusValueById: Maybe<DeletePatientStatusValuePayload>;
  /** Deletes a single `PatientStatusValue` using a unique key. */
  deletePatientStatusValueByName: Maybe<DeletePatientStatusValuePayload>;
  /** Deletes a single `Pause` using its globally unique id. */
  deletePause: Maybe<DeletePausePayload>;
  /** Deletes a single `Pause` using a unique key. */
  deletePauseById: Maybe<DeletePausePayload>;
  /** Deletes a single `PauseReason` using its globally unique id. */
  deletePauseReason: Maybe<DeletePauseReasonPayload>;
  /** Deletes a single `PauseReason` using a unique key. */
  deletePauseReasonById: Maybe<DeletePauseReasonPayload>;
  /** Deletes a single `PauseReason` using a unique key. */
  deletePauseReasonByValue: Maybe<DeletePauseReasonPayload>;
  /** Deletes a single `PaymentSetup` using its globally unique id. */
  deletePaymentSetup: Maybe<DeletePaymentSetupPayload>;
  /** Deletes a single `PaymentSetup` using a unique key. */
  deletePaymentSetupById: Maybe<DeletePaymentSetupPayload>;
  deletePhoneNumberById: Maybe<Scalars['Boolean']>;
  /** Deletes a single `PrivilegedAction` using its globally unique id. */
  deletePrivilegedAction: Maybe<DeletePrivilegedActionPayload>;
  /** Deletes a single `PrivilegedAction` using a unique key. */
  deletePrivilegedActionById: Maybe<DeletePrivilegedActionPayload>;
  /** Deletes a single `PrivilegedAction` using a unique key. */
  deletePrivilegedActionByName: Maybe<DeletePrivilegedActionPayload>;
  /** Deletes a single `ProgramMfaConfig` using its globally unique id. */
  deleteProgramMfaConfig: Maybe<DeleteProgramMfaConfigPayload>;
  /** Deletes a single `ProgramMfaConfig` using a unique key. */
  deleteProgramMfaConfigById: Maybe<DeleteProgramMfaConfigPayload>;
  /** Deletes a single `ProgramMfaConfig` using a unique key. */
  deleteProgramMfaConfigByProgramId: Maybe<DeleteProgramMfaConfigPayload>;
  /** Deletes a single `ProgramOutreachSubmission` using its globally unique id. */
  deleteProgramOutreachSubmission: Maybe<DeleteProgramOutreachSubmissionPayload>;
  /** Deletes a single `ProgramOutreachSubmission` using a unique key. */
  deleteProgramOutreachSubmissionById: Maybe<DeleteProgramOutreachSubmissionPayload>;
  /** Deletes a single `ProgramReward` using its globally unique id. */
  deleteProgramReward: Maybe<DeleteProgramRewardPayload>;
  /** Deletes a single `ProgramReward` using a unique key. */
  deleteProgramRewardById: Maybe<DeleteProgramRewardPayload>;
  /** Deletes a single `ProgramRewardConfig` using its globally unique id. */
  deleteProgramRewardConfig: Maybe<DeleteProgramRewardConfigPayload>;
  /** Deletes a single `ProgramRewardConfig` using a unique key. */
  deleteProgramRewardConfigById: Maybe<DeleteProgramRewardConfigPayload>;
  /** Deletes a single `ProgramRewardConfig` using a unique key. */
  deleteProgramRewardConfigByName: Maybe<DeleteProgramRewardConfigPayload>;
  /** Deletes a single `ProgramTemplate` using its globally unique id. */
  deleteProgramTemplate: Maybe<DeleteProgramTemplatePayload>;
  /** Deletes a single `ProgramTemplate` using a unique key. */
  deleteProgramTemplateById: Maybe<DeleteProgramTemplatePayload>;
  /** Deletes a single `ProgramTemplate` using a unique key. */
  deleteProgramTemplateByName: Maybe<DeleteProgramTemplatePayload>;
  /** Deletes a single `ProspectStatus` using its globally unique id. */
  deleteProspectStatus: Maybe<DeleteProspectStatusPayload>;
  /** Deletes a single `ProspectStatus` using a unique key. */
  deleteProspectStatusById: Maybe<DeleteProspectStatusPayload>;
  /** Deletes a single `ProspectStatus` using a unique key. */
  deleteProspectStatusByProspectIdAndCreatedAtAndValue: Maybe<DeleteProspectStatusPayload>;
  /** Deletes a single `ProspectStatusValue` using its globally unique id. */
  deleteProspectStatusValue: Maybe<DeleteProspectStatusValuePayload>;
  /** Deletes a single `ProspectStatusValue` using a unique key. */
  deleteProspectStatusValueById: Maybe<DeleteProspectStatusValuePayload>;
  /** Deletes a single `ProspectStatusValue` using a unique key. */
  deleteProspectStatusValueByName: Maybe<DeleteProspectStatusValuePayload>;
  /** Deletes a single `PushNotification` using its globally unique id. */
  deletePushNotification: Maybe<DeletePushNotificationPayload>;
  /** Deletes a single `PushNotification` using a unique key. */
  deletePushNotificationById: Maybe<DeletePushNotificationPayload>;
  /** Deletes a single `PushToken` using its globally unique id. */
  deletePushToken: Maybe<DeletePushTokenPayload>;
  /** Deletes a single `PushToken` using a unique key. */
  deletePushTokenById: Maybe<DeletePushTokenPayload>;
  /** Deletes a single `RawIncomingDatum` using its globally unique id. */
  deleteRawIncomingDatum: Maybe<DeleteRawIncomingDatumPayload>;
  /** Deletes a single `RawIncomingDatum` using a unique key. */
  deleteRawIncomingDatumById: Maybe<DeleteRawIncomingDatumPayload>;
  /** Deletes a single `Reminder` using its globally unique id. */
  deleteReminder: Maybe<DeleteReminderPayload>;
  /** Deletes a single `Reminder` using a unique key. */
  deleteReminderById: Maybe<DeleteReminderPayload>;
  /** Deletes a single `ReminderConfig` using its globally unique id. */
  deleteReminderConfig: Maybe<DeleteReminderConfigPayload>;
  /** Deletes a single `ReminderConfig` using a unique key. */
  deleteReminderConfigById: Maybe<DeleteReminderConfigPayload>;
  /** Deletes a single `ReminderMessage` using its globally unique id. */
  deleteReminderMessage: Maybe<DeleteReminderMessagePayload>;
  /** Deletes a single `ReminderMessage` using a unique key. */
  deleteReminderMessageById: Maybe<DeleteReminderMessagePayload>;
  /** Deletes a single `RewardPeriod` using its globally unique id. */
  deleteRewardPeriod: Maybe<DeleteRewardPeriodPayload>;
  /** Deletes a single `RewardPeriod` using a unique key. */
  deleteRewardPeriodById: Maybe<DeleteRewardPeriodPayload>;
  /** Deletes a single `RewardPeriodConfig` using its globally unique id. */
  deleteRewardPeriodConfig: Maybe<DeleteRewardPeriodConfigPayload>;
  /** Deletes a single `RewardPeriodConfig` using a unique key. */
  deleteRewardPeriodConfigById: Maybe<DeleteRewardPeriodConfigPayload>;
  /** Deletes a single `SmsAutoResponder` using its globally unique id. */
  deleteSmsAutoResponder: Maybe<DeleteSmsAutoResponderPayload>;
  /** Deletes a single `SmsAutoResponder` using a unique key. */
  deleteSmsAutoResponderById: Maybe<DeleteSmsAutoResponderPayload>;
  /** Deletes a single `SmsOutreachMessage` using its globally unique id. */
  deleteSmsOutreachMessage: Maybe<DeleteSmsOutreachMessagePayload>;
  /** Deletes a single `SmsOutreachMessage` using a unique key. */
  deleteSmsOutreachMessageById: Maybe<DeleteSmsOutreachMessagePayload>;
  /** Deletes a single `SmsOutreachMessageTemplate` using its globally unique id. */
  deleteSmsOutreachMessageTemplate: Maybe<DeleteSmsOutreachMessageTemplatePayload>;
  /** Deletes a single `SmsOutreachMessageTemplate` using a unique key. */
  deleteSmsOutreachMessageTemplateById: Maybe<DeleteSmsOutreachMessageTemplatePayload>;
  /** Deletes a single `SmsOutreachRecipient` using its globally unique id. */
  deleteSmsOutreachRecipient: Maybe<DeleteSmsOutreachRecipientPayload>;
  /** Deletes a single `SmsOutreachRecipient` using a unique key. */
  deleteSmsOutreachRecipientById: Maybe<DeleteSmsOutreachRecipientPayload>;
  /** Deletes a single `SmsOutreachRecipient` using a unique key. */
  deleteSmsOutreachRecipientByPhoneNumber: Maybe<DeleteSmsOutreachRecipientPayload>;
  /** Deletes a single `TimedObject` using its globally unique id. */
  deleteTimedObject: Maybe<DeleteTimedObjectPayload>;
  /** Deletes a single `TimedObject` using a unique key. */
  deleteTimedObjectById: Maybe<DeleteTimedObjectPayload>;
  /** Deletes a single `TimezoneRecord` using its globally unique id. */
  deleteTimezoneRecord: Maybe<DeleteTimezoneRecordPayload>;
  /** Deletes a single `TimezoneRecord` using a unique key. */
  deleteTimezoneRecordById: Maybe<DeleteTimezoneRecordPayload>;
  /** Deletes a single `Walkthrough` using its globally unique id. */
  deleteWalkthrough: Maybe<DeleteWalkthroughPayload>;
  /** Deletes a single `Walkthrough` using a unique key. */
  deleteWalkthroughById: Maybe<DeleteWalkthroughPayload>;
  /** Deletes a single `WalkthroughPage` using its globally unique id. */
  deleteWalkthroughPage: Maybe<DeleteWalkthroughPagePayload>;
  /** Deletes a single `WalkthroughPage` using a unique key. */
  deleteWalkthroughPageById: Maybe<DeleteWalkthroughPagePayload>;
  /** Deletes a single `WalkthroughSetup` using its globally unique id. */
  deleteWalkthroughSetup: Maybe<DeleteWalkthroughSetupPayload>;
  /** Deletes a single `WalkthroughSetup` using a unique key. */
  deleteWalkthroughSetupById: Maybe<DeleteWalkthroughSetupPayload>;
  /** Deletes a single `WalkthroughSetupConfig` using its globally unique id. */
  deleteWalkthroughSetupConfig: Maybe<DeleteWalkthroughSetupConfigPayload>;
  /** Deletes a single `WalkthroughSetupConfig` using a unique key. */
  deleteWalkthroughSetupConfigById: Maybe<DeleteWalkthroughSetupConfigPayload>;
  /** Deletes a single `WalkthroughSummary` using its globally unique id. */
  deleteWalkthroughSummary: Maybe<DeleteWalkthroughSummaryPayload>;
  /** Deletes a single `WalkthroughSummary` using a unique key. */
  deleteWalkthroughSummaryById: Maybe<DeleteWalkthroughSummaryPayload>;
  /** Deletes a single `WinbackRewardConfig` using its globally unique id. */
  deleteWinbackRewardConfig: Maybe<DeleteWinbackRewardConfigPayload>;
  /** Deletes a single `WinbackRewardConfig` using a unique key. */
  deleteWinbackRewardConfigByChallengeTypeKey: Maybe<DeleteWinbackRewardConfigPayload>;
  /** Deletes a single `WinbackRewardConfig` using a unique key. */
  deleteWinbackRewardConfigById: Maybe<DeleteWinbackRewardConfigPayload>;
  /** Deletes a single `WinbackRewardOpportunity` using its globally unique id. */
  deleteWinbackRewardOpportunity: Maybe<DeleteWinbackRewardOpportunityPayload>;
  /** Deletes a single `WinbackRewardOpportunity` using a unique key. */
  deleteWinbackRewardOpportunityById: Maybe<DeleteWinbackRewardOpportunityPayload>;
  /** Deletes a single `WinbackRewardOpportunity` using a unique key. */
  deleteWinbackRewardOpportunityByPatientIdAndChallengeId: Maybe<DeleteWinbackRewardOpportunityPayload>;
  enrollMember: EnrollMemberPayload;
  enrollPaperMember: EnrollPaperMemberPayload;
  extendMembers: Maybe<ExtendMembersPayload>;
  generateNumericPatientLoginToken: Maybe<GenerateNumericPatientLoginTokenPayload>;
  generatePatientLoginToken: Maybe<GeneratePatientLoginTokenPayload>;
  generateRandomString: Maybe<GenerateRandomStringPayload>;
  /** Generates a refresh token, given a phone number and password. */
  generateRefreshToken: Maybe<GenerateRefreshTokenPayload>;
  generateSmsOutreachMessages: Maybe<Scalars['Boolean']>;
  generateTestRefreshToken: GenerateTestRefreshTokenPayload;
  getTokenViaSSO: Maybe<Token>;
  graduateMembers: Maybe<GraduateMembersPayload>;
  /** Make a heartbeat ping to let the server know the patient is active on a phone. */
  heartbeatPing: Maybe<HeartbeatPingPayload>;
  prepareTestAccount: PrepareTestAccountPayload;
  prepareTestProspect: PrepareTestProspectPayload;
  /** Creates a fresh JWT token that will securely identify a patient, given a valid refresh token. */
  reauthenticatePatient: Maybe<ReauthenticatePatientPayload>;
  reindexAllPersons: ReindexAllPersonsPayload;
  removeIdentityTag: Maybe<Scalars['Boolean']>;
  removePatientById: Maybe<Scalars['Boolean']>;
  selfServeEnroll: Maybe<Scalars['Boolean']>;
  sendOneOffMessage: Maybe<Scalars['Boolean']>;
  setPrimaryAddress: Maybe<SetPrimaryAddressPayload>;
  spendPatientLoginToken: Maybe<SpendPatientLoginTokenPayload>;
  spendPatientLoginTokenAndPhoneNumber: Maybe<SpendPatientLoginTokenAndPhoneNumberPayload>;
  submitMetricRange: Maybe<MetricRange>;
  submitPauseRequest: Maybe<SubmitPauseRequestPayload>;
  submitUnpauseRequest: Maybe<SubmitUnpauseRequestPayload>;
  testSmsMessage: Maybe<Scalars['Boolean']>;
  trackTermsAgreement: Maybe<Scalars['Boolean']>;
  /** Updates a single `AccountTransaction` using its globally unique id and a patch. */
  updateAccountTransaction: Maybe<UpdateAccountTransactionPayload>;
  /** Updates a single `AccountTransaction` using a unique key and a patch. */
  updateAccountTransactionById: Maybe<UpdateAccountTransactionPayload>;
  /** Updates a single `ActionLog` using its globally unique id and a patch. */
  updateActionLog: Maybe<UpdateActionLogPayload>;
  /** Updates a single `ActionLog` using a unique key and a patch. */
  updateActionLogById: Maybe<UpdateActionLogPayload>;
  updateAddress: Maybe<UpdateAddressPayload>;
  /** Updates a single `Admin` using its globally unique id and a patch. */
  updateAdmin: Maybe<UpdateAdminPayload>;
  /** Updates a single `Admin` using a unique key and a patch. */
  updateAdminById: Maybe<UpdateAdminPayload>;
  /** Updates a single `AdminRole` using its globally unique id and a patch. */
  updateAdminRole: Maybe<UpdateAdminRolePayload>;
  /** Updates a single `AdminRole` using a unique key and a patch. */
  updateAdminRoleById: Maybe<UpdateAdminRolePayload>;
  /** Updates a single `AdminRole` using a unique key and a patch. */
  updateAdminRoleByName: Maybe<UpdateAdminRolePayload>;
  /** Updates a single `AdminRolePrivilegedAction` using its globally unique id and a patch. */
  updateAdminRolePrivilegedAction: Maybe<UpdateAdminRolePrivilegedActionPayload>;
  /** Updates a single `AdminRolePrivilegedAction` using a unique key and a patch. */
  updateAdminRolePrivilegedActionById: Maybe<UpdateAdminRolePrivilegedActionPayload>;
  /** Updates a single `BonusBehaviorSubmissionStatus` using its globally unique id and a patch. */
  updateBonusBehaviorSubmissionStatus: Maybe<UpdateBonusBehaviorSubmissionStatusPayload>;
  /** Updates a single `BonusBehaviorSubmissionStatus` using a unique key and a patch. */
  updateBonusBehaviorSubmissionStatusByBonusBehaviorSubmissionIdAndCreatedAtAndValue: Maybe<UpdateBonusBehaviorSubmissionStatusPayload>;
  /** Updates a single `BonusBehaviorSubmissionStatus` using a unique key and a patch. */
  updateBonusBehaviorSubmissionStatusById: Maybe<UpdateBonusBehaviorSubmissionStatusPayload>;
  /** Updates a single `CheckIn` using its globally unique id and a patch. */
  updateCheckIn: Maybe<UpdateCheckInPayload>;
  /** Updates a single `CheckIn` using a unique key and a patch. */
  updateCheckInById: Maybe<UpdateCheckInPayload>;
  updateContactById: Maybe<Contact>;
  /** Updates a single `CueCheckIn` using its globally unique id and a patch. */
  updateCueCheckIn: Maybe<UpdateCueCheckInPayload>;
  /** Updates a single `CueCheckIn` using a unique key and a patch. */
  updateCueCheckInById: Maybe<UpdateCueCheckInPayload>;
  /** Updates a single `Customer` using its globally unique id and a patch. */
  updateCustomer: Maybe<UpdateCustomerPayload>;
  /** Updates a single `Customer` using a unique key and a patch. */
  updateCustomerById: Maybe<UpdateCustomerPayload>;
  /** Updates a single `Customer` using a unique key and a patch. */
  updateCustomerByName: Maybe<UpdateCustomerPayload>;
  /** Updates a single `DebitCard` using its globally unique id and a patch. */
  updateDebitCard: Maybe<UpdateDebitCardPayload>;
  /** Updates a single `DebitCardBalance` using its globally unique id and a patch. */
  updateDebitCardBalance: Maybe<UpdateDebitCardBalancePayload>;
  /** Updates a single `DebitCardBalance` using a unique key and a patch. */
  updateDebitCardBalanceById: Maybe<UpdateDebitCardBalancePayload>;
  /** Updates a single `DebitCard` using a unique key and a patch. */
  updateDebitCardById: Maybe<UpdateDebitCardPayload>;
  /** Updates a single `Device` using its globally unique id and a patch. */
  updateDevice: Maybe<UpdateDevicePayload>;
  /** Updates a single `Device` using a unique key and a patch. */
  updateDeviceById: Maybe<UpdateDevicePayload>;
  updateDialysisAppointmentReminder: UpdateDialysisAppointmentReminderPayload;
  /** Upserts a Members Displayed Highlight */
  updateDisplayedHighlight: Maybe<DisplayedHighlightPayload>;
  updateEmailAddress: Maybe<UpdateEmailAddressPayload>;
  /** Updates a single `Group` using its globally unique id and a patch. */
  updateGroup: Maybe<UpdateGroupPayload>;
  /** Updates a single `Group` using a unique key and a patch. */
  updateGroupById: Maybe<UpdateGroupPayload>;
  /** Updates a single `Heartbeat` using its globally unique id and a patch. */
  updateHeartbeat: Maybe<UpdateHeartbeatPayload>;
  /** Updates a single `Heartbeat` using a unique key and a patch. */
  updateHeartbeatById: Maybe<UpdateHeartbeatPayload>;
  /** Updates a single `HydrationCheckIn` using its globally unique id and a patch. */
  updateHydrationCheckIn: Maybe<UpdateHydrationCheckInPayload>;
  /** Updates a single `HydrationCheckIn` using a unique key and a patch. */
  updateHydrationCheckInById: Maybe<UpdateHydrationCheckInPayload>;
  /** Updates a single `MarvMigration` using its globally unique id and a patch. */
  updateMarvMigration: Maybe<UpdateMarvMigrationPayload>;
  /** Updates a single `MarvMigration` using a unique key and a patch. */
  updateMarvMigrationByLevelAndNamespace: Maybe<UpdateMarvMigrationPayload>;
  /** Updates a single `MealCheckIn` using its globally unique id and a patch. */
  updateMealCheckIn: Maybe<UpdateMealCheckInPayload>;
  /** Updates a single `MealCheckIn` using a unique key and a patch. */
  updateMealCheckInById: Maybe<UpdateMealCheckInPayload>;
  /** Updates a single `MeasurementCheckIn` using its globally unique id and a patch. */
  updateMeasurementCheckIn: Maybe<UpdateMeasurementCheckInPayload>;
  /** Updates a single `MeasurementCheckIn` using a unique key and a patch. */
  updateMeasurementCheckInById: Maybe<UpdateMeasurementCheckInPayload>;
  /** Updates a single `MedicationCheckIn` using its globally unique id and a patch. */
  updateMedicationCheckIn: Maybe<UpdateMedicationCheckInPayload>;
  /** Updates a single `MedicationCheckIn` using a unique key and a patch. */
  updateMedicationCheckInById: Maybe<UpdateMedicationCheckInPayload>;
  updateMemberById: Maybe<Member>;
  /** Updates a single `Message` using its globally unique id and a patch. */
  updateMessage: Maybe<UpdateMessagePayload>;
  /** Updates a single `Message` using a unique key and a patch. */
  updateMessageByExternalId: Maybe<UpdateMessagePayload>;
  /** Updates a single `Message` using a unique key and a patch. */
  updateMessageById: Maybe<UpdateMessagePayload>;
  updateName: Maybe<UpdateNamePayload>;
  /** Updates a single `ObjectDetection` using its globally unique id and a patch. */
  updateObjectDetection: Maybe<UpdateObjectDetectionPayload>;
  /** Updates a single `ObjectDetection` using a unique key and a patch. */
  updateObjectDetectionById: Maybe<UpdateObjectDetectionPayload>;
  updatePatient: Maybe<UpdatePatientPayload>;
  /** Updates a single `PatientMembershipConfig` using its globally unique id and a patch. */
  updatePatientMembershipConfig: Maybe<UpdatePatientMembershipConfigPayload>;
  /** Updates a single `PatientMembershipConfig` using a unique key and a patch. */
  updatePatientMembershipConfigById: Maybe<UpdatePatientMembershipConfigPayload>;
  /** Updates a single `PatientStatus` using its globally unique id and a patch. */
  updatePatientStatus: Maybe<UpdatePatientStatusPayload>;
  /** Updates a single `PatientStatus` using a unique key and a patch. */
  updatePatientStatusById: Maybe<UpdatePatientStatusPayload>;
  /** Updates a single `PatientStatus` using a unique key and a patch. */
  updatePatientStatusByPatientIdAndCreatedAtAndValue: Maybe<UpdatePatientStatusPayload>;
  /** Updates a single `PatientStatusValue` using its globally unique id and a patch. */
  updatePatientStatusValue: Maybe<UpdatePatientStatusValuePayload>;
  /** Updates a single `PatientStatusValue` using a unique key and a patch. */
  updatePatientStatusValueById: Maybe<UpdatePatientStatusValuePayload>;
  /** Updates a single `PatientStatusValue` using a unique key and a patch. */
  updatePatientStatusValueByName: Maybe<UpdatePatientStatusValuePayload>;
  /** Updates a single `Pause` using its globally unique id and a patch. */
  updatePause: Maybe<UpdatePausePayload>;
  /** Updates a single `Pause` using a unique key and a patch. */
  updatePauseById: Maybe<UpdatePausePayload>;
  updatePauseObject: Maybe<Scalars['Boolean']>;
  /** Updates a single `PauseReason` using its globally unique id and a patch. */
  updatePauseReason: Maybe<UpdatePauseReasonPayload>;
  /** Updates a single `PauseReason` using a unique key and a patch. */
  updatePauseReasonById: Maybe<UpdatePauseReasonPayload>;
  /** Updates a single `PauseReason` using a unique key and a patch. */
  updatePauseReasonByValue: Maybe<UpdatePauseReasonPayload>;
  /** Updates a single `PaymentSetup` using its globally unique id and a patch. */
  updatePaymentSetup: Maybe<UpdatePaymentSetupPayload>;
  /** Updates a single `PaymentSetup` using a unique key and a patch. */
  updatePaymentSetupById: Maybe<UpdatePaymentSetupPayload>;
  updatePhoneNumber: Maybe<UpdatePhoneNumberPayload>;
  /** Updates a single `PrivilegedAction` using its globally unique id and a patch. */
  updatePrivilegedAction: Maybe<UpdatePrivilegedActionPayload>;
  /** Updates a single `PrivilegedAction` using a unique key and a patch. */
  updatePrivilegedActionById: Maybe<UpdatePrivilegedActionPayload>;
  /** Updates a single `PrivilegedAction` using a unique key and a patch. */
  updatePrivilegedActionByName: Maybe<UpdatePrivilegedActionPayload>;
  updateProgramById: Maybe<Program>;
  /** Updates a single `ProgramMfaConfig` using its globally unique id and a patch. */
  updateProgramMfaConfig: Maybe<UpdateProgramMfaConfigPayload>;
  /** Updates a single `ProgramMfaConfig` using a unique key and a patch. */
  updateProgramMfaConfigById: Maybe<UpdateProgramMfaConfigPayload>;
  /** Updates a single `ProgramMfaConfig` using a unique key and a patch. */
  updateProgramMfaConfigByProgramId: Maybe<UpdateProgramMfaConfigPayload>;
  /** Updates a single `ProgramOutreachSubmission` using its globally unique id and a patch. */
  updateProgramOutreachSubmission: Maybe<UpdateProgramOutreachSubmissionPayload>;
  /** Updates a single `ProgramOutreachSubmission` using a unique key and a patch. */
  updateProgramOutreachSubmissionById: Maybe<UpdateProgramOutreachSubmissionPayload>;
  /** Updates a single `ProgramReward` using its globally unique id and a patch. */
  updateProgramReward: Maybe<UpdateProgramRewardPayload>;
  /** Updates a single `ProgramReward` using a unique key and a patch. */
  updateProgramRewardById: Maybe<UpdateProgramRewardPayload>;
  /** Updates a single `ProgramRewardConfig` using its globally unique id and a patch. */
  updateProgramRewardConfig: Maybe<UpdateProgramRewardConfigPayload>;
  /** Updates a single `ProgramRewardConfig` using a unique key and a patch. */
  updateProgramRewardConfigById: Maybe<UpdateProgramRewardConfigPayload>;
  /** Updates a single `ProgramRewardConfig` using a unique key and a patch. */
  updateProgramRewardConfigByName: Maybe<UpdateProgramRewardConfigPayload>;
  /** Updates a single `ProgramTemplate` using its globally unique id and a patch. */
  updateProgramTemplate: Maybe<UpdateProgramTemplatePayload>;
  /** Updates a single `ProgramTemplate` using a unique key and a patch. */
  updateProgramTemplateById: Maybe<UpdateProgramTemplatePayload>;
  /** Updates a single `ProgramTemplate` using a unique key and a patch. */
  updateProgramTemplateByName: Maybe<UpdateProgramTemplatePayload>;
  updateProspectById: Maybe<Prospect>;
  /** Updates a single `ProspectStatus` using its globally unique id and a patch. */
  updateProspectStatus: Maybe<UpdateProspectStatusPayload>;
  /** Updates a single `ProspectStatus` using a unique key and a patch. */
  updateProspectStatusById: Maybe<UpdateProspectStatusPayload>;
  /** Updates a single `ProspectStatus` using a unique key and a patch. */
  updateProspectStatusByProspectIdAndCreatedAtAndValue: Maybe<UpdateProspectStatusPayload>;
  /** Updates a single `ProspectStatusValue` using its globally unique id and a patch. */
  updateProspectStatusValue: Maybe<UpdateProspectStatusValuePayload>;
  /** Updates a single `ProspectStatusValue` using a unique key and a patch. */
  updateProspectStatusValueById: Maybe<UpdateProspectStatusValuePayload>;
  /** Updates a single `ProspectStatusValue` using a unique key and a patch. */
  updateProspectStatusValueByName: Maybe<UpdateProspectStatusValuePayload>;
  /** Updates a single `PushNotification` using its globally unique id and a patch. */
  updatePushNotification: Maybe<UpdatePushNotificationPayload>;
  /** Updates a single `PushNotification` using a unique key and a patch. */
  updatePushNotificationById: Maybe<UpdatePushNotificationPayload>;
  /** Updates a single `PushToken` using its globally unique id and a patch. */
  updatePushToken: Maybe<UpdatePushTokenPayload>;
  /** Updates a single `PushToken` using a unique key and a patch. */
  updatePushTokenById: Maybe<UpdatePushTokenPayload>;
  /** Updates a single `RawIncomingDatum` using its globally unique id and a patch. */
  updateRawIncomingDatum: Maybe<UpdateRawIncomingDatumPayload>;
  /** Updates a single `RawIncomingDatum` using a unique key and a patch. */
  updateRawIncomingDatumById: Maybe<UpdateRawIncomingDatumPayload>;
  /** Updates a single `Reminder` using its globally unique id and a patch. */
  updateReminder: Maybe<UpdateReminderPayload>;
  /** Updates a single `Reminder` using a unique key and a patch. */
  updateReminderById: Maybe<UpdateReminderPayload>;
  /** Updates a single `ReminderConfig` using its globally unique id and a patch. */
  updateReminderConfig: Maybe<UpdateReminderConfigPayload>;
  /** Updates a single `ReminderConfig` using a unique key and a patch. */
  updateReminderConfigById: Maybe<UpdateReminderConfigPayload>;
  /** Updates a single `ReminderMessage` using its globally unique id and a patch. */
  updateReminderMessage: Maybe<UpdateReminderMessagePayload>;
  /** Updates a single `ReminderMessage` using a unique key and a patch. */
  updateReminderMessageById: Maybe<UpdateReminderMessagePayload>;
  /** Updates a single `RewardPeriod` using its globally unique id and a patch. */
  updateRewardPeriod: Maybe<UpdateRewardPeriodPayload>;
  /** Updates a single `RewardPeriod` using a unique key and a patch. */
  updateRewardPeriodById: Maybe<UpdateRewardPeriodPayload>;
  /** Updates a single `RewardPeriodConfig` using its globally unique id and a patch. */
  updateRewardPeriodConfig: Maybe<UpdateRewardPeriodConfigPayload>;
  /** Updates a single `RewardPeriodConfig` using a unique key and a patch. */
  updateRewardPeriodConfigById: Maybe<UpdateRewardPeriodConfigPayload>;
  /** Updates a single `SmsAutoResponder` using its globally unique id and a patch. */
  updateSmsAutoResponder: Maybe<UpdateSmsAutoResponderPayload>;
  /** Updates a single `SmsAutoResponder` using a unique key and a patch. */
  updateSmsAutoResponderById: Maybe<UpdateSmsAutoResponderPayload>;
  /** Updates a single `SmsOutreachMessage` using its globally unique id and a patch. */
  updateSmsOutreachMessage: Maybe<UpdateSmsOutreachMessagePayload>;
  /** Updates a single `SmsOutreachMessage` using a unique key and a patch. */
  updateSmsOutreachMessageById: Maybe<UpdateSmsOutreachMessagePayload>;
  /** Updates a single `SmsOutreachMessageTemplate` using its globally unique id and a patch. */
  updateSmsOutreachMessageTemplate: Maybe<UpdateSmsOutreachMessageTemplatePayload>;
  /** Updates a single `SmsOutreachMessageTemplate` using a unique key and a patch. */
  updateSmsOutreachMessageTemplateById: Maybe<UpdateSmsOutreachMessageTemplatePayload>;
  /** Updates a single `SmsOutreachRecipient` using its globally unique id and a patch. */
  updateSmsOutreachRecipient: Maybe<UpdateSmsOutreachRecipientPayload>;
  /** Updates a single `SmsOutreachRecipient` using a unique key and a patch. */
  updateSmsOutreachRecipientById: Maybe<UpdateSmsOutreachRecipientPayload>;
  /** Updates a single `SmsOutreachRecipient` using a unique key and a patch. */
  updateSmsOutreachRecipientByPhoneNumber: Maybe<UpdateSmsOutreachRecipientPayload>;
  /** Updates a single `TimedObject` using its globally unique id and a patch. */
  updateTimedObject: Maybe<UpdateTimedObjectPayload>;
  /** Updates a single `TimedObject` using a unique key and a patch. */
  updateTimedObjectById: Maybe<UpdateTimedObjectPayload>;
  /** Updates a single `TimezoneRecord` using its globally unique id and a patch. */
  updateTimezoneRecord: Maybe<UpdateTimezoneRecordPayload>;
  /** Updates a single `TimezoneRecord` using a unique key and a patch. */
  updateTimezoneRecordById: Maybe<UpdateTimezoneRecordPayload>;
  /** Updates a single `Walkthrough` using its globally unique id and a patch. */
  updateWalkthrough: Maybe<UpdateWalkthroughPayload>;
  /** Updates a single `Walkthrough` using a unique key and a patch. */
  updateWalkthroughById: Maybe<UpdateWalkthroughPayload>;
  /** Updates a single `WalkthroughPage` using its globally unique id and a patch. */
  updateWalkthroughPage: Maybe<UpdateWalkthroughPagePayload>;
  /** Updates a single `WalkthroughPage` using a unique key and a patch. */
  updateWalkthroughPageById: Maybe<UpdateWalkthroughPagePayload>;
  /** Updates a single `WalkthroughSetup` using its globally unique id and a patch. */
  updateWalkthroughSetup: Maybe<UpdateWalkthroughSetupPayload>;
  /** Updates a single `WalkthroughSetup` using a unique key and a patch. */
  updateWalkthroughSetupById: Maybe<UpdateWalkthroughSetupPayload>;
  /** Updates a single `WalkthroughSetupConfig` using its globally unique id and a patch. */
  updateWalkthroughSetupConfig: Maybe<UpdateWalkthroughSetupConfigPayload>;
  /** Updates a single `WalkthroughSetupConfig` using a unique key and a patch. */
  updateWalkthroughSetupConfigById: Maybe<UpdateWalkthroughSetupConfigPayload>;
  /** Updates a single `WalkthroughSummary` using its globally unique id and a patch. */
  updateWalkthroughSummary: Maybe<UpdateWalkthroughSummaryPayload>;
  /** Updates a single `WalkthroughSummary` using a unique key and a patch. */
  updateWalkthroughSummaryById: Maybe<UpdateWalkthroughSummaryPayload>;
  /** Updates a single `WinbackRewardConfig` using its globally unique id and a patch. */
  updateWinbackRewardConfig: Maybe<UpdateWinbackRewardConfigPayload>;
  /** Updates a single `WinbackRewardConfig` using a unique key and a patch. */
  updateWinbackRewardConfigByChallengeTypeKey: Maybe<UpdateWinbackRewardConfigPayload>;
  /** Updates a single `WinbackRewardConfig` using a unique key and a patch. */
  updateWinbackRewardConfigById: Maybe<UpdateWinbackRewardConfigPayload>;
  /** Updates a single `WinbackRewardOpportunity` using its globally unique id and a patch. */
  updateWinbackRewardOpportunity: Maybe<UpdateWinbackRewardOpportunityPayload>;
  /** Updates a single `WinbackRewardOpportunity` using a unique key and a patch. */
  updateWinbackRewardOpportunityById: Maybe<UpdateWinbackRewardOpportunityPayload>;
  /** Updates a single `WinbackRewardOpportunity` using a unique key and a patch. */
  updateWinbackRewardOpportunityByPatientIdAndChallengeId: Maybe<UpdateWinbackRewardOpportunityPayload>;
  uploadBulkSms: Maybe<Scalars['Boolean']>;
  uploadProspectFile: Maybe<Scalars['UUID']>;
  verifyDateOfBirth: Maybe<VerifyZipCodeAndDayOfBirthPayload>;
  verifySecurityQuestionAnswer: Maybe<VerifySecurityQuestionAnswerPayload>;
  verifyZipCode: Maybe<Scalars['Boolean']>;
  verifyZipCodeAndDateOfBirth: Maybe<VerifyZipCodeAndDayOfBirthPayload>;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationAddIdentityTagArgs {
  input: AddIdentityTagInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationApproveSmsOutreachMessageArgs {
  messageId: Scalars['UUID'];
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationAuthenticateAdminArgs {
  input: AuthenticateAdminInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCancelPauseRequestArgs {
  input: CancelPauseRequestInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCancelUnpauseRequestArgs {
  input: CancelUnpauseRequestInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationChangeBonusBehaviorSubmissionStatusArgs {
  input: ChangeBonusBehaviorSubmissionStatusInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationChangeMemberStatusArgs {
  memberId: Scalars['UUID'];
  note?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  reasonDetail?: InputMaybe<Scalars['String']>;
  status: Scalars['String'];
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationChangeProspectStatusArgs {
  note?: InputMaybe<Scalars['String']>;
  prospectId: Scalars['UUID'];
  reason?: InputMaybe<Scalars['String']>;
  reasonDetail?: InputMaybe<Scalars['String']>;
  status: Scalars['String'];
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCheckInCategoryMatchesArgs {
  input: CheckInCategoryMatchesInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateAccountTransactionArgs {
  input: CreateAccountTransactionInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateAccountTransactionCreditArgs {
  input: CreateAccountTransactionCreditInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateActionLogArgs {
  input: CreateActionLogInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateAddressArgs {
  contactId: Scalars['UUID'];
  contactType: ContactType;
  input: CreateAddressInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateAdminArgs {
  input: CreateAdminInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateAdminRoleArgs {
  input: CreateAdminRoleInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateAdminRolePrivilegedActionArgs {
  input: CreateAdminRolePrivilegedActionInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateBonusBehaviorConfigArgs {
  input: CreateBonusBehaviorConfigInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateBonusBehaviorSubmissionArgs {
  input: CreateBonusBehaviorSubmissionInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateBonusBehaviorSubmissionStatusArgs {
  input: CreateBonusBehaviorSubmissionStatusInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateCheckInArgs {
  input: CreateCheckInInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateCheckInDataArgs {
  input: CheckInDataInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateCheckInSubmissionArgs {
  input: CheckInSubmissionInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateContactArgs {
  input: ContactInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateCueCheckInArgs {
  input: CreateCueCheckInInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateCustomerArgs {
  input: CreateCustomerInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateDebitCardArgs {
  input: CreateDebitCardInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateDebitCardBalanceArgs {
  input: CreateDebitCardBalanceInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateDeviceArgs {
  input: CreateDeviceInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateDialysisAppointmentScheduleArgs {
  input: CreateDialysisAppointmentScheduleInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateEmailAddressArgs {
  contactId: Scalars['UUID'];
  contactType: ContactType;
  input: CreateEmailAddressInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateGroupArgs {
  input: CreateGroupInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateHeartbeatArgs {
  input: CreateHeartbeatInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateHighlightSubmissionArgs {
  input: CreateHighlightSubmissionInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateHydrationCheckInArgs {
  input: CreateHydrationCheckInInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateMarvMigrationArgs {
  input: CreateMarvMigrationInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateMarvMigrationsLockArgs {
  input: CreateMarvMigrationsLockInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateMealCheckInArgs {
  input: CreateMealCheckInInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateMeasurementCheckInArgs {
  input: CreateMeasurementCheckInInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateMedicationCheckInArgs {
  input: CreateMedicationCheckInInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateMessageArgs {
  input: CreateMessageInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateNameArgs {
  contactId: Scalars['UUID'];
  contactType: ContactType;
  input: CreateNameInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateObjectDetectionArgs {
  input: CreateObjectDetectionInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreatePatientArgs {
  input: CreatePatientInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreatePatientMembershipConfigArgs {
  input: CreatePatientMembershipConfigInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreatePatientNoteArgs {
  input: CreatePatientNoteInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreatePatientStatusArgs {
  input: CreatePatientStatusInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreatePatientStatusValueArgs {
  input: CreatePatientStatusValueInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreatePauseArgs {
  input: CreatePauseInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreatePauseReasonArgs {
  input: CreatePauseReasonInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreatePaymentSetupArgs {
  input: CreatePaymentSetupInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreatePhoneNumberArgs {
  contactId: Scalars['UUID'];
  contactType: ContactType;
  input: CreatePhoneNumberInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreatePrivilegedActionArgs {
  input: CreatePrivilegedActionInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateProgramArgs {
  input: CreateProgramInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateProgramMfaConfigArgs {
  input: CreateProgramMfaConfigInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateProgramOutreachSubmissionArgs {
  input: CreateProgramOutreachSubmissionInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateProgramRewardArgs {
  input: CreateProgramRewardInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateProgramRewardConfigArgs {
  input: CreateProgramRewardConfigInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateProgramTemplateArgs {
  input: CreateProgramTemplateInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateProspectArgs {
  input: CreateProspectInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateProspectForInactiveMemberArgs {
  input?: InputMaybe<CreateProspectForInactiveMemberInput>;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateProspectNoteArgs {
  input: CreateProspectNoteInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateProspectStatusArgs {
  input: CreateProspectStatusInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateProspectStatusValueArgs {
  input: CreateProspectStatusValueInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreatePushNotificationArgs {
  input: CreatePushNotificationInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreatePushTokenArgs {
  input: CreatePushTokenInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateRawIncomingDatumArgs {
  input: CreateRawIncomingDatumInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateReminderArgs {
  input: CreateReminderInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateReminderConfigArgs {
  input: CreateReminderConfigInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateReminderMessageArgs {
  input: CreateReminderMessageInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateRewardPeriodArgs {
  input: CreateRewardPeriodInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateRewardPeriodConfigArgs {
  input: CreateRewardPeriodConfigInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateSmsAutoResponderArgs {
  input: CreateSmsAutoResponderInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateSmsOutreachMessageArgs {
  input: CreateSmsOutreachMessageInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateSmsOutreachMessageTemplateArgs {
  input: CreateSmsOutreachMessageTemplateInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateSmsOutreachRecipientArgs {
  input: CreateSmsOutreachRecipientInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateTimedObjectArgs {
  input: CreateTimedObjectInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateTimezoneRecordArgs {
  input: CreateTimezoneRecordInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateWalkthroughArgs {
  input: CreateWalkthroughInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateWalkthroughPageArgs {
  input: CreateWalkthroughPageInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateWalkthroughSetupArgs {
  input: CreateWalkthroughSetupInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateWalkthroughSetupConfigArgs {
  input: CreateWalkthroughSetupConfigInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateWalkthroughSummaryArgs {
  input: CreateWalkthroughSummaryInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateWinbackRewardConfigArgs {
  input: CreateWinbackRewardConfigInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreateWinbackRewardOpportunityArgs {
  input: CreateWinbackRewardOpportunityInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationCreditAppointmentArgs {
  input: CreditAppointmentInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteAccountTransactionArgs {
  input: DeleteAccountTransactionInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteAccountTransactionByIdArgs {
  input: DeleteAccountTransactionByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteActionLogArgs {
  input: DeleteActionLogInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteActionLogByIdArgs {
  input: DeleteActionLogByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteAddressByIdArgs {
  id: Scalars['UUID'];
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteAdminArgs {
  input: DeleteAdminInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteAdminByIdArgs {
  input: DeleteAdminByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteAdminRoleArgs {
  input: DeleteAdminRoleInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteAdminRoleByIdArgs {
  input: DeleteAdminRoleByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteAdminRoleByNameArgs {
  input: DeleteAdminRoleByNameInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteAdminRolePrivilegedActionArgs {
  input: DeleteAdminRolePrivilegedActionInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteAdminRolePrivilegedActionByIdArgs {
  input: DeleteAdminRolePrivilegedActionByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteBonusBehaviorSubmissionStatusArgs {
  input: DeleteBonusBehaviorSubmissionStatusInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteBonusBehaviorSubmissionStatusByBonusBehaviorSubmissionIdAndCreatedAtAndValueArgs {
  input: DeleteBonusBehaviorSubmissionStatusByBonusBehaviorSubmissionIdAndCreatedAtAndValueInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteBonusBehaviorSubmissionStatusByIdArgs {
  input: DeleteBonusBehaviorSubmissionStatusByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteCheckInArgs {
  input: DeleteCheckInInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteCheckInByIdArgs {
  input: DeleteCheckInByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteContactByIdArgs {
  id: Scalars['UUID'];
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteCueCheckInArgs {
  input: DeleteCueCheckInInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteCueCheckInByIdArgs {
  input: DeleteCueCheckInByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteCustomerArgs {
  input: DeleteCustomerInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteCustomerByIdArgs {
  input: DeleteCustomerByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteCustomerByNameArgs {
  input: DeleteCustomerByNameInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteDebitCardArgs {
  input: DeleteDebitCardInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteDebitCardBalanceArgs {
  input: DeleteDebitCardBalanceInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteDebitCardBalanceByIdArgs {
  input: DeleteDebitCardBalanceByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteDebitCardByIdArgs {
  input: DeleteDebitCardByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteDeviceArgs {
  input: DeleteDeviceInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteDeviceByIdArgs {
  input: DeleteDeviceByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteEmailAddressByIdArgs {
  id: Scalars['UUID'];
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteFutureDialysisAppointmentEventsArgs {
  input: DeleteFutureDialysisAppointmentEventsInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteGroupArgs {
  input: DeleteGroupInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteGroupByIdArgs {
  input: DeleteGroupByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteHeartbeatArgs {
  input: DeleteHeartbeatInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteHeartbeatByIdArgs {
  input: DeleteHeartbeatByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteHydrationCheckInArgs {
  input: DeleteHydrationCheckInInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteHydrationCheckInByIdArgs {
  input: DeleteHydrationCheckInByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteMarvMigrationArgs {
  input: DeleteMarvMigrationInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteMarvMigrationByLevelAndNamespaceArgs {
  input: DeleteMarvMigrationByLevelAndNamespaceInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteMealCheckInArgs {
  input: DeleteMealCheckInInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteMealCheckInByIdArgs {
  input: DeleteMealCheckInByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteMeasurementCheckInArgs {
  input: DeleteMeasurementCheckInInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteMeasurementCheckInByIdArgs {
  input: DeleteMeasurementCheckInByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteMedicationCheckInArgs {
  input: DeleteMedicationCheckInInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteMedicationCheckInByIdArgs {
  input: DeleteMedicationCheckInByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteMemberArgs {
  input: DeleteMemberInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteMessageArgs {
  input: DeleteMessageInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteMessageByExternalIdArgs {
  input: DeleteMessageByExternalIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteMessageByIdArgs {
  input: DeleteMessageByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteNameByIdArgs {
  id: Scalars['UUID'];
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteObjectDetectionArgs {
  input: DeleteObjectDetectionInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteObjectDetectionByIdArgs {
  input: DeleteObjectDetectionByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeletePatientArgs {
  input: DeletePatientInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeletePatientByIdArgs {
  input: DeletePatientByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeletePatientMembershipConfigArgs {
  input: DeletePatientMembershipConfigInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeletePatientMembershipConfigByIdArgs {
  input: DeletePatientMembershipConfigByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeletePatientStatusArgs {
  input: DeletePatientStatusInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeletePatientStatusByIdArgs {
  input: DeletePatientStatusByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeletePatientStatusByPatientIdAndCreatedAtAndValueArgs {
  input: DeletePatientStatusByPatientIdAndCreatedAtAndValueInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeletePatientStatusValueArgs {
  input: DeletePatientStatusValueInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeletePatientStatusValueByIdArgs {
  input: DeletePatientStatusValueByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeletePatientStatusValueByNameArgs {
  input: DeletePatientStatusValueByNameInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeletePauseArgs {
  input: DeletePauseInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeletePauseByIdArgs {
  input: DeletePauseByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeletePauseReasonArgs {
  input: DeletePauseReasonInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeletePauseReasonByIdArgs {
  input: DeletePauseReasonByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeletePauseReasonByValueArgs {
  input: DeletePauseReasonByValueInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeletePaymentSetupArgs {
  input: DeletePaymentSetupInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeletePaymentSetupByIdArgs {
  input: DeletePaymentSetupByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeletePhoneNumberByIdArgs {
  id: Scalars['UUID'];
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeletePrivilegedActionArgs {
  input: DeletePrivilegedActionInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeletePrivilegedActionByIdArgs {
  input: DeletePrivilegedActionByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeletePrivilegedActionByNameArgs {
  input: DeletePrivilegedActionByNameInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteProgramMfaConfigArgs {
  input: DeleteProgramMfaConfigInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteProgramMfaConfigByIdArgs {
  input: DeleteProgramMfaConfigByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteProgramMfaConfigByProgramIdArgs {
  input: DeleteProgramMfaConfigByProgramIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteProgramOutreachSubmissionArgs {
  input: DeleteProgramOutreachSubmissionInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteProgramOutreachSubmissionByIdArgs {
  input: DeleteProgramOutreachSubmissionByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteProgramRewardArgs {
  input: DeleteProgramRewardInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteProgramRewardByIdArgs {
  input: DeleteProgramRewardByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteProgramRewardConfigArgs {
  input: DeleteProgramRewardConfigInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteProgramRewardConfigByIdArgs {
  input: DeleteProgramRewardConfigByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteProgramRewardConfigByNameArgs {
  input: DeleteProgramRewardConfigByNameInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteProgramTemplateArgs {
  input: DeleteProgramTemplateInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteProgramTemplateByIdArgs {
  input: DeleteProgramTemplateByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteProgramTemplateByNameArgs {
  input: DeleteProgramTemplateByNameInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteProspectStatusArgs {
  input: DeleteProspectStatusInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteProspectStatusByIdArgs {
  input: DeleteProspectStatusByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteProspectStatusByProspectIdAndCreatedAtAndValueArgs {
  input: DeleteProspectStatusByProspectIdAndCreatedAtAndValueInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteProspectStatusValueArgs {
  input: DeleteProspectStatusValueInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteProspectStatusValueByIdArgs {
  input: DeleteProspectStatusValueByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteProspectStatusValueByNameArgs {
  input: DeleteProspectStatusValueByNameInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeletePushNotificationArgs {
  input: DeletePushNotificationInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeletePushNotificationByIdArgs {
  input: DeletePushNotificationByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeletePushTokenArgs {
  input: DeletePushTokenInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeletePushTokenByIdArgs {
  input: DeletePushTokenByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteRawIncomingDatumArgs {
  input: DeleteRawIncomingDatumInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteRawIncomingDatumByIdArgs {
  input: DeleteRawIncomingDatumByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteReminderArgs {
  input: DeleteReminderInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteReminderByIdArgs {
  input: DeleteReminderByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteReminderConfigArgs {
  input: DeleteReminderConfigInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteReminderConfigByIdArgs {
  input: DeleteReminderConfigByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteReminderMessageArgs {
  input: DeleteReminderMessageInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteReminderMessageByIdArgs {
  input: DeleteReminderMessageByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteRewardPeriodArgs {
  input: DeleteRewardPeriodInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteRewardPeriodByIdArgs {
  input: DeleteRewardPeriodByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteRewardPeriodConfigArgs {
  input: DeleteRewardPeriodConfigInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteRewardPeriodConfigByIdArgs {
  input: DeleteRewardPeriodConfigByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteSmsAutoResponderArgs {
  input: DeleteSmsAutoResponderInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteSmsAutoResponderByIdArgs {
  input: DeleteSmsAutoResponderByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteSmsOutreachMessageArgs {
  input: DeleteSmsOutreachMessageInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteSmsOutreachMessageByIdArgs {
  input: DeleteSmsOutreachMessageByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteSmsOutreachMessageTemplateArgs {
  input: DeleteSmsOutreachMessageTemplateInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteSmsOutreachMessageTemplateByIdArgs {
  input: DeleteSmsOutreachMessageTemplateByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteSmsOutreachRecipientArgs {
  input: DeleteSmsOutreachRecipientInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteSmsOutreachRecipientByIdArgs {
  input: DeleteSmsOutreachRecipientByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteSmsOutreachRecipientByPhoneNumberArgs {
  input: DeleteSmsOutreachRecipientByPhoneNumberInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteTimedObjectArgs {
  input: DeleteTimedObjectInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteTimedObjectByIdArgs {
  input: DeleteTimedObjectByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteTimezoneRecordArgs {
  input: DeleteTimezoneRecordInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteTimezoneRecordByIdArgs {
  input: DeleteTimezoneRecordByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteWalkthroughArgs {
  input: DeleteWalkthroughInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteWalkthroughByIdArgs {
  input: DeleteWalkthroughByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteWalkthroughPageArgs {
  input: DeleteWalkthroughPageInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteWalkthroughPageByIdArgs {
  input: DeleteWalkthroughPageByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteWalkthroughSetupArgs {
  input: DeleteWalkthroughSetupInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteWalkthroughSetupByIdArgs {
  input: DeleteWalkthroughSetupByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteWalkthroughSetupConfigArgs {
  input: DeleteWalkthroughSetupConfigInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteWalkthroughSetupConfigByIdArgs {
  input: DeleteWalkthroughSetupConfigByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteWalkthroughSummaryArgs {
  input: DeleteWalkthroughSummaryInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteWalkthroughSummaryByIdArgs {
  input: DeleteWalkthroughSummaryByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteWinbackRewardConfigArgs {
  input: DeleteWinbackRewardConfigInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteWinbackRewardConfigByChallengeTypeKeyArgs {
  input: DeleteWinbackRewardConfigByChallengeTypeKeyInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteWinbackRewardConfigByIdArgs {
  input: DeleteWinbackRewardConfigByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteWinbackRewardOpportunityArgs {
  input: DeleteWinbackRewardOpportunityInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteWinbackRewardOpportunityByIdArgs {
  input: DeleteWinbackRewardOpportunityByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationDeleteWinbackRewardOpportunityByPatientIdAndChallengeIdArgs {
  input: DeleteWinbackRewardOpportunityByPatientIdAndChallengeIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationEnrollMemberArgs {
  input: EnrollMemberInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationEnrollPaperMemberArgs {
  input?: InputMaybe<EnrollPaperMemberInput>;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationExtendMembersArgs {
  input: ExtendMembersInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationGenerateNumericPatientLoginTokenArgs {
  input: GenerateNumericPatientLoginTokenInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationGeneratePatientLoginTokenArgs {
  input: GeneratePatientLoginTokenInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationGenerateRandomStringArgs {
  input: GenerateRandomStringInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationGenerateRefreshTokenArgs {
  input: GenerateRefreshTokenInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationGenerateSmsOutreachMessagesArgs {
  batchLabel?: InputMaybe<Scalars['String']>;
  filePath: Scalars['String'];
  messageTemplateId: Scalars['UUID'];
  protocol?: InputMaybe<SmsOutreachMessageProtocol>;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationGenerateTestRefreshTokenArgs {
  input: GenerateTestRefreshTokenInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationGetTokenViaSSOArgs {
  identityToken: Scalars['String'];
  provider: Scalars['String'];
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationGraduateMembersArgs {
  input: GraduateMembersInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationHeartbeatPingArgs {
  input: HeartbeatPingInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationPrepareTestAccountArgs {
  input: PrepareTestAccountInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationPrepareTestProspectArgs {
  input: PrepareTestProspectInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationReauthenticatePatientArgs {
  input: ReauthenticatePatientInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationRemoveIdentityTagArgs {
  input: RemoveTagInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationRemovePatientByIdArgs {
  id: Scalars['UUID'];
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationSelfServeEnrollArgs {
  input: SelfServeEnrollInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationSendOneOffMessageArgs {
  input: OneOffSenderInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationSetPrimaryAddressArgs {
  contactId: Scalars['UUID'];
  contactType: ContactType;
  input: SetPrimaryAddressInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationSpendPatientLoginTokenArgs {
  input: SpendPatientLoginTokenInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationSpendPatientLoginTokenAndPhoneNumberArgs {
  input: SpendPatientLoginTokenAndPhoneNumberInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationSubmitMetricRangeArgs {
  input: CreateMetricRangeInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationSubmitPauseRequestArgs {
  input: SubmitPauseRequestInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationSubmitUnpauseRequestArgs {
  input: SubmitUnpauseRequestInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationTestSmsMessageArgs {
  messageTemplateId: Scalars['String'];
  recipient: SmsTestMessageRecipientInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationTrackTermsAgreementArgs {
  input: TrackTermsAgreementInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateAccountTransactionArgs {
  input: UpdateAccountTransactionInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateAccountTransactionByIdArgs {
  input: UpdateAccountTransactionByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateActionLogArgs {
  input: UpdateActionLogInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateActionLogByIdArgs {
  input: UpdateActionLogByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateAddressArgs {
  input: UpdateAddressInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateAdminArgs {
  input: UpdateAdminInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateAdminByIdArgs {
  input: UpdateAdminByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateAdminRoleArgs {
  input: UpdateAdminRoleInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateAdminRoleByIdArgs {
  input: UpdateAdminRoleByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateAdminRoleByNameArgs {
  input: UpdateAdminRoleByNameInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateAdminRolePrivilegedActionArgs {
  input: UpdateAdminRolePrivilegedActionInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateAdminRolePrivilegedActionByIdArgs {
  input: UpdateAdminRolePrivilegedActionByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateBonusBehaviorSubmissionStatusArgs {
  input: UpdateBonusBehaviorSubmissionStatusInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateBonusBehaviorSubmissionStatusByBonusBehaviorSubmissionIdAndCreatedAtAndValueArgs {
  input: UpdateBonusBehaviorSubmissionStatusByBonusBehaviorSubmissionIdAndCreatedAtAndValueInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateBonusBehaviorSubmissionStatusByIdArgs {
  input: UpdateBonusBehaviorSubmissionStatusByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateCheckInArgs {
  input: UpdateCheckInInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateCheckInByIdArgs {
  input: UpdateCheckInByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateContactByIdArgs {
  contactPatch: ContactPatch;
  id: Scalars['UUID'];
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateCueCheckInArgs {
  input: UpdateCueCheckInInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateCueCheckInByIdArgs {
  input: UpdateCueCheckInByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateCustomerArgs {
  input: UpdateCustomerInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateCustomerByIdArgs {
  input: UpdateCustomerByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateCustomerByNameArgs {
  input: UpdateCustomerByNameInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateDebitCardArgs {
  input: UpdateDebitCardInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateDebitCardBalanceArgs {
  input: UpdateDebitCardBalanceInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateDebitCardBalanceByIdArgs {
  input: UpdateDebitCardBalanceByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateDebitCardByIdArgs {
  input: UpdateDebitCardByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateDeviceArgs {
  input: UpdateDeviceInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateDeviceByIdArgs {
  input: UpdateDeviceByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateDialysisAppointmentReminderArgs {
  input: UpdateDialysisAppointmentReminderInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateDisplayedHighlightArgs {
  input: DisplayedHighlightInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateEmailAddressArgs {
  input: UpdateEmailAddressInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateGroupArgs {
  input: UpdateGroupInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateGroupByIdArgs {
  input: UpdateGroupByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateHeartbeatArgs {
  input: UpdateHeartbeatInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateHeartbeatByIdArgs {
  input: UpdateHeartbeatByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateHydrationCheckInArgs {
  input: UpdateHydrationCheckInInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateHydrationCheckInByIdArgs {
  input: UpdateHydrationCheckInByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateMarvMigrationArgs {
  input: UpdateMarvMigrationInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateMarvMigrationByLevelAndNamespaceArgs {
  input: UpdateMarvMigrationByLevelAndNamespaceInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateMealCheckInArgs {
  input: UpdateMealCheckInInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateMealCheckInByIdArgs {
  input: UpdateMealCheckInByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateMeasurementCheckInArgs {
  input: UpdateMeasurementCheckInInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateMeasurementCheckInByIdArgs {
  input: UpdateMeasurementCheckInByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateMedicationCheckInArgs {
  input: UpdateMedicationCheckInInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateMedicationCheckInByIdArgs {
  input: UpdateMedicationCheckInByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateMemberByIdArgs {
  id?: InputMaybe<Scalars['UUID']>;
  memberPatch?: InputMaybe<MemberPatch>;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateMessageArgs {
  input: UpdateMessageInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateMessageByExternalIdArgs {
  input: UpdateMessageByExternalIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateMessageByIdArgs {
  input: UpdateMessageByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateNameArgs {
  input: UpdateNameInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateObjectDetectionArgs {
  input: UpdateObjectDetectionInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateObjectDetectionByIdArgs {
  input: UpdateObjectDetectionByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdatePatientArgs {
  input: UpdatePatientInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdatePatientMembershipConfigArgs {
  input: UpdatePatientMembershipConfigInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdatePatientMembershipConfigByIdArgs {
  input: UpdatePatientMembershipConfigByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdatePatientStatusArgs {
  input: UpdatePatientStatusInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdatePatientStatusByIdArgs {
  input: UpdatePatientStatusByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdatePatientStatusByPatientIdAndCreatedAtAndValueArgs {
  input: UpdatePatientStatusByPatientIdAndCreatedAtAndValueInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdatePatientStatusValueArgs {
  input: UpdatePatientStatusValueInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdatePatientStatusValueByIdArgs {
  input: UpdatePatientStatusValueByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdatePatientStatusValueByNameArgs {
  input: UpdatePatientStatusValueByNameInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdatePauseArgs {
  input: UpdatePauseInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdatePauseByIdArgs {
  input: UpdatePauseByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdatePauseObjectArgs {
  pausePatch: PausePatch;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdatePauseReasonArgs {
  input: UpdatePauseReasonInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdatePauseReasonByIdArgs {
  input: UpdatePauseReasonByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdatePauseReasonByValueArgs {
  input: UpdatePauseReasonByValueInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdatePaymentSetupArgs {
  input: UpdatePaymentSetupInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdatePaymentSetupByIdArgs {
  input: UpdatePaymentSetupByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdatePhoneNumberArgs {
  input: UpdatePhoneNumberInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdatePrivilegedActionArgs {
  input: UpdatePrivilegedActionInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdatePrivilegedActionByIdArgs {
  input: UpdatePrivilegedActionByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdatePrivilegedActionByNameArgs {
  input: UpdatePrivilegedActionByNameInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateProgramByIdArgs {
  id: Scalars['String'];
  programPatch: ProgramPatch;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateProgramMfaConfigArgs {
  input: UpdateProgramMfaConfigInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateProgramMfaConfigByIdArgs {
  input: UpdateProgramMfaConfigByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateProgramMfaConfigByProgramIdArgs {
  input: UpdateProgramMfaConfigByProgramIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateProgramOutreachSubmissionArgs {
  input: UpdateProgramOutreachSubmissionInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateProgramOutreachSubmissionByIdArgs {
  input: UpdateProgramOutreachSubmissionByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateProgramRewardArgs {
  input: UpdateProgramRewardInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateProgramRewardByIdArgs {
  input: UpdateProgramRewardByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateProgramRewardConfigArgs {
  input: UpdateProgramRewardConfigInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateProgramRewardConfigByIdArgs {
  input: UpdateProgramRewardConfigByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateProgramRewardConfigByNameArgs {
  input: UpdateProgramRewardConfigByNameInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateProgramTemplateArgs {
  input: UpdateProgramTemplateInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateProgramTemplateByIdArgs {
  input: UpdateProgramTemplateByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateProgramTemplateByNameArgs {
  input: UpdateProgramTemplateByNameInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateProspectByIdArgs {
  id: Scalars['UUID'];
  prospectPatch: ProspectPatch;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateProspectStatusArgs {
  input: UpdateProspectStatusInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateProspectStatusByIdArgs {
  input: UpdateProspectStatusByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateProspectStatusByProspectIdAndCreatedAtAndValueArgs {
  input: UpdateProspectStatusByProspectIdAndCreatedAtAndValueInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateProspectStatusValueArgs {
  input: UpdateProspectStatusValueInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateProspectStatusValueByIdArgs {
  input: UpdateProspectStatusValueByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateProspectStatusValueByNameArgs {
  input: UpdateProspectStatusValueByNameInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdatePushNotificationArgs {
  input: UpdatePushNotificationInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdatePushNotificationByIdArgs {
  input: UpdatePushNotificationByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdatePushTokenArgs {
  input: UpdatePushTokenInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdatePushTokenByIdArgs {
  input: UpdatePushTokenByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateRawIncomingDatumArgs {
  input: UpdateRawIncomingDatumInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateRawIncomingDatumByIdArgs {
  input: UpdateRawIncomingDatumByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateReminderArgs {
  input: UpdateReminderInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateReminderByIdArgs {
  input: UpdateReminderByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateReminderConfigArgs {
  input: UpdateReminderConfigInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateReminderConfigByIdArgs {
  input: UpdateReminderConfigByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateReminderMessageArgs {
  input: UpdateReminderMessageInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateReminderMessageByIdArgs {
  input: UpdateReminderMessageByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateRewardPeriodArgs {
  input: UpdateRewardPeriodInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateRewardPeriodByIdArgs {
  input: UpdateRewardPeriodByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateRewardPeriodConfigArgs {
  input: UpdateRewardPeriodConfigInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateRewardPeriodConfigByIdArgs {
  input: UpdateRewardPeriodConfigByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateSmsAutoResponderArgs {
  input: UpdateSmsAutoResponderInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateSmsAutoResponderByIdArgs {
  input: UpdateSmsAutoResponderByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateSmsOutreachMessageArgs {
  input: UpdateSmsOutreachMessageInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateSmsOutreachMessageByIdArgs {
  input: UpdateSmsOutreachMessageByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateSmsOutreachMessageTemplateArgs {
  input: UpdateSmsOutreachMessageTemplateInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateSmsOutreachMessageTemplateByIdArgs {
  input: UpdateSmsOutreachMessageTemplateByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateSmsOutreachRecipientArgs {
  input: UpdateSmsOutreachRecipientInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateSmsOutreachRecipientByIdArgs {
  input: UpdateSmsOutreachRecipientByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateSmsOutreachRecipientByPhoneNumberArgs {
  input: UpdateSmsOutreachRecipientByPhoneNumberInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateTimedObjectArgs {
  input: UpdateTimedObjectInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateTimedObjectByIdArgs {
  input: UpdateTimedObjectByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateTimezoneRecordArgs {
  input: UpdateTimezoneRecordInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateTimezoneRecordByIdArgs {
  input: UpdateTimezoneRecordByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateWalkthroughArgs {
  input: UpdateWalkthroughInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateWalkthroughByIdArgs {
  input: UpdateWalkthroughByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateWalkthroughPageArgs {
  input: UpdateWalkthroughPageInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateWalkthroughPageByIdArgs {
  input: UpdateWalkthroughPageByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateWalkthroughSetupArgs {
  input: UpdateWalkthroughSetupInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateWalkthroughSetupByIdArgs {
  input: UpdateWalkthroughSetupByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateWalkthroughSetupConfigArgs {
  input: UpdateWalkthroughSetupConfigInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateWalkthroughSetupConfigByIdArgs {
  input: UpdateWalkthroughSetupConfigByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateWalkthroughSummaryArgs {
  input: UpdateWalkthroughSummaryInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateWalkthroughSummaryByIdArgs {
  input: UpdateWalkthroughSummaryByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateWinbackRewardConfigArgs {
  input: UpdateWinbackRewardConfigInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateWinbackRewardConfigByChallengeTypeKeyArgs {
  input: UpdateWinbackRewardConfigByChallengeTypeKeyInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateWinbackRewardConfigByIdArgs {
  input: UpdateWinbackRewardConfigByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateWinbackRewardOpportunityArgs {
  input: UpdateWinbackRewardOpportunityInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateWinbackRewardOpportunityByIdArgs {
  input: UpdateWinbackRewardOpportunityByIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUpdateWinbackRewardOpportunityByPatientIdAndChallengeIdArgs {
  input: UpdateWinbackRewardOpportunityByPatientIdAndChallengeIdInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUploadBulkSmsArgs {
  batchLabel?: InputMaybe<Scalars['String']>;
  file: Scalars['Upload'];
  messageTemplateId: Scalars['UUID'];
  protocol?: InputMaybe<SmsOutreachMessageProtocol>;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationUploadProspectFileArgs {
  file: Scalars['Upload'];
  programId: Scalars['UUID'];
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationVerifyDateOfBirthArgs {
  input: VerifyDateOfBirthInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationVerifySecurityQuestionAnswerArgs {
  input: VerifySecurityQuestionAnswerInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationVerifyZipCodeArgs {
  input: VerifyZipCodeInput;
}


/** The root mutation type which contains root level fields which mutate data. */
export interface MutationVerifyZipCodeAndDateOfBirthArgs {
  input: VerifyZipCodeAndDateOfBirthInput;
}

export interface AddIdentityTagInput {
  tagConfigId: Scalars['UUID'];
  wellthId: Scalars['UUID'];
}

/** All input for the `authenticateAdmin` mutation. */
export interface AuthenticateAdminInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  password: Scalars['String'];
}

/** The output of our `authenticateAdmin` mutation. */
export interface AuthenticateAdminPayload {
  __typename: 'AuthenticateAdminPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  jwtToken: Maybe<Scalars['JwtToken']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}

export interface CancelPauseRequestInput {
  clientMutationId?: InputMaybe<Scalars['String']>;
  memberId?: InputMaybe<Scalars['UUID']>;
}

export interface CancelPauseRequestPayload {
  __typename: 'CancelPauseRequestPayload';
  boolean: Maybe<Scalars['Boolean']>;
  clientMutationId: Maybe<Scalars['String']>;
}

export interface CancelUnpauseRequestInput {
  clientMutationId?: InputMaybe<Scalars['String']>;
  memberId?: InputMaybe<Scalars['UUID']>;
}

export interface CancelUnpauseRequestPayload {
  __typename: 'CancelUnpauseRequestPayload';
  boolean: Maybe<Scalars['Boolean']>;
  clientMutationId: Maybe<Scalars['String']>;
}

export interface ChangeBonusBehaviorSubmissionStatusInput {
  id: Scalars['UUID'];
  note?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  status: BonusBehaviorSubmissionStatusValue;
}

export interface BonusBehaviorSubmission {
  __typename: 'BonusBehaviorSubmission';
  bonusBehavior: Maybe<BonusBehavior>;
  id: Maybe<Scalars['UUID']>;
  photoUrl: Maybe<Scalars['String']>;
  photoUrls: Maybe<Array<Maybe<Scalars['String']>>>;
  status: Maybe<BonusBehaviorSubmissionStatusValue>;
  submissionType: Maybe<BonusBehaviorSubmissionType>;
}

/** All input for the `checkInCategoryMatches` mutation. */
export interface CheckInCategoryMatchesInput {
  arg0?: InputMaybe<Scalars['UUID']>;
  arg1?: InputMaybe<CheckInCategory>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
}

/** The output of our `checkInCategoryMatches` mutation. */
export interface CheckInCategoryMatchesPayload {
  __typename: 'CheckInCategoryMatchesPayload';
  boolean: Maybe<Scalars['Boolean']>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}

/** All input for the create `AccountTransaction` mutation. */
export interface CreateAccountTransactionInput {
  /** The `AccountTransaction` to be created by this mutation. */
  accountTransaction: AccountTransactionInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
}

/** An input for mutations affecting `AccountTransaction` */
export interface AccountTransactionInput {
  /** The amount of money (positive is a credit, negative is a debit) added to the account's balance during this transaction. */
  amount: Scalars['BigFloat'];
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** The currency of this transaction. */
  currency?: InputMaybe<Currency>;
  /** The date at which this account_transaction occurred. */
  date: Scalars['Date'];
  id?: InputMaybe<Scalars['UUID']>;
  /** An optional freetext note about this transaction. */
  note?: InputMaybe<Scalars['String']>;
  /** The patient which owns this account_transaction. */
  patientId: Scalars['UUID'];
  /** The reason for which this transaction occurred. */
  reason: AccountTransactionReason;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our create `AccountTransaction` mutation. */
export interface CreateAccountTransactionPayload {
  __typename: 'CreateAccountTransactionPayload';
  /** The `AccountTransaction` that was created by this mutation. */
  accountTransaction: Maybe<AccountTransaction>;
  /** An edge for our `AccountTransaction`. May be used by Relay 1. */
  accountTransactionEdge: Maybe<AccountTransactionsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Patient` that is related to this `AccountTransaction`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our create `AccountTransaction` mutation. */
export interface CreateAccountTransactionPayloadAccountTransactionEdgeArgs {
  orderBy?: InputMaybe<Array<AccountTransactionsOrderBy>>;
}

export interface CreateAccountTransactionCreditInput {
  creditAmount: Scalars['String'];
  currencySymbol: Currency;
  memberId: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
}

export interface CreateAccountTransactionCreditPayload {
  __typename: 'CreateAccountTransactionCreditPayload';
  amount: Maybe<Scalars['BigFloat']>;
  createdAt: Maybe<Scalars['Date']>;
  currency: Maybe<Currency>;
  date: Maybe<Scalars['Date']>;
  id: Maybe<Scalars['UUID']>;
  memberId: Maybe<Scalars['UUID']>;
  note: Maybe<Scalars['String']>;
  reason: Maybe<AccountTransactionReason>;
  updatedAt: Maybe<Scalars['Date']>;
}

/** All input for the create `ActionLog` mutation. */
export interface CreateActionLogInput {
  /** The `ActionLog` to be created by this mutation. */
  actionLog: ActionLogInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
}

/** An input for mutations affecting `ActionLog` */
export interface ActionLogInput {
  /** The type of action that was taken. */
  actionName: Scalars['String'];
  /** The timestamp when the action was taken. */
  actionTime?: InputMaybe<Scalars['Datetime']>;
  /** The type of actor for which the action was created. */
  actor: ActorCode;
  /** The unique identifier for the given admin if the actor was an admin. */
  adminId?: InputMaybe<Scalars['UUID']>;
  /** A JSON object of the changed object after the action was taken. */
  after?: InputMaybe<Scalars['JSON']>;
  /** A JSON object of the changed object before the action was taken. */
  before?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  diff?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** The actor's ip address from where the action was taken. */
  ipAddress?: InputMaybe<Scalars['String']>;
  /** The unique identifier for the specific object that the action was taken on. */
  objectId?: InputMaybe<Scalars['UUID']>;
  /** The type of object that the action was taken on. */
  objectType?: InputMaybe<Scalars['String']>;
  /** The unique identifier given to the patient that the action was taken on. */
  patientId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our create `ActionLog` mutation. */
export interface CreateActionLogPayload {
  __typename: 'CreateActionLogPayload';
  /** The `ActionLog` that was created by this mutation. */
  actionLog: Maybe<ActionLog>;
  /** An edge for our `ActionLog`. May be used by Relay 1. */
  actionLogEdge: Maybe<ActionLogsEdge>;
  /** Reads a single `Admin` that is related to this `ActionLog`. */
  adminByAdminId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Patient` that is related to this `ActionLog`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our create `ActionLog` mutation. */
export interface CreateActionLogPayloadActionLogEdgeArgs {
  orderBy?: InputMaybe<Array<ActionLogsOrderBy>>;
}

export enum ContactType {
  Member = 'member',
  Prospect = 'prospect'
}

export interface CreateAddressInput {
  address: AddressInput;
  clientMutationId?: InputMaybe<Scalars['String']>;
}

export interface AddressInput {
  city: Scalars['String'];
  country: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  isPrimary: Scalars['Boolean'];
  state: Scalars['String'];
  street: Scalars['String'];
  street2?: InputMaybe<Scalars['String']>;
  zip: Scalars['String'];
}

export interface CreateAddressPayload extends AddressPayload {
  __typename: 'CreateAddressPayload';
  address: Maybe<Address>;
  clientMutationId: Maybe<Scalars['String']>;
}

export interface AddressPayload {
  address: Maybe<Address>;
  clientMutationId: Maybe<Scalars['String']>;
}

/** All input for the create `Admin` mutation. */
export interface CreateAdminInput {
  /** The `Admin` to be created by this mutation. */
  admin: AdminInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
}

/** An input for mutations affecting `Admin` */
export interface AdminInput {
  adminRoleId?: InputMaybe<Scalars['UUID']>;
  /** The administrator's birth date. */
  birthDate?: InputMaybe<Scalars['Date']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** A string array of customers the admin is allowed to edit */
  customerAssociations?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The administrator's first name. */
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** The administrator's last name. */
  lastName?: InputMaybe<Scalars['String']>;
  middleName?: InputMaybe<Scalars['String']>;
  /** The administrator's phone number. */
  phoneNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our create `Admin` mutation. */
export interface CreateAdminPayload {
  __typename: 'CreateAdminPayload';
  /** The `Admin` that was created by this mutation. */
  admin: Maybe<Admin>;
  /** An edge for our `Admin`. May be used by Relay 1. */
  adminEdge: Maybe<AdminsEdge>;
  /** Reads a single `AdminRole` that is related to this `Admin`. */
  adminRoleByAdminRoleId: Maybe<AdminRole>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our create `Admin` mutation. */
export interface CreateAdminPayloadAdminEdgeArgs {
  orderBy?: InputMaybe<Array<AdminsOrderBy>>;
}

/** All input for the create `AdminRole` mutation. */
export interface CreateAdminRoleInput {
  /** The `AdminRole` to be created by this mutation. */
  adminRole: AdminRoleInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
}

/** An input for mutations affecting `AdminRole` */
export interface AdminRoleInput {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our create `AdminRole` mutation. */
export interface CreateAdminRolePayload {
  __typename: 'CreateAdminRolePayload';
  /** The `AdminRole` that was created by this mutation. */
  adminRole: Maybe<AdminRole>;
  /** An edge for our `AdminRole`. May be used by Relay 1. */
  adminRoleEdge: Maybe<AdminRolesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our create `AdminRole` mutation. */
export interface CreateAdminRolePayloadAdminRoleEdgeArgs {
  orderBy?: InputMaybe<Array<AdminRolesOrderBy>>;
}

/** All input for the create `AdminRolePrivilegedAction` mutation. */
export interface CreateAdminRolePrivilegedActionInput {
  /** The `AdminRolePrivilegedAction` to be created by this mutation. */
  adminRolePrivilegedAction: AdminRolePrivilegedActionInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
}

/** An input for mutations affecting `AdminRolePrivilegedAction` */
export interface AdminRolePrivilegedActionInput {
  adminRoleId: Scalars['UUID'];
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  privilegedActionId: Scalars['UUID'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our create `AdminRolePrivilegedAction` mutation. */
export interface CreateAdminRolePrivilegedActionPayload {
  __typename: 'CreateAdminRolePrivilegedActionPayload';
  /** Reads a single `AdminRole` that is related to this `AdminRolePrivilegedAction`. */
  adminRoleByAdminRoleId: Maybe<AdminRole>;
  /** The `AdminRolePrivilegedAction` that was created by this mutation. */
  adminRolePrivilegedAction: Maybe<AdminRolePrivilegedAction>;
  /** An edge for our `AdminRolePrivilegedAction`. May be used by Relay 1. */
  adminRolePrivilegedActionEdge: Maybe<AdminRolePrivilegedActionsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `PrivilegedAction` that is related to this `AdminRolePrivilegedAction`. */
  privilegedActionByPrivilegedActionId: Maybe<PrivilegedAction>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our create `AdminRolePrivilegedAction` mutation. */
export interface CreateAdminRolePrivilegedActionPayloadAdminRolePrivilegedActionEdgeArgs {
  orderBy?: InputMaybe<Array<AdminRolePrivilegedActionsOrderBy>>;
}

export interface CreateBonusBehaviorConfigInput {
  endDate: Scalars['Date'];
  icon: Scalars['String'];
  name: Scalars['String'];
  pagesetId: Scalars['UUID'];
  programId: Scalars['UUID'];
  rewardAmount: Scalars['Int'];
  rewardCurrency: Currency;
  startDate: Scalars['Date'];
}

export interface CreateBonusBehaviorSubmissionInput {
  bonusBehaviorId: Scalars['UUID'];
  photo?: InputMaybe<Scalars['Upload']>;
  submissionTimestamp: Scalars['Date'];
  submissionTimezone: Scalars['String'];
  submissionType: BonusBehaviorSubmissionType;
}

/** All input for the create `BonusBehaviorSubmissionStatus` mutation. */
export interface CreateBonusBehaviorSubmissionStatusInput {
  /** The `BonusBehaviorSubmissionStatus` to be created by this mutation. */
  bonusBehaviorSubmissionStatus: BonusBehaviorSubmissionStatusInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
}

/** An input for mutations affecting `BonusBehaviorSubmissionStatus` */
export interface BonusBehaviorSubmissionStatusInput {
  actor?: InputMaybe<ActorCode>;
  actorId?: InputMaybe<Scalars['String']>;
  bonusBehaviorSubmissionId: Scalars['UUID'];
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  reason: Scalars['String'];
  statusTransitionTimestamp: Scalars['Datetime'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our create `BonusBehaviorSubmissionStatus` mutation. */
export interface CreateBonusBehaviorSubmissionStatusPayload {
  __typename: 'CreateBonusBehaviorSubmissionStatusPayload';
  /** The `BonusBehaviorSubmissionStatus` that was created by this mutation. */
  bonusBehaviorSubmissionStatus: Maybe<BonusBehaviorSubmissionStatus>;
  /** An edge for our `BonusBehaviorSubmissionStatus`. May be used by Relay 1. */
  bonusBehaviorSubmissionStatusEdge: Maybe<BonusBehaviorSubmissionStatusesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our create `BonusBehaviorSubmissionStatus` mutation. */
export interface CreateBonusBehaviorSubmissionStatusPayloadBonusBehaviorSubmissionStatusEdgeArgs {
  orderBy?: InputMaybe<Array<BonusBehaviorSubmissionStatusesOrderBy>>;
}

/** All input for the create `CheckIn` mutation. */
export interface CreateCheckInInput {
  /** The `CheckIn` to be created by this mutation. */
  checkIn: CheckInInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
}

/** An input for mutations affecting `CheckIn` */
export interface CheckInInput {
  /** The category of this check-in. */
  category: CheckInCategory;
  /** The timestamp on the patient's device at the time of check-in. */
  checkInTimestamp: Scalars['Datetime'];
  /** The local timezone on the patient's device at the time of check-in. */
  checkInTimezone: Scalars['Timezone'];
  createdAt?: InputMaybe<Scalars['Datetime']>;
  creditedReason?: InputMaybe<Scalars['String']>;
  creditedReasonDetail?: InputMaybe<Scalars['String']>;
  creditedReasonNote?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isCredited?: InputMaybe<Scalars['Boolean']>;
  /** The object detection status of this check-in, set by the automatic object detection worker. */
  objectDetectionStatus?: InputMaybe<ObjectDetectionStatus>;
  patientId: Scalars['UUID'];
  /** The URL of the large photo for this check-in; optional. */
  photoUrl?: InputMaybe<Scalars['String']>;
  /** The ID of the reminder from which this check-in originated. */
  reminderId: Scalars['UUID'];
  /** The URL of the small photo for this check-in; optional. */
  thumbnailUrl?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** The verification status of this check-in, set by Wellth administrators. */
  verificationStatus?: InputMaybe<VerificationStatus>;
  /** The id of the Wellth administrator who verified this check-in, if any. */
  verifierId?: InputMaybe<Scalars['UUID']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our create `CheckIn` mutation. */
export interface CreateCheckInPayload {
  __typename: 'CreateCheckInPayload';
  /** Reads a single `Admin` that is related to this `CheckIn`. */
  adminByVerifierId: Maybe<Admin>;
  /** The `CheckIn` that was created by this mutation. */
  checkIn: Maybe<CheckIn>;
  /** An edge for our `CheckIn`. May be used by Relay 1. */
  checkInEdge: Maybe<CheckInsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Patient` that is related to this `CheckIn`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Reminder` that is related to this `CheckIn`. */
  reminderByReminderId: Maybe<Reminder>;
}


/** The output of our create `CheckIn` mutation. */
export interface CreateCheckInPayloadCheckInEdgeArgs {
  orderBy?: InputMaybe<Array<CheckInsOrderBy>>;
}

export interface CheckInDataInput {
  checkInCategory: CheckInCategory;
  checkInId: Scalars['UUID'];
  checkInTimestamp: Scalars['Datetime'];
  checkInTimezone: Scalars['Timezone'];
  createdAt: Scalars['Datetime'];
  patientId: Scalars['UUID'];
  reminderId: Scalars['UUID'];
  selfVerified?: InputMaybe<Scalars['Boolean']>;
}

export interface CheckInDataPayload {
  __typename: 'CheckInDataPayload';
  checkIn: Maybe<CheckIn>;
  patient: Maybe<Member>;
  query: Maybe<Query>;
}

export interface CheckInSubmissionInput {
  checkInCategory: CheckInCategory;
  checkInTimestamp: Scalars['Datetime'];
  checkInTimezone: Scalars['Timezone'];
  createdAt: Scalars['Datetime'];
  patientId: Scalars['UUID'];
  photo: Scalars['Upload'];
  reminderId: Scalars['UUID'];
}

export interface CheckInSubmissionPayload {
  __typename: 'CheckInSubmissionPayload';
  checkIn: Maybe<CheckIn>;
  patient: Maybe<Member>;
  query: Maybe<Query>;
}

export interface ContactInput {
  description?: InputMaybe<Scalars['String']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
  memberId: Scalars['UUID'];
  phoneNumber?: InputMaybe<Scalars['String']>;
  relationship?: InputMaybe<RelationshipType>;
  timezone?: InputMaybe<Scalars['String']>;
}

/** All input for the create `CueCheckIn` mutation. */
export interface CreateCueCheckInInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `CueCheckIn` to be created by this mutation. */
  cueCheckIn: CueCheckInInput;
}

/** An input for mutations affecting `CueCheckIn` */
export interface CueCheckInInput {
  category: CheckInCategory;
  checkInTimestamp: Scalars['Datetime'];
  checkInTimezone: Scalars['Timezone'];
  createdAt?: InputMaybe<Scalars['Datetime']>;
  creditedReason?: InputMaybe<Scalars['String']>;
  creditedReasonDetail?: InputMaybe<Scalars['String']>;
  creditedReasonNote?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isCredited?: InputMaybe<Scalars['Boolean']>;
  /** A label used by the cue reminder. Exists here as reference */
  label?: InputMaybe<Scalars['String']>;
  objectDetectionStatus?: InputMaybe<ObjectDetectionStatus>;
  patientId: Scalars['UUID'];
  photoUrl?: InputMaybe<Scalars['String']>;
  reminderId: Scalars['UUID'];
  thumbnailUrl?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  verificationStatus?: InputMaybe<VerificationStatus>;
  verifierId?: InputMaybe<Scalars['UUID']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our create `CueCheckIn` mutation. */
export interface CreateCueCheckInPayload {
  __typename: 'CreateCueCheckInPayload';
  /** Reads a single `Admin` that is related to this `CueCheckIn`. */
  adminByVerifierId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `CueCheckIn` that was created by this mutation. */
  cueCheckIn: Maybe<CueCheckIn>;
  /** An edge for our `CueCheckIn`. May be used by Relay 1. */
  cueCheckInEdge: Maybe<CueCheckInsEdge>;
  /** Reads a single `Patient` that is related to this `CueCheckIn`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Reminder` that is related to this `CueCheckIn`. */
  reminderByReminderId: Maybe<Reminder>;
}


/** The output of our create `CueCheckIn` mutation. */
export interface CreateCueCheckInPayloadCueCheckInEdgeArgs {
  orderBy?: InputMaybe<Array<CueCheckInsOrderBy>>;
}

/** All input for the create `Customer` mutation. */
export interface CreateCustomerInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Customer` to be created by this mutation. */
  customer: CustomerInput;
}

/** An input for mutations affecting `Customer` */
export interface CustomerInput {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our create `Customer` mutation. */
export interface CreateCustomerPayload {
  __typename: 'CreateCustomerPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `Customer` that was created by this mutation. */
  customer: Maybe<Customer>;
  /** An edge for our `Customer`. May be used by Relay 1. */
  customerEdge: Maybe<CustomersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our create `Customer` mutation. */
export interface CreateCustomerPayloadCustomerEdgeArgs {
  orderBy?: InputMaybe<Array<CustomersOrderBy>>;
}

/** All input for the create `DebitCard` mutation. */
export interface CreateDebitCardInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `DebitCard` to be created by this mutation. */
  debitCard: DebitCardInput;
}

/** An input for mutations affecting `DebitCard` */
export interface DebitCardInput {
  /** The latest retrieved balance on the card. */
  balance: Scalars['BigFloat'];
  /** Card number as reported by API */
  cardNumber?: InputMaybe<Scalars['JSON']>;
  /** Status value of this card */
  cardStatus?: InputMaybe<Scalars['BigFloat']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** processor-specific card details. */
  details?: InputMaybe<Scalars['JSON']>;
  /** Expiration date of this card */
  expiryDate?: InputMaybe<Scalars['Date']>;
  /** Any extra details on the card provided by the payment processor. */
  extras?: InputMaybe<Scalars['JSON']>;
  /** The first name on the card. */
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** The last name on the card. */
  lastName?: InputMaybe<Scalars['String']>;
  /** The id of the patient who owns this debit card. */
  patientId: Scalars['UUID'];
  /** The payment processor that created this debit card. */
  processor: PaymentProcessor;
  /** The proxy card number, used to make transactions against the card without implicating PCI compliance. */
  proxyNumber?: InputMaybe<Scalars['String']>;
  /** The latest status of the card. */
  status: DebitCardStatus;
  /** Status description of this card */
  statusDesc?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our create `DebitCard` mutation. */
export interface CreateDebitCardPayload {
  __typename: 'CreateDebitCardPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `DebitCard` that was created by this mutation. */
  debitCard: Maybe<DebitCard>;
  /** An edge for our `DebitCard`. May be used by Relay 1. */
  debitCardEdge: Maybe<DebitCardsEdge>;
  /** Reads a single `Patient` that is related to this `DebitCard`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our create `DebitCard` mutation. */
export interface CreateDebitCardPayloadDebitCardEdgeArgs {
  orderBy?: InputMaybe<Array<DebitCardsOrderBy>>;
}

/** All input for the create `DebitCardBalance` mutation. */
export interface CreateDebitCardBalanceInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `DebitCardBalance` to be created by this mutation. */
  debitCardBalance: DebitCardBalanceInput;
}

/** An input for mutations affecting `DebitCardBalance` */
export interface DebitCardBalanceInput {
  /** The balance available to spend on the debit card at this point in time. */
  balance: Scalars['BigFloat'];
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** The id of the debit card to which this balance entry pertains. */
  debitCardId: Scalars['UUID'];
  id?: InputMaybe<Scalars['UUID']>;
  /** The id of the patient that owns the referenced debit card. */
  patientId: Scalars['UUID'];
  /** The status of the debit card at this point in time. */
  status: DebitCardStatus;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our create `DebitCardBalance` mutation. */
export interface CreateDebitCardBalancePayload {
  __typename: 'CreateDebitCardBalancePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `DebitCardBalance` that was created by this mutation. */
  debitCardBalance: Maybe<DebitCardBalance>;
  /** An edge for our `DebitCardBalance`. May be used by Relay 1. */
  debitCardBalanceEdge: Maybe<DebitCardBalancesEdge>;
  /** Reads a single `DebitCard` that is related to this `DebitCardBalance`. */
  debitCardByDebitCardId: Maybe<DebitCard>;
  /** Reads a single `Patient` that is related to this `DebitCardBalance`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our create `DebitCardBalance` mutation. */
export interface CreateDebitCardBalancePayloadDebitCardBalanceEdgeArgs {
  orderBy?: InputMaybe<Array<DebitCardBalancesOrderBy>>;
}

/** All input for the create `Device` mutation. */
export interface CreateDeviceInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Device` to be created by this mutation. */
  device: DeviceInput;
}

/** An input for mutations affecting `Device` */
export interface DeviceInput {
  /** The ID of the admin who owns this device registration */
  adminId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** The identifier of the device, as created by the manufacturer. */
  identifier: Scalars['String'];
  /** The patient to whom this device is currently assigned; may be null. */
  patientId?: InputMaybe<Scalars['UUID']>;
  /** The Wellth-assigned short identifier, e.g. ABCD, used to easily reference this specific device upon onboarding. */
  shortIdentifier: Scalars['String'];
  /** The source of the device, e.g. Bodytrace */
  source: DeviceSource;
  /** The type of the device, e.g. scale */
  type: DeviceType;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our create `Device` mutation. */
export interface CreateDevicePayload {
  __typename: 'CreateDevicePayload';
  /** Reads a single `Admin` that is related to this `Device`. */
  adminByAdminId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `Device` that was created by this mutation. */
  device: Maybe<Device>;
  /** An edge for our `Device`. May be used by Relay 1. */
  deviceEdge: Maybe<DevicesEdge>;
  /** Reads a single `Patient` that is related to this `Device`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our create `Device` mutation. */
export interface CreateDevicePayloadDeviceEdgeArgs {
  orderBy?: InputMaybe<Array<DevicesOrderBy>>;
}

/** Input for creating a dialysis appointment schedule */
export interface CreateDialysisAppointmentScheduleInput {
  /** End date in YYYY-MM-DD format */
  endDate: Scalars['String'];
  memberId: Scalars['UUID'];
  /** Optional number of minutes before the appointment to send a reminder */
  reminderMinutesAdvance?: InputMaybe<Scalars['Int']>;
  /** Start date in YYYY-MM-DD format */
  startDate: Scalars['String'];
  /** Time in 24-hour HH:mm format */
  time: Scalars['String'];
}

export interface DialysisAppointmentScheduleResponse {
  __typename: 'DialysisAppointmentScheduleResponse';
  day: Scalars['String'];
  reminderMinutesAdvance: Maybe<Scalars['Int']>;
  scheduleJob: Scalars['String'];
  time: Scalars['String'];
}

export interface CreateEmailAddressInput {
  clientMutationId?: InputMaybe<Scalars['String']>;
  emailAddress: EmailAddressInput;
}

export interface EmailAddressInput {
  emailAddress: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  isPrimary: Scalars['Boolean'];
}

export interface CreateEmailAddressPayload {
  __typename: 'CreateEmailAddressPayload';
  clientMutationId: Maybe<Scalars['String']>;
  emailAddress: Maybe<EmailAddress>;
}

/** All input for the create `Group` mutation. */
export interface CreateGroupInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Group` to be created by this mutation. */
  group: GroupInput;
}

/** An input for mutations affecting `Group` */
export interface GroupInput {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** The group's name. */
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our create `Group` mutation. */
export interface CreateGroupPayload {
  __typename: 'CreateGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `Group` that was created by this mutation. */
  group: Maybe<Group>;
  /** An edge for our `Group`. May be used by Relay 1. */
  groupEdge: Maybe<GroupsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our create `Group` mutation. */
export interface CreateGroupPayloadGroupEdgeArgs {
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
}

/** All input for the create `Heartbeat` mutation. */
export interface CreateHeartbeatInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Heartbeat` to be created by this mutation. */
  heartbeat: HeartbeatInput;
}

/** An input for mutations affecting `Heartbeat` */
export interface HeartbeatInput {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** The ID of the patient whose app sent the heartbeat ping to the API. */
  patientId: Scalars['UUID'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our create `Heartbeat` mutation. */
export interface CreateHeartbeatPayload {
  __typename: 'CreateHeartbeatPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `Heartbeat` that was created by this mutation. */
  heartbeat: Maybe<Heartbeat>;
  /** An edge for our `Heartbeat`. May be used by Relay 1. */
  heartbeatEdge: Maybe<HeartbeatsEdge>;
  /** Reads a single `Patient` that is related to this `Heartbeat`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our create `Heartbeat` mutation. */
export interface CreateHeartbeatPayloadHeartbeatEdgeArgs {
  orderBy?: InputMaybe<Array<HeartbeatsOrderBy>>;
}

export interface CreateHighlightSubmissionInput {
  /** The action type of the Highlight Submission */
  actionType?: InputMaybe<HighlightActionType>;
  /** The result of an action for the Highlight Submission */
  actionValue?: InputMaybe<Scalars['JSON']>;
  /** The action of the highlight button */
  buttonAction?: InputMaybe<Scalars['String']>;
  /** A universally unique identifier */
  id: Scalars['UUID'];
  /** The timestamp of the Highlight Submission */
  submissionTimestamp: Scalars['Datetime'];
  /** The timezone of the Highlight Submission */
  submissionTimezone: Scalars['Timezone'];
}

export interface CreateHighlightSubmissionPayload {
  __typename: 'CreateHighlightSubmissionPayload';
  /** A universally unique identifier */
  id: Scalars['UUID'];
  /**
   * The next screen of a chained highlight, resolved from the submitted highlight's branching
   * edges and the member's selection. Null when the highlight is not chained or the chain ended.
   */
  next: Maybe<Highlight>;
}

/** All input for the create `HydrationCheckIn` mutation. */
export interface CreateHydrationCheckInInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `HydrationCheckIn` to be created by this mutation. */
  hydrationCheckIn: HydrationCheckInInput;
}

/** An input for mutations affecting `HydrationCheckIn` */
export interface HydrationCheckInInput {
  category: CheckInCategory;
  checkInTimestamp: Scalars['Datetime'];
  checkInTimezone: Scalars['Timezone'];
  createdAt?: InputMaybe<Scalars['Datetime']>;
  creditedReason?: InputMaybe<Scalars['String']>;
  creditedReasonDetail?: InputMaybe<Scalars['String']>;
  creditedReasonNote?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isCredited?: InputMaybe<Scalars['Boolean']>;
  objectDetectionStatus?: InputMaybe<ObjectDetectionStatus>;
  patientId: Scalars['UUID'];
  photoUrl?: InputMaybe<Scalars['String']>;
  reminderId: Scalars['UUID'];
  thumbnailUrl?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  verificationStatus?: InputMaybe<VerificationStatus>;
  verifierId?: InputMaybe<Scalars['UUID']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our create `HydrationCheckIn` mutation. */
export interface CreateHydrationCheckInPayload {
  __typename: 'CreateHydrationCheckInPayload';
  /** Reads a single `Admin` that is related to this `HydrationCheckIn`. */
  adminByVerifierId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `HydrationCheckIn` that was created by this mutation. */
  hydrationCheckIn: Maybe<HydrationCheckIn>;
  /** An edge for our `HydrationCheckIn`. May be used by Relay 1. */
  hydrationCheckInEdge: Maybe<HydrationCheckInsEdge>;
  /** Reads a single `Patient` that is related to this `HydrationCheckIn`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Reminder` that is related to this `HydrationCheckIn`. */
  reminderByReminderId: Maybe<Reminder>;
}


/** The output of our create `HydrationCheckIn` mutation. */
export interface CreateHydrationCheckInPayloadHydrationCheckInEdgeArgs {
  orderBy?: InputMaybe<Array<HydrationCheckInsOrderBy>>;
}

/** All input for the create `MarvMigration` mutation. */
export interface CreateMarvMigrationInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `MarvMigration` to be created by this mutation. */
  marvMigration: MarvMigrationInput;
}

/** An input for mutations affecting `MarvMigration` */
export interface MarvMigrationInput {
  checksum?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  level: Scalars['Int'];
  namespace?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Datetime']>;
}

/** The output of our create `MarvMigration` mutation. */
export interface CreateMarvMigrationPayload {
  __typename: 'CreateMarvMigrationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `MarvMigration` that was created by this mutation. */
  marvMigration: Maybe<MarvMigration>;
  /** An edge for our `MarvMigration`. May be used by Relay 1. */
  marvMigrationEdge: Maybe<MarvMigrationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our create `MarvMigration` mutation. */
export interface CreateMarvMigrationPayloadMarvMigrationEdgeArgs {
  orderBy?: InputMaybe<Array<MarvMigrationsOrderBy>>;
}

/** All input for the create `MarvMigrationsLock` mutation. */
export interface CreateMarvMigrationsLockInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `MarvMigrationsLock` to be created by this mutation. */
  marvMigrationsLock: MarvMigrationsLockInput;
}

/** An input for mutations affecting `MarvMigrationsLock` */
export interface MarvMigrationsLockInput {
  dummyColumn?: InputMaybe<Scalars['Int']>;
}

/** The output of our create `MarvMigrationsLock` mutation. */
export interface CreateMarvMigrationsLockPayload {
  __typename: 'CreateMarvMigrationsLockPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `MarvMigrationsLock` that was created by this mutation. */
  marvMigrationsLock: Maybe<MarvMigrationsLock>;
  /** An edge for our `MarvMigrationsLock`. May be used by Relay 1. */
  marvMigrationsLockEdge: Maybe<MarvMigrationsLocksEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our create `MarvMigrationsLock` mutation. */
export interface CreateMarvMigrationsLockPayloadMarvMigrationsLockEdgeArgs {
  orderBy?: InputMaybe<Array<MarvMigrationsLocksOrderBy>>;
}

/** All input for the create `MealCheckIn` mutation. */
export interface CreateMealCheckInInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `MealCheckIn` to be created by this mutation. */
  mealCheckIn: MealCheckInInput;
}

/** An input for mutations affecting `MealCheckIn` */
export interface MealCheckInInput {
  category: CheckInCategory;
  checkInTimestamp: Scalars['Datetime'];
  checkInTimezone: Scalars['Timezone'];
  createdAt?: InputMaybe<Scalars['Datetime']>;
  creditedReason?: InputMaybe<Scalars['String']>;
  creditedReasonDetail?: InputMaybe<Scalars['String']>;
  creditedReasonNote?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isCredited?: InputMaybe<Scalars['Boolean']>;
  /** An array of food item names */
  items?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  objectDetectionStatus?: InputMaybe<ObjectDetectionStatus>;
  patientId: Scalars['UUID'];
  photoUrl?: InputMaybe<Scalars['String']>;
  reminderId: Scalars['UUID'];
  thumbnailUrl?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  verificationStatus?: InputMaybe<VerificationStatus>;
  verifierId?: InputMaybe<Scalars['UUID']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our create `MealCheckIn` mutation. */
export interface CreateMealCheckInPayload {
  __typename: 'CreateMealCheckInPayload';
  /** Reads a single `Admin` that is related to this `MealCheckIn`. */
  adminByVerifierId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `MealCheckIn` that was created by this mutation. */
  mealCheckIn: Maybe<MealCheckIn>;
  /** An edge for our `MealCheckIn`. May be used by Relay 1. */
  mealCheckInEdge: Maybe<MealCheckInsEdge>;
  /** Reads a single `Patient` that is related to this `MealCheckIn`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Reminder` that is related to this `MealCheckIn`. */
  reminderByReminderId: Maybe<Reminder>;
}


/** The output of our create `MealCheckIn` mutation. */
export interface CreateMealCheckInPayloadMealCheckInEdgeArgs {
  orderBy?: InputMaybe<Array<MealCheckInsOrderBy>>;
}

/** All input for the create `MeasurementCheckIn` mutation. */
export interface CreateMeasurementCheckInInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `MeasurementCheckIn` to be created by this mutation. */
  measurementCheckIn: MeasurementCheckInInput;
}

/** An input for mutations affecting `MeasurementCheckIn` */
export interface MeasurementCheckInInput {
  category: CheckInCategory;
  checkInTimestamp: Scalars['Datetime'];
  checkInTimezone: Scalars['Timezone'];
  createdAt?: InputMaybe<Scalars['Datetime']>;
  creditedReason?: InputMaybe<Scalars['String']>;
  creditedReasonDetail?: InputMaybe<Scalars['String']>;
  creditedReasonNote?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isCredited?: InputMaybe<Scalars['Boolean']>;
  /** An array of measurement entries */
  measurements?: InputMaybe<Array<InputMaybe<MeasurementInput>>>;
  objectDetectionStatus?: InputMaybe<ObjectDetectionStatus>;
  patientId: Scalars['UUID'];
  photoUrl?: InputMaybe<Scalars['String']>;
  reminderId: Scalars['UUID'];
  thumbnailUrl?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  verificationStatus?: InputMaybe<VerificationStatus>;
  verifierId?: InputMaybe<Scalars['UUID']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our create `MeasurementCheckIn` mutation. */
export interface CreateMeasurementCheckInPayload {
  __typename: 'CreateMeasurementCheckInPayload';
  /** Reads a single `Admin` that is related to this `MeasurementCheckIn`. */
  adminByVerifierId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `MeasurementCheckIn` that was created by this mutation. */
  measurementCheckIn: Maybe<MeasurementCheckIn>;
  /** An edge for our `MeasurementCheckIn`. May be used by Relay 1. */
  measurementCheckInEdge: Maybe<MeasurementCheckInsEdge>;
  /** Reads a single `Patient` that is related to this `MeasurementCheckIn`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Reminder` that is related to this `MeasurementCheckIn`. */
  reminderByReminderId: Maybe<Reminder>;
}


/** The output of our create `MeasurementCheckIn` mutation. */
export interface CreateMeasurementCheckInPayloadMeasurementCheckInEdgeArgs {
  orderBy?: InputMaybe<Array<MeasurementCheckInsOrderBy>>;
}

/** All input for the create `MedicationCheckIn` mutation. */
export interface CreateMedicationCheckInInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `MedicationCheckIn` to be created by this mutation. */
  medicationCheckIn: MedicationCheckInInput;
}

/** An input for mutations affecting `MedicationCheckIn` */
export interface MedicationCheckInInput {
  anomalyTypes?: InputMaybe<Scalars['JSON']>;
  /** Our AI's determination of whether this photo has medications; null if it hasn't been checked yet. */
  autoHasMeds?: InputMaybe<Scalars['Boolean']>;
  /** The number of medication objects our AI found in this photo; null if it hasn't been checked yet. */
  autoMedCount?: InputMaybe<Scalars['Int']>;
  category: CheckInCategory;
  checkInTimestamp: Scalars['Datetime'];
  checkInTimezone: Scalars['Timezone'];
  createdAt?: InputMaybe<Scalars['Datetime']>;
  creditedReason?: InputMaybe<Scalars['String']>;
  creditedReasonDetail?: InputMaybe<Scalars['String']>;
  creditedReasonNote?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isCredited?: InputMaybe<Scalars['Boolean']>;
  /** An administrator's determination of whether this photo has medications; null if it hasn't been checked yet. */
  manualHasMeds?: InputMaybe<Scalars['Boolean']>;
  /** The number of medication objects an administrator found in this photo; null if it hasn't been checked yet. */
  manualMedCount?: InputMaybe<Scalars['Int']>;
  objectDetectionStatus?: InputMaybe<ObjectDetectionStatus>;
  patientId: Scalars['UUID'];
  photoUrl?: InputMaybe<Scalars['String']>;
  reminderId: Scalars['UUID'];
  thumbnailUrl?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  verificationStatus?: InputMaybe<VerificationStatus>;
  verifierId?: InputMaybe<Scalars['UUID']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our create `MedicationCheckIn` mutation. */
export interface CreateMedicationCheckInPayload {
  __typename: 'CreateMedicationCheckInPayload';
  /** Reads a single `Admin` that is related to this `MedicationCheckIn`. */
  adminByVerifierId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `MedicationCheckIn` that was created by this mutation. */
  medicationCheckIn: Maybe<MedicationCheckIn>;
  /** An edge for our `MedicationCheckIn`. May be used by Relay 1. */
  medicationCheckInEdge: Maybe<MedicationCheckInsEdge>;
  /** Reads a single `Patient` that is related to this `MedicationCheckIn`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Reminder` that is related to this `MedicationCheckIn`. */
  reminderByReminderId: Maybe<Reminder>;
}


/** The output of our create `MedicationCheckIn` mutation. */
export interface CreateMedicationCheckInPayloadMedicationCheckInEdgeArgs {
  orderBy?: InputMaybe<Array<MedicationCheckInsOrderBy>>;
}

/** All input for the create `Message` mutation. */
export interface CreateMessageInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Message` to be created by this mutation. */
  message: MessageInput;
}

/** An input for mutations affecting `Message` */
export interface MessageInput {
  /** The admin to or from whom this message is sent; optional */
  adminId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  mediaUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The content of the message. */
  message?: InputMaybe<Scalars['String']>;
  messageType?: InputMaybe<Scalars['String']>;
  /** The patient to or from whom this message is sent */
  patientId?: InputMaybe<Scalars['UUID']>;
  /** The protocol over which the message was sent. */
  protocol: MessageProtocol;
  /** The party who is the recipient of this message */
  recipient: MessageRecipient;
  /** The time at which to send the message. */
  sendAt?: InputMaybe<Scalars['Datetime']>;
  /** The time at which this message was sent. */
  sentDatetime?: InputMaybe<Scalars['Datetime']>;
  sentFrom?: InputMaybe<Scalars['String']>;
  /** The status of the message. */
  status?: InputMaybe<Scalars['String']>;
  /** The optional subject of the message (mostly applicable to emails). */
  subject?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our create `Message` mutation. */
export interface CreateMessagePayload {
  __typename: 'CreateMessagePayload';
  /** Reads a single `Admin` that is related to this `Message`. */
  adminByAdminId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `Message` that was created by this mutation. */
  message: Maybe<Message>;
  /** An edge for our `Message`. May be used by Relay 1. */
  messageEdge: Maybe<MessagesEdge>;
  /** Reads a single `Patient` that is related to this `Message`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our create `Message` mutation. */
export interface CreateMessagePayloadMessageEdgeArgs {
  orderBy?: InputMaybe<Array<MessagesOrderBy>>;
}

export interface CreateNameInput {
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: NameInput;
}

export interface NameInput {
  firstName: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  isPrimary: Scalars['Boolean'];
  lastName: Scalars['String'];
  middleName?: InputMaybe<Scalars['String']>;
}

export interface CreateNamePayload {
  __typename: 'CreateNamePayload';
  clientMutationId: Maybe<Scalars['String']>;
  name: Maybe<Name>;
}

/** All input for the create `ObjectDetection` mutation. */
export interface CreateObjectDetectionInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ObjectDetection` to be created by this mutation. */
  objectDetection: ObjectDetectionInput;
}

/** An input for mutations affecting `ObjectDetection` */
export interface ObjectDetectionInput {
  /** The bottom boundary of the object, relative to the image height. Range: [0.0, 1/0].  Top-left of image is (0.0, 0.0) */
  boundsBottom?: InputMaybe<Scalars['Float']>;
  /** The left boundary of the object, relative to the image height. Range: [0.0, 1/0].  Top-left of image is (0.0, 0.0) */
  boundsLeft?: InputMaybe<Scalars['Float']>;
  /** The right boundary of the object, relative to the image height. Range: [0.0, 1/0].  Top-left of image is (0.0, 0.0) */
  boundsRight?: InputMaybe<Scalars['Float']>;
  /** The top boundary of the object, relative to the image height. Range: [0.0, 1/0].  Top-left of image is (0.0, 0.0) */
  boundsTop?: InputMaybe<Scalars['Float']>;
  /** The check-in from which this detection was derived. */
  checkInId?: InputMaybe<Scalars['UUID']>;
  confidence?: InputMaybe<Scalars['Float']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  model?: InputMaybe<Scalars['String']>;
  /** The type of object detected in the check-in image. */
  objectType?: InputMaybe<Scalars['String']>;
  /** The patient that made the check-in from which this detection was derived. */
  patientId: Scalars['UUID'];
  unit?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
}

/** The output of our create `ObjectDetection` mutation. */
export interface CreateObjectDetectionPayload {
  __typename: 'CreateObjectDetectionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `ObjectDetection` that was created by this mutation. */
  objectDetection: Maybe<ObjectDetection>;
  /** An edge for our `ObjectDetection`. May be used by Relay 1. */
  objectDetectionEdge: Maybe<ObjectDetectionsEdge>;
  /** Reads a single `Patient` that is related to this `ObjectDetection`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our create `ObjectDetection` mutation. */
export interface CreateObjectDetectionPayloadObjectDetectionEdgeArgs {
  orderBy?: InputMaybe<Array<ObjectDetectionsOrderBy>>;
}

/** All input for the create `Patient` mutation. */
export interface CreatePatientInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Patient` to be created by this mutation. */
  patient: PatientInput;
}

/** An input for mutations affecting `Patient` */
export interface PatientInput {
  /** The Wellth Date of activation in the member's timezone at the moment of activation. */
  activationDate?: InputMaybe<Scalars['Date']>;
  /** The member's timezone at the moment of activation. */
  activationTimezone?: InputMaybe<Scalars['Timezone']>;
  activeDays?: InputMaybe<Scalars['Int']>;
  build?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** A free-form editable text field for relevant details about a patient that do not fit into other fields. */
  description?: InputMaybe<Scalars['String']>;
  eligibilityEndDate?: InputMaybe<Scalars['Date']>;
  enrolledBy?: InputMaybe<Scalars['UUID']>;
  /** The Wellth Date of enrollment in the member's timezone at the moment of enrollment. */
  enrollmentDate?: InputMaybe<Scalars['Date']>;
  /** The member's timezone at the moment of enrollment. */
  enrollmentTimezone?: InputMaybe<Scalars['Timezone']>;
  /** The unique identifier given to the patient by our customer. */
  externalId?: InputMaybe<Scalars['String']>;
  externalId2?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** The Wellth Date of inactivation in the member's timezone at the moment of inactivation. */
  inactivationDate?: InputMaybe<Scalars['Date']>;
  /** The member's timezone at the moment of inactivation. */
  inactivationTimezone?: InputMaybe<Scalars['Timezone']>;
  introductionToWellth?: InputMaybe<Scalars['String']>;
  isAutoPauseEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Whether the patient is receiving local notifications. */
  isLocalNotificationEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Whether the patient has completed the in-app product tour. */
  isProductTourCompleted?: InputMaybe<Scalars['Boolean']>;
  /** Whether the product tour should always show for the patient when they open the app. */
  isProductTourRecurring?: InputMaybe<Scalars['Boolean']>;
  /** Whether the patient has the ability to add/edit/delete all fields on all reminders in place ("open" mode). */
  isReminderEditingOpen?: InputMaybe<Scalars['Boolean']>;
  /** Whether the patient is receiving sms notifications. */
  isReminderMessagingEnabled?: InputMaybe<Scalars['Boolean']>;
  isRestfulPatient?: InputMaybe<Scalars['Boolean']>;
  /** Whether the patient consents to the use of a wingperson(s). */
  isSidekickEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Whether the patient is a test patient; test patients should not receive payments, text messages, etc */
  isTestPatient?: InputMaybe<Scalars['Boolean']>;
  liveProgramDays?: InputMaybe<Scalars['Int']>;
  /** The medicaid id of the person */
  medicaidId?: InputMaybe<Scalars['String']>;
  missedCheckinStreak?: InputMaybe<Scalars['Int']>;
  /** The Wellth Date of onboarding in the member's timezone at the moment of onboarding. */
  onboardingDate?: InputMaybe<Scalars['Date']>;
  /** The member's timezone at the moment of onboarding. */
  onboardingTimezone?: InputMaybe<Scalars['Timezone']>;
  /** The pause status of the patient at the current time. */
  pauseStatus?: InputMaybe<PauseStatus>;
  paymentOptionsId?: InputMaybe<Scalars['UUID']>;
  personId?: InputMaybe<Scalars['UUID']>;
  platform?: InputMaybe<Scalars['String']>;
  prospectId: Scalars['UUID'];
  secondaryPhoneNumber?: InputMaybe<Scalars['String']>;
  /** The name of the site where the patient was enrolled. */
  siteName?: InputMaybe<Scalars['String']>;
  typeOfEnrollment?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  version?: InputMaybe<Scalars['String']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our create `Patient` mutation. */
export interface CreatePatientPayload {
  __typename: 'CreatePatientPayload';
  /** Reads a single `Admin` that is related to this `Patient`. */
  adminByEnrolledBy: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `Patient` that was created by this mutation. */
  patient: Maybe<Patient>;
  /** An edge for our `Patient`. May be used by Relay 1. */
  patientEdge: Maybe<PatientsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our create `Patient` mutation. */
export interface CreatePatientPayloadPatientEdgeArgs {
  orderBy?: InputMaybe<Array<PatientsOrderBy>>;
}

/** All input for the create `PatientMembershipConfig` mutation. */
export interface CreatePatientMembershipConfigInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `PatientMembershipConfig` to be created by this mutation. */
  patientMembershipConfig: PatientMembershipConfigInput;
}

/** An input for mutations affecting `PatientMembershipConfig` */
export interface PatientMembershipConfigInput {
  /** The admin which owns this patient membership config. */
  adminId: Scalars['UUID'];
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** The group to which patients should be given membership. */
  groupId: Scalars['UUID'];
  id?: InputMaybe<Scalars['UUID']>;
  /** The id of the program to which this payment setup config is related. */
  programId: Scalars['UUID'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our create `PatientMembershipConfig` mutation. */
export interface CreatePatientMembershipConfigPayload {
  __typename: 'CreatePatientMembershipConfigPayload';
  /** Reads a single `Admin` that is related to this `PatientMembershipConfig`. */
  adminByAdminId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Group` that is related to this `PatientMembershipConfig`. */
  groupByGroupId: Maybe<Group>;
  /** The `PatientMembershipConfig` that was created by this mutation. */
  patientMembershipConfig: Maybe<PatientMembershipConfig>;
  /** An edge for our `PatientMembershipConfig`. May be used by Relay 1. */
  patientMembershipConfigEdge: Maybe<PatientMembershipConfigsEdge>;
  /** Reads a single `Program` that is related to this `PatientMembershipConfig`. */
  programByProgramId: Maybe<Program>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our create `PatientMembershipConfig` mutation. */
export interface CreatePatientMembershipConfigPayloadPatientMembershipConfigEdgeArgs {
  orderBy?: InputMaybe<Array<PatientMembershipConfigsOrderBy>>;
}

export interface CreatePatientNoteInput {
  clientMutationId?: InputMaybe<Scalars['String']>;
  patientNote: PatientNoteInput;
}

export interface PatientNoteInput {
  adminId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  note: Scalars['String'];
  patientId: Scalars['UUID'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
}

export interface CreatePatientNotePayload {
  __typename: 'CreatePatientNotePayload';
  clientMutationId: Maybe<Scalars['String']>;
  patientNote: Maybe<PatientNote>;
}

export interface PatientNote {
  __typename: 'PatientNote';
  adminByAdminId: Maybe<Admin>;
  adminId: Maybe<Scalars['UUID']>;
  createdAt: Scalars['Datetime'];
  id: Scalars['UUID'];
  nodeId: Scalars['ID'];
  note: Scalars['String'];
  patientByPatientId: Maybe<Patient>;
  patientId: Scalars['UUID'];
  updatedAt: Scalars['Datetime'];
}

/** All input for the create `PatientStatus` mutation. */
export interface CreatePatientStatusInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `PatientStatus` to be created by this mutation. */
  patientStatus: PatientStatusInput;
}

/** An input for mutations affecting `PatientStatus` */
export interface PatientStatusInput {
  adminId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  patientId: Scalars['UUID'];
  reason: Scalars['String'];
  reasonDetail?: InputMaybe<Scalars['String']>;
  statusTransitionDate: Scalars['Datetime'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our create `PatientStatus` mutation. */
export interface CreatePatientStatusPayload {
  __typename: 'CreatePatientStatusPayload';
  /** Reads a single `Admin` that is related to this `PatientStatus`. */
  adminByAdminId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Patient` that is related to this `PatientStatus`. */
  patientByPatientId: Maybe<Patient>;
  /** The `PatientStatus` that was created by this mutation. */
  patientStatus: Maybe<PatientStatus>;
  /** An edge for our `PatientStatus`. May be used by Relay 1. */
  patientStatusEdge: Maybe<PatientStatusesEdge>;
  /** Reads a single `PatientStatusValue` that is related to this `PatientStatus`. */
  patientStatusValueByValue: Maybe<PatientStatusValue>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our create `PatientStatus` mutation. */
export interface CreatePatientStatusPayloadPatientStatusEdgeArgs {
  orderBy?: InputMaybe<Array<PatientStatusesOrderBy>>;
}

/** All input for the create `PatientStatusValue` mutation. */
export interface CreatePatientStatusValueInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `PatientStatusValue` to be created by this mutation. */
  patientStatusValue: PatientStatusValueInput;
}

/** An input for mutations affecting `PatientStatusValue` */
export interface PatientStatusValueInput {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our create `PatientStatusValue` mutation. */
export interface CreatePatientStatusValuePayload {
  __typename: 'CreatePatientStatusValuePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `PatientStatusValue` that was created by this mutation. */
  patientStatusValue: Maybe<PatientStatusValue>;
  /** An edge for our `PatientStatusValue`. May be used by Relay 1. */
  patientStatusValueEdge: Maybe<PatientStatusValuesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our create `PatientStatusValue` mutation. */
export interface CreatePatientStatusValuePayloadPatientStatusValueEdgeArgs {
  orderBy?: InputMaybe<Array<PatientStatusValuesOrderBy>>;
}

/** All input for the create `Pause` mutation. */
export interface CreatePauseInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Pause` to be created by this mutation. */
  pause: PauseInput;
}

/** An input for mutations affecting `Pause` */
export interface PauseInput {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** The date at which this pause span ends (inclusive), optionally null. */
  endDate?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** The text of the note. */
  note?: InputMaybe<Scalars['String']>;
  /** The reason for pausing a patient. */
  oldReason?: InputMaybe<Scalars['String']>;
  /** The unique identifier of the patient for which the pause is created. */
  patientId: Scalars['UUID'];
  reason?: InputMaybe<Scalars['String']>;
  /** The date at which this pause span starts. */
  startDate?: InputMaybe<Scalars['Date']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our create `Pause` mutation. */
export interface CreatePausePayload {
  __typename: 'CreatePausePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Patient` that is related to this `Pause`. */
  patientByPatientId: Maybe<Patient>;
  /** The `Pause` that was created by this mutation. */
  pause: Maybe<Pause>;
  /** An edge for our `Pause`. May be used by Relay 1. */
  pauseEdge: Maybe<PausesEdge>;
  /** Reads a single `PauseReason` that is related to this `Pause`. */
  pauseReasonByReason: Maybe<PauseReason>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our create `Pause` mutation. */
export interface CreatePausePayloadPauseEdgeArgs {
  orderBy?: InputMaybe<Array<PausesOrderBy>>;
}

/** All input for the create `PauseReason` mutation. */
export interface CreatePauseReasonInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `PauseReason` to be created by this mutation. */
  pauseReason: PauseReasonInput;
}

/** An input for mutations affecting `PauseReason` */
export interface PauseReasonInput {
  automaticInactivation?: InputMaybe<Scalars['Boolean']>;
  automaticUnpause?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
}

/** The output of our create `PauseReason` mutation. */
export interface CreatePauseReasonPayload {
  __typename: 'CreatePauseReasonPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `PauseReason` that was created by this mutation. */
  pauseReason: Maybe<PauseReason>;
  /** An edge for our `PauseReason`. May be used by Relay 1. */
  pauseReasonEdge: Maybe<PauseReasonsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our create `PauseReason` mutation. */
export interface CreatePauseReasonPayloadPauseReasonEdgeArgs {
  orderBy?: InputMaybe<Array<PauseReasonsOrderBy>>;
}

/** All input for the create `PaymentSetup` mutation. */
export interface CreatePaymentSetupInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `PaymentSetup` to be created by this mutation. */
  paymentSetup: PaymentSetupInput;
}

/** An input for mutations affecting `PaymentSetup` */
export interface PaymentSetupInput {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  debitCardId?: InputMaybe<Scalars['UUID']>;
  /** The typically processor-specific configuration details of this config. */
  details?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** Whether this payment setup the default setup for this patient. */
  isDefault?: InputMaybe<Scalars['Boolean']>;
  maxIncrement?: InputMaybe<Scalars['BigFloat']>;
  /** The name of this payment config. */
  name?: InputMaybe<Scalars['String']>;
  /** An optional freetext note about this payment config. */
  note?: InputMaybe<Scalars['String']>;
  /** The patient which owns this payment config. */
  patientId: Scalars['UUID'];
  paymentOptionCode?: InputMaybe<Scalars['String']>;
  /** The payment processor to which this config pertains. */
  processor: PaymentProcessor;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our create `PaymentSetup` mutation. */
export interface CreatePaymentSetupPayload {
  __typename: 'CreatePaymentSetupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `DebitCard` that is related to this `PaymentSetup`. */
  debitCardByDebitCardId: Maybe<DebitCard>;
  /** Reads a single `Patient` that is related to this `PaymentSetup`. */
  patientByPatientId: Maybe<Patient>;
  /** The `PaymentSetup` that was created by this mutation. */
  paymentSetup: Maybe<PaymentSetup>;
  /** An edge for our `PaymentSetup`. May be used by Relay 1. */
  paymentSetupEdge: Maybe<PaymentSetupsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our create `PaymentSetup` mutation. */
export interface CreatePaymentSetupPayloadPaymentSetupEdgeArgs {
  orderBy?: InputMaybe<Array<PaymentSetupsOrderBy>>;
}

export interface CreatePhoneNumberInput {
  clientMutationId?: InputMaybe<Scalars['String']>;
  phoneNumber: PhoneNumberInput;
}

export interface PhoneNumberInput {
  id?: InputMaybe<Scalars['String']>;
  isPrimary: Scalars['Boolean'];
  phoneNumber: Scalars['String'];
  type?: InputMaybe<PhoneNumberType>;
}

export enum PhoneNumberType {
  Canadian = 'canadian',
  FixedVoip = 'fixedVoip',
  Invalid = 'invalid',
  Landline = 'landline',
  Mobile = 'mobile',
  NonFixedVoip = 'nonFixedVoip',
  Pager = 'pager',
  Personal = 'personal',
  Premium = 'premium',
  SharedCost = 'sharedCost',
  TollFree = 'tollFree',
  Uan = 'uan',
  Unknown = 'unknown',
  Voicemail = 'voicemail'
}

export interface CreatePhoneNumberPayload {
  __typename: 'CreatePhoneNumberPayload';
  clientMutationId: Maybe<Scalars['String']>;
  phoneNumber: Maybe<PhoneNumber>;
}

/** All input for the create `PrivilegedAction` mutation. */
export interface CreatePrivilegedActionInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `PrivilegedAction` to be created by this mutation. */
  privilegedAction: PrivilegedActionInput;
}

/** An input for mutations affecting `PrivilegedAction` */
export interface PrivilegedActionInput {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our create `PrivilegedAction` mutation. */
export interface CreatePrivilegedActionPayload {
  __typename: 'CreatePrivilegedActionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `PrivilegedAction` that was created by this mutation. */
  privilegedAction: Maybe<PrivilegedAction>;
  /** An edge for our `PrivilegedAction`. May be used by Relay 1. */
  privilegedActionEdge: Maybe<PrivilegedActionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our create `PrivilegedAction` mutation. */
export interface CreatePrivilegedActionPayloadPrivilegedActionEdgeArgs {
  orderBy?: InputMaybe<Array<PrivilegedActionsOrderBy>>;
}

/** All input for the create `Program` mutation. */
export interface CreateProgramInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Program` to be created by this mutation. */
  program: ProgramInput;
}

/** An input for mutations affecting `Program` */
export interface ProgramInput {
  adminId: Scalars['UUID'];
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customerId?: InputMaybe<Scalars['UUID']>;
  customJson?: InputMaybe<Scalars['JSON']>;
  eligibleForSelfServe?: InputMaybe<Scalars['Boolean']>;
  /** The date of the last day at which this program can be used. */
  expiry: Scalars['Date'];
  icon?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  impactTierFloor?: InputMaybe<Scalars['String']>;
  /** impact tiers bucket prospects in 3 or 4 bins */
  impactTiers?: InputMaybe<Scalars['String']>;
  /** The amount of days a member has been paused that will automatically inactivated them. */
  inactivateAfterPausedDays?: InputMaybe<Scalars['Int']>;
  /** Amount of days after reward period or reminder end date that will automatically inactivate member */
  inactivateDaysAfterEndDate?: InputMaybe<Scalars['Int']>;
  isDoNotCallSuppressionEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Per-program kill switch for the automated eligibility-loss pause/notify workflow. */
  isEligibilityAutomationEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Flag to determine is creation is suppressed for the program */
  isProspectCreationSuppressed?: InputMaybe<Scalars['Boolean']>;
  /** Flag to determine is reopening is suppressed for the program */
  isProspectReopeningSuppressed?: InputMaybe<Scalars['Boolean']>;
  isProspectWorkflowsEnabled?: InputMaybe<Scalars['Boolean']>;
  isTestProgram?: InputMaybe<Scalars['Boolean']>;
  isUploaderDisabled?: InputMaybe<Scalars['Boolean']>;
  /** The maximum number of times this program can be used across all patients cumulatively */
  maximumUses?: InputMaybe<Scalars['Int']>;
  /** arbitrary reward max used in UX communications */
  maxRewards?: InputMaybe<Scalars['BigFloat']>;
  /** The name of the program */
  name: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  notificationPolicyId?: InputMaybe<Scalars['UUID']>;
  pauseAfterNoActivityDays?: InputMaybe<Scalars['Int']>;
  /** The unique textual code of the program */
  programCode: Scalars['String'];
  programTemplate?: InputMaybe<Scalars['String']>;
  /** Describes which health care sector the program is associated with */
  sector?: InputMaybe<Scalars['String']>;
  skipBloodPressureDetection?: InputMaybe<Scalars['Boolean']>;
  skipGlucoseDetection?: InputMaybe<Scalars['Boolean']>;
  skipMealDetection?: InputMaybe<Scalars['Boolean']>;
  skipMedicationDetection?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** The number of times this program has been used */
  useCount?: InputMaybe<Scalars['Int']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our create `Program` mutation. */
export interface CreateProgramPayload {
  __typename: 'CreateProgramPayload';
  /** Reads a single `Admin` that is related to this `Program`. */
  adminByAdminId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Customer` that is related to this `Program`. */
  customerByCustomerId: Maybe<Customer>;
  /** The `Program` that was created by this mutation. */
  program: Maybe<Program>;
  /** An edge for our `Program`. May be used by Relay 1. */
  programEdge: Maybe<ProgramsEdge>;
  /** Reads a single `ProgramTemplate` that is related to this `Program`. */
  programTemplateByProgramTemplate: Maybe<ProgramTemplate>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our create `Program` mutation. */
export interface CreateProgramPayloadProgramEdgeArgs {
  orderBy?: InputMaybe<Array<ProgramsOrderBy>>;
}

/** All input for the create `ProgramMfaConfig` mutation. */
export interface CreateProgramMfaConfigInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProgramMfaConfig` to be created by this mutation. */
  programMfaConfig: ProgramMfaConfigInput;
}

/** An input for mutations affecting `ProgramMfaConfig` */
export interface ProgramMfaConfigInput {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  isMfaRequired?: InputMaybe<Scalars['Boolean']>;
  mfaExpireMinutes?: InputMaybe<Scalars['Int']>;
  numSecurityQuestions?: InputMaybe<Scalars['Int']>;
  programId: Scalars['UUID'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
}

/** The output of our create `ProgramMfaConfig` mutation. */
export interface CreateProgramMfaConfigPayload {
  __typename: 'CreateProgramMfaConfigPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Program` that is related to this `ProgramMfaConfig`. */
  programByProgramId: Maybe<Program>;
  /** The `ProgramMfaConfig` that was created by this mutation. */
  programMfaConfig: Maybe<ProgramMfaConfig>;
  /** An edge for our `ProgramMfaConfig`. May be used by Relay 1. */
  programMfaConfigEdge: Maybe<ProgramMfaConfigsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our create `ProgramMfaConfig` mutation. */
export interface CreateProgramMfaConfigPayloadProgramMfaConfigEdgeArgs {
  orderBy?: InputMaybe<Array<ProgramMfaConfigsOrderBy>>;
}

/** All input for the create `ProgramOutreachSubmission` mutation. */
export interface CreateProgramOutreachSubmissionInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProgramOutreachSubmission` to be created by this mutation. */
  programOutreachSubmission: ProgramOutreachSubmissionInput;
}

/** An input for mutations affecting `ProgramOutreachSubmission` */
export interface ProgramOutreachSubmissionInput {
  birthDate?: InputMaybe<Scalars['Date']>;
  /** Humana only: whether the member reports taking their blood pressure or blood glucose daily ("yes"/"no"; NULL for other programs). Self-reported eligibility signal; raw_payload keeps the verbatim submitted value. */
  checksBpBg?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  emailPrimary?: InputMaybe<Scalars['String']>;
  /** Submitted Member ID; groups a member's submissions within a program (non-unique — every submission is its own row). */
  externalId: Scalars['String'];
  familyName?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  mailingAddressCity?: InputMaybe<Scalars['String']>;
  mailingAddressLine1?: InputMaybe<Scalars['String']>;
  mailingAddressLine2?: InputMaybe<Scalars['String']>;
  mailingAddressState?: InputMaybe<Scalars['String']>;
  mailingAddressZipCode?: InputMaybe<Scalars['String']>;
  phonePrimary?: InputMaybe<Scalars['String']>;
  /** Program/campaign slug (e.g. uhc); resolved to a program_id during matching. */
  program: Scalars['String'];
  /** Full submitted payload, verbatim (agreed program data-spec field names plus any extras). */
  rawPayload: Scalars['JSON'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
}

/** The output of our create `ProgramOutreachSubmission` mutation. */
export interface CreateProgramOutreachSubmissionPayload {
  __typename: 'CreateProgramOutreachSubmissionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `ProgramOutreachSubmission` that was created by this mutation. */
  programOutreachSubmission: Maybe<ProgramOutreachSubmission>;
  /** An edge for our `ProgramOutreachSubmission`. May be used by Relay 1. */
  programOutreachSubmissionEdge: Maybe<ProgramOutreachSubmissionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our create `ProgramOutreachSubmission` mutation. */
export interface CreateProgramOutreachSubmissionPayloadProgramOutreachSubmissionEdgeArgs {
  orderBy?: InputMaybe<Array<ProgramOutreachSubmissionsOrderBy>>;
}

/** All input for the create `ProgramReward` mutation. */
export interface CreateProgramRewardInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProgramReward` to be created by this mutation. */
  programReward: ProgramRewardInput;
}

/** An input for mutations affecting `ProgramReward` */
export interface ProgramRewardInput {
  accountTransactionId?: InputMaybe<Scalars['UUID']>;
  /** expected reason is expired, but future proofing for other reasons */
  closeReason?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** tracks the wellth internal reward name for convenience */
  name: Scalars['String'];
  patientId: Scalars['UUID'];
  programRewardConfigId: Scalars['UUID'];
  rewardCurrency?: InputMaybe<Currency>;
  rewardedAmount?: InputMaybe<Scalars['BigFloat']>;
  /** expiry is config end_date for eligible; config end_date+grace_period for redeemable; redeemable means ready-to-redeem */
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our create `ProgramReward` mutation. */
export interface CreateProgramRewardPayload {
  __typename: 'CreateProgramRewardPayload';
  /** Reads a single `AccountTransaction` that is related to this `ProgramReward`. */
  accountTransactionByAccountTransactionId: Maybe<AccountTransaction>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Patient` that is related to this `ProgramReward`. */
  patientByPatientId: Maybe<Patient>;
  /** The `ProgramReward` that was created by this mutation. */
  programReward: Maybe<ProgramReward>;
  /** Reads a single `ProgramRewardConfig` that is related to this `ProgramReward`. */
  programRewardConfigByName: Maybe<ProgramRewardConfig>;
  /** Reads a single `ProgramRewardConfig` that is related to this `ProgramReward`. */
  programRewardConfigByProgramRewardConfigId: Maybe<ProgramRewardConfig>;
  /** An edge for our `ProgramReward`. May be used by Relay 1. */
  programRewardEdge: Maybe<ProgramRewardsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our create `ProgramReward` mutation. */
export interface CreateProgramRewardPayloadProgramRewardEdgeArgs {
  orderBy?: InputMaybe<Array<ProgramRewardsOrderBy>>;
}

/** All input for the create `ProgramRewardConfig` mutation. */
export interface CreateProgramRewardConfigInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProgramRewardConfig` to be created by this mutation. */
  programRewardConfig: ProgramRewardConfigInput;
}

/** An input for mutations affecting `ProgramRewardConfig` */
export interface ProgramRewardConfigInput {
  /** toggles rewards on or off */
  active?: InputMaybe<Scalars['Boolean']>;
  adminId: Scalars['UUID'];
  createdAt?: InputMaybe<Scalars['Datetime']>;
  descStringKey?: InputMaybe<Scalars['String']>;
  /** if all enrolled members should get this reward; vs segmentation or client caregap/tbd */
  eligibleForAll?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['Date'];
  /** number of days after end_date the rewards remains redeemable */
  gracePeriod?: InputMaybe<Scalars['Int']>;
  icon?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** does the reward move from eligible=>rewarded or eligible=>redeemable */
  instantRedeem?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  programId: Scalars['UUID'];
  rewardAmount: Scalars['BigFloat'];
  rewardCurrency?: InputMaybe<Currency>;
  /** enum list of reward events like ENROLLED, ADDRESS_CONFIRMED, EMAIL_CONFIRMED, BREAST_CANCER_SCREEN etc */
  rewardEvent: Scalars['String'];
  startDate: Scalars['Date'];
  titleStringKey?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our create `ProgramRewardConfig` mutation. */
export interface CreateProgramRewardConfigPayload {
  __typename: 'CreateProgramRewardConfigPayload';
  /** Reads a single `Admin` that is related to this `ProgramRewardConfig`. */
  adminByAdminId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Program` that is related to this `ProgramRewardConfig`. */
  programByProgramId: Maybe<Program>;
  /** The `ProgramRewardConfig` that was created by this mutation. */
  programRewardConfig: Maybe<ProgramRewardConfig>;
  /** An edge for our `ProgramRewardConfig`. May be used by Relay 1. */
  programRewardConfigEdge: Maybe<ProgramRewardConfigsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our create `ProgramRewardConfig` mutation. */
export interface CreateProgramRewardConfigPayloadProgramRewardConfigEdgeArgs {
  orderBy?: InputMaybe<Array<ProgramRewardConfigsOrderBy>>;
}

/** All input for the create `ProgramTemplate` mutation. */
export interface CreateProgramTemplateInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProgramTemplate` to be created by this mutation. */
  programTemplate: ProgramTemplateInput;
}

/** An input for mutations affecting `ProgramTemplate` */
export interface ProgramTemplateInput {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
}

/** The output of our create `ProgramTemplate` mutation. */
export interface CreateProgramTemplatePayload {
  __typename: 'CreateProgramTemplatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `ProgramTemplate` that was created by this mutation. */
  programTemplate: Maybe<ProgramTemplate>;
  /** An edge for our `ProgramTemplate`. May be used by Relay 1. */
  programTemplateEdge: Maybe<ProgramTemplatesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our create `ProgramTemplate` mutation. */
export interface CreateProgramTemplatePayloadProgramTemplateEdgeArgs {
  orderBy?: InputMaybe<Array<ProgramTemplatesOrderBy>>;
}

export interface CreateProspectInput {
  clientMutationId?: InputMaybe<Scalars['String']>;
  prospectInput: ProspectInput;
}

export interface ProspectInput {
  externalId?: InputMaybe<Scalars['String']>;
  isTestProspect?: InputMaybe<Scalars['Boolean']>;
  person?: InputMaybe<PersonInput>;
  programCode?: InputMaybe<Scalars['String']>;
}

export interface PersonInput {
  address?: InputMaybe<AddressInput>;
  birthDate: Scalars['String'];
  emailAddress?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phoneNumber: Scalars['String'];
}

export interface CreateProspectPayload {
  __typename: 'CreateProspectPayload';
  clientMutationId: Maybe<Scalars['String']>;
  prospect: Maybe<Prospect>;
}

export interface CreateProspectForInactiveMemberInput {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

export interface CreateProspectNoteInput {
  clientMutationId?: InputMaybe<Scalars['String']>;
  prospectNoteInput: ProspectNoteInput;
}

export interface ProspectNoteInput {
  note: Scalars['String'];
  prospectId: Scalars['UUID'];
}

export interface CreateProspectNotePayload {
  __typename: 'CreateProspectNotePayload';
  clientMutationId: Maybe<Scalars['String']>;
  prospectNote: Maybe<ProspectNote>;
}

/** All input for the create `ProspectStatus` mutation. */
export interface CreateProspectStatusInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProspectStatus` to be created by this mutation. */
  prospectStatus: ProspectStatusInput;
}

/** An input for mutations affecting `ProspectStatus` */
export interface ProspectStatusInput {
  adminId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  prospectId?: InputMaybe<Scalars['UUID']>;
  reason?: InputMaybe<Scalars['String']>;
  reasonDetail?: InputMaybe<Scalars['String']>;
  statusTransitionDate: Scalars['Datetime'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our create `ProspectStatus` mutation. */
export interface CreateProspectStatusPayload {
  __typename: 'CreateProspectStatusPayload';
  /** Reads a single `Admin` that is related to this `ProspectStatus`. */
  adminByAdminId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `ProspectStatus` that was created by this mutation. */
  prospectStatus: Maybe<ProspectStatus>;
  /** An edge for our `ProspectStatus`. May be used by Relay 1. */
  prospectStatusEdge: Maybe<ProspectStatusesEdge>;
  /** Reads a single `ProspectStatusValue` that is related to this `ProspectStatus`. */
  prospectStatusValueByValue: Maybe<ProspectStatusValue>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our create `ProspectStatus` mutation. */
export interface CreateProspectStatusPayloadProspectStatusEdgeArgs {
  orderBy?: InputMaybe<Array<ProspectStatusesOrderBy>>;
}

/** All input for the create `ProspectStatusValue` mutation. */
export interface CreateProspectStatusValueInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProspectStatusValue` to be created by this mutation. */
  prospectStatusValue: ProspectStatusValueInput;
}

/** An input for mutations affecting `ProspectStatusValue` */
export interface ProspectStatusValueInput {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our create `ProspectStatusValue` mutation. */
export interface CreateProspectStatusValuePayload {
  __typename: 'CreateProspectStatusValuePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `ProspectStatusValue` that was created by this mutation. */
  prospectStatusValue: Maybe<ProspectStatusValue>;
  /** An edge for our `ProspectStatusValue`. May be used by Relay 1. */
  prospectStatusValueEdge: Maybe<ProspectStatusValuesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our create `ProspectStatusValue` mutation. */
export interface CreateProspectStatusValuePayloadProspectStatusValueEdgeArgs {
  orderBy?: InputMaybe<Array<ProspectStatusValuesOrderBy>>;
}

/** All input for the create `PushNotification` mutation. */
export interface CreatePushNotificationInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `PushNotification` to be created by this mutation. */
  pushNotification: PushNotificationInput;
}

/** An input for mutations affecting `PushNotification` */
export interface PushNotificationInput {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** The patient to whom this push notification is sent */
  patientId: Scalars['UUID'];
  /** The data payload that should be or was relayed to the push notification delivery service. */
  payload: Scalars['JSON'];
  /** The time at which this push notification was sent. */
  sentDatetime?: InputMaybe<Scalars['Datetime']>;
  /** The status of the push notification. */
  status?: InputMaybe<PushNotificationStatus>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our create `PushNotification` mutation. */
export interface CreatePushNotificationPayload {
  __typename: 'CreatePushNotificationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Patient` that is related to this `PushNotification`. */
  patientByPatientId: Maybe<Patient>;
  /** The `PushNotification` that was created by this mutation. */
  pushNotification: Maybe<PushNotification>;
  /** An edge for our `PushNotification`. May be used by Relay 1. */
  pushNotificationEdge: Maybe<PushNotificationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our create `PushNotification` mutation. */
export interface CreatePushNotificationPayloadPushNotificationEdgeArgs {
  orderBy?: InputMaybe<Array<PushNotificationsOrderBy>>;
}

/** All input for the create `PushToken` mutation. */
export interface CreatePushTokenInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `PushToken` to be created by this mutation. */
  pushToken: PushTokenInput;
}

/** An input for mutations affecting `PushToken` */
export interface PushTokenInput {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** The identifier created for this token by the mobile phone device. */
  deviceIdentifier: Scalars['String'];
  /** The third-party handler of these push tokens, used to send the actual notifications. */
  handler?: InputMaybe<PushTokenHandler>;
  id?: InputMaybe<Scalars['UUID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** The patient who created this push token. */
  patientId: Scalars['UUID'];
  /** The identifier generated by the remote service (e.g. SNS) as an endpoint identifier. */
  remoteIdentifier?: InputMaybe<Scalars['String']>;
  /** The service for which this push token is registered. */
  service: PushTokenService;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our create `PushToken` mutation. */
export interface CreatePushTokenPayload {
  __typename: 'CreatePushTokenPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Patient` that is related to this `PushToken`. */
  patientByPatientId: Maybe<Patient>;
  /** The `PushToken` that was created by this mutation. */
  pushToken: Maybe<PushToken>;
  /** An edge for our `PushToken`. May be used by Relay 1. */
  pushTokenEdge: Maybe<PushTokensEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our create `PushToken` mutation. */
export interface CreatePushTokenPayloadPushTokenEdgeArgs {
  orderBy?: InputMaybe<Array<PushTokensOrderBy>>;
}

/** All input for the create `RawIncomingDatum` mutation. */
export interface CreateRawIncomingDatumInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RawIncomingDatum` to be created by this mutation. */
  rawIncomingDatum: RawIncomingDatumInput;
}

/** An input for mutations affecting `RawIncomingDatum` */
export interface RawIncomingDatumInput {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** A JSON-formatted chunk of data.  No particular schema is enforced. */
  data: Scalars['JSON'];
  id?: InputMaybe<Scalars['UUID']>;
  /** The source of the data, e.g. twilio or bodytrace */
  source: RawIncomingDataSource;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our create `RawIncomingDatum` mutation. */
export interface CreateRawIncomingDatumPayload {
  __typename: 'CreateRawIncomingDatumPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `RawIncomingDatum` that was created by this mutation. */
  rawIncomingDatum: Maybe<RawIncomingDatum>;
  /** An edge for our `RawIncomingDatum`. May be used by Relay 1. */
  rawIncomingDatumEdge: Maybe<RawIncomingDataEdge>;
}


/** The output of our create `RawIncomingDatum` mutation. */
export interface CreateRawIncomingDatumPayloadRawIncomingDatumEdgeArgs {
  orderBy?: InputMaybe<Array<RawIncomingDataOrderBy>>;
}

/** All input for the create `Reminder` mutation. */
export interface CreateReminderInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Reminder` to be created by this mutation. */
  reminder: ReminderInput;
}

/** An input for mutations affecting `Reminder` */
export interface ReminderInput {
  /** The check_in category of the reminder, used to determine what kind of check_in to create. */
  checkInCategory: CheckInCategory;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** The date at which this reminder span ends (inclusive), optionally null. */
  endDate?: InputMaybe<Scalars['Date']>;
  /** The time at which this reminder is due on Friday. */
  friTime: Scalars['Time'];
  id?: InputMaybe<Scalars['UUID']>;
  interval?: InputMaybe<ReminderInterval>;
  intervalCount?: InputMaybe<Scalars['Int']>;
  /** Whether the reminder should appear as a demo flow in the application. */
  isDemo?: InputMaybe<Scalars['Boolean']>;
  /** Whether completing the reminder is required in order to earn incentives for the day. */
  isRequired?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  linkedFutureReminderId?: InputMaybe<Scalars['UUID']>;
  /** The time at which this reminder is due on Monday. */
  monTime: Scalars['Time'];
  patientId: Scalars['UUID'];
  /** The reminder_config from which this reminder was created, if one existed. */
  reminderConfigId?: InputMaybe<Scalars['UUID']>;
  /** The time at which this reminder is due on Saturday. */
  satTime: Scalars['Time'];
  /** The date at which this reminder span starts. */
  startDate?: InputMaybe<Scalars['Date']>;
  /** The time at which this reminder is due on Sunday. */
  sunTime: Scalars['Time'];
  /** The time at which this reminder is due on Thursday. */
  thuTime: Scalars['Time'];
  /** The time at which this reminder is due on Tuesday. */
  tueTime: Scalars['Time'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
  /** The time at which this reminder is due on Wednesday. */
  wedTime: Scalars['Time'];
  /** The duration of the window after the due time. */
  windowAfterMinutes?: InputMaybe<Scalars['Int']>;
  /** The duration of the window before the due time. */
  windowBeforeMinutes?: InputMaybe<Scalars['Int']>;
}

/** The output of our create `Reminder` mutation. */
export interface CreateReminderPayload {
  __typename: 'CreateReminderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Patient` that is related to this `Reminder`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `Reminder` that was created by this mutation. */
  reminder: Maybe<Reminder>;
  /** Reads a single `Reminder` that is related to this `Reminder`. */
  reminderByLinkedFutureReminderId: Maybe<Reminder>;
  /** Reads a single `ReminderConfig` that is related to this `Reminder`. */
  reminderConfigByReminderConfigId: Maybe<ReminderConfig>;
  /** An edge for our `Reminder`. May be used by Relay 1. */
  reminderEdge: Maybe<RemindersEdge>;
}


/** The output of our create `Reminder` mutation. */
export interface CreateReminderPayloadReminderEdgeArgs {
  orderBy?: InputMaybe<Array<RemindersOrderBy>>;
}

/** All input for the create `ReminderConfig` mutation. */
export interface CreateReminderConfigInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ReminderConfig` to be created by this mutation. */
  reminderConfig: ReminderConfigInput;
}

/** An input for mutations affecting `ReminderConfig` */
export interface ReminderConfigInput {
  /** The administrator which created and owns this reminder config. */
  adminId: Scalars['UUID'];
  /** The check_in category of the reminder_config, used to determine what kind of check_in to create. */
  checkInCategory: CheckInCategory;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** The time at which this reminder is due on Friday. */
  friTime: Scalars['Time'];
  id?: InputMaybe<Scalars['UUID']>;
  interval?: InputMaybe<ReminderInterval>;
  intervalCount?: InputMaybe<Scalars['Int']>;
  /** Whether the reminder should appear as a demo flow in the application. */
  isDemo?: InputMaybe<Scalars['Boolean']>;
  /** Whether completing the reminder is required in order to earn incentives for the day. */
  isRequired?: InputMaybe<Scalars['Boolean']>;
  /** The number of days for which this reminder should run. */
  lengthInDays: Scalars['Int'];
  /** The time at which this reminder is due on Monday. */
  monTime: Scalars['Time'];
  /** A reference to the program to which this reminder_config is tied. */
  programId: Scalars['UUID'];
  /** The time at which this reminder is due on Saturday. */
  satTime: Scalars['Time'];
  selfServeDefault?: InputMaybe<Scalars['Boolean']>;
  /** The number of days after the 0th program start day at which this reminder should start. */
  startDayIndex: Scalars['Int'];
  /** The time at which this reminder is due on Sunday. */
  sunTime: Scalars['Time'];
  /** The time at which this reminder is due on Thursday. */
  thuTime: Scalars['Time'];
  /** The time at which this reminder is due on Tuesday. */
  tueTime: Scalars['Time'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
  /** The time at which this reminder is due on Wednesday. */
  wedTime: Scalars['Time'];
  /** The duration of the window after the due time. */
  windowAfterMinutes: Scalars['Int'];
  /** The duration of the window before the due time. */
  windowBeforeMinutes: Scalars['Int'];
}

/** The output of our create `ReminderConfig` mutation. */
export interface CreateReminderConfigPayload {
  __typename: 'CreateReminderConfigPayload';
  /** Reads a single `Admin` that is related to this `ReminderConfig`. */
  adminByAdminId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Program` that is related to this `ReminderConfig`. */
  programByProgramId: Maybe<Program>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `ReminderConfig` that was created by this mutation. */
  reminderConfig: Maybe<ReminderConfig>;
  /** An edge for our `ReminderConfig`. May be used by Relay 1. */
  reminderConfigEdge: Maybe<ReminderConfigsEdge>;
}


/** The output of our create `ReminderConfig` mutation. */
export interface CreateReminderConfigPayloadReminderConfigEdgeArgs {
  orderBy?: InputMaybe<Array<ReminderConfigsOrderBy>>;
}

/** All input for the create `ReminderMessage` mutation. */
export interface CreateReminderMessageInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ReminderMessage` to be created by this mutation. */
  reminderMessage: ReminderMessageInput;
}

/** An input for mutations affecting `ReminderMessage` */
export interface ReminderMessageInput {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** The id of the actual SMS message that was sent to remind the patient */
  messageId?: InputMaybe<Scalars['UUID']>;
  /** The time for which the message was sent */
  messageTime: Scalars['Time'];
  /** The type of reminder message this is; can be "midwindow" or "nearend" */
  messageType: ReminderMessageType;
  /** The number of minutes remaining in the window when the reminder message was generated */
  minutesRemaining: Scalars['Int'];
  /** The id of the patient to whom this reminder message will be sent */
  patientId: Scalars['UUID'];
  /** The day on which the reminder was due */
  reminderDay: Scalars['Date'];
  /** The id of the reminder that this message references */
  reminderId: Scalars['UUID'];
  /** The time at which the reminder was due */
  reminderTime: Scalars['Time'];
  /** The status of the reminder message; can be "pending" or "message_created" */
  status?: InputMaybe<ReminderMessageStatus>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our create `ReminderMessage` mutation. */
export interface CreateReminderMessagePayload {
  __typename: 'CreateReminderMessagePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Message` that is related to this `ReminderMessage`. */
  messageByMessageId: Maybe<Message>;
  /** Reads a single `Patient` that is related to this `ReminderMessage`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Reminder` that is related to this `ReminderMessage`. */
  reminderByReminderId: Maybe<Reminder>;
  /** The `ReminderMessage` that was created by this mutation. */
  reminderMessage: Maybe<ReminderMessage>;
  /** An edge for our `ReminderMessage`. May be used by Relay 1. */
  reminderMessageEdge: Maybe<ReminderMessagesEdge>;
}


/** The output of our create `ReminderMessage` mutation. */
export interface CreateReminderMessagePayloadReminderMessageEdgeArgs {
  orderBy?: InputMaybe<Array<ReminderMessagesOrderBy>>;
}

/** All input for the create `RewardPeriod` mutation. */
export interface CreateRewardPeriodInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RewardPeriod` to be created by this mutation. */
  rewardPeriod: RewardPeriodInput;
}

/** An input for mutations affecting `RewardPeriod` */
export interface RewardPeriodInput {
  appointmentLoss?: InputMaybe<Scalars['BigFloat']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** The date at which this reward_period should end. */
  endDate: Scalars['Date'];
  id?: InputMaybe<Scalars['UUID']>;
  /** The maximum loss per day. */
  lossPerDayMax: Scalars['BigFloat'];
  /** The type of loss for this reward period; default "fixed". */
  lossType?: InputMaybe<LossType>;
  /** The patient which owns this reward_period. */
  patientId: Scalars['UUID'];
  /** The maximum amount of money which is possible to receive during this period. */
  rewardAmount: Scalars['BigFloat'];
  /** The currency of the reward. */
  rewardCurrency?: InputMaybe<Currency>;
  /** A reference to the reward_period_config from which this reward_period was generated (if applicable). */
  rewardPeriodConfigId?: InputMaybe<Scalars['UUID']>;
  settledAt?: InputMaybe<Scalars['Datetime']>;
  settleDate: Scalars['Date'];
  /** The date at which this reward_period should start. */
  startDate: Scalars['Date'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
  winBackStrategy?: InputMaybe<WinBackStrategy>;
}

/** The output of our create `RewardPeriod` mutation. */
export interface CreateRewardPeriodPayload {
  __typename: 'CreateRewardPeriodPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Patient` that is related to this `RewardPeriod`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `RewardPeriod` that was created by this mutation. */
  rewardPeriod: Maybe<RewardPeriod>;
  /** Reads a single `RewardPeriodConfig` that is related to this `RewardPeriod`. */
  rewardPeriodConfigByRewardPeriodConfigId: Maybe<RewardPeriodConfig>;
  /** An edge for our `RewardPeriod`. May be used by Relay 1. */
  rewardPeriodEdge: Maybe<RewardPeriodsEdge>;
}


/** The output of our create `RewardPeriod` mutation. */
export interface CreateRewardPeriodPayloadRewardPeriodEdgeArgs {
  orderBy?: InputMaybe<Array<RewardPeriodsOrderBy>>;
}

/** All input for the create `RewardPeriodConfig` mutation. */
export interface CreateRewardPeriodConfigInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RewardPeriodConfig` to be created by this mutation. */
  rewardPeriodConfig: RewardPeriodConfigInput;
}

/** An input for mutations affecting `RewardPeriodConfig` */
export interface RewardPeriodConfigInput {
  /** The administrator which created and owns this reward_period_config. */
  adminId: Scalars['UUID'];
  appointmentLoss?: InputMaybe<Scalars['BigFloat']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** The numeric of days for which this reward_period should run. */
  lengthInDays: Scalars['Int'];
  /** The maximum loss per day. */
  lossPerDayMax: Scalars['BigFloat'];
  /** The type of loss for this reward period; default "fixed". */
  lossType?: InputMaybe<LossType>;
  /** A reference to the program to which this reward_period_config is tied. */
  programId: Scalars['UUID'];
  /** The maximum amount of money which is possible to receive during this period. */
  rewardAmount: Scalars['BigFloat'];
  /** The currency of the reward. */
  rewardCurrency?: InputMaybe<Currency>;
  /** The numeric of days after the 0th program start day at which this reward_period should start. */
  startDayIndex: Scalars['Int'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
  winBackStrategy?: InputMaybe<WinBackStrategy>;
}

/** The output of our create `RewardPeriodConfig` mutation. */
export interface CreateRewardPeriodConfigPayload {
  __typename: 'CreateRewardPeriodConfigPayload';
  /** Reads a single `Admin` that is related to this `RewardPeriodConfig`. */
  adminByAdminId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Program` that is related to this `RewardPeriodConfig`. */
  programByProgramId: Maybe<Program>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `RewardPeriodConfig` that was created by this mutation. */
  rewardPeriodConfig: Maybe<RewardPeriodConfig>;
  /** An edge for our `RewardPeriodConfig`. May be used by Relay 1. */
  rewardPeriodConfigEdge: Maybe<RewardPeriodConfigsEdge>;
}


/** The output of our create `RewardPeriodConfig` mutation. */
export interface CreateRewardPeriodConfigPayloadRewardPeriodConfigEdgeArgs {
  orderBy?: InputMaybe<Array<RewardPeriodConfigsOrderBy>>;
}

/** All input for the create `SmsAutoResponder` mutation. */
export interface CreateSmsAutoResponderInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `SmsAutoResponder` to be created by this mutation. */
  smsAutoResponder: SmsAutoResponderInput;
}

/** An input for mutations affecting `SmsAutoResponder` */
export interface SmsAutoResponderInput {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** The UTC end timestamp of the sms auto responder */
  endTimestamp: Scalars['Datetime'];
  id?: InputMaybe<Scalars['UUID']>;
  /** The sms auto response message string key. */
  messageKey?: InputMaybe<Scalars['String']>;
  /** The reference name of the timeframe which an automatic response will be sent. */
  name: Scalars['String'];
  /** The UTC start timestamp of the sms auto responder */
  startTimestamp: Scalars['Datetime'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our create `SmsAutoResponder` mutation. */
export interface CreateSmsAutoResponderPayload {
  __typename: 'CreateSmsAutoResponderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `SmsAutoResponder` that was created by this mutation. */
  smsAutoResponder: Maybe<SmsAutoResponder>;
  /** An edge for our `SmsAutoResponder`. May be used by Relay 1. */
  smsAutoResponderEdge: Maybe<SmsAutoRespondersEdge>;
}


/** The output of our create `SmsAutoResponder` mutation. */
export interface CreateSmsAutoResponderPayloadSmsAutoResponderEdgeArgs {
  orderBy?: InputMaybe<Array<SmsAutoRespondersOrderBy>>;
}

/** All input for the create `SmsOutreachMessage` mutation. */
export interface CreateSmsOutreachMessageInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `SmsOutreachMessage` to be created by this mutation. */
  smsOutreachMessage: SmsOutreachMessageInput;
}

/** An input for mutations affecting `SmsOutreachMessage` */
export interface SmsOutreachMessageInput {
  adminId?: InputMaybe<Scalars['UUID']>;
  /** Timestamp of when to automatically approve message */
  approveAt?: InputMaybe<Scalars['Datetime']>;
  /** The date the message was approved. */
  approvedAt?: InputMaybe<Scalars['Datetime']>;
  approvedBy?: InputMaybe<Scalars['UUID']>;
  batchLabel?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** Determines if a outreach message is auto approvable */
  isAutoApprove?: InputMaybe<Scalars['Boolean']>;
  /** The content of the message. */
  message: Scalars['String'];
  messageTemplateId: Scalars['UUID'];
  /** The protocol over which the message was sent. */
  protocol?: InputMaybe<SmsOutreachMessageProtocol>;
  /** The time at which this message was read by the recipient. */
  readDatetime?: InputMaybe<Scalars['Datetime']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  /** The party who is the recipient of this message. */
  recipientType: SmsOutreachMessageRecipientType;
  /** The date to send message after. */
  sendAfter?: InputMaybe<Scalars['Datetime']>;
  /** The date the message was sent. */
  sentDatetime?: InputMaybe<Scalars['Datetime']>;
  /** The status of the message. */
  status?: InputMaybe<SmsOutreachMessageStatus>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our create `SmsOutreachMessage` mutation. */
export interface CreateSmsOutreachMessagePayload {
  __typename: 'CreateSmsOutreachMessagePayload';
  /** Reads a single `Admin` that is related to this `SmsOutreachMessage`. */
  adminByAdminId: Maybe<Admin>;
  /** Reads a single `Admin` that is related to this `SmsOutreachMessage`. */
  adminByApprovedBy: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `SmsOutreachMessage` that was created by this mutation. */
  smsOutreachMessage: Maybe<SmsOutreachMessage>;
  /** An edge for our `SmsOutreachMessage`. May be used by Relay 1. */
  smsOutreachMessageEdge: Maybe<SmsOutreachMessagesEdge>;
  /** Reads a single `SmsOutreachMessageTemplate` that is related to this `SmsOutreachMessage`. */
  smsOutreachMessageTemplateByMessageTemplateId: Maybe<SmsOutreachMessageTemplate>;
  /** Reads a single `SmsOutreachRecipient` that is related to this `SmsOutreachMessage`. */
  smsOutreachRecipientByRecipientId: Maybe<SmsOutreachRecipient>;
}


/** The output of our create `SmsOutreachMessage` mutation. */
export interface CreateSmsOutreachMessagePayloadSmsOutreachMessageEdgeArgs {
  orderBy?: InputMaybe<Array<SmsOutreachMessagesOrderBy>>;
}

/** All input for the create `SmsOutreachMessageTemplate` mutation. */
export interface CreateSmsOutreachMessageTemplateInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `SmsOutreachMessageTemplate` to be created by this mutation. */
  smsOutreachMessageTemplate: SmsOutreachMessageTemplateInput;
}

/** An input for mutations affecting `SmsOutreachMessageTemplate` */
export interface SmsOutreachMessageTemplateInput {
  adminId?: InputMaybe<Scalars['UUID']>;
  /** The creation timestamp of a message template. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** Determines if a outreach message template is active. */
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** The content of the message. */
  message: Scalars['String'];
  /** Title for the Sms Template. */
  title?: InputMaybe<Scalars['String']>;
  /** The timestamp when message template was updated. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our create `SmsOutreachMessageTemplate` mutation. */
export interface CreateSmsOutreachMessageTemplatePayload {
  __typename: 'CreateSmsOutreachMessageTemplatePayload';
  /** Reads a single `Admin` that is related to this `SmsOutreachMessageTemplate`. */
  adminByAdminId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `SmsOutreachMessageTemplate` that was created by this mutation. */
  smsOutreachMessageTemplate: Maybe<SmsOutreachMessageTemplate>;
  /** An edge for our `SmsOutreachMessageTemplate`. May be used by Relay 1. */
  smsOutreachMessageTemplateEdge: Maybe<SmsOutreachMessageTemplatesEdge>;
}


/** The output of our create `SmsOutreachMessageTemplate` mutation. */
export interface CreateSmsOutreachMessageTemplatePayloadSmsOutreachMessageTemplateEdgeArgs {
  orderBy?: InputMaybe<Array<SmsOutreachMessageTemplatesOrderBy>>;
}

/** All input for the create `SmsOutreachRecipient` mutation. */
export interface CreateSmsOutreachRecipientInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `SmsOutreachRecipient` to be created by this mutation. */
  smsOutreachRecipient: SmsOutreachRecipientInput;
}

/** An input for mutations affecting `SmsOutreachRecipient` */
export interface SmsOutreachRecipientInput {
  adminId?: InputMaybe<Scalars['UUID']>;
  /** The sms client's birth date. */
  birthDate?: InputMaybe<Scalars['Date']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** The sms client's customer id. */
  customerId?: InputMaybe<Scalars['String']>;
  /** The sms client's first name. */
  firstName?: InputMaybe<Scalars['String']>;
  /** The sms client's group id. */
  groupId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** The sms client's last name. */
  lastName?: InputMaybe<Scalars['String']>;
  /** The sms client's phone number. */
  phoneNumber: Scalars['String'];
  programId?: InputMaybe<Scalars['UUID']>;
  subGroup?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our create `SmsOutreachRecipient` mutation. */
export interface CreateSmsOutreachRecipientPayload {
  __typename: 'CreateSmsOutreachRecipientPayload';
  /** Reads a single `Admin` that is related to this `SmsOutreachRecipient`. */
  adminByAdminId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Group` that is related to this `SmsOutreachRecipient`. */
  groupByGroupId: Maybe<Group>;
  /** Reads a single `Program` that is related to this `SmsOutreachRecipient`. */
  programByProgramId: Maybe<Program>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `SmsOutreachRecipient` that was created by this mutation. */
  smsOutreachRecipient: Maybe<SmsOutreachRecipient>;
  /** An edge for our `SmsOutreachRecipient`. May be used by Relay 1. */
  smsOutreachRecipientEdge: Maybe<SmsOutreachRecipientsEdge>;
}


/** The output of our create `SmsOutreachRecipient` mutation. */
export interface CreateSmsOutreachRecipientPayloadSmsOutreachRecipientEdgeArgs {
  orderBy?: InputMaybe<Array<SmsOutreachRecipientsOrderBy>>;
}

/** All input for the create `TimedObject` mutation. */
export interface CreateTimedObjectInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `TimedObject` to be created by this mutation. */
  timedObject: TimedObjectInput;
}

/** An input for mutations affecting `TimedObject` */
export interface TimedObjectInput {
  /** The time this object was created. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** The unique identifier of this object. */
  id?: InputMaybe<Scalars['UUID']>;
  /** The time this object was last updated. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
}

/** The output of our create `TimedObject` mutation. */
export interface CreateTimedObjectPayload {
  __typename: 'CreateTimedObjectPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `TimedObject` that was created by this mutation. */
  timedObject: Maybe<TimedObject>;
  /** An edge for our `TimedObject`. May be used by Relay 1. */
  timedObjectEdge: Maybe<TimedObjectsEdge>;
}


/** The output of our create `TimedObject` mutation. */
export interface CreateTimedObjectPayloadTimedObjectEdgeArgs {
  orderBy?: InputMaybe<Array<TimedObjectsOrderBy>>;
}

/** All input for the create `TimezoneRecord` mutation. */
export interface CreateTimezoneRecordInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `TimezoneRecord` to be created by this mutation. */
  timezoneRecord: TimezoneRecordInput;
}

/** An input for mutations affecting `TimezoneRecord` */
export interface TimezoneRecordInput {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** The ID of the patient who is moving into a new timezone. */
  patientId: Scalars['UUID'];
  /** The name of the timezone into which the patient is entering; must be one of the names returned from getTimezoneNames. */
  timezoneName: Scalars['Timezone'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our create `TimezoneRecord` mutation. */
export interface CreateTimezoneRecordPayload {
  __typename: 'CreateTimezoneRecordPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Patient` that is related to this `TimezoneRecord`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `TimezoneRecord` that was created by this mutation. */
  timezoneRecord: Maybe<TimezoneRecord>;
  /** An edge for our `TimezoneRecord`. May be used by Relay 1. */
  timezoneRecordEdge: Maybe<TimezoneRecordsEdge>;
}


/** The output of our create `TimezoneRecord` mutation. */
export interface CreateTimezoneRecordPayloadTimezoneRecordEdgeArgs {
  orderBy?: InputMaybe<Array<TimezoneRecordsOrderBy>>;
}

/** All input for the create `Walkthrough` mutation. */
export interface CreateWalkthroughInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Walkthrough` to be created by this mutation. */
  walkthrough: WalkthroughInput;
}

/** An input for mutations affecting `Walkthrough` */
export interface WalkthroughInput {
  adminId: Scalars['UUID'];
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our create `Walkthrough` mutation. */
export interface CreateWalkthroughPayload {
  __typename: 'CreateWalkthroughPayload';
  /** Reads a single `Admin` that is related to this `Walkthrough`. */
  adminByAdminId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `Walkthrough` that was created by this mutation. */
  walkthrough: Maybe<Walkthrough>;
  /** An edge for our `Walkthrough`. May be used by Relay 1. */
  walkthroughEdge: Maybe<WalkthroughsEdge>;
}


/** The output of our create `Walkthrough` mutation. */
export interface CreateWalkthroughPayloadWalkthroughEdgeArgs {
  orderBy?: InputMaybe<Array<WalkthroughsOrderBy>>;
}

/** All input for the create `WalkthroughPage` mutation. */
export interface CreateWalkthroughPageInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `WalkthroughPage` to be created by this mutation. */
  walkthroughPage: WalkthroughPageInput;
}

/** An input for mutations affecting `WalkthroughPage` */
export interface WalkthroughPageInput {
  adminId: Scalars['UUID'];
  /** The background color of this walkthrough page */
  backgroundColor?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** The text to render in the body of this walkthrough page */
  detail: Scalars['String'];
  /** The icon for this walkthrough page */
  icon?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** The language of this walkthrough */
  language?: InputMaybe<LanguageCode>;
  /** The name of this walkthrough (i.e. could match the program name) */
  name?: InputMaybe<Scalars['String']>;
  /** The order in which this walkthrough page is shown in the specific walkthrough */
  pageIndex: Scalars['Int'];
  /** The text to render in the title of this walkthrough page */
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** The identifier for this walkthrough (a specific series of walkthrough pages, shown in sequence) */
  walkthroughId?: InputMaybe<Scalars['UUID']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our create `WalkthroughPage` mutation. */
export interface CreateWalkthroughPagePayload {
  __typename: 'CreateWalkthroughPagePayload';
  /** Reads a single `Admin` that is related to this `WalkthroughPage`. */
  adminByAdminId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Walkthrough` that is related to this `WalkthroughPage`. */
  walkthroughByWalkthroughId: Maybe<Walkthrough>;
  /** The `WalkthroughPage` that was created by this mutation. */
  walkthroughPage: Maybe<WalkthroughPage>;
  /** An edge for our `WalkthroughPage`. May be used by Relay 1. */
  walkthroughPageEdge: Maybe<WalkthroughPagesEdge>;
}


/** The output of our create `WalkthroughPage` mutation. */
export interface CreateWalkthroughPagePayloadWalkthroughPageEdgeArgs {
  orderBy?: InputMaybe<Array<WalkthroughPagesOrderBy>>;
}

/** All input for the create `WalkthroughSetup` mutation. */
export interface CreateWalkthroughSetupInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `WalkthroughSetup` to be created by this mutation. */
  walkthroughSetup: WalkthroughSetupInput;
}

/** An input for mutations affecting `WalkthroughSetup` */
export interface WalkthroughSetupInput {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  /** The patient which owns this walkthrough setup. */
  patientId: Scalars['UUID'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** The id of the walkthrough configured for the given patient. */
  walkthroughId: Scalars['UUID'];
  /** The id of the walkthrough setup config from which this walkthrough setup was created. */
  walkthroughSetupConfigId?: InputMaybe<Scalars['UUID']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our create `WalkthroughSetup` mutation. */
export interface CreateWalkthroughSetupPayload {
  __typename: 'CreateWalkthroughSetupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Patient` that is related to this `WalkthroughSetup`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Walkthrough` that is related to this `WalkthroughSetup`. */
  walkthroughByWalkthroughId: Maybe<Walkthrough>;
  /** The `WalkthroughSetup` that was created by this mutation. */
  walkthroughSetup: Maybe<WalkthroughSetup>;
  /** Reads a single `WalkthroughSetupConfig` that is related to this `WalkthroughSetup`. */
  walkthroughSetupConfigByWalkthroughSetupConfigId: Maybe<WalkthroughSetupConfig>;
  /** An edge for our `WalkthroughSetup`. May be used by Relay 1. */
  walkthroughSetupEdge: Maybe<WalkthroughSetupsEdge>;
}


/** The output of our create `WalkthroughSetup` mutation. */
export interface CreateWalkthroughSetupPayloadWalkthroughSetupEdgeArgs {
  orderBy?: InputMaybe<Array<WalkthroughSetupsOrderBy>>;
}

/** All input for the create `WalkthroughSetupConfig` mutation. */
export interface CreateWalkthroughSetupConfigInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `WalkthroughSetupConfig` to be created by this mutation. */
  walkthroughSetupConfig: WalkthroughSetupConfigInput;
}

/** An input for mutations affecting `WalkthroughSetupConfig` */
export interface WalkthroughSetupConfigInput {
  /** The admin which owns this walkthrough setup config. */
  adminId: Scalars['UUID'];
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** The name of this walkthrough setup config. */
  name?: InputMaybe<Scalars['String']>;
  /** An optional freetext note about this walkthrough setup config. */
  note?: InputMaybe<Scalars['String']>;
  /** The id of the program to which this walkthrough setup config is related (optional). */
  programId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** The walkthrough for this configuration. */
  walkthroughId: Scalars['UUID'];
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our create `WalkthroughSetupConfig` mutation. */
export interface CreateWalkthroughSetupConfigPayload {
  __typename: 'CreateWalkthroughSetupConfigPayload';
  /** Reads a single `Admin` that is related to this `WalkthroughSetupConfig`. */
  adminByAdminId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Program` that is related to this `WalkthroughSetupConfig`. */
  programByProgramId: Maybe<Program>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Walkthrough` that is related to this `WalkthroughSetupConfig`. */
  walkthroughByWalkthroughId: Maybe<Walkthrough>;
  /** The `WalkthroughSetupConfig` that was created by this mutation. */
  walkthroughSetupConfig: Maybe<WalkthroughSetupConfig>;
  /** An edge for our `WalkthroughSetupConfig`. May be used by Relay 1. */
  walkthroughSetupConfigEdge: Maybe<WalkthroughSetupConfigsEdge>;
}


/** The output of our create `WalkthroughSetupConfig` mutation. */
export interface CreateWalkthroughSetupConfigPayloadWalkthroughSetupConfigEdgeArgs {
  orderBy?: InputMaybe<Array<WalkthroughSetupConfigsOrderBy>>;
}

/** All input for the create `WalkthroughSummary` mutation. */
export interface CreateWalkthroughSummaryInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `WalkthroughSummary` to be created by this mutation. */
  walkthroughSummary: WalkthroughSummaryInput;
}

/** An input for mutations affecting `WalkthroughSummary` */
export interface WalkthroughSummaryInput {
  adminId: Scalars['UUID'];
  createdAt?: InputMaybe<Scalars['Datetime']>;
  detail: Scalars['String'];
  icon?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  index: Scalars['Int'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  walkthroughId: Scalars['UUID'];
}

/** The output of our create `WalkthroughSummary` mutation. */
export interface CreateWalkthroughSummaryPayload {
  __typename: 'CreateWalkthroughSummaryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Walkthrough` that is related to this `WalkthroughSummary`. */
  walkthroughByWalkthroughId: Maybe<Walkthrough>;
  /** The `WalkthroughSummary` that was created by this mutation. */
  walkthroughSummary: Maybe<WalkthroughSummary>;
  /** An edge for our `WalkthroughSummary`. May be used by Relay 1. */
  walkthroughSummaryEdge: Maybe<WalkthroughSummariesEdge>;
}


/** The output of our create `WalkthroughSummary` mutation. */
export interface CreateWalkthroughSummaryPayloadWalkthroughSummaryEdgeArgs {
  orderBy?: InputMaybe<Array<WalkthroughSummariesOrderBy>>;
}

/** All input for the create `WinbackRewardConfig` mutation. */
export interface CreateWinbackRewardConfigInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `WinbackRewardConfig` to be created by this mutation. */
  winbackRewardConfig: WinbackRewardConfigInput;
}

/** An input for mutations affecting `WinbackRewardConfig` */
export interface WinbackRewardConfigInput {
  /** Unique string identifier for the challenge blueprint (e.g., thanksgiving_daily_v1) */
  challengeTypeKey: Scalars['String'];
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Detailed description of the challenge for internal reference */
  description: Scalars['String'];
  /** User-facing name for the challenge */
  displayName: Scalars['String'];
  /** The number of days an opportunity is active before it expires */
  durationInDays: Scalars['Int'];
  id?: InputMaybe<Scalars['UUID']>;
  /** Whether this challenge blueprint is currently active and can be used to create new opportunities */
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** The maximum reward amount allowed for an opportunity of this type */
  maxRewardAmount: Scalars['BigFloat'];
  /** The minimum reward amount allowed for an opportunity of this type */
  minRewardAmount: Scalars['BigFloat'];
  /** The currency of the reward (constrained to USD) */
  rewardCurrency?: InputMaybe<Currency>;
  /** The system event that can trigger a completion for this challenge (e.g., user.checked_in) */
  triggerEvent: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our create `WinbackRewardConfig` mutation. */
export interface CreateWinbackRewardConfigPayload {
  __typename: 'CreateWinbackRewardConfigPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `WinbackRewardConfig` that was created by this mutation. */
  winbackRewardConfig: Maybe<WinbackRewardConfig>;
  /** An edge for our `WinbackRewardConfig`. May be used by Relay 1. */
  winbackRewardConfigEdge: Maybe<WinbackRewardConfigsEdge>;
}


/** The output of our create `WinbackRewardConfig` mutation. */
export interface CreateWinbackRewardConfigPayloadWinbackRewardConfigEdgeArgs {
  orderBy?: InputMaybe<Array<WinbackRewardConfigsOrderBy>>;
}

/** All input for the create `WinbackRewardOpportunity` mutation. */
export interface CreateWinbackRewardOpportunityInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `WinbackRewardOpportunity` to be created by this mutation. */
  winbackRewardOpportunity: WinbackRewardOpportunityInput;
}

/** An input for mutations affecting `WinbackRewardOpportunity` */
export interface WinbackRewardOpportunityInput {
  /** Foreign key to account_transaction table once reward is paid out (nullable) */
  accountTransactionId?: InputMaybe<Scalars['UUID']>;
  /** Timestamp when the opportunity was activated for the patient */
  activatedAt?: InputMaybe<Scalars['Datetime']>;
  /** The Customer.io campaign identifier for tracking */
  campaignId: Scalars['String'];
  /** Unique identifier for this specific challenge instance (e.g., thanksgiving_2025_11_27) */
  challengeId: Scalars['String'];
  /** Timestamp when the patient completed this challenge (nullable) */
  completedAt?: InputMaybe<Scalars['Datetime']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Timestamp when this challenge offer expires */
  expiresAt: Scalars['Datetime'];
  id?: InputMaybe<Scalars['UUID']>;
  /** The patient given this challenge reward opportunity */
  patientId: Scalars['UUID'];
  rewardAmount: Scalars['BigFloat'];
  rewardCurrency?: InputMaybe<Currency>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
  /** Foreign key to the challenge reward config blueprint */
  winbackRewardConfigId: Scalars['UUID'];
}

/** The output of our create `WinbackRewardOpportunity` mutation. */
export interface CreateWinbackRewardOpportunityPayload {
  __typename: 'CreateWinbackRewardOpportunityPayload';
  /** Reads a single `AccountTransaction` that is related to this `WinbackRewardOpportunity`. */
  accountTransactionByAccountTransactionId: Maybe<AccountTransaction>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Patient` that is related to this `WinbackRewardOpportunity`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `WinbackRewardConfig` that is related to this `WinbackRewardOpportunity`. */
  winbackRewardConfigByWinbackRewardConfigId: Maybe<WinbackRewardConfig>;
  /** The `WinbackRewardOpportunity` that was created by this mutation. */
  winbackRewardOpportunity: Maybe<WinbackRewardOpportunity>;
  /** An edge for our `WinbackRewardOpportunity`. May be used by Relay 1. */
  winbackRewardOpportunityEdge: Maybe<WinbackRewardOpportunitiesEdge>;
}


/** The output of our create `WinbackRewardOpportunity` mutation. */
export interface CreateWinbackRewardOpportunityPayloadWinbackRewardOpportunityEdgeArgs {
  orderBy?: InputMaybe<Array<WinbackRewardOpportunitiesOrderBy>>;
}

export interface CreditAppointmentInput {
  id: Scalars['UUID'];
  reason: Scalars['String'];
}

/** All input for the `deleteAccountTransaction` mutation. */
export interface DeleteAccountTransactionInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `AccountTransaction` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `AccountTransaction` mutation. */
export interface DeleteAccountTransactionPayload {
  __typename: 'DeleteAccountTransactionPayload';
  /** The `AccountTransaction` that was deleted by this mutation. */
  accountTransaction: Maybe<AccountTransaction>;
  /** An edge for our `AccountTransaction`. May be used by Relay 1. */
  accountTransactionEdge: Maybe<AccountTransactionsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedAccountTransactionId: Maybe<Scalars['ID']>;
  /** Reads a single `Patient` that is related to this `AccountTransaction`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our delete `AccountTransaction` mutation. */
export interface DeleteAccountTransactionPayloadAccountTransactionEdgeArgs {
  orderBy?: InputMaybe<Array<AccountTransactionsOrderBy>>;
}

/** All input for the `deleteAccountTransactionById` mutation. */
export interface DeleteAccountTransactionByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteActionLog` mutation. */
export interface DeleteActionLogInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ActionLog` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `ActionLog` mutation. */
export interface DeleteActionLogPayload {
  __typename: 'DeleteActionLogPayload';
  /** The `ActionLog` that was deleted by this mutation. */
  actionLog: Maybe<ActionLog>;
  /** An edge for our `ActionLog`. May be used by Relay 1. */
  actionLogEdge: Maybe<ActionLogsEdge>;
  /** Reads a single `Admin` that is related to this `ActionLog`. */
  adminByAdminId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedActionLogId: Maybe<Scalars['ID']>;
  /** Reads a single `Patient` that is related to this `ActionLog`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our delete `ActionLog` mutation. */
export interface DeleteActionLogPayloadActionLogEdgeArgs {
  orderBy?: InputMaybe<Array<ActionLogsOrderBy>>;
}

/** All input for the `deleteActionLogById` mutation. */
export interface DeleteActionLogByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteAdmin` mutation. */
export interface DeleteAdminInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Admin` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `Admin` mutation. */
export interface DeleteAdminPayload {
  __typename: 'DeleteAdminPayload';
  /** The `Admin` that was deleted by this mutation. */
  admin: Maybe<Admin>;
  /** An edge for our `Admin`. May be used by Relay 1. */
  adminEdge: Maybe<AdminsEdge>;
  /** Reads a single `AdminRole` that is related to this `Admin`. */
  adminRoleByAdminRoleId: Maybe<AdminRole>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedAdminId: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our delete `Admin` mutation. */
export interface DeleteAdminPayloadAdminEdgeArgs {
  orderBy?: InputMaybe<Array<AdminsOrderBy>>;
}

/** All input for the `deleteAdminById` mutation. */
export interface DeleteAdminByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteAdminRole` mutation. */
export interface DeleteAdminRoleInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `AdminRole` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `AdminRole` mutation. */
export interface DeleteAdminRolePayload {
  __typename: 'DeleteAdminRolePayload';
  /** The `AdminRole` that was deleted by this mutation. */
  adminRole: Maybe<AdminRole>;
  /** An edge for our `AdminRole`. May be used by Relay 1. */
  adminRoleEdge: Maybe<AdminRolesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedAdminRoleId: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our delete `AdminRole` mutation. */
export interface DeleteAdminRolePayloadAdminRoleEdgeArgs {
  orderBy?: InputMaybe<Array<AdminRolesOrderBy>>;
}

/** All input for the `deleteAdminRoleById` mutation. */
export interface DeleteAdminRoleByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteAdminRoleByName` mutation. */
export interface DeleteAdminRoleByNameInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
}

/** All input for the `deleteAdminRolePrivilegedAction` mutation. */
export interface DeleteAdminRolePrivilegedActionInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `AdminRolePrivilegedAction` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `AdminRolePrivilegedAction` mutation. */
export interface DeleteAdminRolePrivilegedActionPayload {
  __typename: 'DeleteAdminRolePrivilegedActionPayload';
  /** Reads a single `AdminRole` that is related to this `AdminRolePrivilegedAction`. */
  adminRoleByAdminRoleId: Maybe<AdminRole>;
  /** The `AdminRolePrivilegedAction` that was deleted by this mutation. */
  adminRolePrivilegedAction: Maybe<AdminRolePrivilegedAction>;
  /** An edge for our `AdminRolePrivilegedAction`. May be used by Relay 1. */
  adminRolePrivilegedActionEdge: Maybe<AdminRolePrivilegedActionsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedAdminRolePrivilegedActionId: Maybe<Scalars['ID']>;
  /** Reads a single `PrivilegedAction` that is related to this `AdminRolePrivilegedAction`. */
  privilegedActionByPrivilegedActionId: Maybe<PrivilegedAction>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our delete `AdminRolePrivilegedAction` mutation. */
export interface DeleteAdminRolePrivilegedActionPayloadAdminRolePrivilegedActionEdgeArgs {
  orderBy?: InputMaybe<Array<AdminRolePrivilegedActionsOrderBy>>;
}

/** All input for the `deleteAdminRolePrivilegedActionById` mutation. */
export interface DeleteAdminRolePrivilegedActionByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteBonusBehaviorSubmissionStatus` mutation. */
export interface DeleteBonusBehaviorSubmissionStatusInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `BonusBehaviorSubmissionStatus` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `BonusBehaviorSubmissionStatus` mutation. */
export interface DeleteBonusBehaviorSubmissionStatusPayload {
  __typename: 'DeleteBonusBehaviorSubmissionStatusPayload';
  /** The `BonusBehaviorSubmissionStatus` that was deleted by this mutation. */
  bonusBehaviorSubmissionStatus: Maybe<BonusBehaviorSubmissionStatus>;
  /** An edge for our `BonusBehaviorSubmissionStatus`. May be used by Relay 1. */
  bonusBehaviorSubmissionStatusEdge: Maybe<BonusBehaviorSubmissionStatusesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedBonusBehaviorSubmissionStatusId: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our delete `BonusBehaviorSubmissionStatus` mutation. */
export interface DeleteBonusBehaviorSubmissionStatusPayloadBonusBehaviorSubmissionStatusEdgeArgs {
  orderBy?: InputMaybe<Array<BonusBehaviorSubmissionStatusesOrderBy>>;
}

/** All input for the `deleteBonusBehaviorSubmissionStatusByBonusBehaviorSubmissionIdAndCreatedAtAndValue` mutation. */
export interface DeleteBonusBehaviorSubmissionStatusByBonusBehaviorSubmissionIdAndCreatedAtAndValueInput {
  bonusBehaviorSubmissionId: Scalars['UUID'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  value: Scalars['String'];
}

/** All input for the `deleteBonusBehaviorSubmissionStatusById` mutation. */
export interface DeleteBonusBehaviorSubmissionStatusByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteCheckIn` mutation. */
export interface DeleteCheckInInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `CheckIn` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `CheckIn` mutation. */
export interface DeleteCheckInPayload {
  __typename: 'DeleteCheckInPayload';
  /** Reads a single `Admin` that is related to this `CheckIn`. */
  adminByVerifierId: Maybe<Admin>;
  /** The `CheckIn` that was deleted by this mutation. */
  checkIn: Maybe<CheckIn>;
  /** An edge for our `CheckIn`. May be used by Relay 1. */
  checkInEdge: Maybe<CheckInsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedCheckInId: Maybe<Scalars['ID']>;
  /** Reads a single `Patient` that is related to this `CheckIn`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Reminder` that is related to this `CheckIn`. */
  reminderByReminderId: Maybe<Reminder>;
}


/** The output of our delete `CheckIn` mutation. */
export interface DeleteCheckInPayloadCheckInEdgeArgs {
  orderBy?: InputMaybe<Array<CheckInsOrderBy>>;
}

/** All input for the `deleteCheckInById` mutation. */
export interface DeleteCheckInByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteCueCheckIn` mutation. */
export interface DeleteCueCheckInInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `CueCheckIn` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `CueCheckIn` mutation. */
export interface DeleteCueCheckInPayload {
  __typename: 'DeleteCueCheckInPayload';
  /** Reads a single `Admin` that is related to this `CueCheckIn`. */
  adminByVerifierId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `CueCheckIn` that was deleted by this mutation. */
  cueCheckIn: Maybe<CueCheckIn>;
  /** An edge for our `CueCheckIn`. May be used by Relay 1. */
  cueCheckInEdge: Maybe<CueCheckInsEdge>;
  deletedCueCheckInId: Maybe<Scalars['ID']>;
  /** Reads a single `Patient` that is related to this `CueCheckIn`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Reminder` that is related to this `CueCheckIn`. */
  reminderByReminderId: Maybe<Reminder>;
}


/** The output of our delete `CueCheckIn` mutation. */
export interface DeleteCueCheckInPayloadCueCheckInEdgeArgs {
  orderBy?: InputMaybe<Array<CueCheckInsOrderBy>>;
}

/** All input for the `deleteCueCheckInById` mutation. */
export interface DeleteCueCheckInByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteCustomer` mutation. */
export interface DeleteCustomerInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Customer` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `Customer` mutation. */
export interface DeleteCustomerPayload {
  __typename: 'DeleteCustomerPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `Customer` that was deleted by this mutation. */
  customer: Maybe<Customer>;
  /** An edge for our `Customer`. May be used by Relay 1. */
  customerEdge: Maybe<CustomersEdge>;
  deletedCustomerId: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our delete `Customer` mutation. */
export interface DeleteCustomerPayloadCustomerEdgeArgs {
  orderBy?: InputMaybe<Array<CustomersOrderBy>>;
}

/** All input for the `deleteCustomerById` mutation. */
export interface DeleteCustomerByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteCustomerByName` mutation. */
export interface DeleteCustomerByNameInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
}

/** All input for the `deleteDebitCard` mutation. */
export interface DeleteDebitCardInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `DebitCard` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `DebitCard` mutation. */
export interface DeleteDebitCardPayload {
  __typename: 'DeleteDebitCardPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `DebitCard` that was deleted by this mutation. */
  debitCard: Maybe<DebitCard>;
  /** An edge for our `DebitCard`. May be used by Relay 1. */
  debitCardEdge: Maybe<DebitCardsEdge>;
  deletedDebitCardId: Maybe<Scalars['ID']>;
  /** Reads a single `Patient` that is related to this `DebitCard`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our delete `DebitCard` mutation. */
export interface DeleteDebitCardPayloadDebitCardEdgeArgs {
  orderBy?: InputMaybe<Array<DebitCardsOrderBy>>;
}

/** All input for the `deleteDebitCardBalance` mutation. */
export interface DeleteDebitCardBalanceInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `DebitCardBalance` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `DebitCardBalance` mutation. */
export interface DeleteDebitCardBalancePayload {
  __typename: 'DeleteDebitCardBalancePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `DebitCardBalance` that was deleted by this mutation. */
  debitCardBalance: Maybe<DebitCardBalance>;
  /** An edge for our `DebitCardBalance`. May be used by Relay 1. */
  debitCardBalanceEdge: Maybe<DebitCardBalancesEdge>;
  /** Reads a single `DebitCard` that is related to this `DebitCardBalance`. */
  debitCardByDebitCardId: Maybe<DebitCard>;
  deletedDebitCardBalanceId: Maybe<Scalars['ID']>;
  /** Reads a single `Patient` that is related to this `DebitCardBalance`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our delete `DebitCardBalance` mutation. */
export interface DeleteDebitCardBalancePayloadDebitCardBalanceEdgeArgs {
  orderBy?: InputMaybe<Array<DebitCardBalancesOrderBy>>;
}

/** All input for the `deleteDebitCardBalanceById` mutation. */
export interface DeleteDebitCardBalanceByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteDebitCardById` mutation. */
export interface DeleteDebitCardByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteDevice` mutation. */
export interface DeleteDeviceInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Device` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `Device` mutation. */
export interface DeleteDevicePayload {
  __typename: 'DeleteDevicePayload';
  /** Reads a single `Admin` that is related to this `Device`. */
  adminByAdminId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedDeviceId: Maybe<Scalars['ID']>;
  /** The `Device` that was deleted by this mutation. */
  device: Maybe<Device>;
  /** An edge for our `Device`. May be used by Relay 1. */
  deviceEdge: Maybe<DevicesEdge>;
  /** Reads a single `Patient` that is related to this `Device`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our delete `Device` mutation. */
export interface DeleteDevicePayloadDeviceEdgeArgs {
  orderBy?: InputMaybe<Array<DevicesOrderBy>>;
}

/** All input for the `deleteDeviceById` mutation. */
export interface DeleteDeviceByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

export interface DeleteFutureDialysisAppointmentEventsInput {
  fromDate: Scalars['String'];
  scheduleJob: Scalars['String'];
}

export interface DeleteFutureDialysisAppointmentEventsPayload {
  __typename: 'DeleteFutureDialysisAppointmentEventsPayload';
  deletedCount: Scalars['Int'];
}

/** All input for the `deleteGroup` mutation. */
export interface DeleteGroupInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Group` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `Group` mutation. */
export interface DeleteGroupPayload {
  __typename: 'DeleteGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedGroupId: Maybe<Scalars['ID']>;
  /** The `Group` that was deleted by this mutation. */
  group: Maybe<Group>;
  /** An edge for our `Group`. May be used by Relay 1. */
  groupEdge: Maybe<GroupsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our delete `Group` mutation. */
export interface DeleteGroupPayloadGroupEdgeArgs {
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
}

/** All input for the `deleteGroupById` mutation. */
export interface DeleteGroupByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteHeartbeat` mutation. */
export interface DeleteHeartbeatInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Heartbeat` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `Heartbeat` mutation. */
export interface DeleteHeartbeatPayload {
  __typename: 'DeleteHeartbeatPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedHeartbeatId: Maybe<Scalars['ID']>;
  /** The `Heartbeat` that was deleted by this mutation. */
  heartbeat: Maybe<Heartbeat>;
  /** An edge for our `Heartbeat`. May be used by Relay 1. */
  heartbeatEdge: Maybe<HeartbeatsEdge>;
  /** Reads a single `Patient` that is related to this `Heartbeat`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our delete `Heartbeat` mutation. */
export interface DeleteHeartbeatPayloadHeartbeatEdgeArgs {
  orderBy?: InputMaybe<Array<HeartbeatsOrderBy>>;
}

/** All input for the `deleteHeartbeatById` mutation. */
export interface DeleteHeartbeatByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteHydrationCheckIn` mutation. */
export interface DeleteHydrationCheckInInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `HydrationCheckIn` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `HydrationCheckIn` mutation. */
export interface DeleteHydrationCheckInPayload {
  __typename: 'DeleteHydrationCheckInPayload';
  /** Reads a single `Admin` that is related to this `HydrationCheckIn`. */
  adminByVerifierId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedHydrationCheckInId: Maybe<Scalars['ID']>;
  /** The `HydrationCheckIn` that was deleted by this mutation. */
  hydrationCheckIn: Maybe<HydrationCheckIn>;
  /** An edge for our `HydrationCheckIn`. May be used by Relay 1. */
  hydrationCheckInEdge: Maybe<HydrationCheckInsEdge>;
  /** Reads a single `Patient` that is related to this `HydrationCheckIn`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Reminder` that is related to this `HydrationCheckIn`. */
  reminderByReminderId: Maybe<Reminder>;
}


/** The output of our delete `HydrationCheckIn` mutation. */
export interface DeleteHydrationCheckInPayloadHydrationCheckInEdgeArgs {
  orderBy?: InputMaybe<Array<HydrationCheckInsOrderBy>>;
}

/** All input for the `deleteHydrationCheckInById` mutation. */
export interface DeleteHydrationCheckInByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteMarvMigration` mutation. */
export interface DeleteMarvMigrationInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `MarvMigration` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `MarvMigration` mutation. */
export interface DeleteMarvMigrationPayload {
  __typename: 'DeleteMarvMigrationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedMarvMigrationId: Maybe<Scalars['ID']>;
  /** The `MarvMigration` that was deleted by this mutation. */
  marvMigration: Maybe<MarvMigration>;
  /** An edge for our `MarvMigration`. May be used by Relay 1. */
  marvMigrationEdge: Maybe<MarvMigrationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our delete `MarvMigration` mutation. */
export interface DeleteMarvMigrationPayloadMarvMigrationEdgeArgs {
  orderBy?: InputMaybe<Array<MarvMigrationsOrderBy>>;
}

/** All input for the `deleteMarvMigrationByLevelAndNamespace` mutation. */
export interface DeleteMarvMigrationByLevelAndNamespaceInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  level: Scalars['Int'];
  namespace: Scalars['String'];
}

/** All input for the `deleteMealCheckIn` mutation. */
export interface DeleteMealCheckInInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `MealCheckIn` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `MealCheckIn` mutation. */
export interface DeleteMealCheckInPayload {
  __typename: 'DeleteMealCheckInPayload';
  /** Reads a single `Admin` that is related to this `MealCheckIn`. */
  adminByVerifierId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedMealCheckInId: Maybe<Scalars['ID']>;
  /** The `MealCheckIn` that was deleted by this mutation. */
  mealCheckIn: Maybe<MealCheckIn>;
  /** An edge for our `MealCheckIn`. May be used by Relay 1. */
  mealCheckInEdge: Maybe<MealCheckInsEdge>;
  /** Reads a single `Patient` that is related to this `MealCheckIn`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Reminder` that is related to this `MealCheckIn`. */
  reminderByReminderId: Maybe<Reminder>;
}


/** The output of our delete `MealCheckIn` mutation. */
export interface DeleteMealCheckInPayloadMealCheckInEdgeArgs {
  orderBy?: InputMaybe<Array<MealCheckInsOrderBy>>;
}

/** All input for the `deleteMealCheckInById` mutation. */
export interface DeleteMealCheckInByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteMeasurementCheckIn` mutation. */
export interface DeleteMeasurementCheckInInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `MeasurementCheckIn` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `MeasurementCheckIn` mutation. */
export interface DeleteMeasurementCheckInPayload {
  __typename: 'DeleteMeasurementCheckInPayload';
  /** Reads a single `Admin` that is related to this `MeasurementCheckIn`. */
  adminByVerifierId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedMeasurementCheckInId: Maybe<Scalars['ID']>;
  /** The `MeasurementCheckIn` that was deleted by this mutation. */
  measurementCheckIn: Maybe<MeasurementCheckIn>;
  /** An edge for our `MeasurementCheckIn`. May be used by Relay 1. */
  measurementCheckInEdge: Maybe<MeasurementCheckInsEdge>;
  /** Reads a single `Patient` that is related to this `MeasurementCheckIn`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Reminder` that is related to this `MeasurementCheckIn`. */
  reminderByReminderId: Maybe<Reminder>;
}


/** The output of our delete `MeasurementCheckIn` mutation. */
export interface DeleteMeasurementCheckInPayloadMeasurementCheckInEdgeArgs {
  orderBy?: InputMaybe<Array<MeasurementCheckInsOrderBy>>;
}

/** All input for the `deleteMeasurementCheckInById` mutation. */
export interface DeleteMeasurementCheckInByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteMedicationCheckIn` mutation. */
export interface DeleteMedicationCheckInInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `MedicationCheckIn` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `MedicationCheckIn` mutation. */
export interface DeleteMedicationCheckInPayload {
  __typename: 'DeleteMedicationCheckInPayload';
  /** Reads a single `Admin` that is related to this `MedicationCheckIn`. */
  adminByVerifierId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedMedicationCheckInId: Maybe<Scalars['ID']>;
  /** The `MedicationCheckIn` that was deleted by this mutation. */
  medicationCheckIn: Maybe<MedicationCheckIn>;
  /** An edge for our `MedicationCheckIn`. May be used by Relay 1. */
  medicationCheckInEdge: Maybe<MedicationCheckInsEdge>;
  /** Reads a single `Patient` that is related to this `MedicationCheckIn`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Reminder` that is related to this `MedicationCheckIn`. */
  reminderByReminderId: Maybe<Reminder>;
}


/** The output of our delete `MedicationCheckIn` mutation. */
export interface DeleteMedicationCheckInPayloadMedicationCheckInEdgeArgs {
  orderBy?: InputMaybe<Array<MedicationCheckInsOrderBy>>;
}

/** All input for the `deleteMedicationCheckInById` mutation. */
export interface DeleteMedicationCheckInByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

export interface DeleteMemberInput {
  desiredProspectStatus?: InputMaybe<ProspectStatusEnum>;
  id: Scalars['UUID'];
  note?: InputMaybe<Scalars['String']>;
}

export enum ProspectStatusEnum {
  Closed = 'closed',
  Converted = 'converted',
  Converting = 'converting',
  Open = 'open'
}

/** All input for the `deleteMessage` mutation. */
export interface DeleteMessageInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Message` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `Message` mutation. */
export interface DeleteMessagePayload {
  __typename: 'DeleteMessagePayload';
  /** Reads a single `Admin` that is related to this `Message`. */
  adminByAdminId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedMessageId: Maybe<Scalars['ID']>;
  /** The `Message` that was deleted by this mutation. */
  message: Maybe<Message>;
  /** An edge for our `Message`. May be used by Relay 1. */
  messageEdge: Maybe<MessagesEdge>;
  /** Reads a single `Patient` that is related to this `Message`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our delete `Message` mutation. */
export interface DeleteMessagePayloadMessageEdgeArgs {
  orderBy?: InputMaybe<Array<MessagesOrderBy>>;
}

/** All input for the `deleteMessageByExternalId` mutation. */
export interface DeleteMessageByExternalIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  externalId: Scalars['String'];
}

/** All input for the `deleteMessageById` mutation. */
export interface DeleteMessageByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteObjectDetection` mutation. */
export interface DeleteObjectDetectionInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ObjectDetection` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `ObjectDetection` mutation. */
export interface DeleteObjectDetectionPayload {
  __typename: 'DeleteObjectDetectionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedObjectDetectionId: Maybe<Scalars['ID']>;
  /** The `ObjectDetection` that was deleted by this mutation. */
  objectDetection: Maybe<ObjectDetection>;
  /** An edge for our `ObjectDetection`. May be used by Relay 1. */
  objectDetectionEdge: Maybe<ObjectDetectionsEdge>;
  /** Reads a single `Patient` that is related to this `ObjectDetection`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our delete `ObjectDetection` mutation. */
export interface DeleteObjectDetectionPayloadObjectDetectionEdgeArgs {
  orderBy?: InputMaybe<Array<ObjectDetectionsOrderBy>>;
}

/** All input for the `deleteObjectDetectionById` mutation. */
export interface DeleteObjectDetectionByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deletePatient` mutation. */
export interface DeletePatientInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Patient` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `Patient` mutation. */
export interface DeletePatientPayload {
  __typename: 'DeletePatientPayload';
  /** Reads a single `Admin` that is related to this `Patient`. */
  adminByEnrolledBy: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedPatientId: Maybe<Scalars['ID']>;
  /** The `Patient` that was deleted by this mutation. */
  patient: Maybe<Patient>;
  /** An edge for our `Patient`. May be used by Relay 1. */
  patientEdge: Maybe<PatientsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our delete `Patient` mutation. */
export interface DeletePatientPayloadPatientEdgeArgs {
  orderBy?: InputMaybe<Array<PatientsOrderBy>>;
}

/** All input for the `deletePatientById` mutation. */
export interface DeletePatientByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deletePatientMembershipConfig` mutation. */
export interface DeletePatientMembershipConfigInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `PatientMembershipConfig` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `PatientMembershipConfig` mutation. */
export interface DeletePatientMembershipConfigPayload {
  __typename: 'DeletePatientMembershipConfigPayload';
  /** Reads a single `Admin` that is related to this `PatientMembershipConfig`. */
  adminByAdminId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedPatientMembershipConfigId: Maybe<Scalars['ID']>;
  /** Reads a single `Group` that is related to this `PatientMembershipConfig`. */
  groupByGroupId: Maybe<Group>;
  /** The `PatientMembershipConfig` that was deleted by this mutation. */
  patientMembershipConfig: Maybe<PatientMembershipConfig>;
  /** An edge for our `PatientMembershipConfig`. May be used by Relay 1. */
  patientMembershipConfigEdge: Maybe<PatientMembershipConfigsEdge>;
  /** Reads a single `Program` that is related to this `PatientMembershipConfig`. */
  programByProgramId: Maybe<Program>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our delete `PatientMembershipConfig` mutation. */
export interface DeletePatientMembershipConfigPayloadPatientMembershipConfigEdgeArgs {
  orderBy?: InputMaybe<Array<PatientMembershipConfigsOrderBy>>;
}

/** All input for the `deletePatientMembershipConfigById` mutation. */
export interface DeletePatientMembershipConfigByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deletePatientStatus` mutation. */
export interface DeletePatientStatusInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `PatientStatus` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `PatientStatus` mutation. */
export interface DeletePatientStatusPayload {
  __typename: 'DeletePatientStatusPayload';
  /** Reads a single `Admin` that is related to this `PatientStatus`. */
  adminByAdminId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedPatientStatusId: Maybe<Scalars['ID']>;
  /** Reads a single `Patient` that is related to this `PatientStatus`. */
  patientByPatientId: Maybe<Patient>;
  /** The `PatientStatus` that was deleted by this mutation. */
  patientStatus: Maybe<PatientStatus>;
  /** An edge for our `PatientStatus`. May be used by Relay 1. */
  patientStatusEdge: Maybe<PatientStatusesEdge>;
  /** Reads a single `PatientStatusValue` that is related to this `PatientStatus`. */
  patientStatusValueByValue: Maybe<PatientStatusValue>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our delete `PatientStatus` mutation. */
export interface DeletePatientStatusPayloadPatientStatusEdgeArgs {
  orderBy?: InputMaybe<Array<PatientStatusesOrderBy>>;
}

/** All input for the `deletePatientStatusById` mutation. */
export interface DeletePatientStatusByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deletePatientStatusByPatientIdAndCreatedAtAndValue` mutation. */
export interface DeletePatientStatusByPatientIdAndCreatedAtAndValueInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  patientId: Scalars['UUID'];
  value: Scalars['String'];
}

/** All input for the `deletePatientStatusValue` mutation. */
export interface DeletePatientStatusValueInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `PatientStatusValue` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `PatientStatusValue` mutation. */
export interface DeletePatientStatusValuePayload {
  __typename: 'DeletePatientStatusValuePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedPatientStatusValueId: Maybe<Scalars['ID']>;
  /** The `PatientStatusValue` that was deleted by this mutation. */
  patientStatusValue: Maybe<PatientStatusValue>;
  /** An edge for our `PatientStatusValue`. May be used by Relay 1. */
  patientStatusValueEdge: Maybe<PatientStatusValuesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our delete `PatientStatusValue` mutation. */
export interface DeletePatientStatusValuePayloadPatientStatusValueEdgeArgs {
  orderBy?: InputMaybe<Array<PatientStatusValuesOrderBy>>;
}

/** All input for the `deletePatientStatusValueById` mutation. */
export interface DeletePatientStatusValueByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deletePatientStatusValueByName` mutation. */
export interface DeletePatientStatusValueByNameInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
}

/** All input for the `deletePause` mutation. */
export interface DeletePauseInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Pause` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `Pause` mutation. */
export interface DeletePausePayload {
  __typename: 'DeletePausePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedPauseId: Maybe<Scalars['ID']>;
  /** Reads a single `Patient` that is related to this `Pause`. */
  patientByPatientId: Maybe<Patient>;
  /** The `Pause` that was deleted by this mutation. */
  pause: Maybe<Pause>;
  /** An edge for our `Pause`. May be used by Relay 1. */
  pauseEdge: Maybe<PausesEdge>;
  /** Reads a single `PauseReason` that is related to this `Pause`. */
  pauseReasonByReason: Maybe<PauseReason>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our delete `Pause` mutation. */
export interface DeletePausePayloadPauseEdgeArgs {
  orderBy?: InputMaybe<Array<PausesOrderBy>>;
}

/** All input for the `deletePauseById` mutation. */
export interface DeletePauseByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deletePauseReason` mutation. */
export interface DeletePauseReasonInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `PauseReason` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `PauseReason` mutation. */
export interface DeletePauseReasonPayload {
  __typename: 'DeletePauseReasonPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedPauseReasonId: Maybe<Scalars['ID']>;
  /** The `PauseReason` that was deleted by this mutation. */
  pauseReason: Maybe<PauseReason>;
  /** An edge for our `PauseReason`. May be used by Relay 1. */
  pauseReasonEdge: Maybe<PauseReasonsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our delete `PauseReason` mutation. */
export interface DeletePauseReasonPayloadPauseReasonEdgeArgs {
  orderBy?: InputMaybe<Array<PauseReasonsOrderBy>>;
}

/** All input for the `deletePauseReasonById` mutation. */
export interface DeletePauseReasonByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deletePauseReasonByValue` mutation. */
export interface DeletePauseReasonByValueInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  value: Scalars['String'];
}

/** All input for the `deletePaymentSetup` mutation. */
export interface DeletePaymentSetupInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `PaymentSetup` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `PaymentSetup` mutation. */
export interface DeletePaymentSetupPayload {
  __typename: 'DeletePaymentSetupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `DebitCard` that is related to this `PaymentSetup`. */
  debitCardByDebitCardId: Maybe<DebitCard>;
  deletedPaymentSetupId: Maybe<Scalars['ID']>;
  /** Reads a single `Patient` that is related to this `PaymentSetup`. */
  patientByPatientId: Maybe<Patient>;
  /** The `PaymentSetup` that was deleted by this mutation. */
  paymentSetup: Maybe<PaymentSetup>;
  /** An edge for our `PaymentSetup`. May be used by Relay 1. */
  paymentSetupEdge: Maybe<PaymentSetupsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our delete `PaymentSetup` mutation. */
export interface DeletePaymentSetupPayloadPaymentSetupEdgeArgs {
  orderBy?: InputMaybe<Array<PaymentSetupsOrderBy>>;
}

/** All input for the `deletePaymentSetupById` mutation. */
export interface DeletePaymentSetupByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deletePrivilegedAction` mutation. */
export interface DeletePrivilegedActionInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `PrivilegedAction` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `PrivilegedAction` mutation. */
export interface DeletePrivilegedActionPayload {
  __typename: 'DeletePrivilegedActionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedPrivilegedActionId: Maybe<Scalars['ID']>;
  /** The `PrivilegedAction` that was deleted by this mutation. */
  privilegedAction: Maybe<PrivilegedAction>;
  /** An edge for our `PrivilegedAction`. May be used by Relay 1. */
  privilegedActionEdge: Maybe<PrivilegedActionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our delete `PrivilegedAction` mutation. */
export interface DeletePrivilegedActionPayloadPrivilegedActionEdgeArgs {
  orderBy?: InputMaybe<Array<PrivilegedActionsOrderBy>>;
}

/** All input for the `deletePrivilegedActionById` mutation. */
export interface DeletePrivilegedActionByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deletePrivilegedActionByName` mutation. */
export interface DeletePrivilegedActionByNameInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
}

/** All input for the `deleteProgramMfaConfig` mutation. */
export interface DeleteProgramMfaConfigInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProgramMfaConfig` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `ProgramMfaConfig` mutation. */
export interface DeleteProgramMfaConfigPayload {
  __typename: 'DeleteProgramMfaConfigPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedProgramMfaConfigId: Maybe<Scalars['ID']>;
  /** Reads a single `Program` that is related to this `ProgramMfaConfig`. */
  programByProgramId: Maybe<Program>;
  /** The `ProgramMfaConfig` that was deleted by this mutation. */
  programMfaConfig: Maybe<ProgramMfaConfig>;
  /** An edge for our `ProgramMfaConfig`. May be used by Relay 1. */
  programMfaConfigEdge: Maybe<ProgramMfaConfigsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our delete `ProgramMfaConfig` mutation. */
export interface DeleteProgramMfaConfigPayloadProgramMfaConfigEdgeArgs {
  orderBy?: InputMaybe<Array<ProgramMfaConfigsOrderBy>>;
}

/** All input for the `deleteProgramMfaConfigById` mutation. */
export interface DeleteProgramMfaConfigByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteProgramMfaConfigByProgramId` mutation. */
export interface DeleteProgramMfaConfigByProgramIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  programId: Scalars['UUID'];
}

/** All input for the `deleteProgramOutreachSubmission` mutation. */
export interface DeleteProgramOutreachSubmissionInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProgramOutreachSubmission` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `ProgramOutreachSubmission` mutation. */
export interface DeleteProgramOutreachSubmissionPayload {
  __typename: 'DeleteProgramOutreachSubmissionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedProgramOutreachSubmissionId: Maybe<Scalars['ID']>;
  /** The `ProgramOutreachSubmission` that was deleted by this mutation. */
  programOutreachSubmission: Maybe<ProgramOutreachSubmission>;
  /** An edge for our `ProgramOutreachSubmission`. May be used by Relay 1. */
  programOutreachSubmissionEdge: Maybe<ProgramOutreachSubmissionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our delete `ProgramOutreachSubmission` mutation. */
export interface DeleteProgramOutreachSubmissionPayloadProgramOutreachSubmissionEdgeArgs {
  orderBy?: InputMaybe<Array<ProgramOutreachSubmissionsOrderBy>>;
}

/** All input for the `deleteProgramOutreachSubmissionById` mutation. */
export interface DeleteProgramOutreachSubmissionByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteProgramReward` mutation. */
export interface DeleteProgramRewardInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProgramReward` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `ProgramReward` mutation. */
export interface DeleteProgramRewardPayload {
  __typename: 'DeleteProgramRewardPayload';
  /** Reads a single `AccountTransaction` that is related to this `ProgramReward`. */
  accountTransactionByAccountTransactionId: Maybe<AccountTransaction>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedProgramRewardId: Maybe<Scalars['ID']>;
  /** Reads a single `Patient` that is related to this `ProgramReward`. */
  patientByPatientId: Maybe<Patient>;
  /** The `ProgramReward` that was deleted by this mutation. */
  programReward: Maybe<ProgramReward>;
  /** Reads a single `ProgramRewardConfig` that is related to this `ProgramReward`. */
  programRewardConfigByName: Maybe<ProgramRewardConfig>;
  /** Reads a single `ProgramRewardConfig` that is related to this `ProgramReward`. */
  programRewardConfigByProgramRewardConfigId: Maybe<ProgramRewardConfig>;
  /** An edge for our `ProgramReward`. May be used by Relay 1. */
  programRewardEdge: Maybe<ProgramRewardsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our delete `ProgramReward` mutation. */
export interface DeleteProgramRewardPayloadProgramRewardEdgeArgs {
  orderBy?: InputMaybe<Array<ProgramRewardsOrderBy>>;
}

/** All input for the `deleteProgramRewardById` mutation. */
export interface DeleteProgramRewardByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteProgramRewardConfig` mutation. */
export interface DeleteProgramRewardConfigInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProgramRewardConfig` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `ProgramRewardConfig` mutation. */
export interface DeleteProgramRewardConfigPayload {
  __typename: 'DeleteProgramRewardConfigPayload';
  /** Reads a single `Admin` that is related to this `ProgramRewardConfig`. */
  adminByAdminId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedProgramRewardConfigId: Maybe<Scalars['ID']>;
  /** Reads a single `Program` that is related to this `ProgramRewardConfig`. */
  programByProgramId: Maybe<Program>;
  /** The `ProgramRewardConfig` that was deleted by this mutation. */
  programRewardConfig: Maybe<ProgramRewardConfig>;
  /** An edge for our `ProgramRewardConfig`. May be used by Relay 1. */
  programRewardConfigEdge: Maybe<ProgramRewardConfigsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our delete `ProgramRewardConfig` mutation. */
export interface DeleteProgramRewardConfigPayloadProgramRewardConfigEdgeArgs {
  orderBy?: InputMaybe<Array<ProgramRewardConfigsOrderBy>>;
}

/** All input for the `deleteProgramRewardConfigById` mutation. */
export interface DeleteProgramRewardConfigByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteProgramRewardConfigByName` mutation. */
export interface DeleteProgramRewardConfigByNameInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
}

/** All input for the `deleteProgramTemplate` mutation. */
export interface DeleteProgramTemplateInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProgramTemplate` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `ProgramTemplate` mutation. */
export interface DeleteProgramTemplatePayload {
  __typename: 'DeleteProgramTemplatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedProgramTemplateId: Maybe<Scalars['ID']>;
  /** The `ProgramTemplate` that was deleted by this mutation. */
  programTemplate: Maybe<ProgramTemplate>;
  /** An edge for our `ProgramTemplate`. May be used by Relay 1. */
  programTemplateEdge: Maybe<ProgramTemplatesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our delete `ProgramTemplate` mutation. */
export interface DeleteProgramTemplatePayloadProgramTemplateEdgeArgs {
  orderBy?: InputMaybe<Array<ProgramTemplatesOrderBy>>;
}

/** All input for the `deleteProgramTemplateById` mutation. */
export interface DeleteProgramTemplateByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteProgramTemplateByName` mutation. */
export interface DeleteProgramTemplateByNameInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
}

/** All input for the `deleteProspectStatus` mutation. */
export interface DeleteProspectStatusInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProspectStatus` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `ProspectStatus` mutation. */
export interface DeleteProspectStatusPayload {
  __typename: 'DeleteProspectStatusPayload';
  /** Reads a single `Admin` that is related to this `ProspectStatus`. */
  adminByAdminId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedProspectStatusId: Maybe<Scalars['ID']>;
  /** The `ProspectStatus` that was deleted by this mutation. */
  prospectStatus: Maybe<ProspectStatus>;
  /** An edge for our `ProspectStatus`. May be used by Relay 1. */
  prospectStatusEdge: Maybe<ProspectStatusesEdge>;
  /** Reads a single `ProspectStatusValue` that is related to this `ProspectStatus`. */
  prospectStatusValueByValue: Maybe<ProspectStatusValue>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our delete `ProspectStatus` mutation. */
export interface DeleteProspectStatusPayloadProspectStatusEdgeArgs {
  orderBy?: InputMaybe<Array<ProspectStatusesOrderBy>>;
}

/** All input for the `deleteProspectStatusById` mutation. */
export interface DeleteProspectStatusByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteProspectStatusByProspectIdAndCreatedAtAndValue` mutation. */
export interface DeleteProspectStatusByProspectIdAndCreatedAtAndValueInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  prospectId: Scalars['UUID'];
  value: Scalars['String'];
}

/** All input for the `deleteProspectStatusValue` mutation. */
export interface DeleteProspectStatusValueInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProspectStatusValue` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `ProspectStatusValue` mutation. */
export interface DeleteProspectStatusValuePayload {
  __typename: 'DeleteProspectStatusValuePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedProspectStatusValueId: Maybe<Scalars['ID']>;
  /** The `ProspectStatusValue` that was deleted by this mutation. */
  prospectStatusValue: Maybe<ProspectStatusValue>;
  /** An edge for our `ProspectStatusValue`. May be used by Relay 1. */
  prospectStatusValueEdge: Maybe<ProspectStatusValuesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our delete `ProspectStatusValue` mutation. */
export interface DeleteProspectStatusValuePayloadProspectStatusValueEdgeArgs {
  orderBy?: InputMaybe<Array<ProspectStatusValuesOrderBy>>;
}

/** All input for the `deleteProspectStatusValueById` mutation. */
export interface DeleteProspectStatusValueByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteProspectStatusValueByName` mutation. */
export interface DeleteProspectStatusValueByNameInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
}

/** All input for the `deletePushNotification` mutation. */
export interface DeletePushNotificationInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `PushNotification` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `PushNotification` mutation. */
export interface DeletePushNotificationPayload {
  __typename: 'DeletePushNotificationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedPushNotificationId: Maybe<Scalars['ID']>;
  /** Reads a single `Patient` that is related to this `PushNotification`. */
  patientByPatientId: Maybe<Patient>;
  /** The `PushNotification` that was deleted by this mutation. */
  pushNotification: Maybe<PushNotification>;
  /** An edge for our `PushNotification`. May be used by Relay 1. */
  pushNotificationEdge: Maybe<PushNotificationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our delete `PushNotification` mutation. */
export interface DeletePushNotificationPayloadPushNotificationEdgeArgs {
  orderBy?: InputMaybe<Array<PushNotificationsOrderBy>>;
}

/** All input for the `deletePushNotificationById` mutation. */
export interface DeletePushNotificationByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deletePushToken` mutation. */
export interface DeletePushTokenInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `PushToken` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `PushToken` mutation. */
export interface DeletePushTokenPayload {
  __typename: 'DeletePushTokenPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedPushTokenId: Maybe<Scalars['ID']>;
  /** Reads a single `Patient` that is related to this `PushToken`. */
  patientByPatientId: Maybe<Patient>;
  /** The `PushToken` that was deleted by this mutation. */
  pushToken: Maybe<PushToken>;
  /** An edge for our `PushToken`. May be used by Relay 1. */
  pushTokenEdge: Maybe<PushTokensEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our delete `PushToken` mutation. */
export interface DeletePushTokenPayloadPushTokenEdgeArgs {
  orderBy?: InputMaybe<Array<PushTokensOrderBy>>;
}

/** All input for the `deletePushTokenById` mutation. */
export interface DeletePushTokenByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteRawIncomingDatum` mutation. */
export interface DeleteRawIncomingDatumInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `RawIncomingDatum` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `RawIncomingDatum` mutation. */
export interface DeleteRawIncomingDatumPayload {
  __typename: 'DeleteRawIncomingDatumPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedRawIncomingDatumId: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `RawIncomingDatum` that was deleted by this mutation. */
  rawIncomingDatum: Maybe<RawIncomingDatum>;
  /** An edge for our `RawIncomingDatum`. May be used by Relay 1. */
  rawIncomingDatumEdge: Maybe<RawIncomingDataEdge>;
}


/** The output of our delete `RawIncomingDatum` mutation. */
export interface DeleteRawIncomingDatumPayloadRawIncomingDatumEdgeArgs {
  orderBy?: InputMaybe<Array<RawIncomingDataOrderBy>>;
}

/** All input for the `deleteRawIncomingDatumById` mutation. */
export interface DeleteRawIncomingDatumByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteReminder` mutation. */
export interface DeleteReminderInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Reminder` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `Reminder` mutation. */
export interface DeleteReminderPayload {
  __typename: 'DeleteReminderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedReminderId: Maybe<Scalars['ID']>;
  /** Reads a single `Patient` that is related to this `Reminder`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `Reminder` that was deleted by this mutation. */
  reminder: Maybe<Reminder>;
  /** Reads a single `Reminder` that is related to this `Reminder`. */
  reminderByLinkedFutureReminderId: Maybe<Reminder>;
  /** Reads a single `ReminderConfig` that is related to this `Reminder`. */
  reminderConfigByReminderConfigId: Maybe<ReminderConfig>;
  /** An edge for our `Reminder`. May be used by Relay 1. */
  reminderEdge: Maybe<RemindersEdge>;
}


/** The output of our delete `Reminder` mutation. */
export interface DeleteReminderPayloadReminderEdgeArgs {
  orderBy?: InputMaybe<Array<RemindersOrderBy>>;
}

/** All input for the `deleteReminderById` mutation. */
export interface DeleteReminderByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteReminderConfig` mutation. */
export interface DeleteReminderConfigInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ReminderConfig` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `ReminderConfig` mutation. */
export interface DeleteReminderConfigPayload {
  __typename: 'DeleteReminderConfigPayload';
  /** Reads a single `Admin` that is related to this `ReminderConfig`. */
  adminByAdminId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedReminderConfigId: Maybe<Scalars['ID']>;
  /** Reads a single `Program` that is related to this `ReminderConfig`. */
  programByProgramId: Maybe<Program>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `ReminderConfig` that was deleted by this mutation. */
  reminderConfig: Maybe<ReminderConfig>;
  /** An edge for our `ReminderConfig`. May be used by Relay 1. */
  reminderConfigEdge: Maybe<ReminderConfigsEdge>;
}


/** The output of our delete `ReminderConfig` mutation. */
export interface DeleteReminderConfigPayloadReminderConfigEdgeArgs {
  orderBy?: InputMaybe<Array<ReminderConfigsOrderBy>>;
}

/** All input for the `deleteReminderConfigById` mutation. */
export interface DeleteReminderConfigByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteReminderMessage` mutation. */
export interface DeleteReminderMessageInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ReminderMessage` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `ReminderMessage` mutation. */
export interface DeleteReminderMessagePayload {
  __typename: 'DeleteReminderMessagePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedReminderMessageId: Maybe<Scalars['ID']>;
  /** Reads a single `Message` that is related to this `ReminderMessage`. */
  messageByMessageId: Maybe<Message>;
  /** Reads a single `Patient` that is related to this `ReminderMessage`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Reminder` that is related to this `ReminderMessage`. */
  reminderByReminderId: Maybe<Reminder>;
  /** The `ReminderMessage` that was deleted by this mutation. */
  reminderMessage: Maybe<ReminderMessage>;
  /** An edge for our `ReminderMessage`. May be used by Relay 1. */
  reminderMessageEdge: Maybe<ReminderMessagesEdge>;
}


/** The output of our delete `ReminderMessage` mutation. */
export interface DeleteReminderMessagePayloadReminderMessageEdgeArgs {
  orderBy?: InputMaybe<Array<ReminderMessagesOrderBy>>;
}

/** All input for the `deleteReminderMessageById` mutation. */
export interface DeleteReminderMessageByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteRewardPeriod` mutation. */
export interface DeleteRewardPeriodInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `RewardPeriod` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `RewardPeriod` mutation. */
export interface DeleteRewardPeriodPayload {
  __typename: 'DeleteRewardPeriodPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedRewardPeriodId: Maybe<Scalars['ID']>;
  /** Reads a single `Patient` that is related to this `RewardPeriod`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `RewardPeriod` that was deleted by this mutation. */
  rewardPeriod: Maybe<RewardPeriod>;
  /** Reads a single `RewardPeriodConfig` that is related to this `RewardPeriod`. */
  rewardPeriodConfigByRewardPeriodConfigId: Maybe<RewardPeriodConfig>;
  /** An edge for our `RewardPeriod`. May be used by Relay 1. */
  rewardPeriodEdge: Maybe<RewardPeriodsEdge>;
}


/** The output of our delete `RewardPeriod` mutation. */
export interface DeleteRewardPeriodPayloadRewardPeriodEdgeArgs {
  orderBy?: InputMaybe<Array<RewardPeriodsOrderBy>>;
}

/** All input for the `deleteRewardPeriodById` mutation. */
export interface DeleteRewardPeriodByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteRewardPeriodConfig` mutation. */
export interface DeleteRewardPeriodConfigInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `RewardPeriodConfig` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `RewardPeriodConfig` mutation. */
export interface DeleteRewardPeriodConfigPayload {
  __typename: 'DeleteRewardPeriodConfigPayload';
  /** Reads a single `Admin` that is related to this `RewardPeriodConfig`. */
  adminByAdminId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedRewardPeriodConfigId: Maybe<Scalars['ID']>;
  /** Reads a single `Program` that is related to this `RewardPeriodConfig`. */
  programByProgramId: Maybe<Program>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `RewardPeriodConfig` that was deleted by this mutation. */
  rewardPeriodConfig: Maybe<RewardPeriodConfig>;
  /** An edge for our `RewardPeriodConfig`. May be used by Relay 1. */
  rewardPeriodConfigEdge: Maybe<RewardPeriodConfigsEdge>;
}


/** The output of our delete `RewardPeriodConfig` mutation. */
export interface DeleteRewardPeriodConfigPayloadRewardPeriodConfigEdgeArgs {
  orderBy?: InputMaybe<Array<RewardPeriodConfigsOrderBy>>;
}

/** All input for the `deleteRewardPeriodConfigById` mutation. */
export interface DeleteRewardPeriodConfigByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteSmsAutoResponder` mutation. */
export interface DeleteSmsAutoResponderInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `SmsAutoResponder` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `SmsAutoResponder` mutation. */
export interface DeleteSmsAutoResponderPayload {
  __typename: 'DeleteSmsAutoResponderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedSmsAutoResponderId: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `SmsAutoResponder` that was deleted by this mutation. */
  smsAutoResponder: Maybe<SmsAutoResponder>;
  /** An edge for our `SmsAutoResponder`. May be used by Relay 1. */
  smsAutoResponderEdge: Maybe<SmsAutoRespondersEdge>;
}


/** The output of our delete `SmsAutoResponder` mutation. */
export interface DeleteSmsAutoResponderPayloadSmsAutoResponderEdgeArgs {
  orderBy?: InputMaybe<Array<SmsAutoRespondersOrderBy>>;
}

/** All input for the `deleteSmsAutoResponderById` mutation. */
export interface DeleteSmsAutoResponderByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteSmsOutreachMessage` mutation. */
export interface DeleteSmsOutreachMessageInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `SmsOutreachMessage` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `SmsOutreachMessage` mutation. */
export interface DeleteSmsOutreachMessagePayload {
  __typename: 'DeleteSmsOutreachMessagePayload';
  /** Reads a single `Admin` that is related to this `SmsOutreachMessage`. */
  adminByAdminId: Maybe<Admin>;
  /** Reads a single `Admin` that is related to this `SmsOutreachMessage`. */
  adminByApprovedBy: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedSmsOutreachMessageId: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `SmsOutreachMessage` that was deleted by this mutation. */
  smsOutreachMessage: Maybe<SmsOutreachMessage>;
  /** An edge for our `SmsOutreachMessage`. May be used by Relay 1. */
  smsOutreachMessageEdge: Maybe<SmsOutreachMessagesEdge>;
  /** Reads a single `SmsOutreachMessageTemplate` that is related to this `SmsOutreachMessage`. */
  smsOutreachMessageTemplateByMessageTemplateId: Maybe<SmsOutreachMessageTemplate>;
  /** Reads a single `SmsOutreachRecipient` that is related to this `SmsOutreachMessage`. */
  smsOutreachRecipientByRecipientId: Maybe<SmsOutreachRecipient>;
}


/** The output of our delete `SmsOutreachMessage` mutation. */
export interface DeleteSmsOutreachMessagePayloadSmsOutreachMessageEdgeArgs {
  orderBy?: InputMaybe<Array<SmsOutreachMessagesOrderBy>>;
}

/** All input for the `deleteSmsOutreachMessageById` mutation. */
export interface DeleteSmsOutreachMessageByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteSmsOutreachMessageTemplate` mutation. */
export interface DeleteSmsOutreachMessageTemplateInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `SmsOutreachMessageTemplate` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `SmsOutreachMessageTemplate` mutation. */
export interface DeleteSmsOutreachMessageTemplatePayload {
  __typename: 'DeleteSmsOutreachMessageTemplatePayload';
  /** Reads a single `Admin` that is related to this `SmsOutreachMessageTemplate`. */
  adminByAdminId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedSmsOutreachMessageTemplateId: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `SmsOutreachMessageTemplate` that was deleted by this mutation. */
  smsOutreachMessageTemplate: Maybe<SmsOutreachMessageTemplate>;
  /** An edge for our `SmsOutreachMessageTemplate`. May be used by Relay 1. */
  smsOutreachMessageTemplateEdge: Maybe<SmsOutreachMessageTemplatesEdge>;
}


/** The output of our delete `SmsOutreachMessageTemplate` mutation. */
export interface DeleteSmsOutreachMessageTemplatePayloadSmsOutreachMessageTemplateEdgeArgs {
  orderBy?: InputMaybe<Array<SmsOutreachMessageTemplatesOrderBy>>;
}

/** All input for the `deleteSmsOutreachMessageTemplateById` mutation. */
export interface DeleteSmsOutreachMessageTemplateByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteSmsOutreachRecipient` mutation. */
export interface DeleteSmsOutreachRecipientInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `SmsOutreachRecipient` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `SmsOutreachRecipient` mutation. */
export interface DeleteSmsOutreachRecipientPayload {
  __typename: 'DeleteSmsOutreachRecipientPayload';
  /** Reads a single `Admin` that is related to this `SmsOutreachRecipient`. */
  adminByAdminId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedSmsOutreachRecipientId: Maybe<Scalars['ID']>;
  /** Reads a single `Group` that is related to this `SmsOutreachRecipient`. */
  groupByGroupId: Maybe<Group>;
  /** Reads a single `Program` that is related to this `SmsOutreachRecipient`. */
  programByProgramId: Maybe<Program>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `SmsOutreachRecipient` that was deleted by this mutation. */
  smsOutreachRecipient: Maybe<SmsOutreachRecipient>;
  /** An edge for our `SmsOutreachRecipient`. May be used by Relay 1. */
  smsOutreachRecipientEdge: Maybe<SmsOutreachRecipientsEdge>;
}


/** The output of our delete `SmsOutreachRecipient` mutation. */
export interface DeleteSmsOutreachRecipientPayloadSmsOutreachRecipientEdgeArgs {
  orderBy?: InputMaybe<Array<SmsOutreachRecipientsOrderBy>>;
}

/** All input for the `deleteSmsOutreachRecipientById` mutation. */
export interface DeleteSmsOutreachRecipientByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteSmsOutreachRecipientByPhoneNumber` mutation. */
export interface DeleteSmsOutreachRecipientByPhoneNumberInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The sms client's phone number. */
  phoneNumber: Scalars['String'];
}

/** All input for the `deleteTimedObject` mutation. */
export interface DeleteTimedObjectInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `TimedObject` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `TimedObject` mutation. */
export interface DeleteTimedObjectPayload {
  __typename: 'DeleteTimedObjectPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedTimedObjectId: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `TimedObject` that was deleted by this mutation. */
  timedObject: Maybe<TimedObject>;
  /** An edge for our `TimedObject`. May be used by Relay 1. */
  timedObjectEdge: Maybe<TimedObjectsEdge>;
}


/** The output of our delete `TimedObject` mutation. */
export interface DeleteTimedObjectPayloadTimedObjectEdgeArgs {
  orderBy?: InputMaybe<Array<TimedObjectsOrderBy>>;
}

/** All input for the `deleteTimedObjectById` mutation. */
export interface DeleteTimedObjectByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The unique identifier of this object. */
  id: Scalars['UUID'];
}

/** All input for the `deleteTimezoneRecord` mutation. */
export interface DeleteTimezoneRecordInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `TimezoneRecord` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `TimezoneRecord` mutation. */
export interface DeleteTimezoneRecordPayload {
  __typename: 'DeleteTimezoneRecordPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedTimezoneRecordId: Maybe<Scalars['ID']>;
  /** Reads a single `Patient` that is related to this `TimezoneRecord`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `TimezoneRecord` that was deleted by this mutation. */
  timezoneRecord: Maybe<TimezoneRecord>;
  /** An edge for our `TimezoneRecord`. May be used by Relay 1. */
  timezoneRecordEdge: Maybe<TimezoneRecordsEdge>;
}


/** The output of our delete `TimezoneRecord` mutation. */
export interface DeleteTimezoneRecordPayloadTimezoneRecordEdgeArgs {
  orderBy?: InputMaybe<Array<TimezoneRecordsOrderBy>>;
}

/** All input for the `deleteTimezoneRecordById` mutation. */
export interface DeleteTimezoneRecordByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteWalkthrough` mutation. */
export interface DeleteWalkthroughInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Walkthrough` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `Walkthrough` mutation. */
export interface DeleteWalkthroughPayload {
  __typename: 'DeleteWalkthroughPayload';
  /** Reads a single `Admin` that is related to this `Walkthrough`. */
  adminByAdminId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedWalkthroughId: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `Walkthrough` that was deleted by this mutation. */
  walkthrough: Maybe<Walkthrough>;
  /** An edge for our `Walkthrough`. May be used by Relay 1. */
  walkthroughEdge: Maybe<WalkthroughsEdge>;
}


/** The output of our delete `Walkthrough` mutation. */
export interface DeleteWalkthroughPayloadWalkthroughEdgeArgs {
  orderBy?: InputMaybe<Array<WalkthroughsOrderBy>>;
}

/** All input for the `deleteWalkthroughById` mutation. */
export interface DeleteWalkthroughByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteWalkthroughPage` mutation. */
export interface DeleteWalkthroughPageInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `WalkthroughPage` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `WalkthroughPage` mutation. */
export interface DeleteWalkthroughPagePayload {
  __typename: 'DeleteWalkthroughPagePayload';
  /** Reads a single `Admin` that is related to this `WalkthroughPage`. */
  adminByAdminId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedWalkthroughPageId: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Walkthrough` that is related to this `WalkthroughPage`. */
  walkthroughByWalkthroughId: Maybe<Walkthrough>;
  /** The `WalkthroughPage` that was deleted by this mutation. */
  walkthroughPage: Maybe<WalkthroughPage>;
  /** An edge for our `WalkthroughPage`. May be used by Relay 1. */
  walkthroughPageEdge: Maybe<WalkthroughPagesEdge>;
}


/** The output of our delete `WalkthroughPage` mutation. */
export interface DeleteWalkthroughPagePayloadWalkthroughPageEdgeArgs {
  orderBy?: InputMaybe<Array<WalkthroughPagesOrderBy>>;
}

/** All input for the `deleteWalkthroughPageById` mutation. */
export interface DeleteWalkthroughPageByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteWalkthroughSetup` mutation. */
export interface DeleteWalkthroughSetupInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `WalkthroughSetup` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `WalkthroughSetup` mutation. */
export interface DeleteWalkthroughSetupPayload {
  __typename: 'DeleteWalkthroughSetupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedWalkthroughSetupId: Maybe<Scalars['ID']>;
  /** Reads a single `Patient` that is related to this `WalkthroughSetup`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Walkthrough` that is related to this `WalkthroughSetup`. */
  walkthroughByWalkthroughId: Maybe<Walkthrough>;
  /** The `WalkthroughSetup` that was deleted by this mutation. */
  walkthroughSetup: Maybe<WalkthroughSetup>;
  /** Reads a single `WalkthroughSetupConfig` that is related to this `WalkthroughSetup`. */
  walkthroughSetupConfigByWalkthroughSetupConfigId: Maybe<WalkthroughSetupConfig>;
  /** An edge for our `WalkthroughSetup`. May be used by Relay 1. */
  walkthroughSetupEdge: Maybe<WalkthroughSetupsEdge>;
}


/** The output of our delete `WalkthroughSetup` mutation. */
export interface DeleteWalkthroughSetupPayloadWalkthroughSetupEdgeArgs {
  orderBy?: InputMaybe<Array<WalkthroughSetupsOrderBy>>;
}

/** All input for the `deleteWalkthroughSetupById` mutation. */
export interface DeleteWalkthroughSetupByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteWalkthroughSetupConfig` mutation. */
export interface DeleteWalkthroughSetupConfigInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `WalkthroughSetupConfig` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `WalkthroughSetupConfig` mutation. */
export interface DeleteWalkthroughSetupConfigPayload {
  __typename: 'DeleteWalkthroughSetupConfigPayload';
  /** Reads a single `Admin` that is related to this `WalkthroughSetupConfig`. */
  adminByAdminId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedWalkthroughSetupConfigId: Maybe<Scalars['ID']>;
  /** Reads a single `Program` that is related to this `WalkthroughSetupConfig`. */
  programByProgramId: Maybe<Program>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Walkthrough` that is related to this `WalkthroughSetupConfig`. */
  walkthroughByWalkthroughId: Maybe<Walkthrough>;
  /** The `WalkthroughSetupConfig` that was deleted by this mutation. */
  walkthroughSetupConfig: Maybe<WalkthroughSetupConfig>;
  /** An edge for our `WalkthroughSetupConfig`. May be used by Relay 1. */
  walkthroughSetupConfigEdge: Maybe<WalkthroughSetupConfigsEdge>;
}


/** The output of our delete `WalkthroughSetupConfig` mutation. */
export interface DeleteWalkthroughSetupConfigPayloadWalkthroughSetupConfigEdgeArgs {
  orderBy?: InputMaybe<Array<WalkthroughSetupConfigsOrderBy>>;
}

/** All input for the `deleteWalkthroughSetupConfigById` mutation. */
export interface DeleteWalkthroughSetupConfigByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteWalkthroughSummary` mutation. */
export interface DeleteWalkthroughSummaryInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `WalkthroughSummary` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `WalkthroughSummary` mutation. */
export interface DeleteWalkthroughSummaryPayload {
  __typename: 'DeleteWalkthroughSummaryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedWalkthroughSummaryId: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Walkthrough` that is related to this `WalkthroughSummary`. */
  walkthroughByWalkthroughId: Maybe<Walkthrough>;
  /** The `WalkthroughSummary` that was deleted by this mutation. */
  walkthroughSummary: Maybe<WalkthroughSummary>;
  /** An edge for our `WalkthroughSummary`. May be used by Relay 1. */
  walkthroughSummaryEdge: Maybe<WalkthroughSummariesEdge>;
}


/** The output of our delete `WalkthroughSummary` mutation. */
export interface DeleteWalkthroughSummaryPayloadWalkthroughSummaryEdgeArgs {
  orderBy?: InputMaybe<Array<WalkthroughSummariesOrderBy>>;
}

/** All input for the `deleteWalkthroughSummaryById` mutation. */
export interface DeleteWalkthroughSummaryByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteWinbackRewardConfig` mutation. */
export interface DeleteWinbackRewardConfigInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `WinbackRewardConfig` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `WinbackRewardConfig` mutation. */
export interface DeleteWinbackRewardConfigPayload {
  __typename: 'DeleteWinbackRewardConfigPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedWinbackRewardConfigId: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `WinbackRewardConfig` that was deleted by this mutation. */
  winbackRewardConfig: Maybe<WinbackRewardConfig>;
  /** An edge for our `WinbackRewardConfig`. May be used by Relay 1. */
  winbackRewardConfigEdge: Maybe<WinbackRewardConfigsEdge>;
}


/** The output of our delete `WinbackRewardConfig` mutation. */
export interface DeleteWinbackRewardConfigPayloadWinbackRewardConfigEdgeArgs {
  orderBy?: InputMaybe<Array<WinbackRewardConfigsOrderBy>>;
}

/** All input for the `deleteWinbackRewardConfigByChallengeTypeKey` mutation. */
export interface DeleteWinbackRewardConfigByChallengeTypeKeyInput {
  /** Unique string identifier for the challenge blueprint (e.g., thanksgiving_daily_v1) */
  challengeTypeKey: Scalars['String'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
}

/** All input for the `deleteWinbackRewardConfigById` mutation. */
export interface DeleteWinbackRewardConfigByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteWinbackRewardOpportunity` mutation. */
export interface DeleteWinbackRewardOpportunityInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `WinbackRewardOpportunity` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `WinbackRewardOpportunity` mutation. */
export interface DeleteWinbackRewardOpportunityPayload {
  __typename: 'DeleteWinbackRewardOpportunityPayload';
  /** Reads a single `AccountTransaction` that is related to this `WinbackRewardOpportunity`. */
  accountTransactionByAccountTransactionId: Maybe<AccountTransaction>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedWinbackRewardOpportunityId: Maybe<Scalars['ID']>;
  /** Reads a single `Patient` that is related to this `WinbackRewardOpportunity`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `WinbackRewardConfig` that is related to this `WinbackRewardOpportunity`. */
  winbackRewardConfigByWinbackRewardConfigId: Maybe<WinbackRewardConfig>;
  /** The `WinbackRewardOpportunity` that was deleted by this mutation. */
  winbackRewardOpportunity: Maybe<WinbackRewardOpportunity>;
  /** An edge for our `WinbackRewardOpportunity`. May be used by Relay 1. */
  winbackRewardOpportunityEdge: Maybe<WinbackRewardOpportunitiesEdge>;
}


/** The output of our delete `WinbackRewardOpportunity` mutation. */
export interface DeleteWinbackRewardOpportunityPayloadWinbackRewardOpportunityEdgeArgs {
  orderBy?: InputMaybe<Array<WinbackRewardOpportunitiesOrderBy>>;
}

/** All input for the `deleteWinbackRewardOpportunityById` mutation. */
export interface DeleteWinbackRewardOpportunityByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteWinbackRewardOpportunityByPatientIdAndChallengeId` mutation. */
export interface DeleteWinbackRewardOpportunityByPatientIdAndChallengeIdInput {
  /** Unique identifier for this specific challenge instance (e.g., thanksgiving_2025_11_27) */
  challengeId: Scalars['String'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The patient given this challenge reward opportunity */
  patientId: Scalars['UUID'];
}

export interface EnrollMemberInput {
  addressCity?: InputMaybe<Scalars['String']>;
  addressCountry?: InputMaybe<Scalars['String']>;
  addressState?: InputMaybe<Scalars['String']>;
  addressStreet?: InputMaybe<Scalars['String']>;
  addressStreet2?: InputMaybe<Scalars['String']>;
  addressValidated?: InputMaybe<Scalars['Boolean']>;
  addressZip?: InputMaybe<Scalars['String']>;
  asOfDate?: InputMaybe<Scalars['Date']>;
  birthdate: Scalars['Date'];
  customerId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  introductionToWellth?: InputMaybe<IntroductionToWellthOptions>;
  language: LanguageCode;
  lastName: Scalars['String'];
  paymentOptionsId?: InputMaybe<Scalars['UUID']>;
  phoneNumber: Scalars['String'];
  programCode: Scalars['String'];
  prospectId?: InputMaybe<Scalars['UUID']>;
  reminderList?: InputMaybe<Array<InputMaybe<ReminderConfigLiteInput>>>;
  siteName?: InputMaybe<Scalars['String']>;
  timezone: Scalars['String'];
  typeOfEnrollment?: InputMaybe<TypeOfEnrollmentOptions>;
  welcomeMessage: Scalars['String'];
}

export enum IntroductionToWellthOptions {
  Clinician = 'clinician',
  CustomerCareTeam = 'customerCareTeam',
  CustomerDirectEmail = 'customerDirectEmail',
  CustomerDirectMail = 'customerDirectMail',
  CustomerEmail = 'customerEmail',
  CustomerFlyerHandout = 'customerFlyerHandout',
  CustomerMailer = 'customerMailer',
  CustomerPhoneCall = 'customerPhoneCall',
  CustomerTextMessage = 'customerTextMessage',
  CustomerWebsite = 'customerWebsite',
  DirectMailFromWellth = 'directMailFromWellth',
  EmailFromWellth = 'emailFromWellth',
  FamilyOrFriends = 'familyOrFriends',
  FlyerBrochure = 'flyerBrochure',
  Other = 'other',
  ParticipatedInPreviousProgram = 'participatedInPreviousProgram',
  PhoneCallFromWellth = 'phoneCallFromWellth',
  Provider = 'provider',
  SmsTextFromWellth = 'smsTextFromWellth',
  SocialMediaAd = 'socialMediaAd',
  WellthBifold = 'wellthBifold',
  WellthEmail = 'wellthEmail',
  WellthFacebookAd = 'wellthFacebookAd',
  WellthFlyer = 'wellthFlyer',
  WellthLetter = 'wellthLetter',
  WellthPhoneCall = 'wellthPhoneCall',
  WellthPostcard = 'wellthPostcard',
  WellthTextMessage = 'wellthTextMessage',
  WellthWebsite = 'wellthWebsite',
  WordOfMouth = 'wordOfMouth'
}

export interface ReminderConfigLiteInput {
  checkInCategory?: InputMaybe<CheckInCategory>;
  friTime?: InputMaybe<Scalars['Time']>;
  id?: InputMaybe<Scalars['String']>;
  interval?: InputMaybe<ReminderInterval>;
  intervalCount?: InputMaybe<Scalars['Int']>;
  isDemo?: InputMaybe<Scalars['Boolean']>;
  isRequired?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  lengthInDays?: InputMaybe<Scalars['Int']>;
  monTime?: InputMaybe<Scalars['Time']>;
  satTime?: InputMaybe<Scalars['Time']>;
  startDayIndex?: InputMaybe<Scalars['Int']>;
  sunTime?: InputMaybe<Scalars['Time']>;
  thuTime?: InputMaybe<Scalars['Time']>;
  tueTime?: InputMaybe<Scalars['Time']>;
  wedTime?: InputMaybe<Scalars['Time']>;
  windowAfterMinutes?: InputMaybe<Scalars['Int']>;
  windowBeforeMinutes?: InputMaybe<Scalars['Int']>;
}

export interface EnrollMemberPayload {
  __typename: 'EnrollMemberPayload';
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  memberId: Scalars['UUID'];
  memberNodeId: Scalars['ID'];
}

export interface EnrollPaperMemberInput {
  addressCity?: InputMaybe<Scalars['String']>;
  addressCountry?: InputMaybe<Scalars['String']>;
  addressState?: InputMaybe<Scalars['String']>;
  addressStreet?: InputMaybe<Scalars['String']>;
  addressStreet2?: InputMaybe<Scalars['String']>;
  addressZip?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  paymentOptionsId?: InputMaybe<Scalars['UUID']>;
  phoneNumber: Scalars['String'];
  programCode: Scalars['String'];
  prospectId?: InputMaybe<Scalars['UUID']>;
}

export interface EnrollPaperMemberPayload {
  __typename: 'EnrollPaperMemberPayload';
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  memberId: Scalars['UUID'];
  shortId: Scalars['String'];
}

export interface ExtendMembersInput {
  amount?: InputMaybe<Scalars['String']>;
  extensionType: ExtensionType;
  memberIds?: InputMaybe<Array<Scalars['UUID']>>;
  numberOfPeriods?: InputMaybe<Scalars['Int']>;
  programCode: Scalars['String'];
  targetDate?: InputMaybe<Scalars['Date']>;
}

export enum ExtensionType {
  ByCount = 'BY_COUNT',
  ThroughDate = 'THROUGH_DATE'
}

export interface ExtendMembersPayload {
  __typename: 'ExtendMembersPayload';
  requestId: Scalars['String'];
  totalChunks: Scalars['Int'];
}

export interface GenerateNumericPatientLoginTokenInput {
  clientMutationId?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<ISOLanguage>;
  phoneNumber: Scalars['String'];
}

export interface GenerateNumericPatientLoginTokenPayload {
  __typename: 'GenerateNumericPatientLoginTokenPayload';
  clientMutationId: Maybe<Scalars['String']>;
  query: Maybe<Query>;
  wellthId: Maybe<Scalars['String']>;
}

export interface GeneratePatientLoginTokenInput {
  clientMutationId?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<ISOLanguage>;
  phoneNumber: Scalars['String'];
}

export interface GeneratePatientLoginTokenPayload {
  __typename: 'GeneratePatientLoginTokenPayload';
  clientMutationId: Maybe<Scalars['String']>;
  query: Maybe<Query>;
}

/** All input for the `generateRandomString` mutation. */
export interface GenerateRandomStringInput {
  chars?: InputMaybe<Scalars['String']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  length?: InputMaybe<Scalars['Int']>;
}

/** The output of our `generateRandomString` mutation. */
export interface GenerateRandomStringPayload {
  __typename: 'GenerateRandomStringPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  string: Maybe<Scalars['String']>;
}

/** All input for the `generateRefreshToken` mutation. */
export interface GenerateRefreshTokenInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  phoneNumber: Scalars['String'];
}

/** The output of our `generateRefreshToken` mutation. */
export interface GenerateRefreshTokenPayload {
  __typename: 'GenerateRefreshTokenPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  string: Maybe<Scalars['String']>;
}

export interface GenerateTestRefreshTokenInput {
  clientMutationId?: InputMaybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
}

export interface GenerateTestRefreshTokenPayload {
  __typename: 'GenerateTestRefreshTokenPayload';
  clientMutationId: Maybe<Scalars['String']>;
  onboardingInformation: Maybe<OnboardingInformation>;
  refreshToken: Scalars['String'];
}

export interface Token {
  __typename: 'Token';
  jwtToken: Maybe<Scalars['String']>;
}

export interface GraduateMembersInput {
  graduationDate: Scalars['Date'];
  graduationType: GraduationType;
  inactivatePaused?: InputMaybe<Scalars['Boolean']>;
  memberIds: Array<Scalars['UUID']>;
  programCode: Scalars['String'];
}

export enum GraduationType {
  GraduateAfter = 'GRADUATE_AFTER',
  GraduateBy = 'GRADUATE_BY'
}

export interface GraduateMembersPayload {
  __typename: 'GraduateMembersPayload';
  requestId: Scalars['String'];
  totalChunks: Scalars['Int'];
}

/** All input for the `heartbeatPing` mutation. */
export interface HeartbeatPingInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
}

/** The output of our `heartbeatPing` mutation. */
export interface HeartbeatPingPayload {
  __typename: 'HeartbeatPingPayload';
  boolean: Maybe<Scalars['Boolean']>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}

export interface PrepareTestAccountInput {
  clientMutationId?: InputMaybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  programCode?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
}

export interface PrepareTestAccountPayload {
  __typename: 'PrepareTestAccountPayload';
  clientMutationId: Maybe<Scalars['String']>;
  onboardingInformation: Maybe<OnboardingInformation>;
  query: Maybe<Query>;
  string: Maybe<Scalars['String']>;
  wellthId: Maybe<Scalars['String']>;
}

export interface PrepareTestProspectInput {
  isEligibleForSelfServe?: InputMaybe<Scalars['Boolean']>;
  phoneNumber: Scalars['String'];
}

export interface PrepareTestProspectPayload {
  __typename: 'PrepareTestProspectPayload';
  externalId: Maybe<Scalars['String']>;
  wellthId: Maybe<Scalars['String']>;
}

/** All input for the `reauthenticatePatient` mutation. */
export interface ReauthenticatePatientInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  refreshToken: Scalars['String'];
}

/** The output of our `reauthenticatePatient` mutation. */
export interface ReauthenticatePatientPayload {
  __typename: 'ReauthenticatePatientPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  jwtToken: Maybe<Scalars['JwtToken']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}

export interface ReindexAllPersonsPayload {
  __typename: 'ReindexAllPersonsPayload';
  message: Scalars['String'];
  status: Scalars['String'];
}

export interface RemoveTagInput {
  id: Scalars['UUID'];
}

export interface SelfServeEnrollInput {
  monthAndDay: MonthAndDayInput;
  phoneNumber: Scalars['String'];
  zipCode?: InputMaybe<Scalars['String']>;
}

export interface MonthAndDayInput {
  day: Scalars['Int'];
  month: Scalars['Int'];
}

export interface OneOffSenderInput {
  message: Scalars['String'];
  phoneNumberConfig?: InputMaybe<PhoneNumberConfig>;
  recipientPhoneNumber: Scalars['String'];
  wellthId?: InputMaybe<Scalars['UUID']>;
}

export enum PhoneNumberConfig {
  LongCode = 'long_code',
  ShortCode = 'short_code'
}

export interface SetPrimaryAddressInput {
  city: Scalars['String'];
  country: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
  street: Scalars['String'];
  street2?: InputMaybe<Scalars['String']>;
  zip: Scalars['String'];
}

export interface SetPrimaryAddressPayload extends AddressPayload {
  __typename: 'SetPrimaryAddressPayload';
  address: Maybe<Address>;
  clientMutationId: Maybe<Scalars['String']>;
}

export interface SpendPatientLoginTokenInput {
  clientMutationId?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<ISOLanguage>;
  token: Scalars['String'];
}

export interface SpendPatientLoginTokenPayload {
  __typename: 'SpendPatientLoginTokenPayload';
  clientMutationId: Maybe<Scalars['String']>;
  loginResult: Maybe<LoginResult>;
  query: Maybe<Query>;
}

export interface LoginResult {
  __typename: 'LoginResult';
  refreshToken: Maybe<Scalars['String']>;
}

export interface SpendPatientLoginTokenAndPhoneNumberInput {
  clientMutationId?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<ISOLanguage>;
  phoneNumber: Scalars['String'];
  token: Scalars['String'];
}

export interface SpendPatientLoginTokenAndPhoneNumberPayload {
  __typename: 'SpendPatientLoginTokenAndPhoneNumberPayload';
  clientMutationId: Maybe<Scalars['String']>;
  loginResult: Maybe<LoginResult>;
  onboardingInformation: Maybe<OnboardingInformation>;
  query: Maybe<Query>;
}

export interface CreateMetricRangeInput {
  lowerLimit: Scalars['Int'];
  name: MetricName;
  unit: MetricUnit;
  upperLimit: Scalars['Int'];
  wellthId: Scalars['UUID'];
}

export interface SubmitPauseRequestInput {
  clientMutationId?: InputMaybe<Scalars['String']>;
  memberId?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
}

export interface SubmitPauseRequestPayload {
  __typename: 'SubmitPauseRequestPayload';
  boolean: Maybe<Scalars['Boolean']>;
  clientMutationId: Maybe<Scalars['String']>;
}

export interface SubmitUnpauseRequestInput {
  clientMutationId?: InputMaybe<Scalars['String']>;
  memberId?: InputMaybe<Scalars['UUID']>;
}

export interface SubmitUnpauseRequestPayload {
  __typename: 'SubmitUnpauseRequestPayload';
  boolean: Maybe<Scalars['Boolean']>;
  clientMutationId: Maybe<Scalars['String']>;
}

export interface SmsTestMessageRecipientInput {
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
}

export interface TrackTermsAgreementInput {
  memberId: Scalars['String'];
  privacyPolicyTimestamp?: InputMaybe<Scalars['Date']>;
  termsOfServiceTimestamp?: InputMaybe<Scalars['Date']>;
}

/** All input for the `updateAccountTransaction` mutation. */
export interface UpdateAccountTransactionInput {
  /** An object where the defined keys will be set on the `AccountTransaction` being updated. */
  accountTransactionPatch: AccountTransactionPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `AccountTransaction` to be updated. */
  nodeId: Scalars['ID'];
}

/** Represents an update to a `AccountTransaction`. Fields that are set will be updated. */
export interface AccountTransactionPatch {
  /** The amount of money (positive is a credit, negative is a debit) added to the account's balance during this transaction. */
  amount?: InputMaybe<Scalars['BigFloat']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** The currency of this transaction. */
  currency?: InputMaybe<Currency>;
  /** The date at which this account_transaction occurred. */
  date?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** An optional freetext note about this transaction. */
  note?: InputMaybe<Scalars['String']>;
  /** The patient which owns this account_transaction. */
  patientId?: InputMaybe<Scalars['UUID']>;
  /** The reason for which this transaction occurred. */
  reason?: InputMaybe<AccountTransactionReason>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our update `AccountTransaction` mutation. */
export interface UpdateAccountTransactionPayload {
  __typename: 'UpdateAccountTransactionPayload';
  /** The `AccountTransaction` that was updated by this mutation. */
  accountTransaction: Maybe<AccountTransaction>;
  /** An edge for our `AccountTransaction`. May be used by Relay 1. */
  accountTransactionEdge: Maybe<AccountTransactionsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Patient` that is related to this `AccountTransaction`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our update `AccountTransaction` mutation. */
export interface UpdateAccountTransactionPayloadAccountTransactionEdgeArgs {
  orderBy?: InputMaybe<Array<AccountTransactionsOrderBy>>;
}

/** All input for the `updateAccountTransactionById` mutation. */
export interface UpdateAccountTransactionByIdInput {
  /** An object where the defined keys will be set on the `AccountTransaction` being updated. */
  accountTransactionPatch: AccountTransactionPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `updateActionLog` mutation. */
export interface UpdateActionLogInput {
  /** An object where the defined keys will be set on the `ActionLog` being updated. */
  actionLogPatch: ActionLogPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ActionLog` to be updated. */
  nodeId: Scalars['ID'];
}

/** Represents an update to a `ActionLog`. Fields that are set will be updated. */
export interface ActionLogPatch {
  /** The type of action that was taken. */
  actionName?: InputMaybe<Scalars['String']>;
  /** The timestamp when the action was taken. */
  actionTime?: InputMaybe<Scalars['Datetime']>;
  /** The type of actor for which the action was created. */
  actor?: InputMaybe<ActorCode>;
  /** The unique identifier for the given admin if the actor was an admin. */
  adminId?: InputMaybe<Scalars['UUID']>;
  /** A JSON object of the changed object after the action was taken. */
  after?: InputMaybe<Scalars['JSON']>;
  /** A JSON object of the changed object before the action was taken. */
  before?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  diff?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** The actor's ip address from where the action was taken. */
  ipAddress?: InputMaybe<Scalars['String']>;
  /** The unique identifier for the specific object that the action was taken on. */
  objectId?: InputMaybe<Scalars['UUID']>;
  /** The type of object that the action was taken on. */
  objectType?: InputMaybe<Scalars['String']>;
  /** The unique identifier given to the patient that the action was taken on. */
  patientId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our update `ActionLog` mutation. */
export interface UpdateActionLogPayload {
  __typename: 'UpdateActionLogPayload';
  /** The `ActionLog` that was updated by this mutation. */
  actionLog: Maybe<ActionLog>;
  /** An edge for our `ActionLog`. May be used by Relay 1. */
  actionLogEdge: Maybe<ActionLogsEdge>;
  /** Reads a single `Admin` that is related to this `ActionLog`. */
  adminByAdminId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Patient` that is related to this `ActionLog`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our update `ActionLog` mutation. */
export interface UpdateActionLogPayloadActionLogEdgeArgs {
  orderBy?: InputMaybe<Array<ActionLogsOrderBy>>;
}

/** All input for the `updateActionLogById` mutation. */
export interface UpdateActionLogByIdInput {
  /** An object where the defined keys will be set on the `ActionLog` being updated. */
  actionLogPatch: ActionLogPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

export interface UpdateAddressInput {
  addressPatch: AddressPatch;
  clientMutationId?: InputMaybe<Scalars['String']>;
}

export interface AddressPatch {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  street2?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
}

export interface UpdateAddressPayload extends AddressPayload {
  __typename: 'UpdateAddressPayload';
  address: Maybe<Address>;
  clientMutationId: Maybe<Scalars['String']>;
}

/** All input for the `updateAdmin` mutation. */
export interface UpdateAdminInput {
  /** An object where the defined keys will be set on the `Admin` being updated. */
  adminPatch: AdminPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Admin` to be updated. */
  nodeId: Scalars['ID'];
}

/** Represents an update to a `Admin`. Fields that are set will be updated. */
export interface AdminPatch {
  adminRoleId?: InputMaybe<Scalars['UUID']>;
  /** The administrator's birth date. */
  birthDate?: InputMaybe<Scalars['Date']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** A string array of customers the admin is allowed to edit */
  customerAssociations?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The administrator's first name. */
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** The administrator's last name. */
  lastName?: InputMaybe<Scalars['String']>;
  middleName?: InputMaybe<Scalars['String']>;
  /** The administrator's phone number. */
  phoneNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our update `Admin` mutation. */
export interface UpdateAdminPayload {
  __typename: 'UpdateAdminPayload';
  /** The `Admin` that was updated by this mutation. */
  admin: Maybe<Admin>;
  /** An edge for our `Admin`. May be used by Relay 1. */
  adminEdge: Maybe<AdminsEdge>;
  /** Reads a single `AdminRole` that is related to this `Admin`. */
  adminRoleByAdminRoleId: Maybe<AdminRole>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our update `Admin` mutation. */
export interface UpdateAdminPayloadAdminEdgeArgs {
  orderBy?: InputMaybe<Array<AdminsOrderBy>>;
}

/** All input for the `updateAdminById` mutation. */
export interface UpdateAdminByIdInput {
  /** An object where the defined keys will be set on the `Admin` being updated. */
  adminPatch: AdminPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `updateAdminRole` mutation. */
export interface UpdateAdminRoleInput {
  /** An object where the defined keys will be set on the `AdminRole` being updated. */
  adminRolePatch: AdminRolePatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `AdminRole` to be updated. */
  nodeId: Scalars['ID'];
}

/** Represents an update to a `AdminRole`. Fields that are set will be updated. */
export interface AdminRolePatch {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our update `AdminRole` mutation. */
export interface UpdateAdminRolePayload {
  __typename: 'UpdateAdminRolePayload';
  /** The `AdminRole` that was updated by this mutation. */
  adminRole: Maybe<AdminRole>;
  /** An edge for our `AdminRole`. May be used by Relay 1. */
  adminRoleEdge: Maybe<AdminRolesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our update `AdminRole` mutation. */
export interface UpdateAdminRolePayloadAdminRoleEdgeArgs {
  orderBy?: InputMaybe<Array<AdminRolesOrderBy>>;
}

/** All input for the `updateAdminRoleById` mutation. */
export interface UpdateAdminRoleByIdInput {
  /** An object where the defined keys will be set on the `AdminRole` being updated. */
  adminRolePatch: AdminRolePatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `updateAdminRoleByName` mutation. */
export interface UpdateAdminRoleByNameInput {
  /** An object where the defined keys will be set on the `AdminRole` being updated. */
  adminRolePatch: AdminRolePatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
}

/** All input for the `updateAdminRolePrivilegedAction` mutation. */
export interface UpdateAdminRolePrivilegedActionInput {
  /** An object where the defined keys will be set on the `AdminRolePrivilegedAction` being updated. */
  adminRolePrivilegedActionPatch: AdminRolePrivilegedActionPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `AdminRolePrivilegedAction` to be updated. */
  nodeId: Scalars['ID'];
}

/** Represents an update to a `AdminRolePrivilegedAction`. Fields that are set will be updated. */
export interface AdminRolePrivilegedActionPatch {
  adminRoleId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  privilegedActionId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our update `AdminRolePrivilegedAction` mutation. */
export interface UpdateAdminRolePrivilegedActionPayload {
  __typename: 'UpdateAdminRolePrivilegedActionPayload';
  /** Reads a single `AdminRole` that is related to this `AdminRolePrivilegedAction`. */
  adminRoleByAdminRoleId: Maybe<AdminRole>;
  /** The `AdminRolePrivilegedAction` that was updated by this mutation. */
  adminRolePrivilegedAction: Maybe<AdminRolePrivilegedAction>;
  /** An edge for our `AdminRolePrivilegedAction`. May be used by Relay 1. */
  adminRolePrivilegedActionEdge: Maybe<AdminRolePrivilegedActionsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `PrivilegedAction` that is related to this `AdminRolePrivilegedAction`. */
  privilegedActionByPrivilegedActionId: Maybe<PrivilegedAction>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our update `AdminRolePrivilegedAction` mutation. */
export interface UpdateAdminRolePrivilegedActionPayloadAdminRolePrivilegedActionEdgeArgs {
  orderBy?: InputMaybe<Array<AdminRolePrivilegedActionsOrderBy>>;
}

/** All input for the `updateAdminRolePrivilegedActionById` mutation. */
export interface UpdateAdminRolePrivilegedActionByIdInput {
  /** An object where the defined keys will be set on the `AdminRolePrivilegedAction` being updated. */
  adminRolePrivilegedActionPatch: AdminRolePrivilegedActionPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `updateBonusBehaviorSubmissionStatus` mutation. */
export interface UpdateBonusBehaviorSubmissionStatusInput {
  /** An object where the defined keys will be set on the `BonusBehaviorSubmissionStatus` being updated. */
  bonusBehaviorSubmissionStatusPatch: BonusBehaviorSubmissionStatusPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `BonusBehaviorSubmissionStatus` to be updated. */
  nodeId: Scalars['ID'];
}

/** Represents an update to a `BonusBehaviorSubmissionStatus`. Fields that are set will be updated. */
export interface BonusBehaviorSubmissionStatusPatch {
  actor?: InputMaybe<ActorCode>;
  actorId?: InputMaybe<Scalars['String']>;
  bonusBehaviorSubmissionId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  statusTransitionTimestamp?: InputMaybe<Scalars['Datetime']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our update `BonusBehaviorSubmissionStatus` mutation. */
export interface UpdateBonusBehaviorSubmissionStatusPayload {
  __typename: 'UpdateBonusBehaviorSubmissionStatusPayload';
  /** The `BonusBehaviorSubmissionStatus` that was updated by this mutation. */
  bonusBehaviorSubmissionStatus: Maybe<BonusBehaviorSubmissionStatus>;
  /** An edge for our `BonusBehaviorSubmissionStatus`. May be used by Relay 1. */
  bonusBehaviorSubmissionStatusEdge: Maybe<BonusBehaviorSubmissionStatusesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our update `BonusBehaviorSubmissionStatus` mutation. */
export interface UpdateBonusBehaviorSubmissionStatusPayloadBonusBehaviorSubmissionStatusEdgeArgs {
  orderBy?: InputMaybe<Array<BonusBehaviorSubmissionStatusesOrderBy>>;
}

/** All input for the `updateBonusBehaviorSubmissionStatusByBonusBehaviorSubmissionIdAndCreatedAtAndValue` mutation. */
export interface UpdateBonusBehaviorSubmissionStatusByBonusBehaviorSubmissionIdAndCreatedAtAndValueInput {
  bonusBehaviorSubmissionId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `BonusBehaviorSubmissionStatus` being updated. */
  bonusBehaviorSubmissionStatusPatch: BonusBehaviorSubmissionStatusPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  value: Scalars['String'];
}

/** All input for the `updateBonusBehaviorSubmissionStatusById` mutation. */
export interface UpdateBonusBehaviorSubmissionStatusByIdInput {
  /** An object where the defined keys will be set on the `BonusBehaviorSubmissionStatus` being updated. */
  bonusBehaviorSubmissionStatusPatch: BonusBehaviorSubmissionStatusPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `updateCheckIn` mutation. */
export interface UpdateCheckInInput {
  /** An object where the defined keys will be set on the `CheckIn` being updated. */
  checkInPatch: CheckInPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `CheckIn` to be updated. */
  nodeId: Scalars['ID'];
}

/** Represents an update to a `CheckIn`. Fields that are set will be updated. */
export interface CheckInPatch {
  /** The category of this check-in. */
  category?: InputMaybe<CheckInCategory>;
  /** The timestamp on the patient's device at the time of check-in. */
  checkInTimestamp?: InputMaybe<Scalars['Datetime']>;
  /** The local timezone on the patient's device at the time of check-in. */
  checkInTimezone?: InputMaybe<Scalars['Timezone']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  creditedReason?: InputMaybe<Scalars['String']>;
  creditedReasonDetail?: InputMaybe<Scalars['String']>;
  creditedReasonNote?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isCredited?: InputMaybe<Scalars['Boolean']>;
  /** The object detection status of this check-in, set by the automatic object detection worker. */
  objectDetectionStatus?: InputMaybe<ObjectDetectionStatus>;
  patientId?: InputMaybe<Scalars['UUID']>;
  /** The URL of the large photo for this check-in; optional. */
  photoUrl?: InputMaybe<Scalars['String']>;
  /** The ID of the reminder from which this check-in originated. */
  reminderId?: InputMaybe<Scalars['UUID']>;
  /** The URL of the small photo for this check-in; optional. */
  thumbnailUrl?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** The verification status of this check-in, set by Wellth administrators. */
  verificationStatus?: InputMaybe<VerificationStatus>;
  /** The id of the Wellth administrator who verified this check-in, if any. */
  verifierId?: InputMaybe<Scalars['UUID']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our update `CheckIn` mutation. */
export interface UpdateCheckInPayload {
  __typename: 'UpdateCheckInPayload';
  /** Reads a single `Admin` that is related to this `CheckIn`. */
  adminByVerifierId: Maybe<Admin>;
  /** The `CheckIn` that was updated by this mutation. */
  checkIn: Maybe<CheckIn>;
  /** An edge for our `CheckIn`. May be used by Relay 1. */
  checkInEdge: Maybe<CheckInsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Patient` that is related to this `CheckIn`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Reminder` that is related to this `CheckIn`. */
  reminderByReminderId: Maybe<Reminder>;
}


/** The output of our update `CheckIn` mutation. */
export interface UpdateCheckInPayloadCheckInEdgeArgs {
  orderBy?: InputMaybe<Array<CheckInsOrderBy>>;
}

/** All input for the `updateCheckInById` mutation. */
export interface UpdateCheckInByIdInput {
  /** An object where the defined keys will be set on the `CheckIn` being updated. */
  checkInPatch: CheckInPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
}

export interface ContactPatch {
  description?: InputMaybe<Scalars['String']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  relationship?: InputMaybe<RelationshipType>;
  timezone?: InputMaybe<Scalars['String']>;
}

/** All input for the `updateCueCheckIn` mutation. */
export interface UpdateCueCheckInInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `CueCheckIn` being updated. */
  cueCheckInPatch: CueCheckInPatch;
  /** The globally unique `ID` which will identify a single `CueCheckIn` to be updated. */
  nodeId: Scalars['ID'];
}

/** Represents an update to a `CueCheckIn`. Fields that are set will be updated. */
export interface CueCheckInPatch {
  category?: InputMaybe<CheckInCategory>;
  checkInTimestamp?: InputMaybe<Scalars['Datetime']>;
  checkInTimezone?: InputMaybe<Scalars['Timezone']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  creditedReason?: InputMaybe<Scalars['String']>;
  creditedReasonDetail?: InputMaybe<Scalars['String']>;
  creditedReasonNote?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isCredited?: InputMaybe<Scalars['Boolean']>;
  /** A label used by the cue reminder. Exists here as reference */
  label?: InputMaybe<Scalars['String']>;
  objectDetectionStatus?: InputMaybe<ObjectDetectionStatus>;
  patientId?: InputMaybe<Scalars['UUID']>;
  photoUrl?: InputMaybe<Scalars['String']>;
  reminderId?: InputMaybe<Scalars['UUID']>;
  thumbnailUrl?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  verificationStatus?: InputMaybe<VerificationStatus>;
  verifierId?: InputMaybe<Scalars['UUID']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our update `CueCheckIn` mutation. */
export interface UpdateCueCheckInPayload {
  __typename: 'UpdateCueCheckInPayload';
  /** Reads a single `Admin` that is related to this `CueCheckIn`. */
  adminByVerifierId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `CueCheckIn` that was updated by this mutation. */
  cueCheckIn: Maybe<CueCheckIn>;
  /** An edge for our `CueCheckIn`. May be used by Relay 1. */
  cueCheckInEdge: Maybe<CueCheckInsEdge>;
  /** Reads a single `Patient` that is related to this `CueCheckIn`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Reminder` that is related to this `CueCheckIn`. */
  reminderByReminderId: Maybe<Reminder>;
}


/** The output of our update `CueCheckIn` mutation. */
export interface UpdateCueCheckInPayloadCueCheckInEdgeArgs {
  orderBy?: InputMaybe<Array<CueCheckInsOrderBy>>;
}

/** All input for the `updateCueCheckInById` mutation. */
export interface UpdateCueCheckInByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `CueCheckIn` being updated. */
  cueCheckInPatch: CueCheckInPatch;
  id: Scalars['UUID'];
}

/** All input for the `updateCustomer` mutation. */
export interface UpdateCustomerInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Customer` being updated. */
  customerPatch: CustomerPatch;
  /** The globally unique `ID` which will identify a single `Customer` to be updated. */
  nodeId: Scalars['ID'];
}

/** Represents an update to a `Customer`. Fields that are set will be updated. */
export interface CustomerPatch {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our update `Customer` mutation. */
export interface UpdateCustomerPayload {
  __typename: 'UpdateCustomerPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `Customer` that was updated by this mutation. */
  customer: Maybe<Customer>;
  /** An edge for our `Customer`. May be used by Relay 1. */
  customerEdge: Maybe<CustomersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our update `Customer` mutation. */
export interface UpdateCustomerPayloadCustomerEdgeArgs {
  orderBy?: InputMaybe<Array<CustomersOrderBy>>;
}

/** All input for the `updateCustomerById` mutation. */
export interface UpdateCustomerByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Customer` being updated. */
  customerPatch: CustomerPatch;
  id: Scalars['UUID'];
}

/** All input for the `updateCustomerByName` mutation. */
export interface UpdateCustomerByNameInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Customer` being updated. */
  customerPatch: CustomerPatch;
  name: Scalars['String'];
}

/** All input for the `updateDebitCard` mutation. */
export interface UpdateDebitCardInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `DebitCard` being updated. */
  debitCardPatch: DebitCardPatch;
  /** The globally unique `ID` which will identify a single `DebitCard` to be updated. */
  nodeId: Scalars['ID'];
}

/** Represents an update to a `DebitCard`. Fields that are set will be updated. */
export interface DebitCardPatch {
  /** The latest retrieved balance on the card. */
  balance?: InputMaybe<Scalars['BigFloat']>;
  /** Card number as reported by API */
  cardNumber?: InputMaybe<Scalars['JSON']>;
  /** Status value of this card */
  cardStatus?: InputMaybe<Scalars['BigFloat']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** processor-specific card details. */
  details?: InputMaybe<Scalars['JSON']>;
  /** Expiration date of this card */
  expiryDate?: InputMaybe<Scalars['Date']>;
  /** Any extra details on the card provided by the payment processor. */
  extras?: InputMaybe<Scalars['JSON']>;
  /** The first name on the card. */
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** The last name on the card. */
  lastName?: InputMaybe<Scalars['String']>;
  /** The id of the patient who owns this debit card. */
  patientId?: InputMaybe<Scalars['UUID']>;
  /** The payment processor that created this debit card. */
  processor?: InputMaybe<PaymentProcessor>;
  /** The proxy card number, used to make transactions against the card without implicating PCI compliance. */
  proxyNumber?: InputMaybe<Scalars['String']>;
  /** The latest status of the card. */
  status?: InputMaybe<DebitCardStatus>;
  /** Status description of this card */
  statusDesc?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our update `DebitCard` mutation. */
export interface UpdateDebitCardPayload {
  __typename: 'UpdateDebitCardPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `DebitCard` that was updated by this mutation. */
  debitCard: Maybe<DebitCard>;
  /** An edge for our `DebitCard`. May be used by Relay 1. */
  debitCardEdge: Maybe<DebitCardsEdge>;
  /** Reads a single `Patient` that is related to this `DebitCard`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our update `DebitCard` mutation. */
export interface UpdateDebitCardPayloadDebitCardEdgeArgs {
  orderBy?: InputMaybe<Array<DebitCardsOrderBy>>;
}

/** All input for the `updateDebitCardBalance` mutation. */
export interface UpdateDebitCardBalanceInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `DebitCardBalance` being updated. */
  debitCardBalancePatch: DebitCardBalancePatch;
  /** The globally unique `ID` which will identify a single `DebitCardBalance` to be updated. */
  nodeId: Scalars['ID'];
}

/** Represents an update to a `DebitCardBalance`. Fields that are set will be updated. */
export interface DebitCardBalancePatch {
  /** The balance available to spend on the debit card at this point in time. */
  balance?: InputMaybe<Scalars['BigFloat']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** The id of the debit card to which this balance entry pertains. */
  debitCardId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** The id of the patient that owns the referenced debit card. */
  patientId?: InputMaybe<Scalars['UUID']>;
  /** The status of the debit card at this point in time. */
  status?: InputMaybe<DebitCardStatus>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our update `DebitCardBalance` mutation. */
export interface UpdateDebitCardBalancePayload {
  __typename: 'UpdateDebitCardBalancePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `DebitCardBalance` that was updated by this mutation. */
  debitCardBalance: Maybe<DebitCardBalance>;
  /** An edge for our `DebitCardBalance`. May be used by Relay 1. */
  debitCardBalanceEdge: Maybe<DebitCardBalancesEdge>;
  /** Reads a single `DebitCard` that is related to this `DebitCardBalance`. */
  debitCardByDebitCardId: Maybe<DebitCard>;
  /** Reads a single `Patient` that is related to this `DebitCardBalance`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our update `DebitCardBalance` mutation. */
export interface UpdateDebitCardBalancePayloadDebitCardBalanceEdgeArgs {
  orderBy?: InputMaybe<Array<DebitCardBalancesOrderBy>>;
}

/** All input for the `updateDebitCardBalanceById` mutation. */
export interface UpdateDebitCardBalanceByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `DebitCardBalance` being updated. */
  debitCardBalancePatch: DebitCardBalancePatch;
  id: Scalars['UUID'];
}

/** All input for the `updateDebitCardById` mutation. */
export interface UpdateDebitCardByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `DebitCard` being updated. */
  debitCardPatch: DebitCardPatch;
  id: Scalars['UUID'];
}

/** All input for the `updateDevice` mutation. */
export interface UpdateDeviceInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Device` being updated. */
  devicePatch: DevicePatch;
  /** The globally unique `ID` which will identify a single `Device` to be updated. */
  nodeId: Scalars['ID'];
}

/** Represents an update to a `Device`. Fields that are set will be updated. */
export interface DevicePatch {
  /** The ID of the admin who owns this device registration */
  adminId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** The identifier of the device, as created by the manufacturer. */
  identifier?: InputMaybe<Scalars['String']>;
  /** The patient to whom this device is currently assigned; may be null. */
  patientId?: InputMaybe<Scalars['UUID']>;
  /** The Wellth-assigned short identifier, e.g. ABCD, used to easily reference this specific device upon onboarding. */
  shortIdentifier?: InputMaybe<Scalars['String']>;
  /** The source of the device, e.g. Bodytrace */
  source?: InputMaybe<DeviceSource>;
  /** The type of the device, e.g. scale */
  type?: InputMaybe<DeviceType>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our update `Device` mutation. */
export interface UpdateDevicePayload {
  __typename: 'UpdateDevicePayload';
  /** Reads a single `Admin` that is related to this `Device`. */
  adminByAdminId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `Device` that was updated by this mutation. */
  device: Maybe<Device>;
  /** An edge for our `Device`. May be used by Relay 1. */
  deviceEdge: Maybe<DevicesEdge>;
  /** Reads a single `Patient` that is related to this `Device`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our update `Device` mutation. */
export interface UpdateDevicePayloadDeviceEdgeArgs {
  orderBy?: InputMaybe<Array<DevicesOrderBy>>;
}

/** All input for the `updateDeviceById` mutation. */
export interface UpdateDeviceByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Device` being updated. */
  devicePatch: DevicePatch;
  id: Scalars['UUID'];
}

export interface UpdateDialysisAppointmentReminderInput {
  /** Optional number of minutes before the appointment to send a reminder. Set to null to remove reminder. */
  reminderMinutesAdvance?: InputMaybe<Scalars['Int']>;
  scheduleJob: Scalars['String'];
}

export interface UpdateDialysisAppointmentReminderPayload {
  __typename: 'UpdateDialysisAppointmentReminderPayload';
  reminderMinutesAdvance: Maybe<Scalars['Int']>;
  scheduleJob: Scalars['String'];
}

export interface DisplayedHighlightInput {
  /** A universally unique identifier */
  id: Scalars['UUID'];
  /** The timestamp of the Highlight that was rendered to the client */
  renderTimestamp: Scalars['Datetime'];
  /** The timezone of the Highlight that was rendered to the client */
  renderTimezone?: InputMaybe<Scalars['Timezone']>;
}

export interface DisplayedHighlightPayload {
  __typename: 'DisplayedHighlightPayload';
  /** A universally unique identifier */
  id: Scalars['UUID'];
}

export interface UpdateEmailAddressInput {
  clientMutationId?: InputMaybe<Scalars['String']>;
  emailAddressPatch: EmailAddressPatch;
}

export interface EmailAddressPatch {
  emailAddress?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  isPrimary?: InputMaybe<Scalars['Boolean']>;
}

export interface UpdateEmailAddressPayload {
  __typename: 'UpdateEmailAddressPayload';
  clientMutationId: Maybe<Scalars['String']>;
  emailAddress: Maybe<EmailAddress>;
}

/** All input for the `updateGroup` mutation. */
export interface UpdateGroupInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Group` being updated. */
  groupPatch: GroupPatch;
  /** The globally unique `ID` which will identify a single `Group` to be updated. */
  nodeId: Scalars['ID'];
}

/** Represents an update to a `Group`. Fields that are set will be updated. */
export interface GroupPatch {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** The group's name. */
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our update `Group` mutation. */
export interface UpdateGroupPayload {
  __typename: 'UpdateGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `Group` that was updated by this mutation. */
  group: Maybe<Group>;
  /** An edge for our `Group`. May be used by Relay 1. */
  groupEdge: Maybe<GroupsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our update `Group` mutation. */
export interface UpdateGroupPayloadGroupEdgeArgs {
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
}

/** All input for the `updateGroupById` mutation. */
export interface UpdateGroupByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Group` being updated. */
  groupPatch: GroupPatch;
  id: Scalars['UUID'];
}

/** All input for the `updateHeartbeat` mutation. */
export interface UpdateHeartbeatInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Heartbeat` being updated. */
  heartbeatPatch: HeartbeatPatch;
  /** The globally unique `ID` which will identify a single `Heartbeat` to be updated. */
  nodeId: Scalars['ID'];
}

/** Represents an update to a `Heartbeat`. Fields that are set will be updated. */
export interface HeartbeatPatch {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** The ID of the patient whose app sent the heartbeat ping to the API. */
  patientId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our update `Heartbeat` mutation. */
export interface UpdateHeartbeatPayload {
  __typename: 'UpdateHeartbeatPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `Heartbeat` that was updated by this mutation. */
  heartbeat: Maybe<Heartbeat>;
  /** An edge for our `Heartbeat`. May be used by Relay 1. */
  heartbeatEdge: Maybe<HeartbeatsEdge>;
  /** Reads a single `Patient` that is related to this `Heartbeat`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our update `Heartbeat` mutation. */
export interface UpdateHeartbeatPayloadHeartbeatEdgeArgs {
  orderBy?: InputMaybe<Array<HeartbeatsOrderBy>>;
}

/** All input for the `updateHeartbeatById` mutation. */
export interface UpdateHeartbeatByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Heartbeat` being updated. */
  heartbeatPatch: HeartbeatPatch;
  id: Scalars['UUID'];
}

/** All input for the `updateHydrationCheckIn` mutation. */
export interface UpdateHydrationCheckInInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `HydrationCheckIn` being updated. */
  hydrationCheckInPatch: HydrationCheckInPatch;
  /** The globally unique `ID` which will identify a single `HydrationCheckIn` to be updated. */
  nodeId: Scalars['ID'];
}

/** Represents an update to a `HydrationCheckIn`. Fields that are set will be updated. */
export interface HydrationCheckInPatch {
  category?: InputMaybe<CheckInCategory>;
  checkInTimestamp?: InputMaybe<Scalars['Datetime']>;
  checkInTimezone?: InputMaybe<Scalars['Timezone']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  creditedReason?: InputMaybe<Scalars['String']>;
  creditedReasonDetail?: InputMaybe<Scalars['String']>;
  creditedReasonNote?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isCredited?: InputMaybe<Scalars['Boolean']>;
  objectDetectionStatus?: InputMaybe<ObjectDetectionStatus>;
  patientId?: InputMaybe<Scalars['UUID']>;
  photoUrl?: InputMaybe<Scalars['String']>;
  reminderId?: InputMaybe<Scalars['UUID']>;
  thumbnailUrl?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  verificationStatus?: InputMaybe<VerificationStatus>;
  verifierId?: InputMaybe<Scalars['UUID']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our update `HydrationCheckIn` mutation. */
export interface UpdateHydrationCheckInPayload {
  __typename: 'UpdateHydrationCheckInPayload';
  /** Reads a single `Admin` that is related to this `HydrationCheckIn`. */
  adminByVerifierId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `HydrationCheckIn` that was updated by this mutation. */
  hydrationCheckIn: Maybe<HydrationCheckIn>;
  /** An edge for our `HydrationCheckIn`. May be used by Relay 1. */
  hydrationCheckInEdge: Maybe<HydrationCheckInsEdge>;
  /** Reads a single `Patient` that is related to this `HydrationCheckIn`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Reminder` that is related to this `HydrationCheckIn`. */
  reminderByReminderId: Maybe<Reminder>;
}


/** The output of our update `HydrationCheckIn` mutation. */
export interface UpdateHydrationCheckInPayloadHydrationCheckInEdgeArgs {
  orderBy?: InputMaybe<Array<HydrationCheckInsOrderBy>>;
}

/** All input for the `updateHydrationCheckInById` mutation. */
export interface UpdateHydrationCheckInByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `HydrationCheckIn` being updated. */
  hydrationCheckInPatch: HydrationCheckInPatch;
  id: Scalars['UUID'];
}

/** All input for the `updateMarvMigration` mutation. */
export interface UpdateMarvMigrationInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `MarvMigration` being updated. */
  marvMigrationPatch: MarvMigrationPatch;
  /** The globally unique `ID` which will identify a single `MarvMigration` to be updated. */
  nodeId: Scalars['ID'];
}

/** Represents an update to a `MarvMigration`. Fields that are set will be updated. */
export interface MarvMigrationPatch {
  checksum?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  level?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Datetime']>;
}

/** The output of our update `MarvMigration` mutation. */
export interface UpdateMarvMigrationPayload {
  __typename: 'UpdateMarvMigrationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `MarvMigration` that was updated by this mutation. */
  marvMigration: Maybe<MarvMigration>;
  /** An edge for our `MarvMigration`. May be used by Relay 1. */
  marvMigrationEdge: Maybe<MarvMigrationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our update `MarvMigration` mutation. */
export interface UpdateMarvMigrationPayloadMarvMigrationEdgeArgs {
  orderBy?: InputMaybe<Array<MarvMigrationsOrderBy>>;
}

/** All input for the `updateMarvMigrationByLevelAndNamespace` mutation. */
export interface UpdateMarvMigrationByLevelAndNamespaceInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  level: Scalars['Int'];
  /** An object where the defined keys will be set on the `MarvMigration` being updated. */
  marvMigrationPatch: MarvMigrationPatch;
  namespace: Scalars['String'];
}

/** All input for the `updateMealCheckIn` mutation. */
export interface UpdateMealCheckInInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `MealCheckIn` being updated. */
  mealCheckInPatch: MealCheckInPatch;
  /** The globally unique `ID` which will identify a single `MealCheckIn` to be updated. */
  nodeId: Scalars['ID'];
}

/** Represents an update to a `MealCheckIn`. Fields that are set will be updated. */
export interface MealCheckInPatch {
  category?: InputMaybe<CheckInCategory>;
  checkInTimestamp?: InputMaybe<Scalars['Datetime']>;
  checkInTimezone?: InputMaybe<Scalars['Timezone']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  creditedReason?: InputMaybe<Scalars['String']>;
  creditedReasonDetail?: InputMaybe<Scalars['String']>;
  creditedReasonNote?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isCredited?: InputMaybe<Scalars['Boolean']>;
  /** An array of food item names */
  items?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  objectDetectionStatus?: InputMaybe<ObjectDetectionStatus>;
  patientId?: InputMaybe<Scalars['UUID']>;
  photoUrl?: InputMaybe<Scalars['String']>;
  reminderId?: InputMaybe<Scalars['UUID']>;
  thumbnailUrl?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  verificationStatus?: InputMaybe<VerificationStatus>;
  verifierId?: InputMaybe<Scalars['UUID']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our update `MealCheckIn` mutation. */
export interface UpdateMealCheckInPayload {
  __typename: 'UpdateMealCheckInPayload';
  /** Reads a single `Admin` that is related to this `MealCheckIn`. */
  adminByVerifierId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `MealCheckIn` that was updated by this mutation. */
  mealCheckIn: Maybe<MealCheckIn>;
  /** An edge for our `MealCheckIn`. May be used by Relay 1. */
  mealCheckInEdge: Maybe<MealCheckInsEdge>;
  /** Reads a single `Patient` that is related to this `MealCheckIn`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Reminder` that is related to this `MealCheckIn`. */
  reminderByReminderId: Maybe<Reminder>;
}


/** The output of our update `MealCheckIn` mutation. */
export interface UpdateMealCheckInPayloadMealCheckInEdgeArgs {
  orderBy?: InputMaybe<Array<MealCheckInsOrderBy>>;
}

/** All input for the `updateMealCheckInById` mutation. */
export interface UpdateMealCheckInByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `MealCheckIn` being updated. */
  mealCheckInPatch: MealCheckInPatch;
}

/** All input for the `updateMeasurementCheckIn` mutation. */
export interface UpdateMeasurementCheckInInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `MeasurementCheckIn` being updated. */
  measurementCheckInPatch: MeasurementCheckInPatch;
  /** The globally unique `ID` which will identify a single `MeasurementCheckIn` to be updated. */
  nodeId: Scalars['ID'];
}

/** Represents an update to a `MeasurementCheckIn`. Fields that are set will be updated. */
export interface MeasurementCheckInPatch {
  category?: InputMaybe<CheckInCategory>;
  checkInTimestamp?: InputMaybe<Scalars['Datetime']>;
  checkInTimezone?: InputMaybe<Scalars['Timezone']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  creditedReason?: InputMaybe<Scalars['String']>;
  creditedReasonDetail?: InputMaybe<Scalars['String']>;
  creditedReasonNote?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isCredited?: InputMaybe<Scalars['Boolean']>;
  /** An array of measurement entries */
  measurements?: InputMaybe<Array<InputMaybe<MeasurementInput>>>;
  objectDetectionStatus?: InputMaybe<ObjectDetectionStatus>;
  patientId?: InputMaybe<Scalars['UUID']>;
  photoUrl?: InputMaybe<Scalars['String']>;
  reminderId?: InputMaybe<Scalars['UUID']>;
  thumbnailUrl?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  verificationStatus?: InputMaybe<VerificationStatus>;
  verifierId?: InputMaybe<Scalars['UUID']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our update `MeasurementCheckIn` mutation. */
export interface UpdateMeasurementCheckInPayload {
  __typename: 'UpdateMeasurementCheckInPayload';
  /** Reads a single `Admin` that is related to this `MeasurementCheckIn`. */
  adminByVerifierId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `MeasurementCheckIn` that was updated by this mutation. */
  measurementCheckIn: Maybe<MeasurementCheckIn>;
  /** An edge for our `MeasurementCheckIn`. May be used by Relay 1. */
  measurementCheckInEdge: Maybe<MeasurementCheckInsEdge>;
  /** Reads a single `Patient` that is related to this `MeasurementCheckIn`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Reminder` that is related to this `MeasurementCheckIn`. */
  reminderByReminderId: Maybe<Reminder>;
}


/** The output of our update `MeasurementCheckIn` mutation. */
export interface UpdateMeasurementCheckInPayloadMeasurementCheckInEdgeArgs {
  orderBy?: InputMaybe<Array<MeasurementCheckInsOrderBy>>;
}

/** All input for the `updateMeasurementCheckInById` mutation. */
export interface UpdateMeasurementCheckInByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `MeasurementCheckIn` being updated. */
  measurementCheckInPatch: MeasurementCheckInPatch;
}

/** All input for the `updateMedicationCheckIn` mutation. */
export interface UpdateMedicationCheckInInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `MedicationCheckIn` being updated. */
  medicationCheckInPatch: MedicationCheckInPatch;
  /** The globally unique `ID` which will identify a single `MedicationCheckIn` to be updated. */
  nodeId: Scalars['ID'];
}

/** Represents an update to a `MedicationCheckIn`. Fields that are set will be updated. */
export interface MedicationCheckInPatch {
  anomalyTypes?: InputMaybe<Scalars['JSON']>;
  /** Our AI's determination of whether this photo has medications; null if it hasn't been checked yet. */
  autoHasMeds?: InputMaybe<Scalars['Boolean']>;
  /** The number of medication objects our AI found in this photo; null if it hasn't been checked yet. */
  autoMedCount?: InputMaybe<Scalars['Int']>;
  category?: InputMaybe<CheckInCategory>;
  checkInTimestamp?: InputMaybe<Scalars['Datetime']>;
  checkInTimezone?: InputMaybe<Scalars['Timezone']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  creditedReason?: InputMaybe<Scalars['String']>;
  creditedReasonDetail?: InputMaybe<Scalars['String']>;
  creditedReasonNote?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isCredited?: InputMaybe<Scalars['Boolean']>;
  /** An administrator's determination of whether this photo has medications; null if it hasn't been checked yet. */
  manualHasMeds?: InputMaybe<Scalars['Boolean']>;
  /** The number of medication objects an administrator found in this photo; null if it hasn't been checked yet. */
  manualMedCount?: InputMaybe<Scalars['Int']>;
  objectDetectionStatus?: InputMaybe<ObjectDetectionStatus>;
  patientId?: InputMaybe<Scalars['UUID']>;
  photoUrl?: InputMaybe<Scalars['String']>;
  reminderId?: InputMaybe<Scalars['UUID']>;
  thumbnailUrl?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  verificationStatus?: InputMaybe<VerificationStatus>;
  verifierId?: InputMaybe<Scalars['UUID']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our update `MedicationCheckIn` mutation. */
export interface UpdateMedicationCheckInPayload {
  __typename: 'UpdateMedicationCheckInPayload';
  /** Reads a single `Admin` that is related to this `MedicationCheckIn`. */
  adminByVerifierId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `MedicationCheckIn` that was updated by this mutation. */
  medicationCheckIn: Maybe<MedicationCheckIn>;
  /** An edge for our `MedicationCheckIn`. May be used by Relay 1. */
  medicationCheckInEdge: Maybe<MedicationCheckInsEdge>;
  /** Reads a single `Patient` that is related to this `MedicationCheckIn`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Reminder` that is related to this `MedicationCheckIn`. */
  reminderByReminderId: Maybe<Reminder>;
}


/** The output of our update `MedicationCheckIn` mutation. */
export interface UpdateMedicationCheckInPayloadMedicationCheckInEdgeArgs {
  orderBy?: InputMaybe<Array<MedicationCheckInsOrderBy>>;
}

/** All input for the `updateMedicationCheckInById` mutation. */
export interface UpdateMedicationCheckInByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `MedicationCheckIn` being updated. */
  medicationCheckInPatch: MedicationCheckInPatch;
}

export interface MemberPatch {
  description?: InputMaybe<Scalars['String']>;
  eligibilityEndDate?: InputMaybe<Scalars['Date']>;
  externalId?: InputMaybe<Scalars['String']>;
  externalId2?: InputMaybe<Scalars['String']>;
  isAutoPauseEnabled?: InputMaybe<Scalars['Boolean']>;
  isLocalNotificationEnabled?: InputMaybe<Scalars['Boolean']>;
  isProductTourRecurring?: InputMaybe<Scalars['Boolean']>;
  isReminderEditingOpen?: InputMaybe<Scalars['Boolean']>;
  isReminderMessagingEnabled?: InputMaybe<Scalars['Boolean']>;
  isRestfulMember?: InputMaybe<Scalars['Boolean']>;
  isTestMember?: InputMaybe<Scalars['Boolean']>;
  paymentOptionsId?: InputMaybe<Scalars['String']>;
  person?: InputMaybe<PersonPatch>;
  siteName?: InputMaybe<Scalars['String']>;
}

export interface PersonPatch {
  addresses?: InputMaybe<Array<InputMaybe<AddressInput>>>;
  birthDate?: InputMaybe<Scalars['Date']>;
  emailAddresses?: InputMaybe<Array<InputMaybe<EmailAddressInput>>>;
  ethnicity?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  medicareId?: InputMaybe<Scalars['String']>;
  names?: InputMaybe<Array<InputMaybe<NameInput>>>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<PhoneNumberInput>>>;
  primaryLanguage?: InputMaybe<ISOLanguage>;
  primaryTimezone?: InputMaybe<Scalars['String']>;
  race?: InputMaybe<Scalars['String']>;
}

/** All input for the `updateMessage` mutation. */
export interface UpdateMessageInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Message` being updated. */
  messagePatch: MessagePatch;
  /** The globally unique `ID` which will identify a single `Message` to be updated. */
  nodeId: Scalars['ID'];
}

/** Represents an update to a `Message`. Fields that are set will be updated. */
export interface MessagePatch {
  /** The admin to or from whom this message is sent; optional */
  adminId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  mediaUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The content of the message. */
  message?: InputMaybe<Scalars['String']>;
  messageType?: InputMaybe<Scalars['String']>;
  /** The patient to or from whom this message is sent */
  patientId?: InputMaybe<Scalars['UUID']>;
  /** The protocol over which the message was sent. */
  protocol?: InputMaybe<MessageProtocol>;
  /** The party who is the recipient of this message */
  recipient?: InputMaybe<MessageRecipient>;
  /** The time at which to send the message. */
  sendAt?: InputMaybe<Scalars['Datetime']>;
  /** The time at which this message was sent. */
  sentDatetime?: InputMaybe<Scalars['Datetime']>;
  sentFrom?: InputMaybe<Scalars['String']>;
  /** The status of the message. */
  status?: InputMaybe<Scalars['String']>;
  /** The optional subject of the message (mostly applicable to emails). */
  subject?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our update `Message` mutation. */
export interface UpdateMessagePayload {
  __typename: 'UpdateMessagePayload';
  /** Reads a single `Admin` that is related to this `Message`. */
  adminByAdminId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `Message` that was updated by this mutation. */
  message: Maybe<Message>;
  /** An edge for our `Message`. May be used by Relay 1. */
  messageEdge: Maybe<MessagesEdge>;
  /** Reads a single `Patient` that is related to this `Message`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our update `Message` mutation. */
export interface UpdateMessagePayloadMessageEdgeArgs {
  orderBy?: InputMaybe<Array<MessagesOrderBy>>;
}

/** All input for the `updateMessageByExternalId` mutation. */
export interface UpdateMessageByExternalIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  externalId: Scalars['String'];
  /** An object where the defined keys will be set on the `Message` being updated. */
  messagePatch: MessagePatch;
}

/** All input for the `updateMessageById` mutation. */
export interface UpdateMessageByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Message` being updated. */
  messagePatch: MessagePatch;
}

export interface UpdateNameInput {
  clientMutationId?: InputMaybe<Scalars['String']>;
  namePatch: NamePatch;
}

export interface NamePatch {
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  middleName?: InputMaybe<Scalars['String']>;
}

export interface UpdateNamePayload {
  __typename: 'UpdateNamePayload';
  clientMutationId: Maybe<Scalars['String']>;
  name: Maybe<Name>;
}

/** All input for the `updateObjectDetection` mutation. */
export interface UpdateObjectDetectionInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ObjectDetection` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `ObjectDetection` being updated. */
  objectDetectionPatch: ObjectDetectionPatch;
}

/** Represents an update to a `ObjectDetection`. Fields that are set will be updated. */
export interface ObjectDetectionPatch {
  /** The bottom boundary of the object, relative to the image height. Range: [0.0, 1/0].  Top-left of image is (0.0, 0.0) */
  boundsBottom?: InputMaybe<Scalars['Float']>;
  /** The left boundary of the object, relative to the image height. Range: [0.0, 1/0].  Top-left of image is (0.0, 0.0) */
  boundsLeft?: InputMaybe<Scalars['Float']>;
  /** The right boundary of the object, relative to the image height. Range: [0.0, 1/0].  Top-left of image is (0.0, 0.0) */
  boundsRight?: InputMaybe<Scalars['Float']>;
  /** The top boundary of the object, relative to the image height. Range: [0.0, 1/0].  Top-left of image is (0.0, 0.0) */
  boundsTop?: InputMaybe<Scalars['Float']>;
  /** The check-in from which this detection was derived. */
  checkInId?: InputMaybe<Scalars['UUID']>;
  confidence?: InputMaybe<Scalars['Float']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  model?: InputMaybe<Scalars['String']>;
  /** The type of object detected in the check-in image. */
  objectType?: InputMaybe<Scalars['String']>;
  /** The patient that made the check-in from which this detection was derived. */
  patientId?: InputMaybe<Scalars['UUID']>;
  unit?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
}

/** The output of our update `ObjectDetection` mutation. */
export interface UpdateObjectDetectionPayload {
  __typename: 'UpdateObjectDetectionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `ObjectDetection` that was updated by this mutation. */
  objectDetection: Maybe<ObjectDetection>;
  /** An edge for our `ObjectDetection`. May be used by Relay 1. */
  objectDetectionEdge: Maybe<ObjectDetectionsEdge>;
  /** Reads a single `Patient` that is related to this `ObjectDetection`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our update `ObjectDetection` mutation. */
export interface UpdateObjectDetectionPayloadObjectDetectionEdgeArgs {
  orderBy?: InputMaybe<Array<ObjectDetectionsOrderBy>>;
}

/** All input for the `updateObjectDetectionById` mutation. */
export interface UpdateObjectDetectionByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ObjectDetection` being updated. */
  objectDetectionPatch: ObjectDetectionPatch;
}

export interface UpdatePatientInput {
  clientMutationId?: InputMaybe<Scalars['String']>;
  nodeId: Scalars['ID'];
  patientPatch: PatientPatch;
}

/** Represents an update to a `Patient`. Fields that are set will be updated. */
export interface PatientPatch {
  /** The Wellth Date of activation in the member's timezone at the moment of activation. */
  activationDate?: InputMaybe<Scalars['Date']>;
  /** The member's timezone at the moment of activation. */
  activationTimezone?: InputMaybe<Scalars['Timezone']>;
  activeDays?: InputMaybe<Scalars['Int']>;
  birthDate?: InputMaybe<Scalars['String']>;
  build?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** A free-form editable text field for relevant details about a patient that do not fit into other fields. */
  description?: InputMaybe<Scalars['String']>;
  eligibilityEndDate?: InputMaybe<Scalars['Date']>;
  email?: InputMaybe<Scalars['String']>;
  enrolledBy?: InputMaybe<Scalars['UUID']>;
  /** The Wellth Date of enrollment in the member's timezone at the moment of enrollment. */
  enrollmentDate?: InputMaybe<Scalars['Date']>;
  /** The member's timezone at the moment of enrollment. */
  enrollmentTimezone?: InputMaybe<Scalars['Timezone']>;
  /** The unique identifier given to the patient by our customer. */
  externalId?: InputMaybe<Scalars['String']>;
  externalId2?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** The Wellth Date of inactivation in the member's timezone at the moment of inactivation. */
  inactivationDate?: InputMaybe<Scalars['Date']>;
  /** The member's timezone at the moment of inactivation. */
  inactivationTimezone?: InputMaybe<Scalars['Timezone']>;
  introductionToWellth?: InputMaybe<Scalars['String']>;
  isAutoPauseEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Whether the patient is receiving local notifications. */
  isLocalNotificationEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Whether the patient has completed the in-app product tour. */
  isProductTourCompleted?: InputMaybe<Scalars['Boolean']>;
  /** Whether the product tour should always show for the patient when they open the app. */
  isProductTourRecurring?: InputMaybe<Scalars['Boolean']>;
  /** Whether the patient has the ability to add/edit/delete all fields on all reminders in place ("open" mode). */
  isReminderEditingOpen?: InputMaybe<Scalars['Boolean']>;
  /** Whether the patient is receiving sms notifications. */
  isReminderMessagingEnabled?: InputMaybe<Scalars['Boolean']>;
  isRestfulPatient?: InputMaybe<Scalars['Boolean']>;
  /** Whether the patient consents to the use of a wingperson(s). */
  isSidekickEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Whether the patient is a test patient; test patients should not receive payments, text messages, etc */
  isTestPatient?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<LanguageCode>;
  lastName?: InputMaybe<Scalars['String']>;
  liveProgramDays?: InputMaybe<Scalars['Int']>;
  /** The medicaid id of the person */
  medicaidId?: InputMaybe<Scalars['String']>;
  middleName?: InputMaybe<Scalars['String']>;
  missedCheckinStreak?: InputMaybe<Scalars['Int']>;
  /** The Wellth Date of onboarding in the member's timezone at the moment of onboarding. */
  onboardingDate?: InputMaybe<Scalars['Date']>;
  /** The member's timezone at the moment of onboarding. */
  onboardingTimezone?: InputMaybe<Scalars['Timezone']>;
  /** The pause status of the patient at the current time. */
  pauseStatus?: InputMaybe<PauseStatus>;
  paymentOptionsId?: InputMaybe<Scalars['UUID']>;
  personId?: InputMaybe<Scalars['UUID']>;
  platform?: InputMaybe<Scalars['String']>;
  prospectId?: InputMaybe<Scalars['UUID']>;
  secondaryPhoneNumber?: InputMaybe<Scalars['String']>;
  /** The name of the site where the patient was enrolled. */
  siteName?: InputMaybe<Scalars['String']>;
  typeOfEnrollment?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  version?: InputMaybe<Scalars['String']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

export interface UpdatePatientPayload {
  __typename: 'UpdatePatientPayload';
  clientMutationId: Maybe<Scalars['String']>;
  patient: Maybe<Patient>;
}

/** All input for the `updatePatientMembershipConfig` mutation. */
export interface UpdatePatientMembershipConfigInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `PatientMembershipConfig` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `PatientMembershipConfig` being updated. */
  patientMembershipConfigPatch: PatientMembershipConfigPatch;
}

/** Represents an update to a `PatientMembershipConfig`. Fields that are set will be updated. */
export interface PatientMembershipConfigPatch {
  /** The admin which owns this patient membership config. */
  adminId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** The group to which patients should be given membership. */
  groupId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** The id of the program to which this payment setup config is related. */
  programId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our update `PatientMembershipConfig` mutation. */
export interface UpdatePatientMembershipConfigPayload {
  __typename: 'UpdatePatientMembershipConfigPayload';
  /** Reads a single `Admin` that is related to this `PatientMembershipConfig`. */
  adminByAdminId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Group` that is related to this `PatientMembershipConfig`. */
  groupByGroupId: Maybe<Group>;
  /** The `PatientMembershipConfig` that was updated by this mutation. */
  patientMembershipConfig: Maybe<PatientMembershipConfig>;
  /** An edge for our `PatientMembershipConfig`. May be used by Relay 1. */
  patientMembershipConfigEdge: Maybe<PatientMembershipConfigsEdge>;
  /** Reads a single `Program` that is related to this `PatientMembershipConfig`. */
  programByProgramId: Maybe<Program>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our update `PatientMembershipConfig` mutation. */
export interface UpdatePatientMembershipConfigPayloadPatientMembershipConfigEdgeArgs {
  orderBy?: InputMaybe<Array<PatientMembershipConfigsOrderBy>>;
}

/** All input for the `updatePatientMembershipConfigById` mutation. */
export interface UpdatePatientMembershipConfigByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `PatientMembershipConfig` being updated. */
  patientMembershipConfigPatch: PatientMembershipConfigPatch;
}

/** All input for the `updatePatientStatus` mutation. */
export interface UpdatePatientStatusInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `PatientStatus` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `PatientStatus` being updated. */
  patientStatusPatch: PatientStatusPatch;
}

/** Represents an update to a `PatientStatus`. Fields that are set will be updated. */
export interface PatientStatusPatch {
  adminId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['UUID']>;
  reason?: InputMaybe<Scalars['String']>;
  reasonDetail?: InputMaybe<Scalars['String']>;
  statusTransitionDate?: InputMaybe<Scalars['Datetime']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our update `PatientStatus` mutation. */
export interface UpdatePatientStatusPayload {
  __typename: 'UpdatePatientStatusPayload';
  /** Reads a single `Admin` that is related to this `PatientStatus`. */
  adminByAdminId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Patient` that is related to this `PatientStatus`. */
  patientByPatientId: Maybe<Patient>;
  /** The `PatientStatus` that was updated by this mutation. */
  patientStatus: Maybe<PatientStatus>;
  /** An edge for our `PatientStatus`. May be used by Relay 1. */
  patientStatusEdge: Maybe<PatientStatusesEdge>;
  /** Reads a single `PatientStatusValue` that is related to this `PatientStatus`. */
  patientStatusValueByValue: Maybe<PatientStatusValue>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our update `PatientStatus` mutation. */
export interface UpdatePatientStatusPayloadPatientStatusEdgeArgs {
  orderBy?: InputMaybe<Array<PatientStatusesOrderBy>>;
}

/** All input for the `updatePatientStatusById` mutation. */
export interface UpdatePatientStatusByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `PatientStatus` being updated. */
  patientStatusPatch: PatientStatusPatch;
}

/** All input for the `updatePatientStatusByPatientIdAndCreatedAtAndValue` mutation. */
export interface UpdatePatientStatusByPatientIdAndCreatedAtAndValueInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  patientId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `PatientStatus` being updated. */
  patientStatusPatch: PatientStatusPatch;
  value: Scalars['String'];
}

/** All input for the `updatePatientStatusValue` mutation. */
export interface UpdatePatientStatusValueInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `PatientStatusValue` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `PatientStatusValue` being updated. */
  patientStatusValuePatch: PatientStatusValuePatch;
}

/** Represents an update to a `PatientStatusValue`. Fields that are set will be updated. */
export interface PatientStatusValuePatch {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our update `PatientStatusValue` mutation. */
export interface UpdatePatientStatusValuePayload {
  __typename: 'UpdatePatientStatusValuePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `PatientStatusValue` that was updated by this mutation. */
  patientStatusValue: Maybe<PatientStatusValue>;
  /** An edge for our `PatientStatusValue`. May be used by Relay 1. */
  patientStatusValueEdge: Maybe<PatientStatusValuesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our update `PatientStatusValue` mutation. */
export interface UpdatePatientStatusValuePayloadPatientStatusValueEdgeArgs {
  orderBy?: InputMaybe<Array<PatientStatusValuesOrderBy>>;
}

/** All input for the `updatePatientStatusValueById` mutation. */
export interface UpdatePatientStatusValueByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `PatientStatusValue` being updated. */
  patientStatusValuePatch: PatientStatusValuePatch;
}

/** All input for the `updatePatientStatusValueByName` mutation. */
export interface UpdatePatientStatusValueByNameInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `PatientStatusValue` being updated. */
  patientStatusValuePatch: PatientStatusValuePatch;
}

/** All input for the `updatePause` mutation. */
export interface UpdatePauseInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Pause` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Pause` being updated. */
  pausePatch: PausePatch;
}

/** Represents an update to a `Pause`. Fields that are set will be updated. */
export interface PausePatch {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** The date at which this pause span ends (inclusive), optionally null. */
  endDate?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** The text of the note. */
  note?: InputMaybe<Scalars['String']>;
  /** The reason for pausing a patient. */
  oldReason?: InputMaybe<Scalars['String']>;
  /** The unique identifier of the patient for which the pause is created. */
  patientId?: InputMaybe<Scalars['UUID']>;
  reason?: InputMaybe<Scalars['String']>;
  /** The date at which this pause span starts. */
  startDate?: InputMaybe<Scalars['Date']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our update `Pause` mutation. */
export interface UpdatePausePayload {
  __typename: 'UpdatePausePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Patient` that is related to this `Pause`. */
  patientByPatientId: Maybe<Patient>;
  /** The `Pause` that was updated by this mutation. */
  pause: Maybe<Pause>;
  /** An edge for our `Pause`. May be used by Relay 1. */
  pauseEdge: Maybe<PausesEdge>;
  /** Reads a single `PauseReason` that is related to this `Pause`. */
  pauseReasonByReason: Maybe<PauseReason>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our update `Pause` mutation. */
export interface UpdatePausePayloadPauseEdgeArgs {
  orderBy?: InputMaybe<Array<PausesOrderBy>>;
}

/** All input for the `updatePauseById` mutation. */
export interface UpdatePauseByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Pause` being updated. */
  pausePatch: PausePatch;
}

/** All input for the `updatePauseReason` mutation. */
export interface UpdatePauseReasonInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `PauseReason` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `PauseReason` being updated. */
  pauseReasonPatch: PauseReasonPatch;
}

/** Represents an update to a `PauseReason`. Fields that are set will be updated. */
export interface PauseReasonPatch {
  automaticInactivation?: InputMaybe<Scalars['Boolean']>;
  automaticUnpause?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
}

/** The output of our update `PauseReason` mutation. */
export interface UpdatePauseReasonPayload {
  __typename: 'UpdatePauseReasonPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `PauseReason` that was updated by this mutation. */
  pauseReason: Maybe<PauseReason>;
  /** An edge for our `PauseReason`. May be used by Relay 1. */
  pauseReasonEdge: Maybe<PauseReasonsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our update `PauseReason` mutation. */
export interface UpdatePauseReasonPayloadPauseReasonEdgeArgs {
  orderBy?: InputMaybe<Array<PauseReasonsOrderBy>>;
}

/** All input for the `updatePauseReasonById` mutation. */
export interface UpdatePauseReasonByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `PauseReason` being updated. */
  pauseReasonPatch: PauseReasonPatch;
}

/** All input for the `updatePauseReasonByValue` mutation. */
export interface UpdatePauseReasonByValueInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `PauseReason` being updated. */
  pauseReasonPatch: PauseReasonPatch;
  value: Scalars['String'];
}

/** All input for the `updatePaymentSetup` mutation. */
export interface UpdatePaymentSetupInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `PaymentSetup` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `PaymentSetup` being updated. */
  paymentSetupPatch: PaymentSetupPatch;
}

/** Represents an update to a `PaymentSetup`. Fields that are set will be updated. */
export interface PaymentSetupPatch {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  debitCardId?: InputMaybe<Scalars['UUID']>;
  /** The typically processor-specific configuration details of this config. */
  details?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** Whether this payment setup the default setup for this patient. */
  isDefault?: InputMaybe<Scalars['Boolean']>;
  maxIncrement?: InputMaybe<Scalars['BigFloat']>;
  /** The name of this payment config. */
  name?: InputMaybe<Scalars['String']>;
  /** An optional freetext note about this payment config. */
  note?: InputMaybe<Scalars['String']>;
  /** The patient which owns this payment config. */
  patientId?: InputMaybe<Scalars['UUID']>;
  paymentOptionCode?: InputMaybe<Scalars['String']>;
  /** The payment processor to which this config pertains. */
  processor?: InputMaybe<PaymentProcessor>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our update `PaymentSetup` mutation. */
export interface UpdatePaymentSetupPayload {
  __typename: 'UpdatePaymentSetupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `DebitCard` that is related to this `PaymentSetup`. */
  debitCardByDebitCardId: Maybe<DebitCard>;
  /** Reads a single `Patient` that is related to this `PaymentSetup`. */
  patientByPatientId: Maybe<Patient>;
  /** The `PaymentSetup` that was updated by this mutation. */
  paymentSetup: Maybe<PaymentSetup>;
  /** An edge for our `PaymentSetup`. May be used by Relay 1. */
  paymentSetupEdge: Maybe<PaymentSetupsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our update `PaymentSetup` mutation. */
export interface UpdatePaymentSetupPayloadPaymentSetupEdgeArgs {
  orderBy?: InputMaybe<Array<PaymentSetupsOrderBy>>;
}

/** All input for the `updatePaymentSetupById` mutation. */
export interface UpdatePaymentSetupByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `PaymentSetup` being updated. */
  paymentSetupPatch: PaymentSetupPatch;
}

export interface UpdatePhoneNumberInput {
  clientMutationId?: InputMaybe<Scalars['String']>;
  phoneNumberPatch: PhoneNumberPatch;
}

export interface PhoneNumberPatch {
  id: Scalars['String'];
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PhoneNumberType>;
}

export interface UpdatePhoneNumberPayload {
  __typename: 'UpdatePhoneNumberPayload';
  clientMutationId: Maybe<Scalars['String']>;
  phoneNumber: Maybe<PhoneNumber>;
}

/** All input for the `updatePrivilegedAction` mutation. */
export interface UpdatePrivilegedActionInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `PrivilegedAction` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `PrivilegedAction` being updated. */
  privilegedActionPatch: PrivilegedActionPatch;
}

/** Represents an update to a `PrivilegedAction`. Fields that are set will be updated. */
export interface PrivilegedActionPatch {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our update `PrivilegedAction` mutation. */
export interface UpdatePrivilegedActionPayload {
  __typename: 'UpdatePrivilegedActionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `PrivilegedAction` that was updated by this mutation. */
  privilegedAction: Maybe<PrivilegedAction>;
  /** An edge for our `PrivilegedAction`. May be used by Relay 1. */
  privilegedActionEdge: Maybe<PrivilegedActionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our update `PrivilegedAction` mutation. */
export interface UpdatePrivilegedActionPayloadPrivilegedActionEdgeArgs {
  orderBy?: InputMaybe<Array<PrivilegedActionsOrderBy>>;
}

/** All input for the `updatePrivilegedActionById` mutation. */
export interface UpdatePrivilegedActionByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `PrivilegedAction` being updated. */
  privilegedActionPatch: PrivilegedActionPatch;
}

/** All input for the `updatePrivilegedActionByName` mutation. */
export interface UpdatePrivilegedActionByNameInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `PrivilegedAction` being updated. */
  privilegedActionPatch: PrivilegedActionPatch;
}

/** Represents an update to a `Program`. Fields that are set will be updated. */
export interface ProgramPatch {
  adminId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customerId?: InputMaybe<Scalars['UUID']>;
  customJson?: InputMaybe<Scalars['JSON']>;
  eligibleForSelfServe?: InputMaybe<Scalars['Boolean']>;
  /** The date of the last day at which this program can be used. */
  expiry?: InputMaybe<Scalars['Date']>;
  icon?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  impactTierFloor?: InputMaybe<Scalars['String']>;
  /** impact tiers bucket prospects in 3 or 4 bins */
  impactTiers?: InputMaybe<Scalars['String']>;
  /** The amount of days a member has been paused that will automatically inactivated them. */
  inactivateAfterPausedDays?: InputMaybe<Scalars['Int']>;
  /** Amount of days after reward period or reminder end date that will automatically inactivate member */
  inactivateDaysAfterEndDate?: InputMaybe<Scalars['Int']>;
  isDoNotCallSuppressionEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Per-program kill switch for the automated eligibility-loss pause/notify workflow. */
  isEligibilityAutomationEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Flag to determine is creation is suppressed for the program */
  isProspectCreationSuppressed?: InputMaybe<Scalars['Boolean']>;
  /** Flag to determine is reopening is suppressed for the program */
  isProspectReopeningSuppressed?: InputMaybe<Scalars['Boolean']>;
  isProspectWorkflowsEnabled?: InputMaybe<Scalars['Boolean']>;
  isTestProgram?: InputMaybe<Scalars['Boolean']>;
  isUploaderDisabled?: InputMaybe<Scalars['Boolean']>;
  /** The maximum number of times this program can be used across all patients cumulatively */
  maximumUses?: InputMaybe<Scalars['Int']>;
  /** arbitrary reward max used in UX communications */
  maxRewards?: InputMaybe<Scalars['BigFloat']>;
  /** The name of the program */
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  notificationPolicyId?: InputMaybe<Scalars['UUID']>;
  pauseAfterNoActivityDays?: InputMaybe<Scalars['Int']>;
  /** The unique textual code of the program */
  programCode?: InputMaybe<Scalars['String']>;
  programTemplate?: InputMaybe<Scalars['String']>;
  /** Describes which health care sector the program is associated with */
  sector?: InputMaybe<Scalars['String']>;
  skipBloodPressureDetection?: InputMaybe<Scalars['Boolean']>;
  skipGlucoseDetection?: InputMaybe<Scalars['Boolean']>;
  skipMealDetection?: InputMaybe<Scalars['Boolean']>;
  skipMedicationDetection?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** The number of times this program has been used */
  useCount?: InputMaybe<Scalars['Int']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** All input for the `updateProgramMfaConfig` mutation. */
export interface UpdateProgramMfaConfigInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProgramMfaConfig` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `ProgramMfaConfig` being updated. */
  programMfaConfigPatch: ProgramMfaConfigPatch;
}

/** Represents an update to a `ProgramMfaConfig`. Fields that are set will be updated. */
export interface ProgramMfaConfigPatch {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  isMfaRequired?: InputMaybe<Scalars['Boolean']>;
  mfaExpireMinutes?: InputMaybe<Scalars['Int']>;
  numSecurityQuestions?: InputMaybe<Scalars['Int']>;
  programId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
}

/** The output of our update `ProgramMfaConfig` mutation. */
export interface UpdateProgramMfaConfigPayload {
  __typename: 'UpdateProgramMfaConfigPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Program` that is related to this `ProgramMfaConfig`. */
  programByProgramId: Maybe<Program>;
  /** The `ProgramMfaConfig` that was updated by this mutation. */
  programMfaConfig: Maybe<ProgramMfaConfig>;
  /** An edge for our `ProgramMfaConfig`. May be used by Relay 1. */
  programMfaConfigEdge: Maybe<ProgramMfaConfigsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our update `ProgramMfaConfig` mutation. */
export interface UpdateProgramMfaConfigPayloadProgramMfaConfigEdgeArgs {
  orderBy?: InputMaybe<Array<ProgramMfaConfigsOrderBy>>;
}

/** All input for the `updateProgramMfaConfigById` mutation. */
export interface UpdateProgramMfaConfigByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ProgramMfaConfig` being updated. */
  programMfaConfigPatch: ProgramMfaConfigPatch;
}

/** All input for the `updateProgramMfaConfigByProgramId` mutation. */
export interface UpdateProgramMfaConfigByProgramIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  programId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ProgramMfaConfig` being updated. */
  programMfaConfigPatch: ProgramMfaConfigPatch;
}

/** All input for the `updateProgramOutreachSubmission` mutation. */
export interface UpdateProgramOutreachSubmissionInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProgramOutreachSubmission` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `ProgramOutreachSubmission` being updated. */
  programOutreachSubmissionPatch: ProgramOutreachSubmissionPatch;
}

/** Represents an update to a `ProgramOutreachSubmission`. Fields that are set will be updated. */
export interface ProgramOutreachSubmissionPatch {
  birthDate?: InputMaybe<Scalars['Date']>;
  /** Humana only: whether the member reports taking their blood pressure or blood glucose daily ("yes"/"no"; NULL for other programs). Self-reported eligibility signal; raw_payload keeps the verbatim submitted value. */
  checksBpBg?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  emailPrimary?: InputMaybe<Scalars['String']>;
  /** Submitted Member ID; groups a member's submissions within a program (non-unique — every submission is its own row). */
  externalId?: InputMaybe<Scalars['String']>;
  familyName?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  mailingAddressCity?: InputMaybe<Scalars['String']>;
  mailingAddressLine1?: InputMaybe<Scalars['String']>;
  mailingAddressLine2?: InputMaybe<Scalars['String']>;
  mailingAddressState?: InputMaybe<Scalars['String']>;
  mailingAddressZipCode?: InputMaybe<Scalars['String']>;
  phonePrimary?: InputMaybe<Scalars['String']>;
  /** Program/campaign slug (e.g. uhc); resolved to a program_id during matching. */
  program?: InputMaybe<Scalars['String']>;
  /** Full submitted payload, verbatim (agreed program data-spec field names plus any extras). */
  rawPayload?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
}

/** The output of our update `ProgramOutreachSubmission` mutation. */
export interface UpdateProgramOutreachSubmissionPayload {
  __typename: 'UpdateProgramOutreachSubmissionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `ProgramOutreachSubmission` that was updated by this mutation. */
  programOutreachSubmission: Maybe<ProgramOutreachSubmission>;
  /** An edge for our `ProgramOutreachSubmission`. May be used by Relay 1. */
  programOutreachSubmissionEdge: Maybe<ProgramOutreachSubmissionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our update `ProgramOutreachSubmission` mutation. */
export interface UpdateProgramOutreachSubmissionPayloadProgramOutreachSubmissionEdgeArgs {
  orderBy?: InputMaybe<Array<ProgramOutreachSubmissionsOrderBy>>;
}

/** All input for the `updateProgramOutreachSubmissionById` mutation. */
export interface UpdateProgramOutreachSubmissionByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ProgramOutreachSubmission` being updated. */
  programOutreachSubmissionPatch: ProgramOutreachSubmissionPatch;
}

/** All input for the `updateProgramReward` mutation. */
export interface UpdateProgramRewardInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProgramReward` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `ProgramReward` being updated. */
  programRewardPatch: ProgramRewardPatch;
}

/** Represents an update to a `ProgramReward`. Fields that are set will be updated. */
export interface ProgramRewardPatch {
  accountTransactionId?: InputMaybe<Scalars['UUID']>;
  /** expected reason is expired, but future proofing for other reasons */
  closeReason?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** tracks the wellth internal reward name for convenience */
  name?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['UUID']>;
  programRewardConfigId?: InputMaybe<Scalars['UUID']>;
  rewardCurrency?: InputMaybe<Currency>;
  rewardedAmount?: InputMaybe<Scalars['BigFloat']>;
  /** expiry is config end_date for eligible; config end_date+grace_period for redeemable; redeemable means ready-to-redeem */
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our update `ProgramReward` mutation. */
export interface UpdateProgramRewardPayload {
  __typename: 'UpdateProgramRewardPayload';
  /** Reads a single `AccountTransaction` that is related to this `ProgramReward`. */
  accountTransactionByAccountTransactionId: Maybe<AccountTransaction>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Patient` that is related to this `ProgramReward`. */
  patientByPatientId: Maybe<Patient>;
  /** The `ProgramReward` that was updated by this mutation. */
  programReward: Maybe<ProgramReward>;
  /** Reads a single `ProgramRewardConfig` that is related to this `ProgramReward`. */
  programRewardConfigByName: Maybe<ProgramRewardConfig>;
  /** Reads a single `ProgramRewardConfig` that is related to this `ProgramReward`. */
  programRewardConfigByProgramRewardConfigId: Maybe<ProgramRewardConfig>;
  /** An edge for our `ProgramReward`. May be used by Relay 1. */
  programRewardEdge: Maybe<ProgramRewardsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our update `ProgramReward` mutation. */
export interface UpdateProgramRewardPayloadProgramRewardEdgeArgs {
  orderBy?: InputMaybe<Array<ProgramRewardsOrderBy>>;
}

/** All input for the `updateProgramRewardById` mutation. */
export interface UpdateProgramRewardByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ProgramReward` being updated. */
  programRewardPatch: ProgramRewardPatch;
}

/** All input for the `updateProgramRewardConfig` mutation. */
export interface UpdateProgramRewardConfigInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProgramRewardConfig` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `ProgramRewardConfig` being updated. */
  programRewardConfigPatch: ProgramRewardConfigPatch;
}

/** Represents an update to a `ProgramRewardConfig`. Fields that are set will be updated. */
export interface ProgramRewardConfigPatch {
  /** toggles rewards on or off */
  active?: InputMaybe<Scalars['Boolean']>;
  adminId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  descStringKey?: InputMaybe<Scalars['String']>;
  /** if all enrolled members should get this reward; vs segmentation or client caregap/tbd */
  eligibleForAll?: InputMaybe<Scalars['Boolean']>;
  endDate?: InputMaybe<Scalars['Date']>;
  /** number of days after end_date the rewards remains redeemable */
  gracePeriod?: InputMaybe<Scalars['Int']>;
  icon?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** does the reward move from eligible=>rewarded or eligible=>redeemable */
  instantRedeem?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  programId?: InputMaybe<Scalars['UUID']>;
  rewardAmount?: InputMaybe<Scalars['BigFloat']>;
  rewardCurrency?: InputMaybe<Currency>;
  /** enum list of reward events like ENROLLED, ADDRESS_CONFIRMED, EMAIL_CONFIRMED, BREAST_CANCER_SCREEN etc */
  rewardEvent?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Date']>;
  titleStringKey?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our update `ProgramRewardConfig` mutation. */
export interface UpdateProgramRewardConfigPayload {
  __typename: 'UpdateProgramRewardConfigPayload';
  /** Reads a single `Admin` that is related to this `ProgramRewardConfig`. */
  adminByAdminId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Program` that is related to this `ProgramRewardConfig`. */
  programByProgramId: Maybe<Program>;
  /** The `ProgramRewardConfig` that was updated by this mutation. */
  programRewardConfig: Maybe<ProgramRewardConfig>;
  /** An edge for our `ProgramRewardConfig`. May be used by Relay 1. */
  programRewardConfigEdge: Maybe<ProgramRewardConfigsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our update `ProgramRewardConfig` mutation. */
export interface UpdateProgramRewardConfigPayloadProgramRewardConfigEdgeArgs {
  orderBy?: InputMaybe<Array<ProgramRewardConfigsOrderBy>>;
}

/** All input for the `updateProgramRewardConfigById` mutation. */
export interface UpdateProgramRewardConfigByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ProgramRewardConfig` being updated. */
  programRewardConfigPatch: ProgramRewardConfigPatch;
}

/** All input for the `updateProgramRewardConfigByName` mutation. */
export interface UpdateProgramRewardConfigByNameInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `ProgramRewardConfig` being updated. */
  programRewardConfigPatch: ProgramRewardConfigPatch;
}

/** All input for the `updateProgramTemplate` mutation. */
export interface UpdateProgramTemplateInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProgramTemplate` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `ProgramTemplate` being updated. */
  programTemplatePatch: ProgramTemplatePatch;
}

/** Represents an update to a `ProgramTemplate`. Fields that are set will be updated. */
export interface ProgramTemplatePatch {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
}

/** The output of our update `ProgramTemplate` mutation. */
export interface UpdateProgramTemplatePayload {
  __typename: 'UpdateProgramTemplatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `ProgramTemplate` that was updated by this mutation. */
  programTemplate: Maybe<ProgramTemplate>;
  /** An edge for our `ProgramTemplate`. May be used by Relay 1. */
  programTemplateEdge: Maybe<ProgramTemplatesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our update `ProgramTemplate` mutation. */
export interface UpdateProgramTemplatePayloadProgramTemplateEdgeArgs {
  orderBy?: InputMaybe<Array<ProgramTemplatesOrderBy>>;
}

/** All input for the `updateProgramTemplateById` mutation. */
export interface UpdateProgramTemplateByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ProgramTemplate` being updated. */
  programTemplatePatch: ProgramTemplatePatch;
}

/** All input for the `updateProgramTemplateByName` mutation. */
export interface UpdateProgramTemplateByNameInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `ProgramTemplate` being updated. */
  programTemplatePatch: ProgramTemplatePatch;
}

export interface ProspectPatch {
  description?: InputMaybe<Scalars['String']>;
  eligibilityEndDate?: InputMaybe<Scalars['Date']>;
  externalId?: InputMaybe<Scalars['String']>;
  isTestProspect?: InputMaybe<Scalars['Boolean']>;
  medicaidId?: InputMaybe<Scalars['String']>;
  person?: InputMaybe<PersonPatch>;
  siteName?: InputMaybe<Scalars['String']>;
}

/** All input for the `updateProspectStatus` mutation. */
export interface UpdateProspectStatusInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProspectStatus` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `ProspectStatus` being updated. */
  prospectStatusPatch: ProspectStatusPatch;
}

/** Represents an update to a `ProspectStatus`. Fields that are set will be updated. */
export interface ProspectStatusPatch {
  adminId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  prospectId?: InputMaybe<Scalars['UUID']>;
  reason?: InputMaybe<Scalars['String']>;
  reasonDetail?: InputMaybe<Scalars['String']>;
  statusTransitionDate?: InputMaybe<Scalars['Datetime']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our update `ProspectStatus` mutation. */
export interface UpdateProspectStatusPayload {
  __typename: 'UpdateProspectStatusPayload';
  /** Reads a single `Admin` that is related to this `ProspectStatus`. */
  adminByAdminId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `ProspectStatus` that was updated by this mutation. */
  prospectStatus: Maybe<ProspectStatus>;
  /** An edge for our `ProspectStatus`. May be used by Relay 1. */
  prospectStatusEdge: Maybe<ProspectStatusesEdge>;
  /** Reads a single `ProspectStatusValue` that is related to this `ProspectStatus`. */
  prospectStatusValueByValue: Maybe<ProspectStatusValue>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our update `ProspectStatus` mutation. */
export interface UpdateProspectStatusPayloadProspectStatusEdgeArgs {
  orderBy?: InputMaybe<Array<ProspectStatusesOrderBy>>;
}

/** All input for the `updateProspectStatusById` mutation. */
export interface UpdateProspectStatusByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ProspectStatus` being updated. */
  prospectStatusPatch: ProspectStatusPatch;
}

/** All input for the `updateProspectStatusByProspectIdAndCreatedAtAndValue` mutation. */
export interface UpdateProspectStatusByProspectIdAndCreatedAtAndValueInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  prospectId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ProspectStatus` being updated. */
  prospectStatusPatch: ProspectStatusPatch;
  value: Scalars['String'];
}

/** All input for the `updateProspectStatusValue` mutation. */
export interface UpdateProspectStatusValueInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProspectStatusValue` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `ProspectStatusValue` being updated. */
  prospectStatusValuePatch: ProspectStatusValuePatch;
}

/** Represents an update to a `ProspectStatusValue`. Fields that are set will be updated. */
export interface ProspectStatusValuePatch {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our update `ProspectStatusValue` mutation. */
export interface UpdateProspectStatusValuePayload {
  __typename: 'UpdateProspectStatusValuePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `ProspectStatusValue` that was updated by this mutation. */
  prospectStatusValue: Maybe<ProspectStatusValue>;
  /** An edge for our `ProspectStatusValue`. May be used by Relay 1. */
  prospectStatusValueEdge: Maybe<ProspectStatusValuesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our update `ProspectStatusValue` mutation. */
export interface UpdateProspectStatusValuePayloadProspectStatusValueEdgeArgs {
  orderBy?: InputMaybe<Array<ProspectStatusValuesOrderBy>>;
}

/** All input for the `updateProspectStatusValueById` mutation. */
export interface UpdateProspectStatusValueByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ProspectStatusValue` being updated. */
  prospectStatusValuePatch: ProspectStatusValuePatch;
}

/** All input for the `updateProspectStatusValueByName` mutation. */
export interface UpdateProspectStatusValueByNameInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `ProspectStatusValue` being updated. */
  prospectStatusValuePatch: ProspectStatusValuePatch;
}

/** All input for the `updatePushNotification` mutation. */
export interface UpdatePushNotificationInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `PushNotification` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `PushNotification` being updated. */
  pushNotificationPatch: PushNotificationPatch;
}

/** Represents an update to a `PushNotification`. Fields that are set will be updated. */
export interface PushNotificationPatch {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** The patient to whom this push notification is sent */
  patientId?: InputMaybe<Scalars['UUID']>;
  /** The data payload that should be or was relayed to the push notification delivery service. */
  payload?: InputMaybe<Scalars['JSON']>;
  /** The time at which this push notification was sent. */
  sentDatetime?: InputMaybe<Scalars['Datetime']>;
  /** The status of the push notification. */
  status?: InputMaybe<PushNotificationStatus>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our update `PushNotification` mutation. */
export interface UpdatePushNotificationPayload {
  __typename: 'UpdatePushNotificationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Patient` that is related to this `PushNotification`. */
  patientByPatientId: Maybe<Patient>;
  /** The `PushNotification` that was updated by this mutation. */
  pushNotification: Maybe<PushNotification>;
  /** An edge for our `PushNotification`. May be used by Relay 1. */
  pushNotificationEdge: Maybe<PushNotificationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our update `PushNotification` mutation. */
export interface UpdatePushNotificationPayloadPushNotificationEdgeArgs {
  orderBy?: InputMaybe<Array<PushNotificationsOrderBy>>;
}

/** All input for the `updatePushNotificationById` mutation. */
export interface UpdatePushNotificationByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `PushNotification` being updated. */
  pushNotificationPatch: PushNotificationPatch;
}

/** All input for the `updatePushToken` mutation. */
export interface UpdatePushTokenInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `PushToken` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `PushToken` being updated. */
  pushTokenPatch: PushTokenPatch;
}

/** Represents an update to a `PushToken`. Fields that are set will be updated. */
export interface PushTokenPatch {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** The identifier created for this token by the mobile phone device. */
  deviceIdentifier?: InputMaybe<Scalars['String']>;
  /** The third-party handler of these push tokens, used to send the actual notifications. */
  handler?: InputMaybe<PushTokenHandler>;
  id?: InputMaybe<Scalars['UUID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** The patient who created this push token. */
  patientId?: InputMaybe<Scalars['UUID']>;
  /** The identifier generated by the remote service (e.g. SNS) as an endpoint identifier. */
  remoteIdentifier?: InputMaybe<Scalars['String']>;
  /** The service for which this push token is registered. */
  service?: InputMaybe<PushTokenService>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our update `PushToken` mutation. */
export interface UpdatePushTokenPayload {
  __typename: 'UpdatePushTokenPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Patient` that is related to this `PushToken`. */
  patientByPatientId: Maybe<Patient>;
  /** The `PushToken` that was updated by this mutation. */
  pushToken: Maybe<PushToken>;
  /** An edge for our `PushToken`. May be used by Relay 1. */
  pushTokenEdge: Maybe<PushTokensEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
}


/** The output of our update `PushToken` mutation. */
export interface UpdatePushTokenPayloadPushTokenEdgeArgs {
  orderBy?: InputMaybe<Array<PushTokensOrderBy>>;
}

/** All input for the `updatePushTokenById` mutation. */
export interface UpdatePushTokenByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `PushToken` being updated. */
  pushTokenPatch: PushTokenPatch;
}

/** All input for the `updateRawIncomingDatum` mutation. */
export interface UpdateRawIncomingDatumInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `RawIncomingDatum` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `RawIncomingDatum` being updated. */
  rawIncomingDatumPatch: RawIncomingDatumPatch;
}

/** Represents an update to a `RawIncomingDatum`. Fields that are set will be updated. */
export interface RawIncomingDatumPatch {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** A JSON-formatted chunk of data.  No particular schema is enforced. */
  data?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** The source of the data, e.g. twilio or bodytrace */
  source?: InputMaybe<RawIncomingDataSource>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our update `RawIncomingDatum` mutation. */
export interface UpdateRawIncomingDatumPayload {
  __typename: 'UpdateRawIncomingDatumPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `RawIncomingDatum` that was updated by this mutation. */
  rawIncomingDatum: Maybe<RawIncomingDatum>;
  /** An edge for our `RawIncomingDatum`. May be used by Relay 1. */
  rawIncomingDatumEdge: Maybe<RawIncomingDataEdge>;
}


/** The output of our update `RawIncomingDatum` mutation. */
export interface UpdateRawIncomingDatumPayloadRawIncomingDatumEdgeArgs {
  orderBy?: InputMaybe<Array<RawIncomingDataOrderBy>>;
}

/** All input for the `updateRawIncomingDatumById` mutation. */
export interface UpdateRawIncomingDatumByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RawIncomingDatum` being updated. */
  rawIncomingDatumPatch: RawIncomingDatumPatch;
}

/** All input for the `updateReminder` mutation. */
export interface UpdateReminderInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Reminder` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Reminder` being updated. */
  reminderPatch: ReminderPatch;
}

/** Represents an update to a `Reminder`. Fields that are set will be updated. */
export interface ReminderPatch {
  /** The check_in category of the reminder, used to determine what kind of check_in to create. */
  checkInCategory?: InputMaybe<CheckInCategory>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** The date at which this reminder span ends (inclusive), optionally null. */
  endDate?: InputMaybe<Scalars['Date']>;
  /** The time at which this reminder is due on Friday. */
  friTime?: InputMaybe<Scalars['Time']>;
  id?: InputMaybe<Scalars['UUID']>;
  interval?: InputMaybe<ReminderInterval>;
  intervalCount?: InputMaybe<Scalars['Int']>;
  /** Whether the reminder should appear as a demo flow in the application. */
  isDemo?: InputMaybe<Scalars['Boolean']>;
  /** Whether completing the reminder is required in order to earn incentives for the day. */
  isRequired?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  linkedFutureReminderId?: InputMaybe<Scalars['UUID']>;
  /** The time at which this reminder is due on Monday. */
  monTime?: InputMaybe<Scalars['Time']>;
  patientId?: InputMaybe<Scalars['UUID']>;
  /** The reminder_config from which this reminder was created, if one existed. */
  reminderConfigId?: InputMaybe<Scalars['UUID']>;
  /** The time at which this reminder is due on Saturday. */
  satTime?: InputMaybe<Scalars['Time']>;
  /** The date at which this reminder span starts. */
  startDate?: InputMaybe<Scalars['Date']>;
  /** The time at which this reminder is due on Sunday. */
  sunTime?: InputMaybe<Scalars['Time']>;
  /** The time at which this reminder is due on Thursday. */
  thuTime?: InputMaybe<Scalars['Time']>;
  /** The time at which this reminder is due on Tuesday. */
  tueTime?: InputMaybe<Scalars['Time']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
  /** The time at which this reminder is due on Wednesday. */
  wedTime?: InputMaybe<Scalars['Time']>;
  /** The duration of the window after the due time. */
  windowAfterMinutes?: InputMaybe<Scalars['Int']>;
  /** The duration of the window before the due time. */
  windowBeforeMinutes?: InputMaybe<Scalars['Int']>;
}

/** The output of our update `Reminder` mutation. */
export interface UpdateReminderPayload {
  __typename: 'UpdateReminderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Patient` that is related to this `Reminder`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `Reminder` that was updated by this mutation. */
  reminder: Maybe<Reminder>;
  /** Reads a single `Reminder` that is related to this `Reminder`. */
  reminderByLinkedFutureReminderId: Maybe<Reminder>;
  /** Reads a single `ReminderConfig` that is related to this `Reminder`. */
  reminderConfigByReminderConfigId: Maybe<ReminderConfig>;
  /** An edge for our `Reminder`. May be used by Relay 1. */
  reminderEdge: Maybe<RemindersEdge>;
}


/** The output of our update `Reminder` mutation. */
export interface UpdateReminderPayloadReminderEdgeArgs {
  orderBy?: InputMaybe<Array<RemindersOrderBy>>;
}

/** All input for the `updateReminderById` mutation. */
export interface UpdateReminderByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Reminder` being updated. */
  reminderPatch: ReminderPatch;
}

/** All input for the `updateReminderConfig` mutation. */
export interface UpdateReminderConfigInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ReminderConfig` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `ReminderConfig` being updated. */
  reminderConfigPatch: ReminderConfigPatch;
}

/** Represents an update to a `ReminderConfig`. Fields that are set will be updated. */
export interface ReminderConfigPatch {
  /** The administrator which created and owns this reminder config. */
  adminId?: InputMaybe<Scalars['UUID']>;
  /** The check_in category of the reminder_config, used to determine what kind of check_in to create. */
  checkInCategory?: InputMaybe<CheckInCategory>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** The time at which this reminder is due on Friday. */
  friTime?: InputMaybe<Scalars['Time']>;
  id?: InputMaybe<Scalars['UUID']>;
  interval?: InputMaybe<ReminderInterval>;
  intervalCount?: InputMaybe<Scalars['Int']>;
  /** Whether the reminder should appear as a demo flow in the application. */
  isDemo?: InputMaybe<Scalars['Boolean']>;
  /** Whether completing the reminder is required in order to earn incentives for the day. */
  isRequired?: InputMaybe<Scalars['Boolean']>;
  /** The number of days for which this reminder should run. */
  lengthInDays?: InputMaybe<Scalars['Int']>;
  /** The time at which this reminder is due on Monday. */
  monTime?: InputMaybe<Scalars['Time']>;
  /** A reference to the program to which this reminder_config is tied. */
  programId?: InputMaybe<Scalars['UUID']>;
  /** The time at which this reminder is due on Saturday. */
  satTime?: InputMaybe<Scalars['Time']>;
  selfServeDefault?: InputMaybe<Scalars['Boolean']>;
  /** The number of days after the 0th program start day at which this reminder should start. */
  startDayIndex?: InputMaybe<Scalars['Int']>;
  /** The time at which this reminder is due on Sunday. */
  sunTime?: InputMaybe<Scalars['Time']>;
  /** The time at which this reminder is due on Thursday. */
  thuTime?: InputMaybe<Scalars['Time']>;
  /** The time at which this reminder is due on Tuesday. */
  tueTime?: InputMaybe<Scalars['Time']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
  /** The time at which this reminder is due on Wednesday. */
  wedTime?: InputMaybe<Scalars['Time']>;
  /** The duration of the window after the due time. */
  windowAfterMinutes?: InputMaybe<Scalars['Int']>;
  /** The duration of the window before the due time. */
  windowBeforeMinutes?: InputMaybe<Scalars['Int']>;
}

/** The output of our update `ReminderConfig` mutation. */
export interface UpdateReminderConfigPayload {
  __typename: 'UpdateReminderConfigPayload';
  /** Reads a single `Admin` that is related to this `ReminderConfig`. */
  adminByAdminId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Program` that is related to this `ReminderConfig`. */
  programByProgramId: Maybe<Program>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `ReminderConfig` that was updated by this mutation. */
  reminderConfig: Maybe<ReminderConfig>;
  /** An edge for our `ReminderConfig`. May be used by Relay 1. */
  reminderConfigEdge: Maybe<ReminderConfigsEdge>;
}


/** The output of our update `ReminderConfig` mutation. */
export interface UpdateReminderConfigPayloadReminderConfigEdgeArgs {
  orderBy?: InputMaybe<Array<ReminderConfigsOrderBy>>;
}

/** All input for the `updateReminderConfigById` mutation. */
export interface UpdateReminderConfigByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ReminderConfig` being updated. */
  reminderConfigPatch: ReminderConfigPatch;
}

/** All input for the `updateReminderMessage` mutation. */
export interface UpdateReminderMessageInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ReminderMessage` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `ReminderMessage` being updated. */
  reminderMessagePatch: ReminderMessagePatch;
}

/** Represents an update to a `ReminderMessage`. Fields that are set will be updated. */
export interface ReminderMessagePatch {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** The id of the actual SMS message that was sent to remind the patient */
  messageId?: InputMaybe<Scalars['UUID']>;
  /** The time for which the message was sent */
  messageTime?: InputMaybe<Scalars['Time']>;
  /** The type of reminder message this is; can be "midwindow" or "nearend" */
  messageType?: InputMaybe<ReminderMessageType>;
  /** The number of minutes remaining in the window when the reminder message was generated */
  minutesRemaining?: InputMaybe<Scalars['Int']>;
  /** The id of the patient to whom this reminder message will be sent */
  patientId?: InputMaybe<Scalars['UUID']>;
  /** The day on which the reminder was due */
  reminderDay?: InputMaybe<Scalars['Date']>;
  /** The id of the reminder that this message references */
  reminderId?: InputMaybe<Scalars['UUID']>;
  /** The time at which the reminder was due */
  reminderTime?: InputMaybe<Scalars['Time']>;
  /** The status of the reminder message; can be "pending" or "message_created" */
  status?: InputMaybe<ReminderMessageStatus>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our update `ReminderMessage` mutation. */
export interface UpdateReminderMessagePayload {
  __typename: 'UpdateReminderMessagePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Message` that is related to this `ReminderMessage`. */
  messageByMessageId: Maybe<Message>;
  /** Reads a single `Patient` that is related to this `ReminderMessage`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Reminder` that is related to this `ReminderMessage`. */
  reminderByReminderId: Maybe<Reminder>;
  /** The `ReminderMessage` that was updated by this mutation. */
  reminderMessage: Maybe<ReminderMessage>;
  /** An edge for our `ReminderMessage`. May be used by Relay 1. */
  reminderMessageEdge: Maybe<ReminderMessagesEdge>;
}


/** The output of our update `ReminderMessage` mutation. */
export interface UpdateReminderMessagePayloadReminderMessageEdgeArgs {
  orderBy?: InputMaybe<Array<ReminderMessagesOrderBy>>;
}

/** All input for the `updateReminderMessageById` mutation. */
export interface UpdateReminderMessageByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ReminderMessage` being updated. */
  reminderMessagePatch: ReminderMessagePatch;
}

/** All input for the `updateRewardPeriod` mutation. */
export interface UpdateRewardPeriodInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `RewardPeriod` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `RewardPeriod` being updated. */
  rewardPeriodPatch: RewardPeriodPatch;
}

/** Represents an update to a `RewardPeriod`. Fields that are set will be updated. */
export interface RewardPeriodPatch {
  appointmentLoss?: InputMaybe<Scalars['BigFloat']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** The date at which this reward_period should end. */
  endDate?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** The maximum loss per day. */
  lossPerDayMax?: InputMaybe<Scalars['BigFloat']>;
  /** The type of loss for this reward period; default "fixed". */
  lossType?: InputMaybe<LossType>;
  /** The patient which owns this reward_period. */
  patientId?: InputMaybe<Scalars['UUID']>;
  /** The maximum amount of money which is possible to receive during this period. */
  rewardAmount?: InputMaybe<Scalars['BigFloat']>;
  /** The currency of the reward. */
  rewardCurrency?: InputMaybe<Currency>;
  /** A reference to the reward_period_config from which this reward_period was generated (if applicable). */
  rewardPeriodConfigId?: InputMaybe<Scalars['UUID']>;
  settledAt?: InputMaybe<Scalars['Datetime']>;
  settleDate?: InputMaybe<Scalars['Date']>;
  /** The date at which this reward_period should start. */
  startDate?: InputMaybe<Scalars['Date']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
  winBackStrategy?: InputMaybe<WinBackStrategy>;
}

/** The output of our update `RewardPeriod` mutation. */
export interface UpdateRewardPeriodPayload {
  __typename: 'UpdateRewardPeriodPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Patient` that is related to this `RewardPeriod`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `RewardPeriod` that was updated by this mutation. */
  rewardPeriod: Maybe<RewardPeriod>;
  /** Reads a single `RewardPeriodConfig` that is related to this `RewardPeriod`. */
  rewardPeriodConfigByRewardPeriodConfigId: Maybe<RewardPeriodConfig>;
  /** An edge for our `RewardPeriod`. May be used by Relay 1. */
  rewardPeriodEdge: Maybe<RewardPeriodsEdge>;
}


/** The output of our update `RewardPeriod` mutation. */
export interface UpdateRewardPeriodPayloadRewardPeriodEdgeArgs {
  orderBy?: InputMaybe<Array<RewardPeriodsOrderBy>>;
}

/** All input for the `updateRewardPeriodById` mutation. */
export interface UpdateRewardPeriodByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RewardPeriod` being updated. */
  rewardPeriodPatch: RewardPeriodPatch;
}

/** All input for the `updateRewardPeriodConfig` mutation. */
export interface UpdateRewardPeriodConfigInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `RewardPeriodConfig` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `RewardPeriodConfig` being updated. */
  rewardPeriodConfigPatch: RewardPeriodConfigPatch;
}

/** Represents an update to a `RewardPeriodConfig`. Fields that are set will be updated. */
export interface RewardPeriodConfigPatch {
  /** The administrator which created and owns this reward_period_config. */
  adminId?: InputMaybe<Scalars['UUID']>;
  appointmentLoss?: InputMaybe<Scalars['BigFloat']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** The numeric of days for which this reward_period should run. */
  lengthInDays?: InputMaybe<Scalars['Int']>;
  /** The maximum loss per day. */
  lossPerDayMax?: InputMaybe<Scalars['BigFloat']>;
  /** The type of loss for this reward period; default "fixed". */
  lossType?: InputMaybe<LossType>;
  /** A reference to the program to which this reward_period_config is tied. */
  programId?: InputMaybe<Scalars['UUID']>;
  /** The maximum amount of money which is possible to receive during this period. */
  rewardAmount?: InputMaybe<Scalars['BigFloat']>;
  /** The currency of the reward. */
  rewardCurrency?: InputMaybe<Currency>;
  /** The numeric of days after the 0th program start day at which this reward_period should start. */
  startDayIndex?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
  winBackStrategy?: InputMaybe<WinBackStrategy>;
}

/** The output of our update `RewardPeriodConfig` mutation. */
export interface UpdateRewardPeriodConfigPayload {
  __typename: 'UpdateRewardPeriodConfigPayload';
  /** Reads a single `Admin` that is related to this `RewardPeriodConfig`. */
  adminByAdminId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Program` that is related to this `RewardPeriodConfig`. */
  programByProgramId: Maybe<Program>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `RewardPeriodConfig` that was updated by this mutation. */
  rewardPeriodConfig: Maybe<RewardPeriodConfig>;
  /** An edge for our `RewardPeriodConfig`. May be used by Relay 1. */
  rewardPeriodConfigEdge: Maybe<RewardPeriodConfigsEdge>;
}


/** The output of our update `RewardPeriodConfig` mutation. */
export interface UpdateRewardPeriodConfigPayloadRewardPeriodConfigEdgeArgs {
  orderBy?: InputMaybe<Array<RewardPeriodConfigsOrderBy>>;
}

/** All input for the `updateRewardPeriodConfigById` mutation. */
export interface UpdateRewardPeriodConfigByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RewardPeriodConfig` being updated. */
  rewardPeriodConfigPatch: RewardPeriodConfigPatch;
}

/** All input for the `updateSmsAutoResponder` mutation. */
export interface UpdateSmsAutoResponderInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `SmsAutoResponder` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `SmsAutoResponder` being updated. */
  smsAutoResponderPatch: SmsAutoResponderPatch;
}

/** Represents an update to a `SmsAutoResponder`. Fields that are set will be updated. */
export interface SmsAutoResponderPatch {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** The UTC end timestamp of the sms auto responder */
  endTimestamp?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** The sms auto response message string key. */
  messageKey?: InputMaybe<Scalars['String']>;
  /** The reference name of the timeframe which an automatic response will be sent. */
  name?: InputMaybe<Scalars['String']>;
  /** The UTC start timestamp of the sms auto responder */
  startTimestamp?: InputMaybe<Scalars['Datetime']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our update `SmsAutoResponder` mutation. */
export interface UpdateSmsAutoResponderPayload {
  __typename: 'UpdateSmsAutoResponderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `SmsAutoResponder` that was updated by this mutation. */
  smsAutoResponder: Maybe<SmsAutoResponder>;
  /** An edge for our `SmsAutoResponder`. May be used by Relay 1. */
  smsAutoResponderEdge: Maybe<SmsAutoRespondersEdge>;
}


/** The output of our update `SmsAutoResponder` mutation. */
export interface UpdateSmsAutoResponderPayloadSmsAutoResponderEdgeArgs {
  orderBy?: InputMaybe<Array<SmsAutoRespondersOrderBy>>;
}

/** All input for the `updateSmsAutoResponderById` mutation. */
export interface UpdateSmsAutoResponderByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `SmsAutoResponder` being updated. */
  smsAutoResponderPatch: SmsAutoResponderPatch;
}

/** All input for the `updateSmsOutreachMessage` mutation. */
export interface UpdateSmsOutreachMessageInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `SmsOutreachMessage` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `SmsOutreachMessage` being updated. */
  smsOutreachMessagePatch: SmsOutreachMessagePatch;
}

/** Represents an update to a `SmsOutreachMessage`. Fields that are set will be updated. */
export interface SmsOutreachMessagePatch {
  adminId?: InputMaybe<Scalars['UUID']>;
  /** Timestamp of when to automatically approve message */
  approveAt?: InputMaybe<Scalars['Datetime']>;
  /** The date the message was approved. */
  approvedAt?: InputMaybe<Scalars['Datetime']>;
  approvedBy?: InputMaybe<Scalars['UUID']>;
  batchLabel?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** Determines if a outreach message is auto approvable */
  isAutoApprove?: InputMaybe<Scalars['Boolean']>;
  /** The content of the message. */
  message?: InputMaybe<Scalars['String']>;
  messageTemplateId?: InputMaybe<Scalars['UUID']>;
  /** The protocol over which the message was sent. */
  protocol?: InputMaybe<SmsOutreachMessageProtocol>;
  /** The time at which this message was read by the recipient. */
  readDatetime?: InputMaybe<Scalars['Datetime']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  /** The party who is the recipient of this message. */
  recipientType?: InputMaybe<SmsOutreachMessageRecipientType>;
  /** The date to send message after. */
  sendAfter?: InputMaybe<Scalars['Datetime']>;
  /** The date the message was sent. */
  sentDatetime?: InputMaybe<Scalars['Datetime']>;
  /** The status of the message. */
  status?: InputMaybe<SmsOutreachMessageStatus>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our update `SmsOutreachMessage` mutation. */
export interface UpdateSmsOutreachMessagePayload {
  __typename: 'UpdateSmsOutreachMessagePayload';
  /** Reads a single `Admin` that is related to this `SmsOutreachMessage`. */
  adminByAdminId: Maybe<Admin>;
  /** Reads a single `Admin` that is related to this `SmsOutreachMessage`. */
  adminByApprovedBy: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `SmsOutreachMessage` that was updated by this mutation. */
  smsOutreachMessage: Maybe<SmsOutreachMessage>;
  /** An edge for our `SmsOutreachMessage`. May be used by Relay 1. */
  smsOutreachMessageEdge: Maybe<SmsOutreachMessagesEdge>;
  /** Reads a single `SmsOutreachMessageTemplate` that is related to this `SmsOutreachMessage`. */
  smsOutreachMessageTemplateByMessageTemplateId: Maybe<SmsOutreachMessageTemplate>;
  /** Reads a single `SmsOutreachRecipient` that is related to this `SmsOutreachMessage`. */
  smsOutreachRecipientByRecipientId: Maybe<SmsOutreachRecipient>;
}


/** The output of our update `SmsOutreachMessage` mutation. */
export interface UpdateSmsOutreachMessagePayloadSmsOutreachMessageEdgeArgs {
  orderBy?: InputMaybe<Array<SmsOutreachMessagesOrderBy>>;
}

/** All input for the `updateSmsOutreachMessageById` mutation. */
export interface UpdateSmsOutreachMessageByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `SmsOutreachMessage` being updated. */
  smsOutreachMessagePatch: SmsOutreachMessagePatch;
}

/** All input for the `updateSmsOutreachMessageTemplate` mutation. */
export interface UpdateSmsOutreachMessageTemplateInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `SmsOutreachMessageTemplate` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `SmsOutreachMessageTemplate` being updated. */
  smsOutreachMessageTemplatePatch: SmsOutreachMessageTemplatePatch;
}

/** Represents an update to a `SmsOutreachMessageTemplate`. Fields that are set will be updated. */
export interface SmsOutreachMessageTemplatePatch {
  adminId?: InputMaybe<Scalars['UUID']>;
  /** The creation timestamp of a message template. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** Determines if a outreach message template is active. */
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** The content of the message. */
  message?: InputMaybe<Scalars['String']>;
  /** Title for the Sms Template. */
  title?: InputMaybe<Scalars['String']>;
  /** The timestamp when message template was updated. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our update `SmsOutreachMessageTemplate` mutation. */
export interface UpdateSmsOutreachMessageTemplatePayload {
  __typename: 'UpdateSmsOutreachMessageTemplatePayload';
  /** Reads a single `Admin` that is related to this `SmsOutreachMessageTemplate`. */
  adminByAdminId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `SmsOutreachMessageTemplate` that was updated by this mutation. */
  smsOutreachMessageTemplate: Maybe<SmsOutreachMessageTemplate>;
  /** An edge for our `SmsOutreachMessageTemplate`. May be used by Relay 1. */
  smsOutreachMessageTemplateEdge: Maybe<SmsOutreachMessageTemplatesEdge>;
}


/** The output of our update `SmsOutreachMessageTemplate` mutation. */
export interface UpdateSmsOutreachMessageTemplatePayloadSmsOutreachMessageTemplateEdgeArgs {
  orderBy?: InputMaybe<Array<SmsOutreachMessageTemplatesOrderBy>>;
}

/** All input for the `updateSmsOutreachMessageTemplateById` mutation. */
export interface UpdateSmsOutreachMessageTemplateByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `SmsOutreachMessageTemplate` being updated. */
  smsOutreachMessageTemplatePatch: SmsOutreachMessageTemplatePatch;
}

/** All input for the `updateSmsOutreachRecipient` mutation. */
export interface UpdateSmsOutreachRecipientInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `SmsOutreachRecipient` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `SmsOutreachRecipient` being updated. */
  smsOutreachRecipientPatch: SmsOutreachRecipientPatch;
}

/** Represents an update to a `SmsOutreachRecipient`. Fields that are set will be updated. */
export interface SmsOutreachRecipientPatch {
  adminId?: InputMaybe<Scalars['UUID']>;
  /** The sms client's birth date. */
  birthDate?: InputMaybe<Scalars['Date']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** The sms client's customer id. */
  customerId?: InputMaybe<Scalars['String']>;
  /** The sms client's first name. */
  firstName?: InputMaybe<Scalars['String']>;
  /** The sms client's group id. */
  groupId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** The sms client's last name. */
  lastName?: InputMaybe<Scalars['String']>;
  /** The sms client's phone number. */
  phoneNumber?: InputMaybe<Scalars['String']>;
  programId?: InputMaybe<Scalars['UUID']>;
  subGroup?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our update `SmsOutreachRecipient` mutation. */
export interface UpdateSmsOutreachRecipientPayload {
  __typename: 'UpdateSmsOutreachRecipientPayload';
  /** Reads a single `Admin` that is related to this `SmsOutreachRecipient`. */
  adminByAdminId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Group` that is related to this `SmsOutreachRecipient`. */
  groupByGroupId: Maybe<Group>;
  /** Reads a single `Program` that is related to this `SmsOutreachRecipient`. */
  programByProgramId: Maybe<Program>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `SmsOutreachRecipient` that was updated by this mutation. */
  smsOutreachRecipient: Maybe<SmsOutreachRecipient>;
  /** An edge for our `SmsOutreachRecipient`. May be used by Relay 1. */
  smsOutreachRecipientEdge: Maybe<SmsOutreachRecipientsEdge>;
}


/** The output of our update `SmsOutreachRecipient` mutation. */
export interface UpdateSmsOutreachRecipientPayloadSmsOutreachRecipientEdgeArgs {
  orderBy?: InputMaybe<Array<SmsOutreachRecipientsOrderBy>>;
}

/** All input for the `updateSmsOutreachRecipientById` mutation. */
export interface UpdateSmsOutreachRecipientByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `SmsOutreachRecipient` being updated. */
  smsOutreachRecipientPatch: SmsOutreachRecipientPatch;
}

/** All input for the `updateSmsOutreachRecipientByPhoneNumber` mutation. */
export interface UpdateSmsOutreachRecipientByPhoneNumberInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The sms client's phone number. */
  phoneNumber: Scalars['String'];
  /** An object where the defined keys will be set on the `SmsOutreachRecipient` being updated. */
  smsOutreachRecipientPatch: SmsOutreachRecipientPatch;
}

/** All input for the `updateTimedObject` mutation. */
export interface UpdateTimedObjectInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `TimedObject` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `TimedObject` being updated. */
  timedObjectPatch: TimedObjectPatch;
}

/** Represents an update to a `TimedObject`. Fields that are set will be updated. */
export interface TimedObjectPatch {
  /** The time this object was created. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** The unique identifier of this object. */
  id?: InputMaybe<Scalars['UUID']>;
  /** The time this object was last updated. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
}

/** The output of our update `TimedObject` mutation. */
export interface UpdateTimedObjectPayload {
  __typename: 'UpdateTimedObjectPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `TimedObject` that was updated by this mutation. */
  timedObject: Maybe<TimedObject>;
  /** An edge for our `TimedObject`. May be used by Relay 1. */
  timedObjectEdge: Maybe<TimedObjectsEdge>;
}


/** The output of our update `TimedObject` mutation. */
export interface UpdateTimedObjectPayloadTimedObjectEdgeArgs {
  orderBy?: InputMaybe<Array<TimedObjectsOrderBy>>;
}

/** All input for the `updateTimedObjectById` mutation. */
export interface UpdateTimedObjectByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The unique identifier of this object. */
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `TimedObject` being updated. */
  timedObjectPatch: TimedObjectPatch;
}

/** All input for the `updateTimezoneRecord` mutation. */
export interface UpdateTimezoneRecordInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `TimezoneRecord` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `TimezoneRecord` being updated. */
  timezoneRecordPatch: TimezoneRecordPatch;
}

/** Represents an update to a `TimezoneRecord`. Fields that are set will be updated. */
export interface TimezoneRecordPatch {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** The ID of the patient who is moving into a new timezone. */
  patientId?: InputMaybe<Scalars['UUID']>;
  /** The name of the timezone into which the patient is entering; must be one of the names returned from getTimezoneNames. */
  timezoneName?: InputMaybe<Scalars['Timezone']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our update `TimezoneRecord` mutation. */
export interface UpdateTimezoneRecordPayload {
  __typename: 'UpdateTimezoneRecordPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Patient` that is related to this `TimezoneRecord`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `TimezoneRecord` that was updated by this mutation. */
  timezoneRecord: Maybe<TimezoneRecord>;
  /** An edge for our `TimezoneRecord`. May be used by Relay 1. */
  timezoneRecordEdge: Maybe<TimezoneRecordsEdge>;
}


/** The output of our update `TimezoneRecord` mutation. */
export interface UpdateTimezoneRecordPayloadTimezoneRecordEdgeArgs {
  orderBy?: InputMaybe<Array<TimezoneRecordsOrderBy>>;
}

/** All input for the `updateTimezoneRecordById` mutation. */
export interface UpdateTimezoneRecordByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `TimezoneRecord` being updated. */
  timezoneRecordPatch: TimezoneRecordPatch;
}

/** All input for the `updateWalkthrough` mutation. */
export interface UpdateWalkthroughInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Walkthrough` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Walkthrough` being updated. */
  walkthroughPatch: WalkthroughPatch;
}

/** Represents an update to a `Walkthrough`. Fields that are set will be updated. */
export interface WalkthroughPatch {
  adminId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our update `Walkthrough` mutation. */
export interface UpdateWalkthroughPayload {
  __typename: 'UpdateWalkthroughPayload';
  /** Reads a single `Admin` that is related to this `Walkthrough`. */
  adminByAdminId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `Walkthrough` that was updated by this mutation. */
  walkthrough: Maybe<Walkthrough>;
  /** An edge for our `Walkthrough`. May be used by Relay 1. */
  walkthroughEdge: Maybe<WalkthroughsEdge>;
}


/** The output of our update `Walkthrough` mutation. */
export interface UpdateWalkthroughPayloadWalkthroughEdgeArgs {
  orderBy?: InputMaybe<Array<WalkthroughsOrderBy>>;
}

/** All input for the `updateWalkthroughById` mutation. */
export interface UpdateWalkthroughByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Walkthrough` being updated. */
  walkthroughPatch: WalkthroughPatch;
}

/** All input for the `updateWalkthroughPage` mutation. */
export interface UpdateWalkthroughPageInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `WalkthroughPage` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `WalkthroughPage` being updated. */
  walkthroughPagePatch: WalkthroughPagePatch;
}

/** Represents an update to a `WalkthroughPage`. Fields that are set will be updated. */
export interface WalkthroughPagePatch {
  adminId?: InputMaybe<Scalars['UUID']>;
  /** The background color of this walkthrough page */
  backgroundColor?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** The text to render in the body of this walkthrough page */
  detail?: InputMaybe<Scalars['String']>;
  /** The icon for this walkthrough page */
  icon?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** The language of this walkthrough */
  language?: InputMaybe<LanguageCode>;
  /** The name of this walkthrough (i.e. could match the program name) */
  name?: InputMaybe<Scalars['String']>;
  /** The order in which this walkthrough page is shown in the specific walkthrough */
  pageIndex?: InputMaybe<Scalars['Int']>;
  /** The text to render in the title of this walkthrough page */
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** The identifier for this walkthrough (a specific series of walkthrough pages, shown in sequence) */
  walkthroughId?: InputMaybe<Scalars['UUID']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our update `WalkthroughPage` mutation. */
export interface UpdateWalkthroughPagePayload {
  __typename: 'UpdateWalkthroughPagePayload';
  /** Reads a single `Admin` that is related to this `WalkthroughPage`. */
  adminByAdminId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Walkthrough` that is related to this `WalkthroughPage`. */
  walkthroughByWalkthroughId: Maybe<Walkthrough>;
  /** The `WalkthroughPage` that was updated by this mutation. */
  walkthroughPage: Maybe<WalkthroughPage>;
  /** An edge for our `WalkthroughPage`. May be used by Relay 1. */
  walkthroughPageEdge: Maybe<WalkthroughPagesEdge>;
}


/** The output of our update `WalkthroughPage` mutation. */
export interface UpdateWalkthroughPagePayloadWalkthroughPageEdgeArgs {
  orderBy?: InputMaybe<Array<WalkthroughPagesOrderBy>>;
}

/** All input for the `updateWalkthroughPageById` mutation. */
export interface UpdateWalkthroughPageByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `WalkthroughPage` being updated. */
  walkthroughPagePatch: WalkthroughPagePatch;
}

/** All input for the `updateWalkthroughSetup` mutation. */
export interface UpdateWalkthroughSetupInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `WalkthroughSetup` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `WalkthroughSetup` being updated. */
  walkthroughSetupPatch: WalkthroughSetupPatch;
}

/** Represents an update to a `WalkthroughSetup`. Fields that are set will be updated. */
export interface WalkthroughSetupPatch {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  /** The patient which owns this walkthrough setup. */
  patientId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** The id of the walkthrough configured for the given patient. */
  walkthroughId?: InputMaybe<Scalars['UUID']>;
  /** The id of the walkthrough setup config from which this walkthrough setup was created. */
  walkthroughSetupConfigId?: InputMaybe<Scalars['UUID']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our update `WalkthroughSetup` mutation. */
export interface UpdateWalkthroughSetupPayload {
  __typename: 'UpdateWalkthroughSetupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Patient` that is related to this `WalkthroughSetup`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Walkthrough` that is related to this `WalkthroughSetup`. */
  walkthroughByWalkthroughId: Maybe<Walkthrough>;
  /** The `WalkthroughSetup` that was updated by this mutation. */
  walkthroughSetup: Maybe<WalkthroughSetup>;
  /** Reads a single `WalkthroughSetupConfig` that is related to this `WalkthroughSetup`. */
  walkthroughSetupConfigByWalkthroughSetupConfigId: Maybe<WalkthroughSetupConfig>;
  /** An edge for our `WalkthroughSetup`. May be used by Relay 1. */
  walkthroughSetupEdge: Maybe<WalkthroughSetupsEdge>;
}


/** The output of our update `WalkthroughSetup` mutation. */
export interface UpdateWalkthroughSetupPayloadWalkthroughSetupEdgeArgs {
  orderBy?: InputMaybe<Array<WalkthroughSetupsOrderBy>>;
}

/** All input for the `updateWalkthroughSetupById` mutation. */
export interface UpdateWalkthroughSetupByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `WalkthroughSetup` being updated. */
  walkthroughSetupPatch: WalkthroughSetupPatch;
}

/** All input for the `updateWalkthroughSetupConfig` mutation. */
export interface UpdateWalkthroughSetupConfigInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `WalkthroughSetupConfig` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `WalkthroughSetupConfig` being updated. */
  walkthroughSetupConfigPatch: WalkthroughSetupConfigPatch;
}

/** Represents an update to a `WalkthroughSetupConfig`. Fields that are set will be updated. */
export interface WalkthroughSetupConfigPatch {
  /** The admin which owns this walkthrough setup config. */
  adminId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** The name of this walkthrough setup config. */
  name?: InputMaybe<Scalars['String']>;
  /** An optional freetext note about this walkthrough setup config. */
  note?: InputMaybe<Scalars['String']>;
  /** The id of the program to which this walkthrough setup config is related (optional). */
  programId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** The walkthrough for this configuration. */
  walkthroughId?: InputMaybe<Scalars['UUID']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our update `WalkthroughSetupConfig` mutation. */
export interface UpdateWalkthroughSetupConfigPayload {
  __typename: 'UpdateWalkthroughSetupConfigPayload';
  /** Reads a single `Admin` that is related to this `WalkthroughSetupConfig`. */
  adminByAdminId: Maybe<Admin>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Program` that is related to this `WalkthroughSetupConfig`. */
  programByProgramId: Maybe<Program>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Walkthrough` that is related to this `WalkthroughSetupConfig`. */
  walkthroughByWalkthroughId: Maybe<Walkthrough>;
  /** The `WalkthroughSetupConfig` that was updated by this mutation. */
  walkthroughSetupConfig: Maybe<WalkthroughSetupConfig>;
  /** An edge for our `WalkthroughSetupConfig`. May be used by Relay 1. */
  walkthroughSetupConfigEdge: Maybe<WalkthroughSetupConfigsEdge>;
}


/** The output of our update `WalkthroughSetupConfig` mutation. */
export interface UpdateWalkthroughSetupConfigPayloadWalkthroughSetupConfigEdgeArgs {
  orderBy?: InputMaybe<Array<WalkthroughSetupConfigsOrderBy>>;
}

/** All input for the `updateWalkthroughSetupConfigById` mutation. */
export interface UpdateWalkthroughSetupConfigByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `WalkthroughSetupConfig` being updated. */
  walkthroughSetupConfigPatch: WalkthroughSetupConfigPatch;
}

/** All input for the `updateWalkthroughSummary` mutation. */
export interface UpdateWalkthroughSummaryInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `WalkthroughSummary` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `WalkthroughSummary` being updated. */
  walkthroughSummaryPatch: WalkthroughSummaryPatch;
}

/** Represents an update to a `WalkthroughSummary`. Fields that are set will be updated. */
export interface WalkthroughSummaryPatch {
  adminId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  detail?: InputMaybe<Scalars['String']>;
  icon?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  walkthroughId?: InputMaybe<Scalars['UUID']>;
}

/** The output of our update `WalkthroughSummary` mutation. */
export interface UpdateWalkthroughSummaryPayload {
  __typename: 'UpdateWalkthroughSummaryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Walkthrough` that is related to this `WalkthroughSummary`. */
  walkthroughByWalkthroughId: Maybe<Walkthrough>;
  /** The `WalkthroughSummary` that was updated by this mutation. */
  walkthroughSummary: Maybe<WalkthroughSummary>;
  /** An edge for our `WalkthroughSummary`. May be used by Relay 1. */
  walkthroughSummaryEdge: Maybe<WalkthroughSummariesEdge>;
}


/** The output of our update `WalkthroughSummary` mutation. */
export interface UpdateWalkthroughSummaryPayloadWalkthroughSummaryEdgeArgs {
  orderBy?: InputMaybe<Array<WalkthroughSummariesOrderBy>>;
}

/** All input for the `updateWalkthroughSummaryById` mutation. */
export interface UpdateWalkthroughSummaryByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `WalkthroughSummary` being updated. */
  walkthroughSummaryPatch: WalkthroughSummaryPatch;
}

/** All input for the `updateWinbackRewardConfig` mutation. */
export interface UpdateWinbackRewardConfigInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `WinbackRewardConfig` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `WinbackRewardConfig` being updated. */
  winbackRewardConfigPatch: WinbackRewardConfigPatch;
}

/** Represents an update to a `WinbackRewardConfig`. Fields that are set will be updated. */
export interface WinbackRewardConfigPatch {
  /** Unique string identifier for the challenge blueprint (e.g., thanksgiving_daily_v1) */
  challengeTypeKey?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Detailed description of the challenge for internal reference */
  description?: InputMaybe<Scalars['String']>;
  /** User-facing name for the challenge */
  displayName?: InputMaybe<Scalars['String']>;
  /** The number of days an opportunity is active before it expires */
  durationInDays?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** Whether this challenge blueprint is currently active and can be used to create new opportunities */
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** The maximum reward amount allowed for an opportunity of this type */
  maxRewardAmount?: InputMaybe<Scalars['BigFloat']>;
  /** The minimum reward amount allowed for an opportunity of this type */
  minRewardAmount?: InputMaybe<Scalars['BigFloat']>;
  /** The currency of the reward (constrained to USD) */
  rewardCurrency?: InputMaybe<Currency>;
  /** The system event that can trigger a completion for this challenge (e.g., user.checked_in) */
  triggerEvent?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
}

/** The output of our update `WinbackRewardConfig` mutation. */
export interface UpdateWinbackRewardConfigPayload {
  __typename: 'UpdateWinbackRewardConfigPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `WinbackRewardConfig` that was updated by this mutation. */
  winbackRewardConfig: Maybe<WinbackRewardConfig>;
  /** An edge for our `WinbackRewardConfig`. May be used by Relay 1. */
  winbackRewardConfigEdge: Maybe<WinbackRewardConfigsEdge>;
}


/** The output of our update `WinbackRewardConfig` mutation. */
export interface UpdateWinbackRewardConfigPayloadWinbackRewardConfigEdgeArgs {
  orderBy?: InputMaybe<Array<WinbackRewardConfigsOrderBy>>;
}

/** All input for the `updateWinbackRewardConfigByChallengeTypeKey` mutation. */
export interface UpdateWinbackRewardConfigByChallengeTypeKeyInput {
  /** Unique string identifier for the challenge blueprint (e.g., thanksgiving_daily_v1) */
  challengeTypeKey: Scalars['String'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `WinbackRewardConfig` being updated. */
  winbackRewardConfigPatch: WinbackRewardConfigPatch;
}

/** All input for the `updateWinbackRewardConfigById` mutation. */
export interface UpdateWinbackRewardConfigByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `WinbackRewardConfig` being updated. */
  winbackRewardConfigPatch: WinbackRewardConfigPatch;
}

/** All input for the `updateWinbackRewardOpportunity` mutation. */
export interface UpdateWinbackRewardOpportunityInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `WinbackRewardOpportunity` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `WinbackRewardOpportunity` being updated. */
  winbackRewardOpportunityPatch: WinbackRewardOpportunityPatch;
}

/** Represents an update to a `WinbackRewardOpportunity`. Fields that are set will be updated. */
export interface WinbackRewardOpportunityPatch {
  /** Foreign key to account_transaction table once reward is paid out (nullable) */
  accountTransactionId?: InputMaybe<Scalars['UUID']>;
  /** Timestamp when the opportunity was activated for the patient */
  activatedAt?: InputMaybe<Scalars['Datetime']>;
  /** The Customer.io campaign identifier for tracking */
  campaignId?: InputMaybe<Scalars['String']>;
  /** Unique identifier for this specific challenge instance (e.g., thanksgiving_2025_11_27) */
  challengeId?: InputMaybe<Scalars['String']>;
  /** Timestamp when the patient completed this challenge (nullable) */
  completedAt?: InputMaybe<Scalars['Datetime']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Timestamp when this challenge offer expires */
  expiresAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** The patient given this challenge reward opportunity */
  patientId?: InputMaybe<Scalars['UUID']>;
  rewardAmount?: InputMaybe<Scalars['BigFloat']>;
  rewardCurrency?: InputMaybe<Currency>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  warehouseRowId?: InputMaybe<Scalars['BigInt']>;
  /** Foreign key to the challenge reward config blueprint */
  winbackRewardConfigId?: InputMaybe<Scalars['UUID']>;
}

/** The output of our update `WinbackRewardOpportunity` mutation. */
export interface UpdateWinbackRewardOpportunityPayload {
  __typename: 'UpdateWinbackRewardOpportunityPayload';
  /** Reads a single `AccountTransaction` that is related to this `WinbackRewardOpportunity`. */
  accountTransactionByAccountTransactionId: Maybe<AccountTransaction>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Patient` that is related to this `WinbackRewardOpportunity`. */
  patientByPatientId: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `WinbackRewardConfig` that is related to this `WinbackRewardOpportunity`. */
  winbackRewardConfigByWinbackRewardConfigId: Maybe<WinbackRewardConfig>;
  /** The `WinbackRewardOpportunity` that was updated by this mutation. */
  winbackRewardOpportunity: Maybe<WinbackRewardOpportunity>;
  /** An edge for our `WinbackRewardOpportunity`. May be used by Relay 1. */
  winbackRewardOpportunityEdge: Maybe<WinbackRewardOpportunitiesEdge>;
}


/** The output of our update `WinbackRewardOpportunity` mutation. */
export interface UpdateWinbackRewardOpportunityPayloadWinbackRewardOpportunityEdgeArgs {
  orderBy?: InputMaybe<Array<WinbackRewardOpportunitiesOrderBy>>;
}

/** All input for the `updateWinbackRewardOpportunityById` mutation. */
export interface UpdateWinbackRewardOpportunityByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `WinbackRewardOpportunity` being updated. */
  winbackRewardOpportunityPatch: WinbackRewardOpportunityPatch;
}

/** All input for the `updateWinbackRewardOpportunityByPatientIdAndChallengeId` mutation. */
export interface UpdateWinbackRewardOpportunityByPatientIdAndChallengeIdInput {
  /** Unique identifier for this specific challenge instance (e.g., thanksgiving_2025_11_27) */
  challengeId: Scalars['String'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The patient given this challenge reward opportunity */
  patientId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `WinbackRewardOpportunity` being updated. */
  winbackRewardOpportunityPatch: WinbackRewardOpportunityPatch;
}

export interface VerifyDateOfBirthInput {
  monthAndDay: MonthAndDayInput;
  phoneNumber: Scalars['String'];
}

export interface VerifyZipCodeAndDayOfBirthPayload {
  __typename: 'VerifyZipCodeAndDayOfBirthPayload';
  firstName: Maybe<Scalars['String']>;
  lastName: Maybe<Scalars['String']>;
}

export interface VerifySecurityQuestionAnswerInput {
  answer: Scalars['String'];
  memberId: Scalars['UUID'];
  questionId: Scalars['UUID'];
}

export interface VerifySecurityQuestionAnswerPayload {
  __typename: 'VerifySecurityQuestionAnswerPayload';
  success: Scalars['Boolean'];
}

export interface VerifyZipCodeInput {
  phoneNumber: Scalars['String'];
  zipCode: Scalars['String'];
}

export interface VerifyZipCodeAndDateOfBirthInput {
  monthAndDay: MonthAndDayInput;
  phoneNumber: Scalars['String'];
  zipCode: Scalars['String'];
}

export enum MemberPauseStatus {
  Active = 'ACTIVE',
  Paused = 'PAUSED',
  Pausing = 'PAUSING',
  Unpausing = 'UNPAUSING'
}

export interface SimpleDialysisAppointment {
  __typename: 'SimpleDialysisAppointment';
  date: Scalars['String'];
  dayOfWeek: Scalars['String'];
  reminderMinutesAdvance: Maybe<Scalars['Int']>;
  scheduleJob: Scalars['String'];
  time: Scalars['String'];
}

export type FullAppointmentFragment = { __typename: 'Appointment', type: PersonVisitType, name: string | null, dueTime: Date | null, isAllDay: boolean | null, lossAmount: number | null, lossCurrencySymbol: string | null, isMissed: boolean | null, status: AppointmentStatusType | null, allowCredit: boolean | null, appointmentId: string, location: { __typename: 'AppointmentLocation', name: string | null, latitude: number | null, longitude: number | null, address: string | null, phoneNumber: string | null } | null };

export type CalendarEventFragment = { __typename: 'CalendarDay', checkInId: string | null, reminderDate: string | null, checkInLocalTime: string | null, reminderIsRequired: boolean | null, windowAfterMinutes: number | null, windowBeforeMinutes: number | null, checkInVerificationStatus: VerificationStatus | null, checkInIsValid: boolean | null, reminderWindowHasClosed: boolean | null, photoUrl: string | null, reminderTime: string | null, frequency: string | null, checkInCategory: CheckInCategory | null, checkInStatus: string | null, reminderId: string | null, checkInTimezone: string | null, isDemo: boolean | null, calendarDate: string | null, objectDetectionStatus: string | null, autoMedCount: number | null };

export type CueCheckInFragment = { __typename: 'CueCheckIn', nodeId: string, id: string, createdAt: Date, updatedAt: Date, patientId: string, reminderId: string, verificationStatus: VerificationStatus, verifierId: string | null, category: CheckInCategory, checkInTimestamp: Date, checkInTimezone: string, photoURL: string | null };

export type EmailFragment = { __typename: 'EmailAddress', id: string | null, emailAddress: string | null, isPrimary: boolean | null };

export type FullReminderFragment = { __typename: 'Reminder', nodeId: string, id: string, checkInCategory: CheckInCategory, createdAt: Date, updatedAt: Date, startDate: string, endDate: string, monTime: string, tueTime: string, wedTime: string, thuTime: string, friTime: string, satTime: string, sunTime: string, windowBeforeMinutes: number, windowAfterMinutes: number, isRequired: boolean, isDemo: boolean, linkedFutureReminderId: string | null, interval: ReminderInterval, intervalCount: number, label: string | null };

export type FullReminderConfigFragment = { __typename: 'ReminderConfig', id: string, monTime: string, startDayIndex: number, lengthInDays: number, checkInCategory: CheckInCategory, windowBeforeMinutes: number, windowAfterMinutes: number, isRequired: boolean, isDemo: boolean, interval: ReminderInterval };

export type FullRewardPeriodConfigFragment = { __typename: 'RewardPeriodConfig', id: string, rewardAmount: any, rewardCurrency: Currency, lengthInDays: number, lossPerDayMax: any, lossType: LossType, programId: string, startDayIndex: number };

export type HydrationCheckInFragment = { __typename: 'HydrationCheckIn', nodeId: string, id: string, createdAt: Date, updatedAt: Date, patientId: string, reminderId: string, verificationStatus: VerificationStatus, verifierId: string | null, category: CheckInCategory, checkInTimestamp: Date, checkInTimezone: string, photoURL: string | null };

export type FullAppointmentLocationFragment = { __typename: 'AppointmentLocation', name: string | null, latitude: number | null, longitude: number | null, address: string | null, phoneNumber: string | null };

export type FullMailingAddressFragment = { __typename: 'Address', id: string | null, street: string | null, street2: string | null, city: string | null, state: string | null, zip: string | null, country: string | null, isPrimary: boolean | null };

export type MealCheckInFragment = { __typename: 'MealCheckIn', nodeId: string, id: string, createdAt: Date, updatedAt: Date, patientId: string, reminderId: string, verificationStatus: VerificationStatus, verifierId: string | null, category: CheckInCategory, items: Array<string | null> | null, checkInTimestamp: Date, checkInTimezone: string, photoURL: string | null };

export type MeasurementCheckInFragment = { __typename: 'MeasurementCheckIn', nodeId: string, id: string, createdAt: Date, updatedAt: Date, patientId: string, reminderId: string, verificationStatus: VerificationStatus, verifierId: string | null, category: CheckInCategory, checkInTimestamp: Date, checkInTimezone: string, photoURL: string | null, measurements: Array<{ __typename: 'Measurement', name: MetricName | null, unit: MetricUnit | null, autoValue: any | null, manualValue: any | null, value: any | null } | null> | null };

export type MedicationCheckInFragment = { __typename: 'MedicationCheckIn', nodeId: string, id: string, createdAt: Date, updatedAt: Date, patientId: string, reminderId: string, verificationStatus: VerificationStatus, verifierId: string | null, category: CheckInCategory, checkInTimestamp: Date, checkInTimezone: string, autoHasMeds: boolean | null, autoMedCount: number | null, manualHasMeds: boolean | null, manualMedCount: number | null, photoURL: string | null };

export type MemberCustomerIdentityFragment = { __typename: 'Member', id: string | null, customerId: string | null, personId: string | null };

export type MemberProfileAdherenceFragment = { __typename: 'AdherenceSummary', requiredReminderCount: number | null, totalReminderCount: number | null, requiredValidCheckInCount: number | null, totalValidCheckInCount: number | null, percentRequiredRemindersAdherent: any | null, percentTotalRemindersAdherent: any | null, creditedCheckInCount: number | null, percentTotalRemindersNonCreditedAdherent: any | null };

export type MemberProfileInformationFragment = { __typename: 'Member', id: string | null, siteName: string | null, externalId: string | null, medicaidId: string | null, isTestMember: boolean | null, isAutoPauseEnabled: boolean | null, eligibilityEndDate: string | null, wellthId: string | null, isReminderMessagingEnabled: boolean | null, latestTimezone: { __typename: 'MemberTimezone', timezoneName: string | null } | null, person: { __typename: 'Person', id: string | null, primaryLanguage: ISOLanguage | null, primaryTimezone: string | null, birthDate: string | null, gender: Gender | null, ethnicity: string | null, race: string | null, medicareId: string | null, coverageType: string | null, planName: string | null, addresses: Array<{ __typename: 'Address', id: string | null, street: string | null, street2: string | null, city: string | null, state: string | null, zip: string | null, country: string | null, isPrimary: boolean | null } | null> | null, names: Array<{ __typename: 'Name', id: string | null, firstName: string | null, middleName: string | null, lastName: string | null, isPrimary: boolean | null } | null> | null, phoneNumbers: Array<{ __typename: 'PhoneNumber', id: string | null, phoneNumber: string | null, type: string | null, isPrimary: boolean | null } | null> | null, emailAddresses: Array<{ __typename: 'EmailAddress', id: string | null, emailAddress: string | null, isPrimary: boolean | null } | null> | null } | null, program: { __typename: 'Program', id: string, programTemplate: string | null } | null };

export type FullNameFragment = { __typename: 'Name', id: string | null, firstName: string | null, middleName: string | null, lastName: string | null, isPrimary: boolean | null };

export type FullPaymentOptionFragment = { __typename: 'PaymentOption', id: string | null, name: string | null, processor: PaymentProcessor | null, packId: string | null, default: boolean | null };

export type PersonDemographicsFragment = { __typename: 'Person', id: string | null, primaryLanguage: ISOLanguage | null, primaryTimezone: string | null, birthDate: string | null, gender: Gender | null, ethnicity: string | null, race: string | null, medicareId: string | null, coverageType: string | null, planName: string | null };

export type PersonProfileInformationFragment = { __typename: 'Person', id: string | null, primaryLanguage: ISOLanguage | null, primaryTimezone: string | null, birthDate: string | null, gender: Gender | null, ethnicity: string | null, race: string | null, medicareId: string | null, coverageType: string | null, planName: string | null, addresses: Array<{ __typename: 'Address', id: string | null, street: string | null, street2: string | null, city: string | null, state: string | null, zip: string | null, country: string | null, isPrimary: boolean | null } | null> | null, names: Array<{ __typename: 'Name', id: string | null, firstName: string | null, middleName: string | null, lastName: string | null, isPrimary: boolean | null } | null> | null, phoneNumbers: Array<{ __typename: 'PhoneNumber', id: string | null, phoneNumber: string | null, type: string | null, isPrimary: boolean | null } | null> | null, emailAddresses: Array<{ __typename: 'EmailAddress', id: string | null, emailAddress: string | null, isPrimary: boolean | null } | null> | null };

export type FullPersonSearchResultFragment = { __typename: 'IndividualSearchResult', id: string | null, shortId: string | null, individualType: IndividualType | null, createdAt: string | null, updatedAt: string | null, personId: string | null, birthDate: string | null, externalId: string | null, location: string | null, programCode: string | null, status: string | null, names: Array<{ __typename: 'Name', firstName: string | null, lastName: string | null } | null> | null, phoneNumbers: Array<{ __typename: 'PhoneNumber', id: string | null, isPrimary: boolean | null, phoneNumber: string | null } | null> | null };

export type FullPhoneNumberFragment = { __typename: 'PhoneNumber', id: string | null, phoneNumber: string | null, type: string | null, isPrimary: boolean | null };

export type FullProgramFragment = { __typename: 'Program', id: string, adminId: string, programCode: string, name: string, expiry: string, useCount: number | null, maximumUses: number | null, customerId: string | null, isTestProgram: boolean, sector: string | null, note: string | null, pauseAfterNoActivityDays: number | null, inactivateAfterPausedDays: number | null, programTemplate: string | null, customerByCustomerId: { __typename: 'Customer', name: string } | null };

export type AddIdentityTagMutationVariables = Exact<{
  input: AddIdentityTagInput;
}>;


export type AddIdentityTagMutation = { __typename: 'Mutation', addIdentityTag: { __typename: 'IdentityTag', id: string | null } | null };

export type ApproveSmsOutreachMessageMutationVariables = Exact<{
  messageId: Scalars['UUID'];
}>;


export type ApproveSmsOutreachMessageMutation = { __typename: 'Mutation', approveSmsOutreachMessage: boolean | null };

export type CancelPauseRequestMutationVariables = Exact<{
  input: CancelPauseRequestInput;
}>;


export type CancelPauseRequestMutation = { __typename: 'Mutation', cancelPauseRequest: { __typename: 'CancelPauseRequestPayload', boolean: boolean | null } | null };

export type CancelUnpauseRequestMutationVariables = Exact<{
  input: CancelUnpauseRequestInput;
}>;


export type CancelUnpauseRequestMutation = { __typename: 'Mutation', cancelUnpauseRequest: { __typename: 'CancelUnpauseRequestPayload', boolean: boolean | null } | null };

export type ChangeBonusBehaviorSubmissionStatusMutationVariables = Exact<{
  input: ChangeBonusBehaviorSubmissionStatusInput;
}>;


export type ChangeBonusBehaviorSubmissionStatusMutation = { __typename: 'Mutation', changeBonusBehaviorSubmissionStatus: { __typename: 'BonusBehaviorSubmission', id: string | null, submissionType: BonusBehaviorSubmissionType | null, status: BonusBehaviorSubmissionStatusValue | null, photoUrl: string | null, bonusBehavior: { __typename: 'BonusBehavior', status: BonusBehaviorStatusValue | null } | null } | null };

export type ChangeMemberStatusMutationVariables = Exact<{
  id: Scalars['UUID'];
  status: Scalars['String'];
  reason?: InputMaybe<Scalars['String']>;
  reasonDetail?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
}>;


export type ChangeMemberStatusMutation = { __typename: 'Mutation', changeMemberStatus: boolean | null };

export type ChangeProspectStatusMutationVariables = Exact<{
  id: Scalars['UUID'];
  status: Scalars['String'];
  reason?: InputMaybe<Scalars['String']>;
  reasonDetail?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
}>;


export type ChangeProspectStatusMutation = { __typename: 'Mutation', changeProspectStatus: boolean | null };

export type CreateAccountTransactionCreditMutationVariables = Exact<{
  input: CreateAccountTransactionCreditInput;
}>;


export type CreateAccountTransactionCreditMutation = { __typename: 'Mutation', createAccountTransactionCredit: { __typename: 'CreateAccountTransactionCreditPayload', id: string | null } | null };

export type CreateBonusBehaviorConfigMutationVariables = Exact<{
  input: CreateBonusBehaviorConfigInput;
}>;


export type CreateBonusBehaviorConfigMutation = { __typename: 'Mutation', createBonusBehaviorConfig: { __typename: 'BonusBehaviorConfig', id: string | null, name: string | null } | null };

export type CreateBonusBehaviorSubmissionMutationVariables = Exact<{
  input: CreateBonusBehaviorSubmissionInput;
}>;


export type CreateBonusBehaviorSubmissionMutation = { __typename: 'Mutation', createBonusBehaviorSubmission: { __typename: 'BonusBehaviorSubmission', id: string | null, submissionType: BonusBehaviorSubmissionType | null, status: BonusBehaviorSubmissionStatusValue | null, photoUrl: string | null, bonusBehavior: { __typename: 'BonusBehavior', id: string | null, status: BonusBehaviorStatusValue | null, icon: string | null, title: string | null, createdAt: string | null, updatedAt: string | null, startDate: string | null, endDate: string | null, submittedDate: string | null, completedDate: string | null, submissionType: BonusBehaviorSubmissionType | null, rewards: { __typename: 'BonusBehaviorReward', amount: any | null, currencySymbol: Currency | null } | null, submissionPage: { __typename: 'BonusBehaviorSubmissionPage', title: string | null, detail: string | null, icon: string | null, getHelpIsEnabled: boolean | null, getHelpText: string | null } | null, verifyPage: { __typename: 'BonusBehaviorVerifyPage', title: string | null } | null, successPage: { __typename: 'BonusBehaviorSuccessPage', title: string | null, detail: string | null, icon: string | null, backgroundColor: string | null } | null, instructionPages: Array<{ __typename: 'BonusBehaviorInstructionPage', title: string | null, detail: string | null, icon: string | null, backgroundColor: string | null, pageIndex: number | null, buttonText: string | null } | null> | null } | null } | null };

export type CreateCueCheckInMutationVariables = Exact<{
  input: CreateCueCheckInInput;
}>;


export type CreateCueCheckInMutation = { __typename: 'Mutation', createCueCheckIn: { __typename: 'CreateCueCheckInPayload', cueCheckIn: { __typename: 'CueCheckIn', nodeId: string, id: string, createdAt: Date, updatedAt: Date, patientId: string, reminderId: string, verificationStatus: VerificationStatus, verifierId: string | null, category: CheckInCategory, checkInTimestamp: Date, checkInTimezone: string, photoURL: string | null } | null } | null };

export type CreateDialysisMutationVariables = Exact<{
  input: CreateDialysisAppointmentScheduleInput;
}>;


export type CreateDialysisMutation = { __typename: 'Mutation', createDialysisAppointmentSchedule: { __typename: 'DialysisAppointmentScheduleResponse', day: string, time: string, scheduleJob: string, reminderMinutesAdvance: number | null } };

export type CreateEmailAddressMutationVariables = Exact<{
  input: CreateEmailAddressInput;
  contactId: Scalars['UUID'];
  contactType: ContactType;
}>;


export type CreateEmailAddressMutation = { __typename: 'Mutation', createEmailAddress: { __typename: 'CreateEmailAddressPayload', emailAddress: { __typename: 'EmailAddress', id: string | null, emailAddress: string | null, isPrimary: boolean | null } | null } | null };

export type CreateHydrationCheckInMutationVariables = Exact<{
  input: CreateHydrationCheckInInput;
}>;


export type CreateHydrationCheckInMutation = { __typename: 'Mutation', createHydrationCheckIn: { __typename: 'CreateHydrationCheckInPayload', hydrationCheckIn: { __typename: 'HydrationCheckIn', nodeId: string, id: string, createdAt: Date, updatedAt: Date, patientId: string, reminderId: string, verificationStatus: VerificationStatus, verifierId: string | null, category: CheckInCategory, checkInTimestamp: Date, checkInTimezone: string, photoURL: string | null } | null } | null };

export type CreateMailingAddressMutationVariables = Exact<{
  input: CreateAddressInput;
  contactId: Scalars['UUID'];
  contactType: ContactType;
}>;


export type CreateMailingAddressMutation = { __typename: 'Mutation', createAddress: { __typename: 'CreateAddressPayload', address: { __typename: 'Address', id: string | null, street: string | null, street2: string | null, city: string | null, state: string | null, zip: string | null, country: string | null, isPrimary: boolean | null } | null } | null };

export type CreateMealCheckInMutationVariables = Exact<{
  input: CreateMealCheckInInput;
}>;


export type CreateMealCheckInMutation = { __typename: 'Mutation', createMealCheckIn: { __typename: 'CreateMealCheckInPayload', mealCheckIn: { __typename: 'MealCheckIn', nodeId: string, id: string, createdAt: Date, updatedAt: Date, patientId: string, reminderId: string, verificationStatus: VerificationStatus, verifierId: string | null, category: CheckInCategory, items: Array<string | null> | null, checkInTimestamp: Date, checkInTimezone: string, photoURL: string | null } | null } | null };

export type CreateMeasurementCheckInMutationVariables = Exact<{
  input: CreateMeasurementCheckInInput;
}>;


export type CreateMeasurementCheckInMutation = { __typename: 'Mutation', createMeasurementCheckIn: { __typename: 'CreateMeasurementCheckInPayload', measurementCheckIn: { __typename: 'MeasurementCheckIn', nodeId: string, id: string, createdAt: Date, updatedAt: Date, patientId: string, reminderId: string, verificationStatus: VerificationStatus, verifierId: string | null, category: CheckInCategory, checkInTimestamp: Date, checkInTimezone: string, photoURL: string | null, measurements: Array<{ __typename: 'Measurement', name: MetricName | null, unit: MetricUnit | null, autoValue: any | null, manualValue: any | null, value: any | null } | null> | null } | null } | null };

export type CreateMedicationCheckInMutationVariables = Exact<{
  input: CreateMedicationCheckInInput;
}>;


export type CreateMedicationCheckInMutation = { __typename: 'Mutation', createMedicationCheckIn: { __typename: 'CreateMedicationCheckInPayload', medicationCheckIn: { __typename: 'MedicationCheckIn', nodeId: string, id: string, createdAt: Date, updatedAt: Date, patientId: string, reminderId: string, verificationStatus: VerificationStatus, verifierId: string | null, category: CheckInCategory, checkInTimestamp: Date, checkInTimezone: string, autoHasMeds: boolean | null, autoMedCount: number | null, manualHasMeds: boolean | null, manualMedCount: number | null, photoURL: string | null } | null } | null };

export type CreateMessageMutationVariables = Exact<{
  input: CreateMessageInput;
}>;


export type CreateMessageMutation = { __typename: 'Mutation', createMessage: { __typename: 'CreateMessagePayload', messageEdge: { __typename: 'MessagesEdge', node: { __typename: 'Message', id: string, createdAt: Date, updatedAt: Date, sentDatetime: Date, recipient: MessageRecipient } | null } | null } | null };

export type CreateNameMutationVariables = Exact<{
  input: CreateNameInput;
  contactId: Scalars['UUID'];
  contactType: ContactType;
}>;


export type CreateNameMutation = { __typename: 'Mutation', createName: { __typename: 'CreateNamePayload', name: { __typename: 'Name', id: string | null, firstName: string | null, middleName: string | null, lastName: string | null, isPrimary: boolean | null } | null } | null };

export type CreatePatientNoteMutationVariables = Exact<{
  input: CreatePatientNoteInput;
}>;


export type CreatePatientNoteMutation = { __typename: 'Mutation', createPatientNote: { __typename: 'CreatePatientNotePayload', patientNote: { __typename: 'PatientNote', id: string, note: string } | null } | null };

export type CreatePhoneNumberMutationVariables = Exact<{
  input: CreatePhoneNumberInput;
  contactId: Scalars['UUID'];
  contactType: ContactType;
}>;


export type CreatePhoneNumberMutation = { __typename: 'Mutation', createPhoneNumber: { __typename: 'CreatePhoneNumberPayload', phoneNumber: { __typename: 'PhoneNumber', id: string | null, phoneNumber: string | null, type: string | null, isPrimary: boolean | null } | null } | null };

export type CreateProspectMutationVariables = Exact<{
  input: CreateProspectInput;
}>;


export type CreateProspectMutation = { __typename: 'Mutation', createProspect: { __typename: 'CreateProspectPayload', prospect: { __typename: 'Prospect', id: string | null, person: { __typename: 'Person', primaryFirstName: string | null, primaryLastName: string | null, primaryPhoneNumber: string | null, birthDate: string | null } | null } | null } | null };

export type CreateProspectForInactiveMemberMutationVariables = Exact<{
  input: CreateProspectForInactiveMemberInput;
}>;


export type CreateProspectForInactiveMemberMutation = { __typename: 'Mutation', createProspectForInactiveMember: { __typename: 'CreateProspectPayload', prospect: { __typename: 'Prospect', id: string | null } | null } | null };

export type CreateProspectNoteMutationVariables = Exact<{
  input: CreateProspectNoteInput;
}>;


export type CreateProspectNoteMutation = { __typename: 'Mutation', createProspectNote: { __typename: 'CreateProspectNotePayload', prospectNote: { __typename: 'ProspectNote', id: string | null, note: string | null } | null } | null };

export type CreateReminderMutationVariables = Exact<{
  input: CreateReminderInput;
}>;


export type CreateReminderMutation = { __typename: 'Mutation', createReminder: { __typename: 'CreateReminderPayload', reminder: { __typename: 'Reminder', nodeId: string, id: string, checkInCategory: CheckInCategory, createdAt: Date, updatedAt: Date, startDate: string, endDate: string, monTime: string, tueTime: string, wedTime: string, thuTime: string, friTime: string, satTime: string, sunTime: string, windowBeforeMinutes: number, windowAfterMinutes: number, isRequired: boolean, isDemo: boolean, linkedFutureReminderId: string | null, interval: ReminderInterval, intervalCount: number, label: string | null } | null } | null };

export type CreateSmsOutreachMessageTemplateMutationVariables = Exact<{
  input: CreateSmsOutreachMessageTemplateInput;
}>;


export type CreateSmsOutreachMessageTemplateMutation = { __typename: 'Mutation', createSmsOutreachMessageTemplate: { __typename: 'CreateSmsOutreachMessageTemplatePayload', smsOutreachMessageTemplate: { __typename: 'SmsOutreachMessageTemplate', adminId: string | null, message: string, id: string } | null } | null };

export type CreditAppointmentMutationVariables = Exact<{
  input: CreditAppointmentInput;
}>;


export type CreditAppointmentMutation = { __typename: 'Mutation', creditAppointment: { __typename: 'Appointment', type: PersonVisitType, name: string | null, dueTime: Date | null, isAllDay: boolean | null, lossAmount: number | null, lossCurrencySymbol: string | null, isMissed: boolean | null, status: AppointmentStatusType | null, allowCredit: boolean | null, appointmentId: string, location: { __typename: 'AppointmentLocation', name: string | null, latitude: number | null, longitude: number | null, address: string | null, phoneNumber: string | null } | null } | null };

export type DeleteEmailAddressMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteEmailAddressMutation = { __typename: 'Mutation', deleteEmailAddressById: boolean | null };

export type DeleteDialysisMutationVariables = Exact<{
  input: DeleteFutureDialysisAppointmentEventsInput;
}>;


export type DeleteDialysisMutation = { __typename: 'Mutation', deleteFutureDialysisAppointmentEvents: { __typename: 'DeleteFutureDialysisAppointmentEventsPayload', deletedCount: number } };

export type DeleteMailingAddressMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteMailingAddressMutation = { __typename: 'Mutation', deleteAddressById: boolean | null };

export type DeleteMemberMutationVariables = Exact<{
  input: DeleteMemberInput;
}>;


export type DeleteMemberMutation = { __typename: 'Mutation', deleteMember: boolean | null };

export type DeleteNameMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteNameMutation = { __typename: 'Mutation', deleteNameById: boolean | null };

export type DeletePhoneNumberMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeletePhoneNumberMutation = { __typename: 'Mutation', deletePhoneNumberById: boolean | null };

export type DeleteReminderMutationVariables = Exact<{
  uuid: Scalars['UUID'];
}>;


export type DeleteReminderMutation = { __typename: 'Mutation', deleteReminderById: { __typename: 'DeleteReminderPayload', deletedReminderId: string | null } | null };

export type UpdateDialysisAppointmentReminderInputMutationVariables = Exact<{
  input: UpdateDialysisAppointmentReminderInput;
}>;


export type UpdateDialysisAppointmentReminderInputMutation = { __typename: 'Mutation', updateDialysisAppointmentReminder: { __typename: 'UpdateDialysisAppointmentReminderPayload', scheduleJob: string, reminderMinutesAdvance: number | null } };

export type EnrollMemberMutationVariables = Exact<{
  input: EnrollMemberInput;
}>;


export type EnrollMemberMutation = { __typename: 'Mutation', enrollMember: { __typename: 'EnrollMemberPayload', memberId: string } };

export type EnrollPaperMutationMutationVariables = Exact<{
  input: EnrollPaperMemberInput;
}>;


export type EnrollPaperMutationMutation = { __typename: 'Mutation', enrollPaperMember: { __typename: 'EnrollPaperMemberPayload', memberId: string } };

export type GetTokenViaSSOMutationVariables = Exact<{
  provider: Scalars['String'];
  identityToken: Scalars['String'];
}>;


export type GetTokenViaSSOMutation = { __typename: 'Mutation', getTokenViaSSO: { __typename: 'Token', jwtToken: string | null } | null };

export type SubmitPauseRequestMutationVariables = Exact<{
  input: SubmitPauseRequestInput;
}>;


export type SubmitPauseRequestMutation = { __typename: 'Mutation', submitPauseRequest: { __typename: 'SubmitPauseRequestPayload', boolean: boolean | null } | null };

export type ReauthenticatePatientMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type ReauthenticatePatientMutation = { __typename: 'Mutation', reauthenticatePatient: { __typename: 'ReauthenticatePatientPayload', jwtToken: string | null } | null };

export type ReindexAllPersonsMutationVariables = Exact<{ [key: string]: never; }>;


export type ReindexAllPersonsMutation = { __typename: 'Mutation', reindexAllPersons: { __typename: 'ReindexAllPersonsPayload', status: string, message: string } };

export type RemoveIdentityTagMutationVariables = Exact<{
  input: RemoveTagInput;
}>;


export type RemoveIdentityTagMutation = { __typename: 'Mutation', removeIdentityTag: boolean | null };

export type SendOneOffMessageMutationVariables = Exact<{
  input: OneOffSenderInput;
}>;


export type SendOneOffMessageMutation = { __typename: 'Mutation', sendOneOffMessage: boolean | null };

export type TestSmsMessageMutationVariables = Exact<{
  recipient: SmsTestMessageRecipientInput;
  messageTemplateId: Scalars['String'];
}>;


export type TestSmsMessageMutation = { __typename: 'Mutation', testSmsMessage: boolean | null };

export type SubmitUnpauseRequestMutationVariables = Exact<{
  input: SubmitUnpauseRequestInput;
}>;


export type SubmitUnpauseRequestMutation = { __typename: 'Mutation', submitUnpauseRequest: { __typename: 'SubmitUnpauseRequestPayload', boolean: boolean | null } | null };

export type UpdateCheckInMutationVariables = Exact<{
  id: Scalars['UUID'];
  checkInPatch: CheckInPatch;
}>;


export type UpdateCheckInMutation = { __typename: 'Mutation', updateCheckInById: { __typename: 'UpdateCheckInPayload', checkIn: { __typename: 'CheckIn', id: string, checkInTimestamp: Date, checkInTimezone: string, photoUrl: string | null, verificationStatus: VerificationStatus, category: CheckInCategory, isCredited: boolean } | null } | null };

export type UpdateEmailAddressMutationVariables = Exact<{
  input: UpdateEmailAddressInput;
}>;


export type UpdateEmailAddressMutation = { __typename: 'Mutation', updateEmailAddress: { __typename: 'UpdateEmailAddressPayload', emailAddress: { __typename: 'EmailAddress', id: string | null, emailAddress: string | null, isPrimary: boolean | null } | null } | null };

export type UpdateMailingAddressMutationVariables = Exact<{
  input: UpdateAddressInput;
}>;


export type UpdateMailingAddressMutation = { __typename: 'Mutation', updateAddress: { __typename: 'UpdateAddressPayload', address: { __typename: 'Address', id: string | null, street: string | null, street2: string | null, city: string | null, state: string | null, zip: string | null, country: string | null, isPrimary: boolean | null } | null } | null };

export type UpdateMemberByIdMutationVariables = Exact<{
  id: Scalars['UUID'];
  memberPatch: MemberPatch;
}>;


export type UpdateMemberByIdMutation = { __typename: 'Mutation', updateMemberById: { __typename: 'Member', id: string | null, siteName: string | null, externalId: string | null, person: { __typename: 'Person', id: string | null, primaryLanguage: ISOLanguage | null, primaryTimezone: string | null, birthDate: string | null, gender: Gender | null, ethnicity: string | null, race: string | null, medicareId: string | null, coverageType: string | null, planName: string | null, addresses: Array<{ __typename: 'Address', id: string | null, street: string | null, street2: string | null, city: string | null, state: string | null, zip: string | null, country: string | null, isPrimary: boolean | null } | null> | null, names: Array<{ __typename: 'Name', id: string | null, firstName: string | null, middleName: string | null, lastName: string | null, isPrimary: boolean | null } | null> | null, phoneNumbers: Array<{ __typename: 'PhoneNumber', id: string | null, phoneNumber: string | null, type: string | null, isPrimary: boolean | null } | null> | null, emailAddresses: Array<{ __typename: 'EmailAddress', id: string | null, emailAddress: string | null, isPrimary: boolean | null } | null> | null } | null } | null };

export type UpdateNameMutationVariables = Exact<{
  input: UpdateNameInput;
}>;


export type UpdateNameMutation = { __typename: 'Mutation', updateName: { __typename: 'UpdateNamePayload', name: { __typename: 'Name', id: string | null, firstName: string | null, middleName: string | null, lastName: string | null, isPrimary: boolean | null } | null } | null };

export type UpdatePauseObjectMutationVariables = Exact<{
  pausePatch: PausePatch;
}>;


export type UpdatePauseObjectMutation = { __typename: 'Mutation', updatePauseObject: boolean | null };

export type UpdatePhoneNumberMutationVariables = Exact<{
  input: UpdatePhoneNumberInput;
}>;


export type UpdatePhoneNumberMutation = { __typename: 'Mutation', updatePhoneNumber: { __typename: 'UpdatePhoneNumberPayload', phoneNumber: { __typename: 'PhoneNumber', id: string | null, phoneNumber: string | null, type: string | null, isPrimary: boolean | null } | null } | null };

export type UpdateProgrambyIdMutationVariables = Exact<{
  id: Scalars['String'];
  programPatch: ProgramPatch;
}>;


export type UpdateProgrambyIdMutation = { __typename: 'Mutation', updateProgramById: { __typename: 'Program', id: string } | null };

export type UpdateProspectByIdMutationVariables = Exact<{
  id: Scalars['UUID'];
  prospectPatch: ProspectPatch;
}>;


export type UpdateProspectByIdMutation = { __typename: 'Mutation', updateProspectById: { __typename: 'Prospect', id: string | null, siteName: string | null, externalId: string | null, description: string | null, eligibilityEndDate: string | null, person: { __typename: 'Person', id: string | null, primaryLanguage: ISOLanguage | null, primaryTimezone: string | null, birthDate: string | null, gender: Gender | null, ethnicity: string | null, race: string | null, medicareId: string | null, coverageType: string | null, planName: string | null, addresses: Array<{ __typename: 'Address', id: string | null, street: string | null, street2: string | null, city: string | null, state: string | null, zip: string | null, country: string | null, isPrimary: boolean | null } | null> | null, names: Array<{ __typename: 'Name', id: string | null, firstName: string | null, middleName: string | null, lastName: string | null, isPrimary: boolean | null } | null> | null, phoneNumbers: Array<{ __typename: 'PhoneNumber', id: string | null, phoneNumber: string | null, type: string | null, isPrimary: boolean | null } | null> | null, emailAddresses: Array<{ __typename: 'EmailAddress', id: string | null, emailAddress: string | null, isPrimary: boolean | null } | null> | null } | null, program: { __typename: 'Program', id: string, programCode: string } | null, prospectStatuses: Array<{ __typename: 'ProspectStatus', value: string } | null> | null } | null };

export type UpdateReminderMutationVariables = Exact<{
  uuid: Scalars['UUID'];
  reminderPatch: ReminderPatch;
}>;


export type UpdateReminderMutation = { __typename: 'Mutation', updateReminderById: { __typename: 'UpdateReminderPayload', reminder: { __typename: 'Reminder', id: string, nodeId: string, startDate: string, endDate: string, monTime: string, tueTime: string, wedTime: string, thuTime: string, friTime: string, satTime: string, sunTime: string, isDemo: boolean } | null } | null };

export type UpdateSmsOutreachMessageTemplateByIdMutationVariables = Exact<{
  input: UpdateSmsOutreachMessageTemplateByIdInput;
}>;


export type UpdateSmsOutreachMessageTemplateByIdMutation = { __typename: 'Mutation', updateSmsOutreachMessageTemplateById: { __typename: 'UpdateSmsOutreachMessageTemplatePayload', smsOutreachMessageTemplate: { __typename: 'SmsOutreachMessageTemplate', message: string } | null } | null };

export type UploadBulkSmsMutationVariables = Exact<{
  file: Scalars['Upload'];
  messageTemplateId: Scalars['UUID'];
}>;


export type UploadBulkSmsMutation = { __typename: 'Mutation', uploadBulkSms: boolean | null };

export type UploadProspectFileMutationVariables = Exact<{
  file: Scalars['Upload'];
  programId: Scalars['UUID'];
}>;


export type UploadProspectFileMutation = { __typename: 'Mutation', uploadProspectFile: string | null };

export type VerifySecurityQuestionAnswerMutationVariables = Exact<{
  input: VerifySecurityQuestionAnswerInput;
}>;


export type VerifySecurityQuestionAnswerMutation = { __typename: 'Mutation', verifySecurityQuestionAnswer: { __typename: 'VerifySecurityQuestionAnswerPayload', success: boolean } | null };

export type ActiveIdentityTagsByWellthIdQueryVariables = Exact<{
  wellthId: Scalars['UUID'];
}>;


export type ActiveIdentityTagsByWellthIdQuery = { __typename: 'Query', activeIdentityTagsByWellthId: Array<{ __typename: 'IdentityTag', id: string | null, name: string | null, backgroundColor: string | null, borderColor: string | null, isAdminRemovable: boolean | null } | null> | null };

export type AdherenceCurrentRewardPeriodQueryVariables = Exact<{
  id: Scalars['UUID'];
  periodStart: Scalars['Date'];
  periodEnd: Scalars['Date'];
}>;


export type AdherenceCurrentRewardPeriodQuery = { __typename: 'Query', member: { __typename: 'Member', id: string | null, adherence: { __typename: 'AdherenceSummary', creditedCheckInCount: number | null } | null } | null };

export type AllAccountTransactionsQueryVariables = Exact<{
  memberId: Scalars['UUID'];
  orderBy?: InputMaybe<Array<AccountTransactionsOrderBy> | AccountTransactionsOrderBy>;
}>;


export type AllAccountTransactionsQuery = { __typename: 'Query', allAccountTransactions: { __typename: 'AccountTransactionsConnection', nodes: Array<{ __typename: 'AccountTransaction', id: string, date: string, amount: any, currency: Currency, reason: AccountTransactionReason, note: string | null } | null> } | null };

export type AllAdminTagConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllAdminTagConfigsQuery = { __typename: 'Query', allAdminTagConfigs: Array<{ __typename: 'TagConfigPayload', id: string | null, name: string | null } | null> | null };

export type AllBonusBehaviorSubmissionPayloadsQueryVariables = Exact<{
  statuses: Array<InputMaybe<BonusBehaviorSubmissionStatusValue>> | InputMaybe<BonusBehaviorSubmissionStatusValue>;
  after?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type AllBonusBehaviorSubmissionPayloadsQuery = { __typename: 'Query', allBonusBehaviorSubmissionPayloads: { __typename: 'BonusBehaviorSubmissionPayload', pageInfo: { __typename: 'PageInfo', endCursor: string | null, hasNextPage: boolean }, edges: Array<{ __typename: 'BonusBehaviorSubmissionEdge', cursor: string | null, node: { __typename: 'BonusBehaviorSubmissionItem', id: string | null, name: string | null, shortId: string | null, memberId: string | null, status: BonusBehaviorSubmissionStatusValue | null, timestamp: string | null, firstName: string | null, lastName: string | null, programCode: string | null, rewardAmount: number | null, rewardCurrency: Currency | null, photoUrl: string | null, photoUrls: Array<string | null> | null, verification: string | null } | null } | null> } | null };

export type AllBonusBehaviorsQueryVariables = Exact<{
  memberId: Scalars['UUID'];
}>;


export type AllBonusBehaviorsQuery = { __typename: 'Query', allBonusBehaviors: Array<{ __typename: 'BonusBehavior', status: BonusBehaviorStatusValue | null, icon: string | null, title: string | null, startDate: string | null, endDate: string | null, submittedDate: string | null, completedDate: string | null, rewards: { __typename: 'BonusBehaviorReward', amount: any | null, currencySymbol: Currency | null } | null } | null> | null };

export type AllBonusBehaviorConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllBonusBehaviorConfigsQuery = { __typename: 'Query', allBonusBehaviorConfigs: Array<{ __typename: 'BonusBehaviorConfig', id: string | null, name: string | null, programCode: string | null, endDate: string | null, startDate: string | null, rewardAmount: number | null, rewardCurrency: Currency | null, note: string | null, bonusBehaviorPagesetId: string | null, icon: string | null, verification: string | null } | null> | null };

export type AllChallengeRewardsQueryVariables = Exact<{
  memberId: Scalars['UUID'];
}>;


export type AllChallengeRewardsQuery = { __typename: 'Query', allChallengeRewards: Array<{ __typename: 'ChallengeRewardDetail', id: string, name: string, eligibilityStartDate: Date, eligibilityEndDate: Date, amount: any, status: string }> | null };

export type AllCustomersQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<CustomersOrderBy> | CustomersOrderBy>;
}>;


export type AllCustomersQuery = { __typename: 'Query', allCustomers: { __typename: 'CustomersConnection', nodes: Array<{ __typename: 'Customer', name: string, id: string } | null> } | null };

export type AllDebitCardsQueryVariables = Exact<{
  memberId: Scalars['UUID'];
}>;


export type AllDebitCardsQuery = { __typename: 'Query', allDebitCards: { __typename: 'DebitCardsConnection', nodes: Array<{ __typename: 'DebitCard', processor: PaymentProcessor, statusDesc: string | null } | null> } | null };

export type AllMembersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  orderBy?: InputMaybe<Array<MemberOrderBy> | MemberOrderBy>;
  condition?: InputMaybe<MemberCondition>;
}>;


export type AllMembersQuery = { __typename: 'Query', allMembers: { __typename: 'MemberConnection', totalCount: number | null, nodes: Array<{ __typename: 'MemberListItem', id: string | null, createdAt: Date | null, siteName: string | null, externalId: string | null, pauseStatus: PauseStatus | null, program: { __typename: 'Program', programCode: string } | null, status: { __typename: 'MemberStatus', value: MemberStatusValue | null, createdAt: Date | null, statusTransitionDate: Date | null, reason: string | null } | null, person: { __typename: 'Person', shortId: string | null, primaryFirstName: string | null, primaryLastName: string | null } | null, statuses: Array<{ __typename: 'PatientStatus', statusTransitionDate: Date } | null> | null } | null>, pageInfo: { __typename: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor: string | null, endCursor: string | null } } | null };

export type AllProgramTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllProgramTemplatesQuery = { __typename: 'Query', allProgramTemplates: { __typename: 'ProgramTemplatesConnection', nodes: Array<{ __typename: 'ProgramTemplate', name: string } | null> } | null };

export type AllProgramsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllProgramsQuery = { __typename: 'Query', allPrograms: { __typename: 'ProgramsConnection', nodes: Array<{ __typename: 'Program', id: string, programCode: string, name: string, sector: string | null, customerId: string | null, createdAt: Date, expiry: string, totalActiveMembers: number | null, currentActiveMembers: number | null, inactivateAfterPausedDays: number | null, pauseAfterNoActivityDays: number | null, programTemplate: string | null, isProspectReopeningSuppressed: boolean, isProspectCreationSuppressed: boolean, isTestProgram: boolean, isUploaderDisabled: boolean | null, customerByCustomerId: { __typename: 'Customer', name: string } | null } | null> } | null };

export type AllSmsOutreachMessageTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllSmsOutreachMessageTemplatesQuery = { __typename: 'Query', allSmsOutreachMessageTemplates: { __typename: 'SmsOutreachMessageTemplatesConnection', nodes: Array<{ __typename: 'SmsOutreachMessageTemplate', id: string, createdAt: Date, updatedAt: Date, adminId: string | null, message: string, title: string | null } | null> } | null };

export type AllSmsOutreachMessagesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SmsOutreachMessageCondition>;
}>;


export type AllSmsOutreachMessagesQuery = { __typename: 'Query', allSmsOutreachMessages: { __typename: 'SmsOutreachMessagesConnection', totalCount: number, pageInfo: { __typename: 'PageInfo', endCursor: string | null, hasNextPage: boolean }, edges: Array<{ __typename: 'SmsOutreachMessagesEdge', node: { __typename: 'SmsOutreachMessage', id: string, message: string, approveAt: Date | null, smsOutreachRecipientByRecipientId: { __typename: 'SmsOutreachRecipient', id: string, firstName: string | null, lastName: string | null, phoneNumber: string, programByProgramId: { __typename: 'Program', programCode: string } | null } | null } | null }> } | null };

export type AvailableProgramsQueryVariables = Exact<{ [key: string]: never; }>;


export type AvailableProgramsQuery = { __typename: 'Query', availablePrograms: Array<{ __typename: 'Program', id: string, programCode: string, programTemplate: string | null } | null> | null };

export type CreatePersonResourceIdentityQueryVariables = Exact<{
  memberId: Scalars['UUID'];
}>;


export type CreatePersonResourceIdentityQuery = { __typename: 'Query', member: { __typename: 'Member', id: string | null, customerId: string | null, personId: string | null } | null };

export type CurrentAdminQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentAdminQuery = { __typename: 'Query', currentAdmin: { __typename: 'Admin', id: string, lastName: string | null, firstName: string | null, adminRoleByAdminRoleId: { __typename: 'AdminRole', name: string } | null } | null };

export type CurrentAdminIdQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentAdminIdQuery = { __typename: 'Query', currentAdminId: string | null };

export type DeviceDetailsQueryVariables = Exact<{
  wellthId: Scalars['UUID'];
}>;


export type DeviceDetailsQuery = { __typename: 'Query', deviceDetails: { __typename: 'DeviceDetails', id: string | null, wellthId: string | null, lastSeen: string | null, model: string | null, appVersion: string | null, os: string | null, osVersion: string | null, appBuildNumber: string | null, brand: string | null, cameraPermission: string | null, notificationsPermission: string | null, locationPermission: string | null, carrier: string | null, manufacturer: string | null } | null };

export type DialysisAppointmentScheduleQueryVariables = Exact<{
  scheduleJob: Scalars['String'];
}>;


export type DialysisAppointmentScheduleQuery = { __typename: 'Query', dialysisAppointmentSchedule: { __typename: 'DialysisAppointmentScheduleSummary', scheduleJob: string, dayOfWeek: string, time: string, startDate: string, endDate: string, reminderMinutesAdvance: number | null } | null };

export type DialysisAppointmentSchedulesQueryVariables = Exact<{
  memberId: Scalars['UUID'];
}>;


export type DialysisAppointmentSchedulesQuery = { __typename: 'Query', dialysisAppointmentSchedules: Array<{ __typename: 'DialysisAppointmentScheduleSummary', scheduleJob: string, dayOfWeek: string, time: string, startDate: string, endDate: string, reminderMinutesAdvance: number | null }> };

export type EditEmailAddressQueryVariables = Exact<{
  emailId: Scalars['UUID'];
}>;


export type EditEmailAddressQuery = { __typename: 'Query', emailAddress: { __typename: 'EmailAddress', id: string | null, emailAddress: string | null, isPrimary: boolean | null } | null };

export type EditMailingAddressQueryVariables = Exact<{
  mailingAddressId: Scalars['UUID'];
}>;


export type EditMailingAddressQuery = { __typename: 'Query', address: { __typename: 'Address', id: string | null, street: string | null, street2: string | null, city: string | null, state: string | null, zip: string | null, country: string | null, isPrimary: boolean | null } | null };

export type EditNameQueryVariables = Exact<{
  nameId: Scalars['UUID'];
}>;


export type EditNameQuery = { __typename: 'Query', name: { __typename: 'Name', id: string | null, firstName: string | null, middleName: string | null, lastName: string | null, isPrimary: boolean | null } | null };

export type EditPhoneNumberQueryVariables = Exact<{
  phoneNumberId: Scalars['UUID'];
}>;


export type EditPhoneNumberQuery = { __typename: 'Query', phoneNumber: { __typename: 'PhoneNumber', id: string | null, phoneNumber: string | null, type: string | null, isPrimary: boolean | null } | null };

export type EmailAddressQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type EmailAddressQuery = { __typename: 'Query', emailAddress: { __typename: 'EmailAddress', id: string | null, emailAddress: string | null, isPrimary: boolean | null } | null };

export type GetAllProspectJobQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetAllProspectJobQuery = { __typename: 'Query', getAllProspectJobs: Array<{ __typename: 'ProspectJob', id: string | null, createdAt: Date | null, status: string | null, program: { __typename: 'Program', programCode: string } | null } | null> | null };

export type GetBonusBehaviorPagesByPagesetQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetBonusBehaviorPagesByPagesetQuery = { __typename: 'Query', getBonusBehaviorPagesByPageset: Array<{ __typename: 'BonusBehaviorPage', id: string | null, title: string | null, detail: string | null, type: BonusBehaviorPageTypeValue | null, icon: string | null, bonusBehaviorPagesetId: string | null } | null> | null };

export type GetConfigsForProgramCodeQueryVariables = Exact<{
  programCode: Scalars['String'];
}>;


export type GetConfigsForProgramCodeQuery = { __typename: 'Query', getConfigsForProgram: { __typename: 'ProgramConfig', reminderConfigs: Array<{ __typename: 'ReminderConfig', id: string, monTime: string, startDayIndex: number, lengthInDays: number, checkInCategory: CheckInCategory, windowBeforeMinutes: number, windowAfterMinutes: number, isRequired: boolean, isDemo: boolean, interval: ReminderInterval } | null> | null, rewardPeriodConfigs: Array<{ __typename: 'RewardPeriodConfig', id: string, rewardAmount: any, rewardCurrency: Currency, lengthInDays: number, lossPerDayMax: any, lossType: LossType, programId: string, startDayIndex: number } | null> | null, paymentOptions: Array<{ __typename: 'PaymentOption', id: string | null, name: string | null } | null> | null } | null };

export type MemberCalendarQueryVariables = Exact<{
  id: Scalars['UUID'];
  totalStartDate: Scalars['Date'];
  endDate: Scalars['Date'];
}>;


export type MemberCalendarQuery = { __typename: 'Query', member: { __typename: 'Member', id: string | null, renderCalendarView: Array<{ __typename: 'CalendarDay', checkInId: string | null, reminderDate: string | null, checkInLocalTime: string | null, reminderIsRequired: boolean | null, windowAfterMinutes: number | null, windowBeforeMinutes: number | null, checkInVerificationStatus: VerificationStatus | null, checkInIsValid: boolean | null, reminderWindowHasClosed: boolean | null, photoUrl: string | null, reminderTime: string | null, frequency: string | null, checkInCategory: CheckInCategory | null, checkInStatus: string | null, reminderId: string | null, checkInTimezone: string | null, isDemo: boolean | null, calendarDate: string | null, objectDetectionStatus: string | null, autoMedCount: number | null } | null> | null } | null };

export type MemberEmailAddressesQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type MemberEmailAddressesQuery = { __typename: 'Query', member: { __typename: 'Member', id: string | null, person: { __typename: 'Person', id: string | null, emailAddresses: Array<{ __typename: 'EmailAddress', id: string | null, emailAddress: string | null, isPrimary: boolean | null } | null> | null } | null } | null };

export type MemberInformationQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type MemberInformationQuery = { __typename: 'Query', member: { __typename: 'Member', id: string | null, customerId: string | null, personId: string | null, siteName: string | null, externalId: string | null, medicaidId: string | null, isTestMember: boolean | null, isAutoPauseEnabled: boolean | null, eligibilityEndDate: string | null, wellthId: string | null, isReminderMessagingEnabled: boolean | null, latestTimezone: { __typename: 'MemberTimezone', timezoneName: string | null } | null, person: { __typename: 'Person', id: string | null, primaryLanguage: ISOLanguage | null, primaryTimezone: string | null, birthDate: string | null, gender: Gender | null, ethnicity: string | null, race: string | null, medicareId: string | null, coverageType: string | null, planName: string | null, addresses: Array<{ __typename: 'Address', id: string | null, street: string | null, street2: string | null, city: string | null, state: string | null, zip: string | null, country: string | null, isPrimary: boolean | null } | null> | null, names: Array<{ __typename: 'Name', id: string | null, firstName: string | null, middleName: string | null, lastName: string | null, isPrimary: boolean | null } | null> | null, phoneNumbers: Array<{ __typename: 'PhoneNumber', id: string | null, phoneNumber: string | null, type: string | null, isPrimary: boolean | null } | null> | null, emailAddresses: Array<{ __typename: 'EmailAddress', id: string | null, emailAddress: string | null, isPrimary: boolean | null } | null> | null } | null, program: { __typename: 'Program', id: string, programTemplate: string | null } | null } | null };

export type MemberMailingAddressesQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type MemberMailingAddressesQuery = { __typename: 'Query', member: { __typename: 'Member', id: string | null, person: { __typename: 'Person', id: string | null, addresses: Array<{ __typename: 'Address', id: string | null, street: string | null, street2: string | null, city: string | null, state: string | null, zip: string | null, country: string | null, isPrimary: boolean | null } | null> | null } | null } | null };

export type MemberMessagesQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type MemberMessagesQuery = { __typename: 'Query', member: { __typename: 'Member', id: string | null, memberMessages: Array<{ __typename: 'MemberMessage', id: string | null, createdAt: Date | null, message: string | null, recipient: MessageRecipient | null, status: string | null, admin: { __typename: 'Admin', firstName: string | null, lastName: string | null } | null } | null> | null } | null };

export type MemberNamesQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type MemberNamesQuery = { __typename: 'Query', member: { __typename: 'Member', id: string | null, person: { __typename: 'Person', id: string | null, names: Array<{ __typename: 'Name', id: string | null, firstName: string | null, middleName: string | null, lastName: string | null, isPrimary: boolean | null } | null> | null } | null } | null };

export type MemberNotesQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type MemberNotesQuery = { __typename: 'Query', member: { __typename: 'Member', id: string | null, memberNotes: Array<{ __typename: 'MemberNote', id: string | null, createdAt: Date | null, note: string | null, admin: { __typename: 'Admin', firstName: string | null, lastName: string | null } | null } | null> | null } | null };

export type MemberPauseStatusQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type MemberPauseStatusQuery = { __typename: 'Query', member: { __typename: 'Member', id: string | null, pauseStatus: PauseStatus | null } | null };

export type MemberPersonProfileQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type MemberPersonProfileQuery = { __typename: 'Query', member: { __typename: 'Member', id: string | null, externalId: string | null, siteName: string | null, eligibilityEndDate: string | null, medicaidId: string | null, wellthId: string | null, latestTimezone: { __typename: 'MemberTimezone', timezoneName: string | null } | null, person: { __typename: 'Person', id: string | null, primaryLanguage: ISOLanguage | null, primaryTimezone: string | null, birthDate: string | null, gender: Gender | null, ethnicity: string | null, race: string | null, medicareId: string | null, coverageType: string | null, planName: string | null } | null, program: { __typename: 'Program', programTemplate: string | null } | null } | null };

export type MemberPhoneNumbersQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type MemberPhoneNumbersQuery = { __typename: 'Query', member: { __typename: 'Member', id: string | null, person: { __typename: 'Person', id: string | null, phoneNumbers: Array<{ __typename: 'PhoneNumber', id: string | null, phoneNumber: string | null, type: string | null, isPrimary: boolean | null } | null> | null } | null } | null };

export type MemberQueryVariables = Exact<{
  id: Scalars['UUID'];
  last7StartDate: Scalars['Date'];
  today: Scalars['Date'];
  last30StartDate: Scalars['Date'];
  totalStartDate: Scalars['Date'];
  endDate: Scalars['Date'];
}>;


export type MemberQuery = { __typename: 'Query', member: { __typename: 'Member', id: string | null, enrollmentDate: string | null, onboardingDate: string | null, activationDate: string | null, wellthId: string | null, externalId: string | null, description: string | null, enrolledBy: string | null, typeOfEnrollment: TypeOfEnrollmentOptions | null, createdAt: Date | null, updatedAt: Date | null, siteName: string | null, isTestMember: boolean | null, isAutoPauseEnabled: boolean | null, pauseStatus: PauseStatus | null, isRestfulMember: boolean | null, isReminderEditingOpen: boolean | null, isReminderMessagingEnabled: boolean | null, isLocalNotificationEnabled: boolean | null, isProductTourRecurring: boolean | null, eligibilityEndDate: string | null, reminders: Array<{ __typename: 'Reminder', nodeId: string, id: string, checkInCategory: CheckInCategory, createdAt: Date, updatedAt: Date, startDate: string, endDate: string, monTime: string, tueTime: string, wedTime: string, thuTime: string, friTime: string, satTime: string, sunTime: string, windowBeforeMinutes: number, windowAfterMinutes: number, isRequired: boolean, isDemo: boolean, linkedFutureReminderId: string | null, interval: ReminderInterval, intervalCount: number, label: string | null } | null> | null, status: { __typename: 'MemberStatus', value: MemberStatusValue | null } | null, latestTimezone: { __typename: 'MemberTimezone', timezoneName: string | null } | null, pauseDetails: { __typename: 'PauseDetails', id: string | null, reason: string | null, startDate: string | null, endDate: string | null, note: string | null, totalPausedDays: number | null, previousStartDate: string | null, previousEndDate: string | null, previousReason: string | null } | null, person: { __typename: 'Person', shortId: string | null, id: string | null, primaryLanguage: ISOLanguage | null, primaryTimezone: string | null, birthDate: string | null, gender: Gender | null, ethnicity: string | null, race: string | null, medicareId: string | null, coverageType: string | null, planName: string | null, addresses: Array<{ __typename: 'Address', id: string | null, street: string | null, street2: string | null, city: string | null, state: string | null, zip: string | null, country: string | null, isPrimary: boolean | null } | null> | null, names: Array<{ __typename: 'Name', id: string | null, firstName: string | null, middleName: string | null, lastName: string | null, isPrimary: boolean | null } | null> | null, phoneNumbers: Array<{ __typename: 'PhoneNumber', id: string | null, phoneNumber: string | null, type: string | null, isPrimary: boolean | null } | null> | null, emailAddresses: Array<{ __typename: 'EmailAddress', id: string | null, emailAddress: string | null, isPrimary: boolean | null } | null> | null } | null, program: { __typename: 'Program', id: string, programCode: string, programTemplate: string | null } | null, currentOrNextRewardPeriodBalance: { __typename: 'RewardPeriodBalanceDetail', rewardPeriodId: string | null, periodSum: any | null, periodReward: any | null, periodCurrency: Currency | null, periodEnd: string | null, periodStart: string | null, settleDate: string | null } | null, last30: { __typename: 'AdherenceSummary', requiredReminderCount: number | null, totalReminderCount: number | null, requiredValidCheckInCount: number | null, totalValidCheckInCount: number | null, percentRequiredRemindersAdherent: any | null, percentTotalRemindersAdherent: any | null, creditedCheckInCount: number | null, percentTotalRemindersNonCreditedAdherent: any | null } | null, last7: { __typename: 'AdherenceSummary', requiredReminderCount: number | null, totalReminderCount: number | null, requiredValidCheckInCount: number | null, totalValidCheckInCount: number | null, percentRequiredRemindersAdherent: any | null, percentTotalRemindersAdherent: any | null, creditedCheckInCount: number | null, percentTotalRemindersNonCreditedAdherent: any | null } | null, total: { __typename: 'AdherenceSummary', requiredReminderCount: number | null, totalReminderCount: number | null, requiredValidCheckInCount: number | null, totalValidCheckInCount: number | null, percentRequiredRemindersAdherent: any | null, percentTotalRemindersAdherent: any | null, creditedCheckInCount: number | null, percentTotalRemindersNonCreditedAdherent: any | null } | null, renderCalendarView: Array<{ __typename: 'CalendarDay', checkInId: string | null, reminderDate: string | null, checkInLocalTime: string | null, reminderIsRequired: boolean | null, windowAfterMinutes: number | null, windowBeforeMinutes: number | null, checkInVerificationStatus: VerificationStatus | null, checkInIsValid: boolean | null, reminderWindowHasClosed: boolean | null, photoUrl: string | null, reminderTime: string | null, frequency: string | null, checkInCategory: CheckInCategory | null, checkInStatus: string | null, reminderId: string | null, checkInTimezone: string | null, isDemo: boolean | null, calendarDate: string | null, objectDetectionStatus: string | null, autoMedCount: number | null } | null> | null, overallScore: { __typename: 'Score', scoreValue: string | null, updatedAt: string | null, impactTier: string | null } | null, appointments: { __typename: 'AppointmentConnection', pageInfo: { __typename: 'PageInfo', startCursor: string | null, endCursor: string | null }, nodes: Array<{ __typename: 'Appointment', type: PersonVisitType, name: string | null, dueTime: Date | null, isAllDay: boolean | null, lossAmount: number | null, lossCurrencySymbol: string | null, isMissed: boolean | null, status: AppointmentStatusType | null, allowCredit: boolean | null, appointmentId: string, location: { __typename: 'AppointmentLocation', name: string | null, latitude: number | null, longitude: number | null, address: string | null, phoneNumber: string | null } | null } | null> } | null } | null };

export type MemberProgramExperienceQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type MemberProgramExperienceQuery = { __typename: 'Query', member: { __typename: 'Member', id: string | null, isTestMember: boolean | null, isReminderMessagingEnabled: boolean | null, isAutoPauseEnabled: boolean | null } | null };

export type MemberRemindersQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type MemberRemindersQuery = { __typename: 'Query', member: { __typename: 'Member', id: string | null, reminders: Array<{ __typename: 'Reminder', nodeId: string, id: string, checkInCategory: CheckInCategory, createdAt: Date, updatedAt: Date, startDate: string, endDate: string, monTime: string, tueTime: string, wedTime: string, thuTime: string, friTime: string, satTime: string, sunTime: string, windowBeforeMinutes: number, windowAfterMinutes: number, isRequired: boolean, isDemo: boolean, linkedFutureReminderId: string | null, interval: ReminderInterval, intervalCount: number, label: string | null } | null> | null } | null };

export type MemberSecurityQuestionsQueryVariables = Exact<{
  memberId: Scalars['UUID'];
}>;


export type MemberSecurityQuestionsQuery = { __typename: 'Query', memberSecurityQuestions: Array<{ __typename: 'MemberSecurityQuestion', id: string, question: { __typename: 'QuestionTranslation', en: string, es: string } }> | null };

export type MemberTimelineQueryVariables = Exact<{
  wellthId?: InputMaybe<Scalars['UUID']>;
  excludeEventCriteria?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  startTimestamp?: InputMaybe<Scalars['String']>;
}>;


export type MemberTimelineQuery = { __typename: 'Query', memberTimelineEvents: Array<{ __typename: 'MemberTimelineEvent', id: string | null, name: string | null, timestamp: string | null, properties: any | null } | null> | null };

export type MemberMixpanelEventsQueryVariables = Exact<{
  id: Scalars['UUID'];
  today: Scalars['Date'];
  totalStartDate: Scalars['Date'];
  eventLimit: Scalars['Int'];
}>;


export type MemberMixpanelEventsQuery = { __typename: 'Query', member: { __typename: 'Member', id: string | null, getMixpanelEvents: { __typename: 'MixpanelEvents', events: Array<{ __typename: 'PatientEvent', name: string | null, to: string | null, from: string | null, target: string | null, model: string | null, time: string | null, type: string | null, networkConnectionType: NetworkConnectionType | null } | null> | null } | null } | null };

export type NameQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type NameQuery = { __typename: 'Query', name: { __typename: 'Name', id: string | null, firstName: string | null, middleName: string | null, lastName: string | null, isPrimary: boolean | null } | null };

export type MemberPaymentOptionQueryVariables = Exact<{
  condition: PaymentOptionCondition;
}>;


export type MemberPaymentOptionQuery = { __typename: 'Query', memberPaymentOption: { __typename: 'PaymentOption', id: string | null, name: string | null, processor: PaymentProcessor | null, packId: string | null, default: boolean | null } | null };

export type GetPcpInfoQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetPcpInfoQuery = { __typename: 'Query', getProspectById: { __typename: 'Prospect', pcpName: string | null, pcpNumber: string | null } | null };

export type PersonProfileQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type PersonProfileQuery = { __typename: 'Query', member: { __typename: 'Member', id: string | null, externalId: string | null, siteName: string | null, eligibilityEndDate: string | null, person: { __typename: 'Person', id: string | null, primaryLanguage: ISOLanguage | null, primaryTimezone: string | null, birthDate: string | null, gender: Gender | null, ethnicity: string | null, race: string | null, medicareId: string | null, coverageType: string | null, planName: string | null } | null } | null };

export type PhoneNumberQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type PhoneNumberQuery = { __typename: 'Query', phoneNumber: { __typename: 'PhoneNumber', id: string | null, phoneNumber: string | null, type: string | null, isPrimary: boolean | null } | null };

export type ProgramByIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ProgramByIdQuery = { __typename: 'Query', programById: { __typename: 'Program', id: string, adminId: string, programCode: string, name: string, expiry: string, useCount: number | null, maximumUses: number | null, customerId: string | null, isTestProgram: boolean, sector: string | null, note: string | null, pauseAfterNoActivityDays: number | null, inactivateAfterPausedDays: number | null, programTemplate: string | null, customerByCustomerId: { __typename: 'Customer', name: string } | null } | null };

export type ProgramPaymentOptionsQueryVariables = Exact<{
  condition: ProgramPaymentOptionsCondition;
}>;


export type ProgramPaymentOptionsQuery = { __typename: 'Query', programPaymentOptions: Array<{ __typename: 'PaymentOption', id: string | null, name: string | null, processor: PaymentProcessor | null, packId: string | null, default: boolean | null } | null> | null };

export type GetProspectByIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetProspectByIdQuery = { __typename: 'Query', getProspectById: { __typename: 'Prospect', id: string | null, createdAt: string | null, status: string | null, externalId: string | null, siteName: string | null, eligibilityEndDate: string | null, description: string | null, isTestProspect: boolean | null, medicaidId: string | null, pcpName: string | null, pcpNumber: string | null, person: { __typename: 'Person', shortId: string | null, id: string | null, primaryTimezone: string | null, primaryLanguage: ISOLanguage | null, birthDate: string | null, gender: Gender | null, race: string | null, ethnicity: string | null, medicareId: string | null, coverageType: string | null, planName: string | null, addresses: Array<{ __typename: 'Address', id: string | null, street: string | null, street2: string | null, city: string | null, state: string | null, zip: string | null, country: string | null, isPrimary: boolean | null } | null> | null, names: Array<{ __typename: 'Name', id: string | null, firstName: string | null, middleName: string | null, lastName: string | null, isPrimary: boolean | null } | null> | null, phoneNumbers: Array<{ __typename: 'PhoneNumber', id: string | null, phoneNumber: string | null, type: string | null, isPrimary: boolean | null } | null> | null, emailAddresses: Array<{ __typename: 'EmailAddress', id: string | null, emailAddress: string | null, isPrimary: boolean | null } | null> | null } | null, program: { __typename: 'Program', id: string, programCode: string, expiry: string, programTemplate: string | null } | null, prospectStatuses: Array<{ __typename: 'ProspectStatus', value: string, reason: string | null, reasonDetail: string | null, note: string | null, id: string, statusTransitionDate: Date, adminFirstName: string | null, adminLastName: string | null } | null> | null, prospectNotes: Array<{ __typename: 'ProspectNote', id: string | null, createdAt: Date | null, note: string | null, admin: { __typename: 'Admin', firstName: string | null, lastName: string | null } | null } | null> | null, overallScore: { __typename: 'Score', scoreValue: string | null, updatedAt: string | null, impactTier: string | null } | null, activeIdentityTags: Array<{ __typename: 'IdentityTag', name: string | null } | null> | null } | null };

export type ProspectEmailAddressesQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ProspectEmailAddressesQuery = { __typename: 'Query', getProspectById: { __typename: 'Prospect', id: string | null, person: { __typename: 'Person', id: string | null, emailAddresses: Array<{ __typename: 'EmailAddress', id: string | null, emailAddress: string | null, isPrimary: boolean | null } | null> | null } | null } | null };

export type ProspectMailingAddressesQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ProspectMailingAddressesQuery = { __typename: 'Query', getProspectById: { __typename: 'Prospect', id: string | null, person: { __typename: 'Person', id: string | null, addresses: Array<{ __typename: 'Address', id: string | null, street: string | null, street2: string | null, city: string | null, state: string | null, zip: string | null, country: string | null, isPrimary: boolean | null } | null> | null } | null } | null };

export type ProspectNamesQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ProspectNamesQuery = { __typename: 'Query', getProspectById: { __typename: 'Prospect', id: string | null, person: { __typename: 'Person', id: string | null, names: Array<{ __typename: 'Name', id: string | null, firstName: string | null, middleName: string | null, lastName: string | null, isPrimary: boolean | null } | null> | null } | null } | null };

export type ProspectPhoneNumbersQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ProspectPhoneNumbersQuery = { __typename: 'Query', getProspectById: { __typename: 'Prospect', id: string | null, person: { __typename: 'Person', id: string | null, phoneNumbers: Array<{ __typename: 'PhoneNumber', id: string | null, phoneNumber: string | null, type: string | null, isPrimary: boolean | null } | null> | null } | null } | null };

export type ProspectProgramExperienceQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ProspectProgramExperienceQuery = { __typename: 'Query', getProspectById: { __typename: 'Prospect', id: string | null, isTestProspect: boolean | null } | null };

export type ReminderQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ReminderQuery = { __typename: 'Query', reminderById: { __typename: 'Reminder', nodeId: string, id: string, checkInCategory: CheckInCategory, createdAt: Date, updatedAt: Date, startDate: string, endDate: string, monTime: string, tueTime: string, wedTime: string, thuTime: string, friTime: string, satTime: string, sunTime: string, windowBeforeMinutes: number, windowAfterMinutes: number, isRequired: boolean, isDemo: boolean, linkedFutureReminderId: string | null, interval: ReminderInterval, intervalCount: number, label: string | null } | null };

export type RequestMfaPinResetQueryVariables = Exact<{
  memberId: Scalars['UUID'];
}>;


export type RequestMfaPinResetQuery = { __typename: 'Query', requestMfaPinReset: { __typename: 'RequestMfaPinResetPayload', success: boolean } | null };

export type RewardCardDetailsByMemberIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type RewardCardDetailsByMemberIdQuery = { __typename: 'Query', rewardCardDetailsByMemberId: { __typename: 'RewardCardDetails', id: string | null, createdAt: Date | null, updatedAt: Date | null, status: DebitCardStatus | null, latestBalance: string | null, processor: string | null, shippedDate: Date | null, packId: string | null, orderDate: Date | null, activationDate: Date | null, rewardCardChoice: string | null } | null };

export type RewardPeriodBalancesQueryVariables = Exact<{
  memberId: Scalars['UUID'];
  relativeTo?: InputMaybe<RewardBalanceRelativeTo>;
}>;


export type RewardPeriodBalancesQuery = { __typename: 'Query', rewardPeriodBalances: { __typename: 'RewardPeriodBalancesConnection', nodes: Array<{ __typename: 'RewardPeriodBalanceDetail', rewardPeriodId: string | null, periodStart: string | null, periodEnd: string | null, periodLossPerDayMax: any | null, periodReward: any | null, periodSum: any | null, settleDate: string | null, rewardsEarned: any | null } | null> } | null };

export type SearchQueryVariables = Exact<{
  searchTerm: Scalars['String'];
}>;


export type SearchQuery = { __typename: 'Query', search: { __typename: 'SearchResult', results: Array<{ __typename: 'IndividualSearchResult', id: string | null, shortId: string | null, individualType: IndividualType | null, createdAt: string | null, updatedAt: string | null, personId: string | null, birthDate: string | null, externalId: string | null, location: string | null, programCode: string | null, status: string | null, names: Array<{ __typename: 'Name', firstName: string | null, lastName: string | null } | null> | null, phoneNumbers: Array<{ __typename: 'PhoneNumber', id: string | null, isPrimary: boolean | null, phoneNumber: string | null } | null> | null } | null> | null } | null };

export type SearchByValuesQueryVariables = Exact<{
  input: SearchByValueInput;
}>;


export type SearchByValuesQuery = { __typename: 'Query', searchByValues: { __typename: 'SearchResult', results: Array<{ __typename: 'IndividualSearchResult', id: string | null, shortId: string | null, individualType: IndividualType | null, createdAt: string | null, updatedAt: string | null, personId: string | null, birthDate: string | null, externalId: string | null, location: string | null, programCode: string | null, status: string | null, names: Array<{ __typename: 'Name', firstName: string | null, lastName: string | null } | null> | null, phoneNumbers: Array<{ __typename: 'PhoneNumber', id: string | null, isPrimary: boolean | null, phoneNumber: string | null } | null> | null } | null> | null } | null };

export type ValidateAddressQueryVariables = Exact<{
  input: ValidateAddressInput;
}>;


export type ValidateAddressQuery = { __typename: 'Query', validateAddress: { __typename: 'ValidateAddressPayload', isValid: boolean | null, note: string | null, correctedAddress: { __typename: 'AddressLite', street: string | null, street2: string | null, city: string | null, state: string | null, zip: string | null } | null } | null };
